import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const DualScreenLockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3v1H14a1 1 0 00-1 1v4a1 1 0 001 1h5a1 1 0 001-1V5a1 1 0 00-1-1h-.5V3a2 2 0 10-4 0zm1 1V3a1 1 0 112 0v1h-2zm1 2.25a.75.75 0 110 1.5.75.75 0 010-1.5zM4 6h8v1h-1.5v10H16a1 1 0 001-1v-5h1v5a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2zm2 9.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1zm-3-8H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7z",
    fill: primaryFill
  }));
};

export const DualScreenLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenLockRegularIcon({}), 'DualScreenLockRegular');

const DualScreenMirrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 16H16a2 2 0 002-2V6a2 2 0 00-2-2h-5.5v12zm-1-12H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V4zM5.75 8c.18 0 .34.1.43.25l1.75 3a.5.5 0 01-.43.75H4a.5.5 0 01-.43-.75l1.75-3A.5.5 0 015.75 8zm8.93.25l1.75 3A.5.5 0 0116 12h-3.5a.5.5 0 01-.43-.75l1.75-3a.5.5 0 01.86 0z",
    fill: primaryFill
  }));
};

export const DualScreenMirrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenMirrorFilledIcon({}), 'DualScreenMirrorFilled');

const DualScreenMirrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h5.5v10H4a1 1 0 01-1-1V6zm7.5 9V5H16a1 1 0 011 1v8a1 1 0 01-1 1h-5.5zM6.25 8c.18 0 .34.1.43.25l1.75 3A.5.5 0 018 12H4.5a.5.5 0 01-.43-.75l1.75-3A.5.5 0 016.25 8zm.88 3l-.88-1.5-.88 1.5h1.76zm7.05-2.75l1.75 3a.5.5 0 01-.43.75H12a.5.5 0 01-.43-.75l1.75-3a.5.5 0 01.86 0zm.45 2.75l-.88-1.5-.88 1.5h1.76z",
    fill: primaryFill
  }));
};

export const DualScreenMirrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenMirrorRegularIcon({}), 'DualScreenMirrorRegular');

const DualScreenPaginationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 16h-5.5V4H16a2 2 0 012 2v8a2 2 0 01-2 2zM4 4h5.5v12H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm8.5 10a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 10-1 0 .5.5 0 001 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const DualScreenPaginationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenPaginationFilledIcon({}), 'DualScreenPaginationFilled');

const DualScreenPaginationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h5.5V5H4zm12 10a1 1 0 001-1V6a1 1 0 00-1-1h-5.5v10H16zm-4.5-1a.5.5 0 100-1 .5.5 0 000 1zm2.5-.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const DualScreenPaginationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenPaginationRegularIcon({}), 'DualScreenPaginationRegular');

const DualScreenSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.07 2.44a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 8.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 2.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zM14.5 6.5a1 1 0 110-2 1 1 0 010 2zm0 4.5c1.33 0 2.55-.47 3.5-1.26V16a2 2 0 01-2 2h-5.5V9.27a5.48 5.48 0 004 1.73zm-5-3.2A5.47 5.47 0 019.02 6H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V7.8zM6 15.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenSettingsFilledIcon({}), 'DualScreenSettingsFilled');

const DualScreenSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.07 2.44a2 2 0 01-1.44 2.48l-.46.12a4.73 4.73 0 00.01 1.01l.35.09A2 2 0 0112 8.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 2.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zM14.5 6.5a1 1 0 110-2 1 1 0 010 2zM17 16v-5.6c.36-.18.7-.4 1-.66V16a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2h5.02c.03.34.1.68.19 1H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7.8c.25.54.6 1.04 1 1.47V17H16a1 1 0 001-1zm-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenSettingsRegularIcon({}), 'DualScreenSettingsRegular');

const DualScreenSpanFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 16h-5.5v-5.5h3.8l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7l1.14 1.15H10.5V4H16a2 2 0 012 2v8a2 2 0 01-2 2zM9.5 9.5V4H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5v-5.5H5.7l1.15 1.15a.5.5 0 01-.7.7l-2-2a.5.5 0 010-.7l2-2a.5.5 0 11.7.7L5.71 9.5H9.5z",
    fill: primaryFill
  }));
};

export const DualScreenSpanFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenSpanFilledIcon({}), 'DualScreenSpanFilled');

const DualScreenSpanRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h5.5v-3.5h1V15H16a1 1 0 001-1V6a1 1 0 00-1-1h-5.5v3.5h-1V5H4zm2.85 3.35a.5.5 0 10-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L5.71 10.5h8.58l-1.14 1.15a.5.5 0 00.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7l1.14 1.15H5.71l1.14-1.15z",
    fill: primaryFill
  }));
};

export const DualScreenSpanRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenSpanRegularIcon({}), 'DualScreenSpanRegular');

const DualScreenSpeakerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.65 2.2c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 11.8-.6zm-3.96-.16c.19.08.31.26.31.46v6a.5.5 0 01-.85.35L11.29 7h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm2.53 1.93c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.59 4.59 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53zm.13 5.73a1.5 1.5 0 01-.53-.74 1.5 1.5 0 01-.87-.07 1.5 1.5 0 01-2.51.67L10.88 8h-.38v8H16a2 2 0 002-2V9.8c-.5.29-1.15.27-1.65-.1zM9.5 16V7.62A1.5 1.5 0 019 6.5v-2c0-.18.03-.34.09-.5H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5zM6 13.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5h1a.5.5 0 010 1h-1a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const DualScreenSpeakerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenSpeakerFilledIcon({}), 'DualScreenSpeakerFilled');

const DualScreenSpeakerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.65 2.2c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 11.8-.6zm-3.96-.16c.19.08.31.26.31.46v6a.5.5 0 01-.85.35L11.29 7h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm2.53 1.93c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45 4.59 4.59 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44 5.5 5.5 0 00.55-2.22c0-.5-.1-1.02-.28-1.53zM17 14V9.98c.34.06.7 0 1-.18V14a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h5.09a1.5 1.5 0 00-.09.5V5H4a1 1 0 00-1 1v8a1 1 0 001 1h5.5V7.62c.27.24.62.38 1 .38v7H16a1 1 0 001-1zm-11-.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: primaryFill
  }));
};

export const DualScreenSpeakerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenSpeakerRegularIcon({}), 'DualScreenSpeakerRegular');

const DualScreenStatusBarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 16h-5.5V4H16a2 2 0 012 2v8a2 2 0 01-2 2zM4 4h5.5v12H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm8.5 2a.5.5 0 000 1H16a.5.5 0 000-1h-3.5z",
    fill: primaryFill
  }));
};

export const DualScreenStatusBarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenStatusBarFilledIcon({}), 'DualScreenStatusBarFilled');

const DualScreenStatusBarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h5.5V5H4zm12 10a1 1 0 001-1V6a1 1 0 00-1-1h-5.5v10H16zm-4-9a.5.5 0 000 1h3.5a.5.5 0 000-1H12z",
    fill: primaryFill
  }));
};

export const DualScreenStatusBarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenStatusBarRegularIcon({}), 'DualScreenStatusBarRegular');

const DualScreenTabletFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1.1.9-2 2-2h10a2 2 0 012 2v6a2 2 0 01-2 2h-3v-2h.5a.5.5 0 000-1H13V9a3 3 0 00-3-3H4V5zm6 12H7.5V7H10a2 2 0 012 2v6a2 2 0 01-2 2zM4 7h2.5v10H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2zm5.5 7a.5.5 0 000 1h.5a.5.5 0 000-1h-.5zm-6 .5c0 .28.22.5.5.5h.5a.5.5 0 000-1H4a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const DualScreenTabletFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenTabletFilledIcon({}), 'DualScreenTabletFilled');

const DualScreenTabletRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5c0-1.1.9-2 2-2h10a2 2 0 012 2v6a2 2 0 01-2 2h-3v-1h3a1 1 0 001-1V5a1 1 0 00-1-1H6a1 1 0 00-1 1v1H4V5zm9 6h.5a.5.5 0 000-1H13v1zM2 9c0-1.1.9-2 2-2h6a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V9zm2-1a1 1 0 00-1 1v6a1 1 0 001 1h2.5V8H4zm6 8a1 1 0 001-1V9a1 1 0 00-1-1H7.5v8H10zm-1-2a.5.5 0 000 1h.5a.5.5 0 000-1H9zm-5 .5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const DualScreenTabletRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenTabletRegularIcon({}), 'DualScreenTabletRegular');

const DualScreenUpdateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 16h-5.5V4H16a2 2 0 012 2v8a2 2 0 01-2 2zM4 4h5.5v12H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm12.85 7.85a.5.5 0 00-.7-.7L15 12.29V6.5a.5.5 0 00-1 0v5.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2z",
    fill: primaryFill
  }));
};

export const DualScreenUpdateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenUpdateFilledIcon({}), 'DualScreenUpdateFilled');

const DualScreenUpdateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v8a1 1 0 001 1h5.5V5H4zm12 10a1 1 0 001-1V6a1 1 0 00-1-1h-5.5v10H16zm-.15-3.15a.5.5 0 00-.7-.7L14 12.29V6.5a.5.5 0 00-1 0v5.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2z",
    fill: primaryFill
  }));
};

export const DualScreenUpdateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenUpdateRegularIcon({}), 'DualScreenUpdateRegular');

const DualScreenVerticalScrollFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 16H16a2 2 0 002-2V6a2 2 0 00-2-2h-5.5v12zm-1-12H4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h5.5V4zm7.35 7.15c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64 1.65-1.64c.2-.2.5-.2.7 0zm0-3a.5.5 0 01-.7.7L14.5 7.21l-1.65 1.64a.5.5 0 01-.7-.7l2-2c.2-.2.5-.2.7 0l2 2z",
    fill: primaryFill
  }));
};

export const DualScreenVerticalScrollFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenVerticalScrollFilledIcon({}), 'DualScreenVerticalScrollFilled');

const DualScreenVerticalScrollRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h5.5v10H4a1 1 0 01-1-1V6zm7.5 9V5H16a1 1 0 011 1v8a1 1 0 01-1 1h-5.5zm5.35-3.85c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64 1.65-1.64c.2-.2.5-.2.7 0zm0-3a.5.5 0 01-.7.7L13.5 7.21l-1.65 1.64a.5.5 0 01-.7-.7l2-2c.2-.2.5-.2.7 0l2 2z",
    fill: primaryFill
  }));
};

export const DualScreenVerticalScrollRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenVerticalScrollRegularIcon({}), 'DualScreenVerticalScrollRegular');

const DualScreenVibrateFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 15H13a2 2 0 002-2V7a2 2 0 00-2-2h-2.5v10zm-1-10H7a2 2 0 00-2 2v6c0 1.1.9 2 2 2h2.5V5zm2.5 7.5c0-.28.22-.5.5-.5h.5a.5.5 0 010 1h-.5a.5.5 0 01-.5-.5zM7 12h.5a.5.5 0 010 1H7a.5.5 0 010-1zM1.88 6.51a.5.5 0 01.6.37l.41 1.64c.1.35.05.71-.1 1.03l-.62 1.23a.5.5 0 000 .44l.78 1.56a.5.5 0 11-.9.44l-.77-1.55a1.5 1.5 0 010-1.34l.6-1.22a.5.5 0 00.04-.35l-.4-1.64a.5.5 0 01.36-.6zm16.6.37a.5.5 0 00-.97.24l.41 1.64a.5.5 0 01-.03.35l-.61 1.22a1.5 1.5 0 000 1.34l.77 1.55a.5.5 0 10.9-.44l-.78-1.56a.5.5 0 010-.44l.61-1.23c.16-.32.2-.68.11-1.03l-.4-1.64z",
    fill: primaryFill
  }));
};

export const DualScreenVibrateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenVibrateFilledIcon({}), 'DualScreenVibrateFilled');

const DualScreenVibrateRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 5a2 2 0 00-2 2v6c0 1.1.9 2 2 2h6a2 2 0 002-2V7a2 2 0 00-2-2H7zM6 7a1 1 0 011-1h2.5v8H7a1 1 0 01-1-1V7zm4.5 7V6H13a1 1 0 011 1v6a1 1 0 01-1 1h-2.5zm1-1.5c0-.28.22-.5.5-.5h.5a.5.5 0 010 1H12a.5.5 0 01-.5-.5zm-4-.5a.5.5 0 000 1H8a.5.5 0 000-1h-.5zM1.88 6.51a.5.5 0 01.6.37l.41 1.64c.1.35.05.71-.1 1.03l-.62 1.23a.5.5 0 000 .44l.78 1.56a.5.5 0 11-.9.44l-.77-1.55a1.5 1.5 0 010-1.34l.6-1.22a.5.5 0 00.04-.35l-.4-1.64a.5.5 0 01.36-.6zm16.6.37a.5.5 0 00-.97.24l.41 1.64a.5.5 0 01-.03.35l-.61 1.22a1.5 1.5 0 000 1.34l.77 1.55a.5.5 0 10.9-.44l-.78-1.56a.5.5 0 010-.44l.61-1.23c.16-.32.2-.68.11-1.03l-.4-1.64z",
    fill: primaryFill
  }));
};

export const DualScreenVibrateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DualScreenVibrateRegularIcon({}), 'DualScreenVibrateRegular');

const DumbbellFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.33 3.13a1.98 1.98 0 00-3 .22A2.4 2.4 0 009.2 7.43l1.01 1-1.06 1.08 1.36 1.36 1.07-1.07 1.01 1.02a2.4 2.4 0 004.08-2.13 1.98 1.98 0 00.23-3l-.6-.6.52-.52a.97.97 0 10-1.37-1.37l-.52.52-.6-.6zm.27 3.54a.5.5 0 11-.7.71l-1.28-1.27a.5.5 0 11.7-.71l1.28 1.27zM4.02 9.2a2.4 2.4 0 013.4 0l3.4 3.4a2.4 2.4 0 01-2.13 4.07 1.98 1.98 0 01-3 .23l-.6-.6-.54.53a.97.97 0 11-1.37-1.36l.54-.54-.6-.6a1.98 1.98 0 01.23-3 2.4 2.4 0 01.67-2.13zm2.94 5.82a.5.5 0 000-.71L5.7 13.04a.5.5 0 00-.7.7l1.27 1.28c.2.2.5.2.7 0z",
    fill: primaryFill
  }));
};

export const DumbbellFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DumbbellFilledIcon({}), 'DumbbellFilled');

const DumbbellRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.6 7.38a.5.5 0 000-.7L13.33 5.4a.5.5 0 10-.71.7l1.27 1.28c.2.2.51.2.71 0zm-6.79 6.08a.5.5 0 11-.7.7L5.82 12.9a.5.5 0 11.7-.71l1.28 1.27zm9.36-10.61a1.47 1.47 0 00-2.07 0l-.62.62-.25-.25a1.85 1.85 0 00-2.84.28 2.27 2.27 0 00-2.1 3.83l.67.66-1.97 1.97-.66-.66a2.27 2.27 0 00-3.83 2.09 1.85 1.85 0 00-.28 2.84l.25.25-.64.64a1.47 1.47 0 002.07 2.07l.64-.64.24.25a1.85 1.85 0 002.85-.28 2.27 2.27 0 002.09-3.83l-.66-.66 1.97-1.97.66.66a2.27 2.27 0 003.83-2.1 1.85 1.85 0 00.28-2.83l-.25-.25.62-.62c.57-.57.57-1.5 0-2.07zm-1.33 1.98l-.66-.66.62-.62a.47.47 0 01.66.66l-.62.62zm-4.52 4.52l-1.97 1.97-.65-.66 1.96-1.96.66.65zm-6.49 6.5l-.63.63a.47.47 0 01-.66-.66l.63-.64.66.66zm7.5-11.92a.85.85 0 011.2 0l2.56 2.56a.85.85 0 01-.34 1.4.5.5 0 00-.3.7A1.27 1.27 0 0113.4 10l-3.38-3.39a1.27 1.27 0 011.43-2.05.5.5 0 00.68-.3c.04-.13.1-.24.2-.34zm-7.5 6.08c.49-.5 1.3-.5 1.8 0L10 13.39a1.27 1.27 0 01-1.43 2.06.5.5 0 00-.68.3.85.85 0 01-1.4.34l-2.57-2.56a.85.85 0 01.34-1.41.5.5 0 00.3-.68A1.27 1.27 0 014.82 10z",
    fill: primaryFill
  }));
};

export const DumbbellRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DumbbellRegularIcon({}), 'DumbbellRegular');

const EarthFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7h-.25c.11.23.25.5.37.83.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12c.07.21.14.46.18.69.05.28.06.63-.11.97-.18.34-.41.57-.69.72-.26.14-.53.2-.75.24l-.08.01c-.41.07-.65.12-.87.35-.18.2-.28.51-.34.94l-.05.54v.1c-.02.2-.04.41-.09.6v.02a6.98 6.98 0 008.86 1.25 3.56 3.56 0 01-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a5.68 5.68 0 01.7-.7c.15-.14.28-.25.39-.37a.9.9 0 00.2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19c-.09.04-.2.1-.34.12a.6.6 0 01-.54-.18.73.73 0 01-.18-.37 2.58 2.58 0 01-.03-.28v-.07l-.02-.23c-.02-.22-.06-.5-.15-.83-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 01.03-.55c.07-.19.2-.33.35-.44a18.6 18.6 0 001.74-1.66c.3-.31.58-.6.77-.82h.01A6.97 6.97 0 0010 3z",
    fill: primaryFill
  }));
};

export const EarthFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EarthFilledIcon({}), 'EarthFilled');

const EarthRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7h-.25c.11.23.25.5.37.83.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12c.07.21.14.46.18.69.05.28.06.63-.11.97-.18.34-.41.57-.69.72-.26.14-.53.2-.75.24l-.08.01c-.41.07-.65.12-.87.35-.18.2-.28.51-.34.94l-.05.54v.1c-.02.2-.04.41-.09.6v.02a6.98 6.98 0 008.86 1.25 3.56 3.56 0 01-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a5.68 5.68 0 01.7-.7c.15-.14.28-.25.39-.37a.9.9 0 00.2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19c-.09.04-.2.1-.34.12a.6.6 0 01-.54-.18.74.74 0 01-.18-.37 2.57 2.57 0 01-.03-.28v-.07l-.02-.23c-.02-.22-.06-.5-.15-.83-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 01.38-1 18.6 18.6 0 001.74-1.65c.3-.31.58-.6.77-.82h.01A6.97 6.97 0 0010 3zm4.64 1.76a42.1 42.1 0 01-2.71 2.66c.03.07.1.18.24.36l.12.16c.32.4.78.97.96 1.68.1.4.15.73.17.98v.01c.6-.33 1.21-.3 1.66.06.46.35.66.97.47 1.57-.08.27-.27.5-.43.66l-.44.43-.11.1c-.2.17-.36.33-.48.48a.83.83 0 00-.19.34c-.04.23.07.5.29.78.1.12.2.23.3.3 0 .01 0 .02.02.03a6.99 6.99 0 00.13-10.6zM8.8 3.36l-.13-.23a7 7 0 00-4.72 10.39l.02-.2c.06-.46.2-1.06.6-1.49.46-.5 1.02-.59 1.4-.65l.1-.02c.21-.03.34-.07.45-.13.1-.05.2-.13.28-.3.03-.06.05-.15.02-.34a4.4 4.4 0 00-.15-.54l-.05-.15c-.15-.5-.37-1.26.09-1.96.4-.6 1.04-.76 1.48-.87l.13-.03c.47-.12.77-.24.98-.68.26-.56.14-1.3-.12-1.98a6.33 6.33 0 00-.38-.83z",
    fill: primaryFill
  }));
};

export const EarthRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EarthRegularIcon({}), 'EarthRegular');

const EditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 2.87a2.97 2.97 0 014.2 4.21l-.66.67-4.2-4.2.66-.68zm-1.38 1.38l-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68l7.98-7.98-4.2-4.21z",
    fill: primaryFill
  }));
};

export const EditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditFilledIcon({}), 'EditFilled');

const EditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.18 2.93a2.97 2.97 0 00-4.26-.06l-9.37 9.38c-.33.32-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.93-.88c.46-.1.9-.33 1.23-.67l9.36-9.36a2.97 2.97 0 00.05-4.15zm-3.55.65a1.97 1.97 0 012.8 2.8l-.68.66-2.8-2.79.68-.67zm-1.38 1.38l2.8 2.8-7.99 7.97c-.2.2-.46.35-.74.4l-3.16.71.7-3.18c.07-.27.2-.51.4-.7l8-8z",
    fill: primaryFill
  }));
};

export const EditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditRegularIcon({}), 'EditRegular');

const EditArrowBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 2.87a2.97 2.97 0 014.2 4.21l-.66.67-4.2-4.2.66-.68zm-1.38 1.38l-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16A5.5 5.5 0 0115 9.2l.75-.74-4.2-4.21zM13.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0116 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const EditArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditArrowBackFilledIcon({}), 'EditArrowBackFilled');

const EditArrowBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.18 2.93a2.97 2.97 0 00-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16c-.11-.39-.18-.8-.2-1.21l-.95.94c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l7.99-8 2.8 2.8L13.78 9c.41.02.82.09 1.21.2l2.13-2.13a2.97 2.97 0 00.05-4.15zm-3.55.65a1.97 1.97 0 012.79 2.8l-.67.66-2.8-2.79.68-.67zM13.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0116 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const EditArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditArrowBackRegularIcon({}), 'EditArrowBackRegular');

const EditOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l5.4 5.4-4 4c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 00.7-.71l-15-15zm12.9 6.3l-2.59 2.6-4.2-4.21 2.58-2.6 4.21 4.22zm-2.83-5.58a2.97 2.97 0 014.2 4.21l-.66.67-4.2-4.2.66-.68z",
    fill: primaryFill
  }));
};

export const EditOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditOffFilledIcon({}), 'EditOffFilled');

const EditOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l5.4 5.4-4 4c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 00.7-.71l-15-15zm8.2 9.6l-3.99 3.98c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l3.99-4 2.8 2.79zm4-4l-2.6 2.59.71.7 3.97-3.96a2.97 2.97 0 00-4.21-4.2L8.96 6.83l.7.7 2.59-2.58 2.8 2.8zm-1.42-4.17a1.97 1.97 0 012.79 2.8l-.67.66-2.8-2.79.68-.67z",
    fill: primaryFill
  }));
};

export const EditOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditOffRegularIcon({}), 'EditOffRegular');

const EditProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 2.87a2.97 2.97 0 014.2 4.21l-.66.67-4.2-4.2.66-.68zm-1.38 1.38l-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16A5.5 5.5 0 0115 9.2l.75-.74-4.2-4.21zM9 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const EditProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditProhibitedFilledIcon({}), 'EditProhibitedFilled');

const EditProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.18 2.93a2.97 2.97 0 00-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16c-.11-.39-.18-.8-.2-1.21l-.95.94c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l7.99-8 2.8 2.8L13.78 9c.41.02.82.09 1.21.2l2.13-2.13a2.97 2.97 0 00.05-4.15zm-3.55.65a1.97 1.97 0 012.79 2.8l-.67.66-2.8-2.79.68-.67zM9 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1 0a3.5 3.5 0 015.6-2.8l-4.9 4.9a3.48 3.48 0 01-.7-2.1zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 01-2.8 5.6z",
    fill: primaryFill
  }));
};

export const EditProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditProhibitedRegularIcon({}), 'EditProhibitedRegular');

const EditSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 2.87a2.97 2.97 0 014.2 4.21l-.66.67-4.2-4.2.66-.68zm-1.38 1.38l-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16A5.5 5.5 0 0115 9.2l.75-.74-4.2-4.21zm-.47 7.2a2 2 0 01-1.43 2.47l-.46.12a4.7 4.7 0 000 1.02l.35.08A2 2 0 0111 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0116 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55zm2.43 4.05a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const EditSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditSettingsFilledIcon({}), 'EditSettingsFilled');

const EditSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.18 2.93a2.97 2.97 0 00-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 00.6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16c-.11-.39-.18-.8-.2-1.21l-.95.94c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l7.99-8 2.8 2.8L13.78 9c.41.02.82.09 1.21.2l2.13-2.13a2.97 2.97 0 00.05-4.15zm-3.55.65a1.97 1.97 0 012.79 2.8l-.67.66-2.8-2.79.68-.67zm-2.56 7.86a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 000 1.02l.35.08A2 2 0 0111 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0116 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const EditSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditSettingsRegularIcon({}), 'EditSettingsRegular');

const EmojiFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zM7.15 12.43a.5.5 0 10-.7.7 5.01 5.01 0 006.9.2l.2-.2.06-.07a.5.5 0 00-.7-.7l-.06.07-.18.17a4.01 4.01 0 01-5.52-.17zM12.5 7.5a1 1 0 100 2 1 1 0 000-2zm-5 0a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }));
};

export const EmojiFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiFilledIcon({}), 'EmojiFilled');

const EmojiRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm-2.85 9.43a4.01 4.01 0 005.52.17l.18-.17a.5.5 0 01.76.63l-.06.07-.02.02a5.01 5.01 0 01-7.08-.02.5.5 0 01.7-.7zM12.5 7.5a1 1 0 110 2 1 1 0 010-2zm-5 0a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const EmojiRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiRegularIcon({}), 'EmojiRegular');

const EmojiAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 1a8 8 0 017.98 8.59 5.48 5.48 0 00-7.64 3 4 4 0 01-3.19-1.16.5.5 0 10-.7.7 5 5 0 003.62 1.48 5.54 5.54 0 00.52 3.37L9 17A8 8 0 119 1zm2.5 5.5a1 1 0 100 2 1 1 0 000-2zm-5 0a1 1 0 100 2 1 1 0 000-2zm12.5 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const EmojiAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiAddFilledIcon({}), 'EmojiAddFilled');

const EmojiAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 1a8 8 0 017.98 8.59A5.46 5.46 0 0016 9.2V9a7 7 0 10-6.8 7c.1.34.23.67.39.98L9 17A8 8 0 119 1zM6.15 11.43a4 4 0 003.19 1.17l-.03.06c-.1.3-.19.62-.24.95a5 5 0 01-3.62-1.48.5.5 0 01.7-.7zM11.5 6.5a1 1 0 110 2 1 1 0 010-2zm-5 0a1 1 0 110 2 1 1 0 010-2zm12.5 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const EmojiAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiAddRegularIcon({}), 'EmojiAddRegular');

const EmojiAngryFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6.5-1.5a.5.5 0 00.26-.93l-2.5-1.5a.5.5 0 00-.52.86l1.22.73a1 1 0 101.54.84zm5 0a1 1 0 00-.46-.84l1.22-.73a.5.5 0 00-.52-.86l-2.5 1.5a.5.5 0 00.26.93 1 1 0 102 0zm.06 4.89c.34-.3.07-.72.06-.73a2.05 2.05 0 00-.23-.23 4.06 4.06 0 00-.67-.49 5.3 5.3 0 00-2.72-.69 5.3 5.3 0 00-2.72.7 4.08 4.08 0 00-.9.7c-.18.23-.17.55.06.74a.5.5 0 00.7-.07l.02-.03c.03-.03.06-.07.12-.11.1-.1.27-.24.5-.37a4.31 4.31 0 012.22-.56 4.3 4.3 0 012.22.56 3.07 3.07 0 01.64.5c.18.22.5.27.7.08z",
    fill: primaryFill
  }));
};

export const EmojiAngryFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiAngryFilledIcon({}), 'EmojiAngryFilled');

const EmojiAngryRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 8.5a1 1 0 11-1.54-.84l-1.22-.73a.5.5 0 01.52-.86l2.5 1.5a.5.5 0 01-.26.93zm5 0a1 1 0 11-2 0 .5.5 0 01-.26-.93l2.5-1.5a.5.5 0 01.52.86l-1.22.73a1 1 0 01.46.84zm.06 4.89a.5.5 0 01-.7-.07A4.3 4.3 0 0010 12.25c-1.02-.01-1.75.27-2.21.55a3.09 3.09 0 00-.65.5.5.5 0 01-.78-.62l.39.31-.39-.31v-.01l.02-.02a1.78 1.78 0 01.23-.23c.15-.13.37-.31.67-.49.6-.35 1.5-.69 2.72-.69a5.3 5.3 0 012.72.7 4.06 4.06 0 01.9.71l.01.02h.01l-.39.32.39-.31a.5.5 0 01-.08.7zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const EmojiAngryRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiAngryRegularIcon({}), 'EmojiAngryRegular');

const EmojiEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 017.95 7.12 2.87 2.87 0 00-2.85.72l-3.38 3.39c-1.5.7-3.33.44-4.57-.8a.5.5 0 10-.7.7 5 5 0 003.9 1.47l-.08.07c-.4.41-.7.92-.84 1.49l-.37 1.5c-.03.09-.04.18-.05.28A8 8 0 0110 2zm2.5 5.5a1 1 0 100 2 1 1 0 000-2zm-5 0a1 1 0 100 2 1 1 0 000-2zm3.48 7.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const EmojiEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiEditFilledIcon({}), 'EmojiEditFilled');

const EmojiEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 017.95 7.12c-.33-.1-.68-.14-1.02-.11a7 7 0 10-7.7 7.95l-.17.7c-.03.09-.04.18-.05.28A8 8 0 0110 2zM7.15 12.43a4.01 4.01 0 004.57.8l-1.38 1.37a5 5 0 01-3.9-1.47.5.5 0 01.71-.7zM12.5 7.5a1 1 0 110 2 1 1 0 010-2zm-5 0a1 1 0 110 2 1 1 0 010-2zm3.48 7.88l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const EmojiEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiEditRegularIcon({}), 'EmojiEditRegular');

const EmojiHandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 1c.28 0 .5.22.5.5v5a.5.5 0 001 0v-4a.5.5 0 011 0v4.25l.31-.06c.32-.04.7-.02 1.07.14.38.16.74.44 1.04.9a.5.5 0 01-.22.73 5.26 5.26 0 00-2.71 2.37C6.94 11.86 5.89 13 4.5 13h-.26A2.5 2.5 0 012 11.62l-.63-1.26A3.5 3.5 0 011 8.79V2.5a.5.5 0 011 0v4a.5.5 0 001 0v-5a.5.5 0 011 0v5a.5.5 0 001 0v-5c0-.28.22-.5.5-.5zm2.87 10.3c-.28.54-.74 1.18-1.35 1.7a5.5 5.5 0 104.21-5.85l.02.02a1.5 1.5 0 01-.66 2.2 4.27 4.27 0 00-2.22 1.92zm2.38 1.2a.75.75 0 110-1.5.75.75 0 010 1.5zm4.25-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-4.05 2.53c.08.17.55.72 1.55.72s1.47-.55 1.55-.72a.5.5 0 11.9.44c-.25.5-1.05 1.28-2.45 1.28-1.4 0-2.2-.78-2.45-1.28a.5.5 0 11.9-.44z",
    fill: primaryFill
  }));
};

export const EmojiHandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiHandFilledIcon({}), 'EmojiHandFilled');

const EmojiHandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 1c-.65 0-1.2.42-1.41 1H3a2 2 0 00-2 2v4.8c0 .54.13 1.07.37 1.56L2 11.62A2.5 2.5 0 004.24 13h1.82a3.1 3.1 0 002.52-1.5 8.04 8.04 0 013.62-3.04.5.5 0 00.29-.58 2.17 2.17 0 00-.8-1.28 1.9 1.9 0 00-1.13-.35c-.2 0-.4.03-.56.06V4a2 2 0 00-2-2h-.09c-.2-.58-.76-1-1.41-1h-2zm0 1H5v4.5a.5.5 0 001 0V2h.5c.28 0 .5.22.5.5v4a.5.5 0 101 0V3a1 1 0 011 1v3a.5.5 0 00.72.45h.01a1.51 1.51 0 01.24-.1 2 2 0 01.6-.1c.2 0 .39.05.53.15.1.07.19.17.28.34-1.87.9-3 2.22-3.64 3.21-.4.63-1.04 1.05-1.68 1.05H4.24a1.5 1.5 0 01-1.35-.83l-.63-1.26A2.5 2.5 0 012 8.79V4a1 1 0 011-1v3.5a.5.5 0 101 0v-4c0-.28.22-.5.5-.5zm8.76 5.05a5.5 5.5 0 11-6.1 6.78c.33-.11.64-.27.93-.45a4.5 4.5 0 105.4-5.27c.02-.16 0-.32-.03-.47-.06-.2-.12-.4-.2-.59zm-2.51 5.45a.75.75 0 100-1.5.75.75 0 000 1.5zm4.25-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-4.05 2.53a.5.5 0 10-.9.44c.25.5 1.05 1.28 2.45 1.28 1.4 0 2.2-.78 2.45-1.28a.5.5 0 10-.9-.44c-.08.17-.55.72-1.55.72s-1.47-.55-1.55-.72zm-9.58-3.92l.45-.23z",
    fill: primaryFill
  }));
};

export const EmojiHandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiHandRegularIcon({}), 'EmojiHandRegular');

const EmojiLaughFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zM6.5 8.08a.5.5 0 11-1-.16c.13-.83.9-1.42 1.75-1.42s1.61.59 1.74 1.42a.5.5 0 11-.99.16c-.04-.3-.34-.58-.75-.58-.42 0-.71.28-.76.58zm5.5 0a.5.5 0 01-1-.16c.13-.83.9-1.42 1.75-1.42s1.61.59 1.74 1.42a.5.5 0 01-.99.16c-.04-.3-.34-.58-.75-.58-.42 0-.71.28-.76.58zM5.5 10.5h9c-.22 2.2-1.93 4-4.5 4a4.36 4.36 0 01-4.5-4z",
    fill: primaryFill
  }));
};

export const EmojiLaughFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiLaughFilledIcon({}), 'EmojiLaughFilled');

const EmojiLaughRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 8.08c.04-.3.33-.58.75-.58.41 0 .7.28.75.58A.5.5 0 109 7.92 1.73 1.73 0 007.25 6.5c-.86 0-1.62.59-1.74 1.42a.5.5 0 10.98.16zm6.25-.58c-.42 0-.71.28-.76.58a.5.5 0 01-.98-.16c.12-.83.88-1.42 1.74-1.42.85 0 1.61.59 1.74 1.42a.5.5 0 01-.99.16c-.04-.3-.34-.58-.75-.58zM5.5 10a.5.5 0 00-.5.55A4.86 4.86 0 0010 15c2.84 0 4.75-2 5-4.45a.5.5 0 00-.5-.55h-9zm4.5 4a3.85 3.85 0 01-3.92-3h7.83c-.4 1.7-1.83 3-3.91 3zm0-12a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const EmojiLaughRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiLaughRegularIcon({}), 'EmojiLaughRegular');

const EmojiMehFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6.5-1.5a1 1 0 10-2 0 1 1 0 002 0zm4 1a1 1 0 100-2 1 1 0 000 2zm-6.5 3c0 .28.22.5.5.5h7a.5.5 0 000-1h-7a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const EmojiMehFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiMehFilledIcon({}), 'EmojiMehFilled');

const EmojiMehRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9.5a1 1 0 100-2 1 1 0 000 2zm6-1a1 1 0 11-2 0 1 1 0 012 0zm-7 3.5a.5.5 0 000 1h7a.5.5 0 000-1h-7zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const EmojiMehRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiMehRegularIcon({}), 'EmojiMehRegular');

const EmojiMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a5 5 0 004.03 4.9 6.48 6.48 0 011.66-3.78 2 2 0 00-2.21.58.5.5 0 11-.76-.65 3 3 0 013.76-.66 6.47 6.47 0 013.43-1.36A5 5 0 002 7zm4.25-1.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm3 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm8.75 7a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-6.75-1a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm3.86 2.57a.5.5 0 00-.71.05 2.5 2.5 0 01-3.8 0 .5.5 0 10-.76.66 3.5 3.5 0 005.32 0 .5.5 0 00-.05-.71zm-.61-1.82a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const EmojiMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiMultipleFilledIcon({}), 'EmojiMultipleFilled');

const EmojiMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2a5 5 0 014.9 4.03c-.33.03-.66.08-.98.16a4 4 0 10-4.73 4.73c-.08.32-.13.65-.16.99A5 5 0 017 2zm.7 6.12c.24-.26.5-.5.78-.73a3 3 0 00-3.76.66.5.5 0 10.76.65 2 2 0 012.21-.58zM6.24 5.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm3 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm1.25 6.75a.75.75 0 100-1.5.75.75 0 000 1.5zm4.6 1.82c.21.18.24.5.06.7a3.5 3.5 0 01-5.32.01.5.5 0 11.76-.65 2.5 2.5 0 003.8 0 .5.5 0 01.7-.06zm-.6-1.82a.75.75 0 100-1.5.75.75 0 000 1.5zm-2 5.75a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-1a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
    fill: primaryFill
  }));
};

export const EmojiMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiMultipleRegularIcon({}), 'EmojiMultipleRegular');

const EmojiSadFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm5.5-.5a1 1 0 100-2 1 1 0 000 2zm6-1a1 1 0 10-2 0 1 1 0 002 0zm.06 4.89c.38-.35.07-.72.06-.73a2.02 2.02 0 00-.23-.23 4.06 4.06 0 00-.67-.49 5.3 5.3 0 00-2.72-.69 5.3 5.3 0 00-2.72.7 4.08 4.08 0 00-.9.7l-.01.03h-.01l.39.32-.39-.31a.5.5 0 00.78.63l.02-.03c.03-.03.06-.07.12-.11.1-.1.27-.24.5-.37a4.31 4.31 0 012.22-.56 4.3 4.3 0 012.22.56 3.07 3.07 0 01.64.5.5.5 0 00.7.08z",
    fill: primaryFill
  }));
};

export const EmojiSadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSadFilledIcon({}), 'EmojiSadFilled');

const EmojiSadRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9.5a1 1 0 100-2 1 1 0 000 2zm6-1a1 1 0 11-2 0 1 1 0 012 0zm.06 4.89a.5.5 0 01-.7-.07A4.3 4.3 0 0010 12.25c-1.02-.01-1.75.27-2.21.55a3.09 3.09 0 00-.65.5.5.5 0 01-.78-.62l.39.31-.39-.31v-.01l.02-.02a2.07 2.07 0 01.23-.23c.15-.13.37-.31.67-.49.6-.35 1.5-.69 2.72-.69a5.3 5.3 0 012.72.7 4.06 4.06 0 01.9.71l.01.02h.01l-.39.32.39-.31a.5.5 0 01-.08.7zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const EmojiSadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSadRegularIcon({}), 'EmojiSadRegular');

const EmojiSadSlightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zM8.5 8.5a1 1 0 11-2 0 1 1 0 012 0zm4-1a1 1 0 110 2 1 1 0 010-2zm.3 4.5h.8a.5.5 0 010 1h-.8c-1.07 0-2.13.32-3.02.92a.5.5 0 11-.56-.84A6.45 6.45 0 0112.8 12z",
    fill: primaryFill
  }));
};

export const EmojiSadSlightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSadSlightFilledIcon({}), 'EmojiSadSlightFilled');

const EmojiSadSlightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 8.5a1 1 0 11-2 0 1 1 0 012 0zm4 1a1 1 0 100-2 1 1 0 000 2zm.3 2.5c-1.27 0-2.52.38-3.58 1.08a.5.5 0 00.56.84c.9-.6 1.95-.92 3.02-.92h.8a.5.5 0 000-1h-.8zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const EmojiSadSlightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSadSlightRegularIcon({}), 'EmojiSadSlightRegular');

const EmojiSmileSlightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zM8.5 8.5a1 1 0 11-2 0 1 1 0 012 0zm4-1a1 1 0 110 2 1 1 0 010-2zm-4.03 5.55c.42.21.97.32 1.53.32a3.5 3.5 0 001.53-.32.5.5 0 11.44.9c-.58.29-1.28.43-1.97.43s-1.39-.14-1.97-.43a.5.5 0 11.44-.9z",
    fill: primaryFill
  }));
};

export const EmojiSmileSlightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSmileSlightFilledIcon({}), 'EmojiSmileSlightFilled');

const EmojiSmileSlightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 8.5a1 1 0 10-2 0 1 1 0 002 0zm-5 0a1 1 0 10-2 0 1 1 0 002 0zm-.03 4.55a.5.5 0 10-.44.9c.58.29 1.28.43 1.97.43s1.39-.14 1.97-.43a.5.5 0 10-.44-.9c-.42.21-.97.32-1.53.32a3.5 3.5 0 01-1.53-.32zM18 10a8 8 0 10-16 0 8 8 0 0016 0zM3 10a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const EmojiSmileSlightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSmileSlightRegularIcon({}), 'EmojiSmileSlightRegular');

const EmojiSparkleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.01.04-.01.01-.23.7-.1.32a.42.42 0 01-.16.2.42.42 0 01-.64-.2l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-.64-.22-.43-.13a.42.42 0 01-.28-.4.42.42 0 01.28-.4l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0zm4.9 7.93l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 00-.15.11.3.3 0 00.15.46l.77.25a1.58 1.58 0 011 1l.24.77a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02zM10 18a8 8 0 007.75-6.02 1.3 1.3 0 01-1.48-.87l-.25-.76a.57.57 0 00-.36-.36l-.79-.26a1.3 1.3 0 01-.75-1.78 1.4 1.4 0 01-.44-.21l-.04-.03-.03-.02c-.21-.17-.37-.4-.46-.66l-.34-1.07a1.2 1.2 0 00-.76-.76l-1.1-.36a1.42 1.42 0 01.02-2.7l.2-.06A8 8 0 1010 18zm-3.55-5.57c.2-.2.51-.2.7 0a4.01 4.01 0 005.52.17l.18-.17.06-.06a.5.5 0 01.7.7l-.06.06-.2.2a5.01 5.01 0 01-6.9-.2.5.5 0 010-.7zM11.5 8.5a1 1 0 112 0 1 1 0 01-2 0zm-5 0a1 1 0 112 0 1 1 0 01-2 0z",
    fill: primaryFill
  }));
};

export const EmojiSparkleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSparkleFilledIcon({}), 'EmojiSparkleFilled');

const EmojiSparkleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.35 1.07a.42.42 0 01-.8 0l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-1.07-.35a.42.42 0 010-.8l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0zm4.9 7.93l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 000 .57l.77.25a1.58 1.58 0 011 1l.03.1.21.67a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02zM17.3 12a1.3 1.3 0 01-.53-.21A7 7 0 1110.1 3a1.42 1.42 0 01.88-.85l.2-.07a8 8 0 106.59 9.9c-.15.03-.3.03-.46 0zm-4.63.6a4.01 4.01 0 01-5.52-.16.5.5 0 10-.7.7 5.01 5.01 0 007.08.02l.02-.02.06-.07a.5.5 0 00-.76-.63l-.18.17zm.83-4.09a1 1 0 10-2 0 1 1 0 002 0zm-5 0a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const EmojiSparkleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSparkleRegularIcon({}), 'EmojiSparkleRegular');

const EmojiSurpriseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm5.5-.5a1 1 0 100-2 1 1 0 000 2zm4.25 3a1.75 1.75 0 10-3.5 0 1.75 1.75 0 003.5 0zm.75-3a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const EmojiSurpriseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSurpriseFilledIcon({}), 'EmojiSurpriseFilled');

const EmojiSurpriseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9.5a1 1 0 100-2 1 1 0 000 2zm4.25 3a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm.75-3a1 1 0 100-2 1 1 0 000 2zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const EmojiSurpriseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EmojiSurpriseRegularIcon({}), 'EmojiSurpriseRegular');

const EngineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 2.5c.28 0 .5.22.5.5v1h2V3a.5.5 0 011 0v1h2.2a1 1 0 01.89.55L14.8 6H16a2 2 0 012 2v5a2 2 0 01-2 2h-1.2l-.71 1.45a1 1 0 01-.9.55H7.71a1 1 0 01-.71-.3l-2.41-2.4A2 2 0 014 12.87V10H3v2.5a.5.5 0 01-1 0v-6a.5.5 0 011 0V9h1V6c0-1.1.9-2 2-2h1V3c0-.28.22-.5.5-.5zm0 4.5a.5.5 0 00-.5.5V10c0 1.1.9 2 2 2h5.5a.5.5 0 000-1H11V7.5a.5.5 0 00-1 0V11H9a1 1 0 01-1-1V7.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const EngineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EngineFilledIcon({}), 'EngineFilled');

const EngineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 3a.5.5 0 00-1 0v1H6a2 2 0 00-2 2v3H3V6.5a.5.5 0 00-1 0v6a.5.5 0 001 0V10h1v2.88a2 2 0 00.59 1.41L7 16.71a1 1 0 00.7.29h5.5a1 1 0 00.89-.55L14.8 15H16a2 2 0 002-2V8a2 2 0 00-2-2h-1.2l-.71-1.45a1 1 0 00-.9-.55H11V3a.5.5 0 00-1 0v1H8V3zM6 5h7.2l.71 1.45a1 1 0 00.9.55H16a1 1 0 011 1v5a1 1 0 01-1 1h-1.2a1 1 0 00-.89.55L13.2 16H7.71l-2.42-2.41a1 1 0 01-.29-.71V6a1 1 0 011-1zm1.5 2c.28 0 .5.22.5.5V10a1 1 0 001 1h1V7.5a.5.5 0 011 0V11h3.5a.5.5 0 010 1H9a2 2 0 01-2-2V7.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const EngineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EngineRegularIcon({}), 'EngineRegular');

const EqualCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm3.5 7a.5.5 0 000-1h-7a.5.5 0 000 1h7zm0 3a.5.5 0 000-1h-7a.5.5 0 000 1h7z",
    fill: primaryFill
  }));
};

export const EqualCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EqualCircleFilledIcon({}), 'EqualCircleFilled');

const EqualCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 9a.5.5 0 000-1h-7a.5.5 0 000 1h7zm0 3a.5.5 0 000-1h-7a.5.5 0 000 1h7zm4.5-2a8 8 0 10-16 0 8 8 0 0016 0zm-8-7a7 7 0 110 14 7 7 0 010-14z",
    fill: primaryFill
  }));
};

export const EqualCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EqualCircleRegularIcon({}), 'EqualCircleRegular');

const EqualOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.79 6.5H3.75a.75.75 0 000 1.5h3.54l3.5 3.5H3.75a.75.75 0 000 1.5h8.54l4.86 4.85a.5.5 0 00.7-.7l-15-15zm10.77 9.35l1.5 1.5h1.13a.75.75 0 000-1.5h-2.63zm-5-5l1.5 1.5h6.13a.75.75 0 000-1.5H8.62z",
    fill: primaryFill
  }));
};

export const EqualOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EqualOffFilledIcon({}), 'EqualOffFilled');

const EqualOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L6.29 7H3.5a.5.5 0 000 1h3.8l4 4H3.5a.5.5 0 000 1h8.8l4.85 4.85a.5.5 0 00.7-.7l-15-15zM14.12 12l1 1h1.38a.5.5 0 000-1h-2.38zm-5-5l1 1h6.38a.5.5 0 000-1H9.12z",
    fill: primaryFill
  }));
};

export const EqualOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EqualOffRegularIcon({}), 'EqualOffRegular');

const EraserFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.2 2.44a1.5 1.5 0 012.12 0l4.24 4.24a1.5 1.5 0 010 2.12L9.36 17h5.14a.5.5 0 010 1H7.82a1.5 1.5 0 01-1.14-.44l-4.24-4.24a1.5 1.5 0 010-2.12l8.76-8.76zM9.78 15.17l-4.95-4.95-1.69 1.69a.5.5 0 000 .7l4.25 4.25c.2.2.5.2.7 0l1.7-1.7z",
    fill: primaryFill
  }));
};

export const EraserFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserFilledIcon({}), 'EraserFilled');

const EraserRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.2 2.44a1.5 1.5 0 012.12 0l4.24 4.24a1.5 1.5 0 010 2.12L9.36 17h5.14a.5.5 0 010 1H7.82a1.5 1.5 0 01-1.14-.44l-4.24-4.24a1.5 1.5 0 010-2.12l8.76-8.76zm1.41.7a.5.5 0 00-.7 0L5.53 9.52l4.95 4.95 6.36-6.36a.5.5 0 000-.71l-4.24-4.24zM9.78 15.18l-4.95-4.95-1.69 1.69a.5.5 0 000 .7l4.25 4.25c.2.2.5.2.7 0l1.7-1.7z",
    fill: primaryFill
  }));
};

export const EraserRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserRegularIcon({}), 'EraserRegular');

const EraserMediumFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.44 11.2a1.5 1.5 0 000 2.12l4.24 4.24a1.5 1.5 0 002.12 0l.72-.72a5.46 5.46 0 01-.37-1.04L8.1 16.86a.5.5 0 01-.71 0L3.15 12.6a.5.5 0 010-.7l1.69-1.7L9 14.39a5.5 5.5 0 017.84-4.86l.72-.72a1.5 1.5 0 000-2.12l-4.24-4.24a1.5 1.5 0 00-2.12 0L2.44 11.2zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: primaryFill
  }));
};

export const EraserMediumFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserMediumFilledIcon({}), 'EraserMediumFilled');

const EraserMediumRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.44 11.2a1.5 1.5 0 000 2.12l4.24 4.24a1.5 1.5 0 002.12 0l.72-.72a5.46 5.46 0 01-.37-1.04L8.1 16.86a.5.5 0 01-.71 0L3.15 12.6a.5.5 0 010-.7l1.69-1.7L9 14.39c.01-.43.07-.84.17-1.24L5.54 9.5l6.37-6.36c.2-.2.5-.2.7 0l4.25 4.24c.2.2.2.51 0 .7L15.8 9.16c.36.1.71.22 1.04.37l.72-.72a1.5 1.5 0 000-2.12l-4.24-4.24a1.5 1.5 0 00-2.12 0L2.44 11.2zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: primaryFill
  }));
};

export const EraserMediumRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserMediumRegularIcon({}), 'EraserMediumRegular');

const EraserSegmentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.32 2.44a1.5 1.5 0 00-2.12 0L2.44 11.2a1.5 1.5 0 000 2.12l4.24 4.24c.31.32.73.46 1.14.44h6.27a1.5 1.5 0 100-1H9.36l8.2-8.2a1.5 1.5 0 000-2.12l-4.24-4.24zm-8.49 7.78l4.95 4.95-1.69 1.69a.5.5 0 01-.7 0L3.14 12.6a.5.5 0 010-.7l1.7-1.7z",
    fill: primaryFill
  }));
};

export const EraserSegmentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserSegmentFilledIcon({}), 'EraserSegmentFilled');

const EraserSegmentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.32 2.44a1.5 1.5 0 00-2.12 0L2.44 11.2a1.5 1.5 0 000 2.12l4.24 4.24c.31.32.73.46 1.14.44h6.27a1.5 1.5 0 100-1H9.36l8.2-8.2a1.5 1.5 0 000-2.12l-4.24-4.24zm-1.42.7c.2-.19.52-.19.71 0l4.24 4.25c.2.2.2.51 0 .7l-6.36 6.37-4.95-4.95 6.36-6.36zm-7.07 7.08l4.95 4.95-1.69 1.69a.5.5 0 01-.7 0L3.14 12.6a.5.5 0 010-.7l1.7-1.7z",
    fill: primaryFill
  }));
};

export const EraserSegmentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserSegmentRegularIcon({}), 'EraserSegmentRegular');

const EraserSmallFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.44 11.2a1.5 1.5 0 000 2.12l4.24 4.24a1.5 1.5 0 002.12 0l2.22-2.2a4 4 0 014.34-4.34l2.2-2.22a1.5 1.5 0 000-2.12l-4.24-4.24a1.5 1.5 0 00-2.12 0L2.44 11.2zm.7 1.41a.5.5 0 010-.7l1.7-1.7 4.95 4.96-1.7 1.69a.5.5 0 01-.7 0L3.15 12.6zM15 18a3 3 0 100-6 3 3 0 000 6z",
    fill: primaryFill
  }));
};

export const EraserSmallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserSmallFilledIcon({}), 'EraserSmallFilled');

const EraserSmallRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.44 11.2a1.5 1.5 0 000 2.12l4.24 4.24a1.5 1.5 0 002.12 0l2.22-2.2a4.06 4.06 0 01.18-1.6l-.7.7-4.96-4.95 6.37-6.36c.2-.2.5-.2.7 0l4.25 4.24c.2.2.2.51 0 .7l-3.1 3.1a4 4 0 011.6-.17l2.2-2.22a1.5 1.5 0 000-2.12l-4.24-4.24a1.5 1.5 0 00-2.12 0L2.44 11.2zm.7 1.41a.5.5 0 010-.7l1.7-1.7 4.95 4.96-1.7 1.69a.5.5 0 01-.7 0L3.15 12.6zM15 18a3 3 0 100-6 3 3 0 000 6z",
    fill: primaryFill
  }));
};

export const EraserSmallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserSmallRegularIcon({}), 'EraserSmallRegular');

const EraserToolFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 2.5a.5.5 0 00-1 0v12A3.5 3.5 0 006.5 18h7a3.5 3.5 0 003.5-3.5v-12a.5.5 0 00-1 0V6H4V2.5zM4 10V7h12v3H4z",
    fill: primaryFill
  }));
};

export const EraserToolFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserToolFilledIcon({}), 'EraserToolFilled');

const EraserToolRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2c.28 0 .5.22.5.5V6h12V2.5a.5.5 0 011 0v12a3.5 3.5 0 01-3.5 3.5h-7A3.5 3.5 0 013 14.5v-12c0-.28.22-.5.5-.5zm.5 9v3.5A2.5 2.5 0 006.5 17h7a2.5 2.5 0 002.5-2.5V11H4zm12-1V7H4v3h12z",
    fill: primaryFill
  }));
};

export const EraserToolRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EraserToolRegularIcon({}), 'EraserToolRegular');

const ErrorCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 10.5a.75.75 0 100 1.5.75.75 0 000-1.5zM10 6a.5.5 0 00-.5.41v4.68a.5.5 0 001 0V6.41A.5.5 0 0010 6z",
    fill: primaryFill
  }));
};

export const ErrorCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ErrorCircleFilledIcon({}), 'ErrorCircleFilled');

const ErrorCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm0 9.5a.75.75 0 110 1.5.75.75 0 010-1.5zM10 6a.5.5 0 01.5.41V11a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const ErrorCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ErrorCircleRegularIcon({}), 'ErrorCircleRegular');

const ErrorCircleSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 10-7.41 7.98 5.48 5.48 0 01-.37-4.01.75.75 0 11.44-1.08 5.5 5.5 0 017.32-2.3L18 10zM9.5 6.41a.5.5 0 011 0v4.68a.5.5 0 01-1 0V6.41zm2.14 8.51a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const ErrorCircleSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ErrorCircleSettingsFilledIcon({}), 'ErrorCircleSettingsFilled');

const ErrorCircleSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 10-7.41 7.98 5.46 5.46 0 01-.38-.98H10a7 7 0 117-6.8c.34.1.67.23.98.39L18 10zm-7.34 2.89a.75.75 0 10-.44 1.08c.1-.38.25-.74.44-1.08zm-.17-6.48a.5.5 0 00-.99.09v4.59a.5.5 0 001-.09V6.41zm1.15 8.51a2 2 0 001.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.71 4.71 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const ErrorCircleSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ErrorCircleSettingsRegularIcon({}), 'ErrorCircleSettingsRegular');

const ExpandUpLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 4a2 2 0 012 2v4h-4a2 2 0 00-2 2v4H6a2 2 0 01-2-2v-2.5a.5.5 0 00-1 0V14a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3h-2.5a.5.5 0 000 1H14zm-5-.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v5a.5.5 0 001 0V4.7l4.15 4.15a.5.5 0 10.7-.7L4.71 4H8.5a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const ExpandUpLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExpandUpLeftFilledIcon({}), 'ExpandUpLeftFilled');

const ExpandUpLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 6a2 2 0 00-2-2h-2.5a.5.5 0 010-1H14a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-2.5a.5.5 0 011 0V14c0 1.1.9 2 2 2h4v-4c0-1.1.9-2 2-2h4V6zm-4 5a1 1 0 00-1 1v4h3a2 2 0 002-2v-3h-4zM9 3.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v5a.5.5 0 001 0V4.7l4.15 4.15a.5.5 0 10.7-.7L4.71 4H8.5a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const ExpandUpLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExpandUpLeftRegularIcon({}), 'ExpandUpLeftRegular');

const ExpandUpRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v4h4a2 2 0 012 2v4h4a2 2 0 002-2v-2.5a.5.5 0 011 0V14a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3h2.5a.5.5 0 010 1H6zm5-.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0V4.7l-4.15 4.15a.5.5 0 01-.7-.7L15.29 4H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ExpandUpRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExpandUpRightFilledIcon({}), 'ExpandUpRightFilled');

const ExpandUpRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 6c0-1.1.9-2 2-2h2.5a.5.5 0 000-1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-2.5a.5.5 0 00-1 0V14a2 2 0 01-2 2h-4v-4a2 2 0 00-2-2H4V6zm0 5h4a1 1 0 011 1v4H6a2 2 0 01-2-2v-3zm7-7.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0V4.7l-4.15 4.15a.5.5 0 01-.7-.7L15.29 4H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const ExpandUpRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExpandUpRightRegularIcon({}), 'ExpandUpRightRegular');

const ExtendedDockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.35 4.15a.5.5 0 00-.7 0l-3 3a.5.5 0 10.7.7L10 5.21l2.65 2.64a.5.5 0 00.7-.7l-3-3zM3 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H3zm6 0c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H9zm4.5 1.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-2z",
    fill: primaryFill
  }));
};

export const ExtendedDockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExtendedDockFilledIcon({}), 'ExtendedDockFilled');

const ExtendedDockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.35 4.15a.5.5 0 00-.7 0l-3 3a.5.5 0 10.7.7L10 5.21l2.65 2.64a.5.5 0 00.7-.7l-3-3zM3 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H3zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5v-2zM9 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H9zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5v-2zm5 0c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-2zM15 11a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2z",
    fill: primaryFill
  }));
};

export const ExtendedDockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExtendedDockRegularIcon({}), 'ExtendedDockRegular');

const EyeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.26 11.6A6.97 6.97 0 0110 6c3.2 0 6.06 2.33 6.74 5.6a.5.5 0 00.98-.2A7.97 7.97 0 0010 5a7.97 7.97 0 00-7.72 6.4.5.5 0 00.98.2zM9.99 8a3.5 3.5 0 110 7 3.5 3.5 0 010-7z",
    fill: primaryFill
  }));
};

export const EyeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeFilledIcon({}), 'EyeFilled');

const EyeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.26 11.6A6.97 6.97 0 0110 6c3.2 0 6.06 2.33 6.74 5.6a.5.5 0 00.98-.2A7.97 7.97 0 0010 5a7.97 7.97 0 00-7.72 6.4.5.5 0 00.98.2zM10 8a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm-2.5 3.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z",
    fill: primaryFill
  }));
};

export const EyeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeRegularIcon({}), 'EyeRegular');

const EyeOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l3.5 3.5a8.1 8.1 0 00-3.37 5.05.5.5 0 10.98.2 7.09 7.09 0 013.1-4.53l1.59 1.59a3.5 3.5 0 104.88 4.88l4.32 4.31a.5.5 0 00.7-.7l-15-15zM10.12 8l3.37 3.37A3.5 3.5 0 0010.12 8zM7.53 5.41l.8.8C8.87 6.07 9.43 6 10 6c3.2 0 6.06 2.33 6.74 5.6a.5.5 0 10.98-.2A7.97 7.97 0 0010 5c-.86 0-1.69.14-2.47.41z",
    fill: primaryFill
  }));
};

export const EyeOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeOffFilledIcon({}), 'EyeOffFilled');

const EyeOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l3.5 3.5a8.1 8.1 0 00-3.37 5.05.5.5 0 10.98.2 7.09 7.09 0 013.1-4.53l1.6 1.59a3.5 3.5 0 104.88 4.89l4.3 4.3a.5.5 0 00.71-.7l-15-15zm9.27 10.68a2.5 2.5 0 11-3.45-3.45l3.45 3.45zm-2-4.83l3.38 3.38A3.5 3.5 0 0010.12 8zM10 6c-.57 0-1.13.07-1.67.21l-.8-.8A7.65 7.65 0 0110 5c3.7 0 6.94 2.67 7.72 6.4a.5.5 0 01-.98.2A6.97 6.97 0 0010 6z",
    fill: primaryFill
  }));
};

export const EyeOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeOffRegularIcon({}), 'EyeOffRegular');

const EyeTrackingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v3a.5.5 0 01-1 0v-3A2.5 2.5 0 014.5 2h3a.5.5 0 010 1h-3zm0 14A1.5 1.5 0 013 15.5v-3a.5.5 0 00-1 0v3A2.5 2.5 0 004.5 18h3a.5.5 0 000-1h-3zM17 4.5c0-.83-.67-1.5-1.5-1.5h-3a.5.5 0 010-1h3A2.5 2.5 0 0118 4.5v3a.5.5 0 01-1 0v-3zM15.5 17c.83 0 1.5-.67 1.5-1.5v-3a.5.5 0 011 0v3a2.5 2.5 0 01-2.5 2.5h-3a.5.5 0 010-1h3zM7 11.5a3 3 0 116 0 3 3 0 01-6 0zM4.95 9.72a.5.5 0 01-.9-.44l.45.22-.45-.22v-.01l.01-.01a2.1 2.1 0 01.08-.14l.25-.38A6.85 6.85 0 0110 6a6.85 6.85 0 015.62 2.74 5.13 5.13 0 01.33.52v.01l-.44.23.45-.22a.5.5 0 01-.9.45V9.7a2.5 2.5 0 00-.25-.39A5.86 5.86 0 0010 7a5.86 5.86 0 00-4.8 2.32 4.14 4.14 0 00-.24.39l-.01.01z",
    fill: primaryFill
  }));
};

export const EyeTrackingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingFilledIcon({}), 'EyeTrackingFilled');

const EyeTrackingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h3a.5.5 0 000-1h-3A2.5 2.5 0 002 4.5v3a.5.5 0 001 0v-3zm0 11c0 .83.67 1.5 1.5 1.5h3a.5.5 0 010 1h-3A2.5 2.5 0 012 15.5v-3a.5.5 0 011 0v3zM15.5 3c.83 0 1.5.67 1.5 1.5v3a.5.5 0 001 0v-3A2.5 2.5 0 0015.5 2h-3a.5.5 0 000 1h3zM17 15.5c0 .83-.67 1.5-1.5 1.5h-3a.5.5 0 000 1h3a2.5 2.5 0 002.5-2.5v-3a.5.5 0 00-1 0v3zm-10-4a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4zm-5.05.22a.5.5 0 01-.9-.44l.45.22-.45-.22v-.01l.01-.01a2.1 2.1 0 01.08-.14l.25-.38A6.85 6.85 0 0110 6a6.85 6.85 0 015.62 2.74 5.13 5.13 0 01.33.52v.01l-.44.23.45-.22a.5.5 0 01-.9.45V9.7a2.5 2.5 0 00-.25-.39A5.86 5.86 0 0010 7a5.86 5.86 0 00-4.8 2.32 4.14 4.14 0 00-.24.39l-.01.01z",
    fill: primaryFill
  }));
};

export const EyeTrackingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingRegularIcon({}), 'EyeTrackingRegular');

const EyeTrackingOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v3a.5.5 0 001 0v-3c0-.23.05-.45.15-.65L6.29 7a6.6 6.6 0 00-2.23 2.27v.01l.44.23-.45-.22a.5.5 0 00.9.44v-.01a2.39 2.39 0 01.25-.39 5.49 5.49 0 011.82-1.6l1.3 1.3a3 3 0 104.16 4.17l3.67 3.66c-.2.1-.42.15-.65.15h-3a.5.5 0 000 1h3c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 00.7-.7l-.26-.27-.74-.73-3.93-3.94-3.63-3.63L8.01 7.3l-.78-.78-3.38-3.37-.73-.74-.27-.26a.5.5 0 10-.7.7l.26.27zm15.57 12.73l.02-.35v-3a.5.5 0 00-1 0v2.38l.98.97zm-8.81-8.8A7 7 0 0110 7a5.86 5.86 0 014.8 2.32 4.13 4.13 0 01.24.39l.01.01a.5.5 0 00.9-.44v-.01l-.01-.01a1.7 1.7 0 00-.08-.14l-.25-.38A6.85 6.85 0 0010 6c-.63 0-1.2.07-1.7.18l.86.87zm6.78 2.23l-.06.03-.39.19.45-.22zM5.12 3H7.5a.5.5 0 000-1h-3c-.12 0-.24 0-.35.02l.97.98zM3 15.5c0 .83.67 1.5 1.5 1.5h3a.5.5 0 010 1h-3A2.5 2.5 0 012 15.5v-3a.5.5 0 011 0v3zm14-11c0-.83-.67-1.5-1.5-1.5h-3a.5.5 0 010-1h3A2.5 2.5 0 0118 4.5v3a.5.5 0 01-1 0v-3z",
    fill: primaryFill
  }));
};

export const EyeTrackingOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOffFilledIcon({}), 'EyeTrackingOffFilled');

const EyeTrackingOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v3a.5.5 0 001 0v-3c0-.23.05-.45.15-.65L6.29 7a6.6 6.6 0 00-2.23 2.27v.01l.44.23-.45-.22a.5.5 0 00.9.44v-.01a2.39 2.39 0 01.25-.39 5.49 5.49 0 011.82-1.6l1.3 1.3a3 3 0 104.16 4.17l3.67 3.66c-.2.1-.42.15-.65.15h-3a.5.5 0 000 1h3c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 00.7-.7l-.26-.27-.74-.73-3.93-3.94-3.63-3.63L8.01 7.3l-.78-.78-3.38-3.37-.73-.74-.27-.26a.5.5 0 10-.7.7l.26.27zm9.34 9.34a2 2 0 11-2.71-2.71l2.71 2.71zm6.23 3.4l.02-.36v-3a.5.5 0 00-1 0v2.38l.98.97zM9.17 7.04A7 7 0 0110 7a5.86 5.86 0 014.8 2.32 4.13 4.13 0 01.24.39l.01.01a.5.5 0 00.9-.44v-.01l-.01-.01a1.7 1.7 0 00-.08-.14l-.25-.38A6.85 6.85 0 0010 6c-.63 0-1.2.07-1.7.18l.86.87zm6.78 2.23l-.06.03-.39.19.45-.22zM5.12 3H7.5a.5.5 0 000-1h-3c-.12 0-.24 0-.35.02l.97.98zM4.5 17A1.5 1.5 0 013 15.5v-3a.5.5 0 00-1 0v3A2.5 2.5 0 004.5 18h3a.5.5 0 000-1h-3zm11-14c.83 0 1.5.67 1.5 1.5v3a.5.5 0 001 0v-3A2.5 2.5 0 0015.5 2h-3a.5.5 0 000 1h3z",
    fill: primaryFill
  }));
};

export const EyeTrackingOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOffRegularIcon({}), 'EyeTrackingOffRegular');

const EyedropperFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.25 2.75a2.62 2.62 0 00-3.71 0L12.5 3.8l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-6.35 6.35A1.5 1.5 0 003 13.91v.5l-.96 2.26a1 1 0 001.32 1.31L5.6 17h.49c.4 0 .78-.16 1.06-.44l6.35-6.35.35.35a1.5 1.5 0 002.12 0l.59-.58a1.5 1.5 0 000-2.13l-.35-.35 1.04-1.04a2.62 2.62 0 000-3.7zM10.5 7.21l2.3 2.3-6.36 6.34a.5.5 0 01-.35.15H5.5a.5.5 0 00-.2.04l-2.34 1.03 1-2.36a.5.5 0 00.04-.2v-.6a.5.5 0 01.15-.35l6.35-6.35z",
    fill: primaryFill
  }));
};

export const EyedropperFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperFilledIcon({}), 'EyedropperFilled');

const EyedropperRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.25 2.75a2.62 2.62 0 00-3.71 0L12.5 3.8l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-6.35 6.35A1.5 1.5 0 003 13.91v.5l-.96 2.26a1 1 0 001.32 1.31L5.6 17h.49c.4 0 .78-.16 1.06-.44l6.35-6.35.35.35a1.5 1.5 0 002.12 0l.59-.58a1.5 1.5 0 000-2.13l-.35-.35 1.04-1.04a2.62 2.62 0 000-3.7zm-3 .71a1.62 1.62 0 012.29 2.3l-1.4 1.39a.5.5 0 000 .7l.71.71c.2.2.2.51 0 .7l-.58.6a.5.5 0 01-.71 0l-4.41-4.42a.5.5 0 010-.7l.58-.59c.2-.2.52-.2.71 0l.7.7a.5.5 0 00.71 0l1.4-1.39zM12.79 9.5l-6.35 6.35a.5.5 0 01-.35.15H5.5a.5.5 0 00-.2.04l-2.34 1.03 1-2.36a.5.5 0 00.04-.2v-.6a.5.5 0 01.15-.35l6.35-6.35 2.3 2.3z",
    fill: primaryFill
  }));
};

export const EyedropperRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperRegularIcon({}), 'EyedropperRegular');

const EyedropperOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.8 8.5L2.14 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-5.65-5.64-4.35 4.35a1.5 1.5 0 01-1.06.44H5.6l-2.25.98a1 1 0 01-1.32-1.3L3 14.41v-.5c0-.4.16-.79.44-1.07L7.79 8.5zm3 3L8.5 9.2l-4.35 4.36a.5.5 0 00-.15.35v.6a.5.5 0 01-.04.2l-1 2.36 2.34-1.03a.5.5 0 01.2-.04h.59a.5.5 0 00.35-.15l4.35-4.35zm2-2l-.6.59.72.7.58-.58.35.35a1.5 1.5 0 002.13 0l.58-.59a1.5 1.5 0 000-2.12l-.35-.35 1.04-1.04a2.62 2.62 0 10-3.71-3.7L12.5 3.78l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-.58.59.7.7.6-.58 2.28 2.29zm1.45-6.04a1.62 1.62 0 112.29 2.3l-1.4 1.39a.5.5 0 000 .7l.71.71c.2.2.2.51 0 .7l-.58.6a.5.5 0 01-.7 0l-4.42-4.42a.5.5 0 010-.7l.59-.6c.2-.19.5-.19.7 0l.7.71a.5.5 0 00.71 0l1.4-1.39z",
    fill: primaryFill
  }));
};

export const EyedropperOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperOffFilledIcon({}), 'EyedropperOffFilled');

const EyedropperOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.8 8.5L2.14 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-5.65-5.64-4.35 4.35a1.5 1.5 0 01-1.06.44H5.6l-2.25.98a1 1 0 01-1.32-1.3L3 14.41v-.5c0-.4.16-.79.44-1.07L7.79 8.5zm3 3L8.5 9.2l-4.35 4.36a.5.5 0 00-.15.35v.6a.5.5 0 01-.04.2l-1 2.36 2.34-1.03a.5.5 0 01.2-.04h.59a.5.5 0 00.35-.15l4.35-4.35zm2-2l-.6.59.72.7.58-.58.35.35a1.5 1.5 0 002.13 0l.58-.59a1.5 1.5 0 000-2.12l-.35-.35 1.04-1.04a2.62 2.62 0 10-3.71-3.7L12.5 3.78l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-.58.59.7.7.6-.58 2.28 2.29z",
    fill: primaryFill
  }));
};

export const EyedropperOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperOffRegularIcon({}), 'EyedropperOffRegular');

const FStopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.08 5.68c.28-1.63 2-2.58 3.53-1.95l.36.14a.75.75 0 10.56-1.38l-.36-.15A4.08 4.08 0 009.6 5.43L9 9H5.74a.75.75 0 000 1.5h2.98l-.5 2.96a2.58 2.58 0 01-3.92 1.75l-.16-.1a.75.75 0 00-.8 1.27l.16.1c2.46 1.55 5.7.1 6.2-2.77l.55-3.21h2.99a.75.75 0 100-1.5h-2.74l.57-3.32z",
    fill: primaryFill
  }));
};

export const FStopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStopFilledIcon({}), 'FStopFilled');

const FStopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.88 5.35a2.83 2.83 0 013.68-2.22l.78.26a.5.5 0 10.32-.95l-.8-.26a3.83 3.83 0 00-4.96 3L9.24 9H5.5a.5.5 0 100 1h3.57l-.62 3.63a2.83 2.83 0 01-4.24 1.96l-.45-.27a.5.5 0 10-.52.86l.46.27a3.83 3.83 0 005.74-2.65l.65-3.8h3.41a.5.5 0 000-1h-3.24l.62-3.65z",
    fill: primaryFill
  }));
};

export const FStopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStopRegularIcon({}), 'FStopRegular');

const FastAccelerationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.9 7.2a3.48 3.48 0 014.2 0l-1.08 1.08a2 2 0 00-2.04 0L8.9 7.2zM13 10a2 2 0 00-.28-1.02L13.8 7.9a3.48 3.48 0 010 4.2l-1.08-1.08A2 2 0 0013 10zm-2 2a2 2 0 001.02-.28l1.08 1.08a3.48 3.48 0 01-4.2 0l1.08-1.08A2 2 0 0011 12zm-2-2c0 .37.1.72.28 1.02L8.2 12.1a3.48 3.48 0 010-4.2l1.08 1.08A2 2 0 009 10zM6.1 5a6.98 6.98 0 00-1.43 8H3.5a.5.5 0 000 1h1.75c.26.36.54.7.85 1H1.5a.5.5 0 000 1h5.9a7 7 0 100-12H2.5a.5.5 0 000 1h3.6zM11 9a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const FastAccelerationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastAccelerationFilledIcon({}), 'FastAccelerationFilled');

const FastAccelerationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 4a6 6 0 11-3.3 11.01V15h-.02A6 6 0 0111 4zM5.25 14c.26.36.54.7.85 1H1.5a.5.5 0 000 1h5.9a7 7 0 100-12H2.5a.5.5 0 000 1h3.6a6.98 6.98 0 00-1.43 8H3.5a.5.5 0 000 1h1.75zM8.2 7.9a3.48 3.48 0 000 4.2l1.08-1.08a2 2 0 010-2.04L8.2 7.9zm.7-.7l1.08 1.08a2 2 0 012.04 0L13.1 7.2a3.48 3.48 0 00-4.2 0zm4.9.7l-1.08 1.08a2 2 0 010 2.04l1.08 1.08a3.48 3.48 0 000-4.2zm-.7 4.9l-1.08-1.08a2 2 0 01-2.04 0L8.9 12.8a3.48 3.48 0 004.2 0zM6.5 10a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm3.5 0a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const FastAccelerationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastAccelerationRegularIcon({}), 'FastAccelerationRegular');

const FastForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.02 5.49a1 1 0 011.59-.81l5.88 4.31c.68.5.68 1.52 0 2.02l-5.88 4.3a1 1 0 01-1.6-.8v-3.16l-5.4 3.97a1 1 0 01-1.6-.8V5.48a1 1 0 011.6-.81l5.4 3.97V5.49z",
    fill: primaryFill
  }));
};

export const FastForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForwardFilledIcon({}), 'FastForwardFilled');

const FastForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.02 5.49a1 1 0 011.59-.81l5.88 4.31c.68.5.68 1.52 0 2.02l-5.88 4.3a1 1 0 01-1.6-.8v-3.16l-5.4 3.97a1 1 0 01-1.6-.8V5.48a1 1 0 011.6-.81l5.4 3.97V5.49zm6.88 4.3l-5.88-4.3v9.02l5.88-4.3c.13-.1.13-.31 0-.41zm-7 0L4.02 5.5v9.02l5.88-4.3c.13-.1.13-.31 0-.41z",
    fill: primaryFill
  }));
};

export const FastForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForwardRegularIcon({}), 'FastForwardRegular');

const FaxFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V7h-1V4.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V8h5.5c-.31.42-.5.94-.5 1.5v6c0 .56.19 1.08.5 1.5h-7A1.5 1.5 0 013 15.5V10c0-1.1.9-2 2-2V4.5zm1.25 6.13a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm0 2.24a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm1.63-.5a.62.62 0 100 1.25.62.62 0 000-1.24zm.62-1.74a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm5-2.63c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-2z",
    fill: primaryFill
  }));
};

export const FaxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FaxFilledIcon({}), 'FaxFilled');

const FaxRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V7h-1V4.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V8h5.5c-.22.3-.38.63-.45 1H5a1 1 0 00-1 1v5.5c0 .28.22.5.5.5h6.55c.07.37.23.7.45 1h-7A1.5 1.5 0 013 15.5V10c0-1.1.9-2 2-2V4.5zm7 5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-6zm1.5-.5a.5.5 0 00-.5.5v6c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-2zm-7.88 1a.62.62 0 110 1.25.62.62 0 010-1.25zm0 2.25a.62.62 0 110 1.25.62.62 0 010-1.25zM8.5 13a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm-.63-3a.62.62 0 110 1.25.62.62 0 010-1.25z",
    fill: primaryFill
  }));
};

export const FaxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FaxRegularIcon({}), 'FaxRegular');

const FilterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.25 13.5a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5zm2-4.25a.75.75 0 010 1.5h-8.5a.75.75 0 010-1.5h8.5zm2-4.25a.75.75 0 010 1.5H3.75a.75.75 0 010-1.5h12.5z",
    fill: primaryFill
  }));
};

export const FilterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterFilledIcon({}), 'FilterFilled');

const FilterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 13h5a.5.5 0 01.09 1H7.5a.5.5 0 01-.09-1h5.09-5zm-2-4h9a.5.5 0 01.09 1H5.5a.5.5 0 01-.09-1h9.09-9zm-2-4h13a.5.5 0 01.09 1H3.5a.5.5 0 01-.09-1H16.5h-13z",
    fill: primaryFill
  }));
};

export const FilterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterRegularIcon({}), 'FilterRegular');

const FilterAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 9.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5a.5.5 0 00-.15-.35zM9.02 5a5.57 5.57 0 00.07 1.5H3.75a.75.75 0 010-1.5h5.27zm1.46 4.25a5.5 5.5 0 002.38 1.5H5.75a.75.75 0 010-1.5h4.73zm1.77 4.25a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5z",
    fill: primaryFill
  }));
};

export const FilterAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterAddFilledIcon({}), 'FilterAddFilled');

const FilterAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 9.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5a.5.5 0 00-.15-.35zM9.02 5H3.41a.5.5 0 00.09 1h5.52a5.57 5.57 0 010-1zm1.24 4H5.4a.5.5 0 00.09 1h5.84c-.4-.28-.77-.62-1.08-1zM7.4 13h5.09a.5.5 0 01.09 1H7.5a.5.5 0 01-.09-1z",
    fill: primaryFill
  }));
};

export const FilterAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterAddRegularIcon({}), 'FilterAddRegular');

const FilterDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.73 10.25A5.46 5.46 0 0014 11c0 .41-.34.75-.75.75h-8.5a.75.75 0 010-1.5h6.98zM9.03 6c.04.52.16 1.03.34 1.5H2.75a.75.75 0 010-1.5h6.27zM12 15.25a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zM14.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L15.21 5.5l1.14 1.15a.5.5 0 01-.7.7L14.5 6.21l-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const FilterDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismissFilledIcon({}), 'FilterDismissFilled');

const FilterDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.2 7H2.42a.5.5 0 00.09 1h7.1c-.16-.32-.3-.65-.4-1zm2.8 8.5a.5.5 0 00-.5-.5H6.41a.5.5 0 00.09 1h5.09a.5.5 0 00.41-.5zm1.5-4.5H4.41a.5.5 0 00.09 1h9.09a.5.5 0 00-.09-1zm1-1a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L15.21 5.5l1.14 1.15a.5.5 0 01-.7.7L14.5 6.21l-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const FilterDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismissRegularIcon({}), 'FilterDismissRegular');

const FilterSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 11-.71-.71A3 3 0 0116 3.15V3c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 0113 7.85V8a.5.5 0 01-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.98 1.98 0 001.72.1 2 2 0 00.66-.44.5.5 0 11.71.71 3 3 0 01-1 .66zM14 10.98a5.46 5.46 0 01-2.27-.73H4.75a.75.75 0 000 1.5h8.5a.75.75 0 00.75-.77zM9.37 7.5c-.18-.47-.3-.98-.35-1.5H2.75a.75.75 0 000 1.5h6.62zm1.88 7a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5z",
    fill: primaryFill
  }));
};

export const FilterSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterSyncFilledIcon({}), 'FilterSyncFilled');

const FilterSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 11-.71-.71A3 3 0 0116 3.15V3c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 0113 7.85V8a.5.5 0 01-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.98 1.98 0 001.72.1 2 2 0 00.66-.44.5.5 0 11.71.71 3 3 0 01-1 .66zM2.5 7h6.7c.1.35.24.68.4 1H2.5a.5.5 0 01-.09-1h.09zm9 8a.5.5 0 01.09 1H6.5a.5.5 0 01-.09-1h5.09zm-7-4h9a.5.5 0 01.09 1H4.5a.5.5 0 01-.09-1h.09z",
    fill: primaryFill
  }));
};

export const FilterSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterSyncRegularIcon({}), 'FilterSyncRegular');

const FingerprintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.83 4.18c1.47-.72 4.65-1.4 8.26.95a.75.75 0 00.82-1.26C11.79 1.2 8.03 1.93 6.17 2.82a.75.75 0 10.66 1.36zm-1.71.27c.23.35.13.82-.22 1.04a5.1 5.1 0 00-1.25 1.39.75.75 0 11-1.3-.76c.28-.48.99-1.4 1.73-1.88a.75.75 0 011.04.21zm5.38-.16a.75.75 0 000 1.5c1.55 0 5.3 1.3 6.26 6.35a.75.75 0 101.48-.28C17.1 6 12.67 4.29 10.5 4.29zm-1.51.78a.75.75 0 01-.45.96C4.6 7.46 3.61 11.23 4 13.89a.75.75 0 11-1.48.22c-.44-3.1.69-7.74 5.52-9.5.39-.13.82.07.96.46zm-.87 3.92c-1.6 1.24-2.58 3.92-.95 7.17a.75.75 0 01-1.34.68c-1.92-3.82-.87-7.3 1.37-9.04a5.07 5.07 0 013.92-1.05 5.72 5.72 0 013.81 2.67.75.75 0 01-1.25.83 4.23 4.23 0 00-2.8-2.02A3.57 3.57 0 008.12 9zm7.63 2.97a.75.75 0 10-1.5.08c.1 1.91 1.29 2.94 2.02 3.17a.75.75 0 10.45-1.43 1.72 1.72 0 01-.5-.43 2.46 2.46 0 01-.47-1.4zm-4.5.54a.75.75 0 00-1.5 0c0 1.07.13 1.9.45 2.73.32.8.8 1.55 1.44 2.45a.75.75 0 101.22-.86 10.4 10.4 0 01-1.26-2.14 5.69 5.69 0 01-.35-2.18zm-1.13 4.64C8.05 13.4 8.78 11.58 9.5 11a1.43 1.43 0 012.3.72c.06.2.12.44.18.77l.04.17c.08.38.18.84.33 1.3.3.95.84 1.99 1.93 2.79a.75.75 0 00.89-1.21 3.93 3.93 0 01-1.4-2.04c-.12-.39-.2-.77-.28-1.15l-.04-.16c-.06-.3-.13-.64-.21-.91a2.93 2.93 0 00-4.68-1.45c-1.62 1.31-1.92 4.12.25 8.03a.75.75 0 001.31-.72z",
    fill: primaryFill
  }));
};

export const FingerprintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FingerprintFilledIcon({}), 'FingerprintFilled');

const FingerprintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.72 3.95c1.53-.74 4.81-1.44 8.5.97a.5.5 0 10.55-.84c-4.03-2.63-7.7-1.9-9.49-1.03a.5.5 0 10.44.9zm-1.81.64a.5.5 0 01-.14.7 5.33 5.33 0 00-1.34 1.46.5.5 0 11-.86-.5c.27-.46.95-1.34 1.65-1.8a.5.5 0 01.69.14zm5.59-.05a.5.5 0 100 1c1.66 0 5.51 1.38 6.5 6.55a.5.5 0 101-.18c-1.1-5.72-5.43-7.37-7.5-7.37zM9.34 10.8c-.87.7-1.52 2.69.56 6.46a.5.5 0 11-.87.48c-2.15-3.88-1.78-6.52-.32-7.71A2.68 2.68 0 0113 11.35c.08.26.14.58.2.9l.04.15c.08.38.17.78.3 1.18.26.79.67 1.57 1.48 2.16a.5.5 0 01-.6.8 5.17 5.17 0 01-1.83-2.65c-.15-.46-.25-.9-.33-1.29l-.03-.16a9 9 0 00-.19-.8 1.68 1.68 0 00-2.7-.84zm6.16 1.17a.5.5 0 10-1 .06c.1 1.8 1.22 2.74 1.85 2.95a.5.5 0 00.3-.96c-.22-.07-1.07-.64-1.15-2.05zm-4.5.53a.5.5 0 10-1 0c0 1.05.13 1.85.44 2.64.3.77.77 1.5 1.4 2.4a.5.5 0 10.82-.58 10.63 10.63 0 01-1.3-2.19A5.94 5.94 0 0111 12.5zM7.97 8.79c-1.72 1.33-2.7 4.14-1.02 7.49a.5.5 0 01-.9.44C4.18 13 5.22 9.65 7.35 8a4.82 4.82 0 013.73-1 5.47 5.47 0 013.65 2.56.5.5 0 11-.84.55 4.48 4.48 0 00-2.97-2.12 3.82 3.82 0 00-2.95.8zm.49-3a.5.5 0 10-.35-.94c-4.68 1.7-5.79 6.19-5.35 9.22a.5.5 0 10.99-.14c-.4-2.74.62-6.65 4.7-8.14z",
    fill: primaryFill
  }));
};

export const FingerprintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FingerprintRegularIcon({}), 'FingerprintRegular');

const FixedWidthFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 3c.28 0 .5.22.5.5V5h5.5V3.5a.5.5 0 011 0V5H16V3.5a.5.5 0 011 0v4a.5.5 0 01-1 0V6h-5.5v1.5a.5.5 0 01-1 0V6H4v1.5a.5.5 0 01-1 0v-4c0-.28.22-.5.5-.5zm6 6H5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h4.5V9zm1 8H15a2 2 0 002-2v-4a2 2 0 00-2-2h-4.5v8z",
    fill: primaryFill
  }));
};

export const FixedWidthFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FixedWidthFilledIcon({}), 'FixedWidthFilled');

const FixedWidthRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 3c.28 0 .5.22.5.5V5h5.5V3.5a.5.5 0 011 0V5H16V3.5a.5.5 0 011 0v4a.5.5 0 01-1 0V6h-5.5v1.5a.5.5 0 01-1 0V6H4v1.5a.5.5 0 01-1 0v-4c0-.28.22-.5.5-.5zM3 11c0-1.1.9-2 2-2h10a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4zm7.5 5H15a1 1 0 001-1v-4a1 1 0 00-1-1h-4.5v6zm-1-6H5a1 1 0 00-1 1v4a1 1 0 001 1h4.5v-6z",
    fill: primaryFill
  }));
};

export const FixedWidthRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FixedWidthRegularIcon({}), 'FixedWidthRegular');

const FlagFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 13h11a.5.5 0 00.42-.78L13.1 8l2.82-4.22A.5.5 0 0015.5 3H4a.5.5 0 00-.5.5v14a.5.5 0 001 0V13z",
    fill: primaryFill
  }));
};

export const FlagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagFilledIcon({}), 'FlagFilled');

const FlagRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 13h11a.5.5 0 00.42-.78L13.1 8l2.82-4.22A.5.5 0 0015.5 3H4a.5.5 0 00-.5.5v14a.5.5 0 001 0V13zm0-1V4h10.07l-2.49 3.72a.5.5 0 000 .56L14.57 12H4.5z",
    fill: primaryFill
  }));
};

export const FlagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagRegularIcon({}), 'FlagRegular');

const FlagOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.5 4.21V17.5a.5.5 0 001 0V13h7.8l4.85 4.85a.5.5 0 00.7-.7L3.77 3.05l-.92-.9zM15.5 13h-.38l-10-10H15.5c.4 0 .64.45.42.78L13.1 8l2.82 4.22a.5.5 0 01-.42.78z",
    fill: primaryFill
  }));
};

export const FlagOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOffFilledIcon({}), 'FlagOffFilled');

const FlagOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.5 4.21V17.5a.5.5 0 001 0V13h7.8l4.85 4.85a.5.5 0 00.7-.7L3.77 3.05l-.92-.9zM11.3 12H4.5V5.2l6.8 6.8zm3.28 0h-.45l1 1h.38a.5.5 0 00.42-.78L13.1 8l2.82-4.22A.5.5 0 0015.5 3H5.12l1 1h8.45l-2.49 3.72a.5.5 0 000 .56L14.57 12z",
    fill: primaryFill
  }));
};

export const FlagOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOffRegularIcon({}), 'FlagOffRegular');

const FlagPrideFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fill: "#745125",
    d: "M4 4h12v1H4z"
  }), React.createElement("path", {
    fill: "#E62C46",
    d: "M4 5h12v1H4z"
  }), React.createElement("path", {
    fill: "#F36D38",
    d: "M4 6h12v1H4z"
  }), React.createElement("path", {
    fill: "#FFD23E",
    d: "M4 7h12v1H4z"
  }), React.createElement("path", {
    fill: "#61BC51",
    d: "M4 8h12v1H4z"
  }), React.createElement("path", {
    fill: "#1793E8",
    d: "M4 9h12v1H4z"
  }), React.createElement("path", {
    fill: "#B73FBB",
    d: "M4 10h12v1H4z"
  }), React.createElement("path", {
    d: "M3.5 3h13c.28 0 .5.22.5.5v8a.5.5 0 01-.5.5H4v5.5a.5.5 0 01-1 0v-14c0-.28.22-.5.5-.5zM4 4v7h12V4H4z",
    fill: primaryFill
  }));
};

export const FlagPrideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagPrideFilledIcon({}), 'FlagPrideFilled');

const FlashFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l8.67-8.86c.65-.68.19-1.82-.76-1.82H12.2l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2z",
    fill: primaryFill
  }));
};

export const FlashFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFilledIcon({}), 'FlashFilled');

const FlashRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1 1.4L12.22 7h2.56c.95 0 1.4 1.14.77 1.81l-8.68 8.86c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM7.2 3a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 8.68-8.86a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21z",
    fill: primaryFill
  }));
};

export const FlashRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashRegularIcon({}), 'FlashRegular');

const FlashAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.19-1.82-.76-1.82h-2.56l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const FlashAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAddFilledIcon({}), 'FlashAddFilled');

const FlashAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1.01 1.4L12.2 7h2.56c.95 0 1.4 1.14.77 1.81l-.24.25a5.54 5.54 0 00-1.38-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 2.88-2.94a5.58 5.58 0 00.05 1.37l-2.21 2.26c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const FlashAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAddRegularIcon({}), 'FlashAddRegular');

const FlashAutoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l4.82-4.93 1.42-3.78a1.5 1.5 0 012.6-.37c.38-.68-.08-1.6-.93-1.6H12.2l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zm7.29 7c.2 0 .4.13.47.32l3 8a.5.5 0 11-.94.36l-1-2.68h-3.06l-1 2.68a.5.5 0 01-.94-.36l3-8A.5.5 0 0114.5 9zm1.15 5l-1.15-3.08L13.35 14h2.3z",
    fill: primaryFill
  }));
};

export const FlashAutoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAutoFilledIcon({}), 'FlashAutoFilled');

const FlashAutoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1 1.4L12.22 7h2.56c.85 0 1.3.92.93 1.6a1.5 1.5 0 00-.88-.57.07.07 0 00-.02-.02L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 6.4-6.55-.86 2.32-4.82 4.92c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM14.5 9c.2 0 .4.13.47.32l3 8a.5.5 0 11-.94.36l-1-2.68h-3.06l-1 2.68a.5.5 0 01-.94-.36l3-8A.5.5 0 0114.5 9zm1.15 5l-1.15-3.08L13.35 14h2.3z",
    fill: primaryFill
  }));
};

export const FlashAutoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAutoRegularIcon({}), 'FlashAutoRegular');

const FlashCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.18-1.82-.76-1.82H12.2l1.27-3.6c.23-.69-.28-1.4-1.01-1.4H7.21zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmarkFilledIcon({}), 'FlashCheckmarkFilled');

const FlashCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.19 2.77c.13-.46.55-.77 1.02-.77h5.25c.73 0 1.24.71 1 1.4L12.2 7h2.57c.94 0 1.4 1.14.76 1.81l-.24.25a5.55 5.55 0 00-1.37-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.49-4.25a.06.06 0 00-.06-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c-.01.04.02.08.06.08h1.9a.5.5 0 01.5.62l-1.33 5.3v.04l.03.03.04.01h.01l.02-.02 2.89-2.95a5.57 5.57 0 00.05 1.38l-2.22 2.26c-.75.79-2.05.06-1.8-1L6.24 12H4.96c-.7 0-1.21-.68-1.02-1.36l2.25-7.87zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmarkRegularIcon({}), 'FlashCheckmarkRegular');

const FlashFlowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l4.81-4.92-.25-.76h-.18a3 3 0 11.59-3A2.5 2.5 0 0114 10.37l1.52-1.55c.65-.68.19-1.82-.76-1.82h-2.56l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zm10.72 13.77A2.01 2.01 0 0019 14a2 2 0 00-3.73-1h-1.05a.5.5 0 01-.47-.34l-.55-1.63A1.5 1.5 0 0011.78 10H11a2 2 0 10-.27 1h1.05c.21 0 .4.14.47.34l.55 1.63V13a1.5 1.5 0 001.42 1H15a2 2 0 002.93 1.77zm-.44-.9a1 1 0 01-1.49-.86V14a1 1 0 012-.01V14a1 1 0 01-.51.87zM10 10a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const FlashFlowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlowFilledIcon({}), 'FlashFlowFilled');

const FlashFlowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1.01 1.4L12.2 7h2.56c.95 0 1.4 1.14.77 1.81L14 10.38a2.5 2.5 0 00-.63-.79l1.44-1.46a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.21a3 3 0 001 1.38l-1.14 4.54v.04l.03.03.04.01h.01l.03-.02 4.2-4.3c.34-.17.65-.4.9-.68h.18l.25.76-4.81 4.91c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zm12.52 12.25A2.01 2.01 0 0117 16a2 2 0 01-2-2h-.78a1.5 1.5 0 01-1.41-1l-.01-.03-.55-1.63a.5.5 0 00-.47-.34h-1.05a2 2 0 11.27-1h.78c.64 0 1.22.41 1.42 1.03l.55 1.63c.06.2.26.34.47.34h1.05a2 2 0 113.45 2.02zM17 15a1 1 0 001-1v-.01-.04a1 1 0 00-2 .05v.02a1 1 0 001 .98zm-8-4a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const FlashFlowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlowRegularIcon({}), 'FlashFlowRegular');

const FlashOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.86 12.56l5.29 5.3a.5.5 0 00.7-.71l-15-15a.5.5 0 10-.7.7l3.12 3.13-1.33 4.66c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l5-5.12zm3.67-3.74l-2.27 2.32L5.9 3.78l.29-1C6.32 2.3 6.74 2 7.21 2h5.25c.73 0 1.24.71 1 1.4L12.2 7h2.57c.94 0 1.4 1.14.76 1.81z",
    fill: primaryFill
  }));
};

export const FlashOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashOffFilledIcon({}), 'FlashOffFilled');

const FlashOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.27 5.98L2.15 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-5.3-5.29-5 5.11c-.75.79-2.05.06-1.8-1L6.24 12H4.96c-.7 0-1.21-.68-1.02-1.36l1.33-4.66zm5.88 5.88L6.08 6.79 4.9 10.92c-.01.04.02.08.06.08h1.9a.5.5 0 01.5.62l-1.33 5.3v.04l.03.03.04.01h.01l.02-.02 5.02-5.12zm3.66-3.74l-2.26 2.3.7.72 2.28-2.32c.65-.68.18-1.82-.76-1.82H12.2l1.27-3.6c.23-.69-.28-1.4-1.01-1.4H7.21c-.47 0-.89.31-1.02.77L5.9 3.78l.81.8.44-1.53c0-.03.03-.05.06-.05h5.25c.04 0 .07.04.06.08l-1.5 4.25a.5.5 0 00.48.67h3.3l.02.04.01.05-.02.03z",
    fill: primaryFill
  }));
};

export const FlashOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashOffRegularIcon({}), 'FlashOffRegular');

const FlashPlayFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.19-1.82-.76-1.82h-2.56l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const FlashPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashPlayFilledIcon({}), 'FlashPlayFilled');

const FlashPlayRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1.01 1.4L12.2 7h2.56c.95 0 1.4 1.14.77 1.81l-.24.25a5.54 5.54 0 00-1.38-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 2.88-2.94a5.58 5.58 0 00.05 1.37l-2.21 2.26c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const FlashPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashPlayRegularIcon({}), 'FlashPlayRegular');

const FlashSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.18-1.82-.76-1.82H12.2l1.27-3.6c.23-.69-.28-1.4-1.01-1.4H7.21zm4.86 9.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 000 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const FlashSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashSettingsFilledIcon({}), 'FlashSettingsFilled');

const FlashSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.19 2.77c.13-.46.55-.77 1.02-.77h5.25c.73 0 1.24.71 1 1.4L12.2 7h2.57c.94 0 1.4 1.14.76 1.81l-.24.25a5.55 5.55 0 00-1.37-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.49-4.25a.06.06 0 00-.06-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c-.01.04.02.08.06.08h1.9a.5.5 0 01.5.62l-1.33 5.3v.04l.03.03.04.01h.01l.02-.02 2.89-2.95a5.57 5.57 0 00.05 1.38l-2.22 2.26c-.75.79-2.05.06-1.8-1L6.24 12H4.96c-.7 0-1.21-.68-1.02-1.36l2.25-7.87zm5.88 8.67a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 000 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const FlashSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashSettingsRegularIcon({}), 'FlashSettingsRegular');

const FlashlightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.96 1.17c.27 0 .5.22.5.5v.83a.5.5 0 11-1 0v-.83c0-.28.22-.5.5-.5zm3.9.98c.19.2.19.5 0 .7l-1.5 1.5a.5.5 0 11-.71-.7l1.5-1.5c.2-.2.5-.2.7 0zM7 5.2v2.58l5.2 5.2h2.6L7 5.22zm8.7 7.29l1.1-1.09a2 2 0 000-2.82L11.4 3.2a2 2 0 00-2.82 0L7.5 4.29l8.2 8.2zm-4.7.7L6.8 9l-4.1 4.09a2 2 0 000 2.82L4.1 17.3a2 2 0 002.82 0L11 13.21zm-3.15-.35l-1 1a.5.5 0 01-.7-.7l1-1a.5.5 0 11.7.7zM17 6.05c0-.29.22-.5.5-.5h.83a.5.5 0 110 1h-.83a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const FlashlightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightFilledIcon({}), 'FlashlightFilled');

const FlashlightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.46 1.67a.5.5 0 00-1 0v.83a.5.5 0 101 0v-.83zm3.4 1.18a.5.5 0 10-.71-.7l-1.5 1.5a.5.5 0 00.7.7l1.5-1.5zm-10 10a.5.5 0 00-.71-.7l-1 1a.5.5 0 10.7.7l1-1zM7 5v3.8l-4.3 4.29a2 2 0 000 2.82L4.1 17.3a2 2 0 002.82 0l4.3-4.3H15a.5.5 0 00.35-.14l1.44-1.44a2 2 0 000-2.82L11.41 3.2a2 2 0 00-2.82 0L7.15 4.65A.5.5 0 007 5zM9.3 3.9a1 1 0 011.4 0L16.1 9.3a1 1 0 010 1.42L15 11.79 8.2 5l1.1-1.08zM8 6.21L13.8 12h-2.6L8 8.8V6.2zm-.5 3.5l2.8 2.79-4.1 4.09a1 1 0 01-1.4 0L3.4 15.2a1 1 0 010-1.42L7.5 9.71zm10-4.17a.5.5 0 000 1h.83a.5.5 0 000-1h-.83z",
    fill: primaryFill
  }));
};

export const FlashlightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightRegularIcon({}), 'FlashlightRegular');

const FlashlightOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l15 15a.5.5 0 00.7-.7l-15-15zM16.8 11.4l-1.08 1.09L7.5 4.3l1.09-1.1a2 2 0 012.82 0L16.8 8.6a2 2 0 010 2.82zM6.8 9L11 13.2l-4.09 4.1a2 2 0 01-2.82 0L2.7 15.9a2 2 0 010-2.82L6.79 9zm.06 4.85l1-1a.5.5 0 10-.7-.7l-1 1a.5.5 0 10.7.7z",
    fill: primaryFill
  }));
};

export const FlashlightOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightOffFilledIcon({}), 'FlashlightOffFilled');

const FlashlightOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L7 7.71v1.08l-4.3 4.3a2 2 0 000 2.82L4.1 17.3a2 2 0 002.82 0l4.3-4.29h1.08l4.86 4.85a.5.5 0 00.7-.7l-15-15zm12.67 9.13l-1.06 1.06.65.65a.5.5 0 00.24-.14l1.44-1.44a2 2 0 000-2.82L11.41 3.2a2 2 0 00-2.82 0L7.15 4.65a.5.5 0 00-.14.24l.65.65L9.3 3.91a1 1 0 011.42 0l5.38 5.38a1 1 0 010 1.42l-.57.57zm-7.67 1.57a.5.5 0 10-.7-.7l-1 1a.5.5 0 10.7.7l1-1zM7.5 9.71l2.8 2.79-4.1 4.09a1 1 0 01-1.4 0L3.4 15.2a1 1 0 010-1.42L7.5 9.71z",
    fill: primaryFill
  }));
};

export const FlashlightOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightOffRegularIcon({}), 'FlashlightOffRegular');

const FlipHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.88 15.66a.75.75 0 01-.63.34h-5.5a.75.75 0 01-.75-.75V2.75a.75.75 0 011.44-.3l5.5 12.5c.1.23.08.5-.06.71zM12.5 6.32v8.18h3.6l-3.6-8.18zM2.5 16a.5.5 0 01-.45-.71l6-13A.5.5 0 019 2.5v13a.5.5 0 01-.5.5h-6z",
    fill: primaryFill
  }));
};

export const FlipHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontalFilledIcon({}), 'FlipHorizontalFilled');

const FlipHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.92 15.77a.5.5 0 01-.42.23h-6a.5.5 0 01-.5-.5v-13a.5.5 0 01.95-.2l6 13a.5.5 0 01-.03.47zM12 4.77V15h4.72L12 4.78zM2.5 16a.5.5 0 01-.45-.71l6-13A.5.5 0 019 2.5v13a.5.5 0 01-.5.5h-6z",
    fill: primaryFill
  }));
};

export const FlipHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontalRegularIcon({}), 'FlipHorizontalRegular');

const FlipVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.66 2.12c.21.14.34.38.34.63v5.5c0 .41-.34.75-.75.75H2.75a.75.75 0 01-.3-1.44l12.5-5.5c.23-.1.5-.08.71.06zM6.32 7.5h8.18V3.9L6.32 7.5zm9.68 10a.5.5 0 01-.71.45l-13-6A.5.5 0 012.5 11h13c.28 0 .5.22.5.5v6z",
    fill: primaryFill
  }));
};

export const FlipVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVerticalFilledIcon({}), 'FlipVerticalFilled');

const FlipVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.77 2.08c.14.1.23.25.23.42v6a.5.5 0 01-.5.5h-13a.5.5 0 01-.2-.95l13-6a.5.5 0 01.47.03zM4.77 8H15V3.28L4.78 8zM16 17.5a.5.5 0 01-.71.45l-13-6A.5.5 0 012.5 11h13c.28 0 .5.22.5.5v6z",
    fill: primaryFill
  }));
};

export const FlipVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVerticalRegularIcon({}), 'FlipVerticalRegular');

const FlowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 4a3 3 0 00-2.96 2.5A2.5 2.5 0 009.73 8.6l-.44 2.66a1.5 1.5 0 01-1.33 1.24 3 3 0 100 1 2.5 2.5 0 002.31-2.08l.44-2.66a1.5 1.5 0 011.33-1.24A3 3 0 1015 4z",
    fill: primaryFill
  }));
};

export const FlowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowFilledIcon({}), 'FlowFilled');

const FlowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 5a2 2 0 100 4 2 2 0 000-4zm-2.96 1.5a3 3 0 110 1 1.5 1.5 0 00-1.33 1.25l-.44 2.66a2.5 2.5 0 01-2.31 2.09 3 3 0 110-1 1.5 1.5 0 001.33-1.25l.44-2.66a2.5 2.5 0 012.31-2.09zM5 11a2 2 0 100 4 2 2 0 000-4z",
    fill: primaryFill
  }));
};

export const FlowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowRegularIcon({}), 'FlowRegular');

const FlowchartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2C7.33 3 8 3.67 8 4.5v2C8 7.33 7.33 8 6.5 8H6v3.84a1 1 0 01.2.16L8 13.8a1 1 0 01.16.2H12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5V15H8.16a1 1 0 01-.16.2L6.2 17a1 1 0 01-1.4 0L3 15.2a1 1 0 010-1.4L4.8 12a1 1 0 01.2-.16V8h-.5A1.5 1.5 0 013 6.5v-2z",
    fill: primaryFill
  }));
};

export const FlowchartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartFilledIcon({}), 'FlowchartFilled');

const FlowchartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2C3 7.33 3.67 8 4.5 8H5v3.84a1 1 0 00-.2.16L3 13.8a1 1 0 000 1.4L4.8 17a1 1 0 001.4 0L8 15.2a1 1 0 00.16-.2H12v.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v.5H8.16a1 1 0 00-.16-.2L6.2 12a1 1 0 00-.2-.16V8h.5C7.33 8 8 7.33 8 6.5v-2C8 3.67 7.33 3 6.5 3h-2zM4 4.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2zm-.3 10l1.8-1.8 1.8 1.8-1.8 1.8-1.8-1.8zm9.8-1.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const FlowchartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartRegularIcon({}), 'FlowchartRegular');

const FlowchartCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm4-3.5v2c0 .28.22.5.5.5H7v1.8l-1.35 1.35a.5.5 0 000 .7l1.5 1.5c.2.2.5.2.7 0L9.21 13H11v.5c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v.5H9.2L8 10.8V9h.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const FlowchartCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartCircleFilledIcon({}), 'FlowchartCircleFilled');

const FlowchartCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H8v1.8L9.2 12H11v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V13H9.2l-1.35 1.35a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 010-.7L7 10.79V9h-.5a.5.5 0 01-.5-.5v-2zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const FlowchartCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartCircleRegularIcon({}), 'FlowchartCircleRegular');

const FluentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.05a.5.5 0 01.44 0l5 2.5a.5.5 0 010 .9l-4.1 2.05 4.1 2.05a.5.5 0 010 .9L11 12.8v4.69a.5.5 0 01-.76.43l-5-3A.5.5 0 015 14.5V5c0-.19.1-.36.28-.45l5-2.5z",
    fill: primaryFill
  }));
};

export const FluentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FluentFilledIcon({}), 'FluentFilled');

const FluentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.28 2.05a.5.5 0 01.44 0l5 2.5a.5.5 0 010 .9l-4.1 2.05 4.1 2.05a.5.5 0 010 .9L11 12.8v4.69a.5.5 0 01-.76.43l-5-3A.5.5 0 015 14.5V5c0-.19.1-.36.28-.45l5-2.5zM11 11.7L14.38 10 11 8.3v3.4zm-1-3.38L6.62 10 10 11.7V8.3zm0-1.62V3.31L6.62 5 10 6.7zm-4-.88v3.38L9.38 7.5 6 5.8zm0 5v3.4l4 2.4v-3.8l-4-2zm5-7.5v3.38L14.38 5 11 3.3z",
    fill: primaryFill
  }));
};

export const FluentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FluentRegularIcon({}), 'FluentRegular');

const FluidFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 5.54V3.5zM8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 00-.5-.5H8V4zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 014 13.5V8h1zm6.5 2c-.82 0-1.5.67-1.5 1.5v5c0 .83.68 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-5z",
    fill: primaryFill
  }));
};

export const FluidFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FluidFilledIcon({}), 'FluidFilled');

const FluidRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 00-.5-.5H8V4zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 014 13.5V8h1zM2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 5.54V3.5zM3.5 3a.5.5 0 00-.5.5v2.04c0 .28.22.5.5.5h2a.5.5 0 00.5-.5V3.5a.5.5 0 00-.5-.5h-2zm6.5 8.5c0-.83.68-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5a1.5 1.5 0 01-1.5-1.5v-5zm1.5-.5a.5.5 0 00-.5.5v5c0 .28.23.5.5.5h5a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5h-5z",
    fill: primaryFill
  }));
};

export const FluidRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FluidRegularIcon({}), 'FluidRegular');

const FolderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.56 4.5h4.94a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H4.5A2.5 2.5 0 012 14.66V7.5H7.22c.3-.04.6-.16.83-.36l.1-.1 2.41-2.54zM7.16 3c.28 0 .54.07.77.21l.14.09 1.31.99-1.95 2.05-.06.06a.5.5 0 01-.22.1H2v-1A2.5 2.5 0 014.34 3h2.83z",
    fill: primaryFill
  }));
};

export const FolderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderFilledIcon({}), 'FolderFilled');

const FolderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.17 3c.27 0 .53.07.76.21l.14.09 1.6 1.2h5.83a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H4.5A2.5 2.5 0 012 14.66V5.5A2.5 2.5 0 014.34 3h2.83zm.99 4.03a1.5 1.5 0 01-.94.46l-.15.01H3v7c0 .78.6 1.42 1.36 1.5H15.5c.78 0 1.42-.6 1.5-1.36V7c0-.78-.6-1.42-1.36-1.5H9.62L8.16 7.03zM7.16 4H4.5c-.78 0-1.42.6-1.5 1.36V6.5h4.07a.5.5 0 00.3-.1l.06-.06L8.7 5.02 7.47 4.1a.5.5 0 00-.22-.1h-.08z",
    fill: primaryFill
  }));
};

export const FolderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderRegularIcon({}), 'FolderRegular');

const FolderAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zm8.44 10a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FolderAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAddFilledIcon({}), 'FolderAddFilled');

const FolderAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zm16 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FolderAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAddRegularIcon({}), 'FolderAddRegular');

const FolderArrowLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.07 3.3l1.32.99-1.96 2.05a.5.5 0 01-.36.16H2v-1A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3zm.09 3.73c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94l-2.4 2.53zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeftFilledIcon({}), 'FolderArrowLeftFilled');

const FolderArrowLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3l1.6 1.2h5.83A2.5 2.5 0 0118 7v3.26a5.5 5.5 0 00-1-.66V7c0-.83-.67-1.5-1.5-1.5H9.62L8.16 7.03c-.29.3-.68.47-1.09.47H3v7c0 .83.67 1.5 1.5 1.5h4.7c.1.35.24.68.4 1H4.5A2.5 2.5 0 012 14.5v-9zM4.5 4C3.67 4 3 4.67 3 5.5v1h4.07a.5.5 0 00.36-.16L8.7 5.02 7.47 4.1a.5.5 0 00-.3-.1H4.5zm10 15a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeftRegularIcon({}), 'FolderArrowLeftRegular');

const FolderArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRightFilledIcon({}), 'FolderArrowRightFilled');

const FolderArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRightRegularIcon({}), 'FolderArrowRightRegular');

const FolderArrowUpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.07 3.3l1.32.99-1.96 2.05a.5.5 0 01-.36.16H2v-1A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3zm.09 3.73l2.4-2.53h4.94A2.5 2.5 0 0118 6.84v3.42A5.5 5.5 0 009.6 17H4.5A2.5 2.5 0 012 14.5v-7h5.07c.41 0 .8-.17 1.09-.47zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 13.71v2.79a.5.5 0 101 0v-2.8l1.15 1.15a.5.5 0 10.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUpFilledIcon({}), 'FolderArrowUpFilled');

const FolderArrowUpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3h2.67c.32 0 .64.1.9.3l1.6 1.2h5.83A2.5 2.5 0 0118 7v3.26a5.5 5.5 0 00-1-.66V7c0-.83-.67-1.5-1.5-1.5H9.62L8.16 7.03c-.29.3-.68.47-1.09.47H3v7c0 .83.67 1.5 1.5 1.5h4.7c.1.35.24.68.4 1H4.5A2.5 2.5 0 012 14.5v-9A2.5 2.5 0 014.5 3zM3 5.5v1h4.07a.5.5 0 00.36-.16L8.7 5.02 7.47 4.1a.5.5 0 00-.3-.1H4.5C3.67 4 3 4.67 3 5.5zm16 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 13.71v2.79a.5.5 0 101 0v-2.8l1.15 1.15a.5.5 0 10.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUpRegularIcon({}), 'FolderArrowUpRegular');

const FolderBriefcaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.07 3.3l1.32.99-1.96 2.05a.5.5 0 01-.36.16H2v-1A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3zm.09 3.73l2.4-2.53h4.94A2.5 2.5 0 0118 6.84v4.33a3 3 0 00-1-.17v-1a1 1 0 00-1-1h-4a1 1 0 00-1 1v1a3 3 0 00-3 3v3H4.5A2.5 2.5 0 012 14.5v-7h5.07c.41 0 .8-.17 1.09-.47zM11 12a2 2 0 00-2 2v3c0 1.1.9 2 2 2h6a2 2 0 002-2v-3a2 2 0 00-2-2h-1v-1.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V12h-1zm2 0v-1h2v1h-2z",
    fill: primaryFill
  }));
};

export const FolderBriefcaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderBriefcaseFilledIcon({}), 'FolderBriefcaseFilled');

const FolderBriefcaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17H8v-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v4a3 3 0 011 .17V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zm9 5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V12h1a2 2 0 012 2v3a2 2 0 01-2 2h-6a2 2 0 01-2-2v-3c0-1.1.9-2 2-2h1v-1.5zm3 .5h-2v1h2v-1z",
    fill: primaryFill
  }));
};

export const FolderBriefcaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderBriefcaseRegularIcon({}), 'FolderBriefcaseRegular');

const FolderGlobeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zm2.45 9.5a8.9 8.9 0 01.54-2.85c.17-.42.35-.72.53-.91.19-.2.33-.24.42-.24.1 0 .23.05.42.24.18.19.36.5.53.91.3.73.5 1.72.54 2.85h-2.98zm-.39-3.22l.2-.46a4.5 4.5 0 00-2.8 3.68h1.99c.05-1.23.27-2.36.61-3.22zm3.76 0a5.29 5.29 0 00-.21-.46c1.51.6 2.62 2 2.8 3.68H17a9.92 9.92 0 00-.61-3.22zm.61 4.22h1.98a4.5 4.5 0 01-2.8 3.68 9.92 9.92 0 00.82-3.68zm-2.07 3.76c-.19.2-.33.24-.42.24-.1 0-.23-.05-.42-.24-.18-.19-.36-.5-.53-.91a8.9 8.9 0 01-.54-2.85h2.98a8.9 8.9 0 01-.54 2.85c-.17.42-.35.72-.53.91zM10.02 15a4.5 4.5 0 002.8 3.68l-.2-.46a9.92 9.92 0 01-.61-3.22h-1.98z",
    fill: primaryFill
  }));
};

export const FolderGlobeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderGlobeFilledIcon({}), 'FolderGlobeFilled');

const FolderGlobeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zM13.01 14a8.9 8.9 0 01.54-2.85c.17-.42.35-.72.53-.91.19-.2.33-.24.42-.24.1 0 .23.05.42.24.18.19.36.5.53.91.3.73.5 1.72.54 2.85h-2.98zm-.39-3.22l.2-.46a4.5 4.5 0 00-2.8 3.68h1.99c.05-1.23.27-2.36.61-3.22zm3.76 0a5.29 5.29 0 00-.21-.46c1.51.6 2.62 2 2.8 3.68H17a9.92 9.92 0 00-.61-3.22zm.61 4.22h1.98a4.5 4.5 0 01-2.8 3.68 9.92 9.92 0 00.82-3.68zm-2.07 3.76c-.19.2-.33.24-.42.24-.1 0-.23-.05-.42-.24-.18-.19-.36-.5-.53-.91a8.9 8.9 0 01-.54-2.85h2.98a8.9 8.9 0 01-.54 2.85c-.17.42-.35.72-.53.91zM10.02 15a4.5 4.5 0 002.8 3.68l-.2-.46a9.92 9.92 0 01-.61-3.22h-1.98z",
    fill: primaryFill
  }));
};

export const FolderGlobeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderGlobeRegularIcon({}), 'FolderGlobeRegular');

const FolderLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h2.26a4.5 4.5 0 013.74-7h5c.93 0 1.79.28 2.5.76V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zM8 14.5a2.5 2.5 0 012.5-2.5h1a.5.5 0 000-1h-1a3.5 3.5 0 100 7h1a.5.5 0 000-1h-1A2.5 2.5 0 018 14.5zm10 0a2.5 2.5 0 00-2.5-2.5h-1a.5.5 0 010-1h1a3.5 3.5 0 110 7h-1a.5.5 0 010-1h1a2.5 2.5 0 002.5-2.5zm-8 0c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const FolderLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLinkFilledIcon({}), 'FolderLinkFilled');

const FolderLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h2.26c-.2-.3-.38-.64-.5-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v3.26c.36.12.7.3 1 .5V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zm5 9a2.5 2.5 0 012.5-2.5h1a.5.5 0 000-1h-1a3.5 3.5 0 100 7h1a.5.5 0 000-1h-1A2.5 2.5 0 018 14.5zm10 0a2.5 2.5 0 00-2.5-2.5h-1a.5.5 0 010-1h1a3.5 3.5 0 110 7h-1a.5.5 0 010-1h1a2.5 2.5 0 002.5-2.5zm-8 0c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const FolderLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLinkRegularIcon({}), 'FolderLinkRegular');

const FolderMailFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 4.5h-4.94l-2.4 2.53-.11.1c-.23.2-.52.33-.83.36l-.15.01H2v7.16A2.5 2.5 0 004.5 17H9v-3.5a2.5 2.5 0 012.5-2.5h6c.17 0 .34.02.5.05V6.84l-.02-.17A2.5 2.5 0 0015.5 4.5zM7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v1h5.15a.5.5 0 00.22-.1l.06-.06L9.4 4.3 8.06 3.3l-.14-.09zm6.58 12.72l-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43zm.23 1.01l4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3.05l4.25 2.48c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const FolderMailFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMailFilledIcon({}), 'FolderMailFilled');

const FolderMailRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v9.16A2.5 2.5 0 004.5 17H9v-1H4.36A1.5 1.5 0 013 14.5v-7H7.22c.36-.04.69-.2.94-.47L9.62 5.5h6.02A1.5 1.5 0 0117 7v4h.5c.17 0 .34.02.5.05V6.84l-.02-.17A2.5 2.5 0 0015.5 4.5H9.67l-1.6-1.2-.14-.09zM4.5 4h2.75a.5.5 0 01.22.1l1.22.92-1.26 1.32-.06.06a.5.5 0 01-.3.1H3V5.36A1.5 1.5 0 014.5 4zm10.01 11.93l-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43zm.23 1.01l4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3.05l4.25 2.48c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const FolderMailRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMailRegularIcon({}), 'FolderMailRegular');

const FolderOpenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3h2.66c.33 0 .64.1.9.3l1.6 1.2h4.84A2.5 2.5 0 0117 7H5.82c-.71 0-1.33.51-1.47 1.22L2.77 16.3A2.5 2.5 0 012 14.5v-9zm1.77 10.9c-.06.32.18.6.5.6h10.91c.72 0 1.34-.5 1.47-1.21l1.4-7.2a.5.5 0 00-.5-.59H5.83a.5.5 0 00-.49.4l-1.56 8z",
    fill: primaryFill
  }));
};

export const FolderOpenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpenFilledIcon({}), 'FolderOpenFilled');

const FolderOpenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7.07V7a2.5 2.5 0 00-2.5-2.5H9.66l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.46 17h10.72c.72 0 1.34-.5 1.47-1.21l1.36-7A1.5 1.5 0 0017 7.07zM4.5 4h2.66c.11 0 .22.04.3.1L9.2 5.4c.08.06.19.1.3.1h5c.82 0 1.5.67 1.5 1.5H5.82c-.71 0-1.33.51-1.47 1.22l-1.3 6.67a1.5 1.5 0 01-.05-.4V5.5C3 4.67 3.67 4 4.5 4zm.83 4.4a.5.5 0 01.5-.4h10.7a.5.5 0 01.5.6l-1.36 7a.5.5 0 01-.49.4H4.46a.5.5 0 01-.49-.6l1.36-7z",
    fill: primaryFill
  }));
};

export const FolderOpenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpenRegularIcon({}), 'FolderOpenRegular');

const FolderOpenVerticalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.14 2.87c-.1.2-.14.4-.14.63v10.63a2.5 2.5 0 001.6 2.33l4.36 1.68c.35.14.72.13 1.04.02V6.56a1.5 1.5 0 00-.96-1.39l-5.9-2.3zm.8-.76l5.47 2.13A2.5 2.5 0 0112 6.57V16h1.5c.83 0 1.5-.67 1.5-1.5v-2.94l.96-3.82c.02-.12.04-.24.04-.36V3.5c0-.83-.67-1.5-1.5-1.5h-9c-.2 0-.4.04-.57.11z",
    fill: primaryFill
  }));
};

export const FolderOpenVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpenVerticalFilledIcon({}), 'FolderOpenVerticalFilled');

const FolderOpenVerticalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v3.88c0 .12-.02.24-.04.36L15 11.56v2.94c0 .83-.67 1.5-1.5 1.5H12v.74a1.5 1.5 0 01-2.04 1.4L5.6 16.46A2.5 2.5 0 014 14.13V3.5zM7.19 3l3.21 1.24A2.5 2.5 0 0112 6.57V15h1.5a.5.5 0 00.5-.5v-3l.01-.12L15 7.5a.5.5 0 00.01-.12V3.5a.5.5 0 00-.5-.5H7.19zM5 3.96v10.17c0 .62.38 1.17.96 1.4l4.36 1.68a.5.5 0 00.68-.47V6.57a1.5 1.5 0 00-.96-1.4L5.68 3.5a.5.5 0 00-.68.47z",
    fill: primaryFill
  }));
};

export const FolderOpenVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpenVerticalRegularIcon({}), 'FolderOpenVerticalRegular');

const FolderPersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 4.5h-4.94l-2.4 2.53-.11.1c-.23.2-.52.33-.83.36l-.15.01H2v7.16A2.5 2.5 0 004.5 17h6.54a2.5 2.5 0 012.23-2.99A2.99 2.99 0 0115.5 9a3 3 0 012.5 1.34v-3.5l-.02-.17A2.5 2.5 0 0015.5 4.5zM7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v1h5.15a.5.5 0 00.22-.1l.06-.06L9.4 4.3 8.06 3.3l-.14-.09zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const FolderPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPersonFilledIcon({}), 'FolderPersonFilled');

const FolderPersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v9.16A2.5 2.5 0 004.5 17h6.54a3.3 3.3 0 01.01-1H4.36A1.5 1.5 0 013 14.5v-7H7.22c.36-.04.69-.2.94-.47L9.62 5.5h6.02A1.5 1.5 0 0117 7v2.4c.4.23.74.56 1 .94v-3.5l-.02-.17A2.5 2.5 0 0015.5 4.5H9.67l-1.6-1.2-.14-.09zM4.5 4h2.75a.5.5 0 01.22.1l1.22.92-1.26 1.32-.06.06a.5.5 0 01-.3.1H3V5.36A1.5 1.5 0 014.5 4zm13 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const FolderPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPersonRegularIcon({}), 'FolderPersonRegular');

const FolderProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zm-.56 10a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.5-3.5a3.5 3.5 0 00-2.8 5.6l4.9-4.9a3.48 3.48 0 00-2.1-.7zm0 7a3.5 3.5 0 002.8-5.6l-4.9 4.9c.59.44 1.31.7 2.1.7z",
    fill: primaryFill
  }));
};

export const FolderProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibitedFilledIcon({}), 'FolderProhibitedFilled');

const FolderProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3l1.6 1.2h5.83A2.5 2.5 0 0118 7v3.26a5.5 5.5 0 00-1-.66V7c0-.83-.67-1.5-1.5-1.5H9.62L8.16 7.03c-.29.3-.68.47-1.09.47H3v7c0 .83.67 1.5 1.5 1.5h4.7c.1.35.24.68.4 1H4.5A2.5 2.5 0 012 14.5v-9zM4.5 4C3.67 4 3 4.67 3 5.5v1h4.07a.5.5 0 00.36-.16L8.7 5.02 7.47 4.1a.5.5 0 00-.3-.1H4.5zM10 14.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.5-3.5a3.5 3.5 0 00-2.8 5.6l4.9-4.9a3.48 3.48 0 00-2.1-.7zm2.8 1.4l-4.9 4.9a3.5 3.5 0 004.9-4.9z",
    fill: primaryFill
  }));
};

export const FolderProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibitedRegularIcon({}), 'FolderProhibitedRegular');

const FolderSwapFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.56 4.5h4.94a2.5 2.5 0 012.48 2.17l.01.17L18 7v6.88l-1.44-1.44A1.5 1.5 0 0014.08 14h-1.16a1.5 1.5 0 00-2.48-1.56l-2 2a1.5 1.5 0 000 2.13l.44.43H4.5A2.5 2.5 0 012 14.66V7.5H7.22c.3-.04.6-.16.83-.36l.1-.1 2.41-2.54zM7.16 3c.28 0 .54.07.77.21l.14.09 1.31.99-1.95 2.05-.06.06a.5.5 0 01-.22.1H2v-1A2.5 2.5 0 014.34 3h2.83zm4.7 10.86a.5.5 0 00-.71-.7l-2 1.99a.5.5 0 000 .7l2 2a.5.5 0 10.7-.7L10.72 16h5.58l-1.14 1.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 10-.7.7L16.29 15h-5.58l1.15-1.14z",
    fill: primaryFill
  }));
};

export const FolderSwapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwapFilledIcon({}), 'FolderSwapFilled');

const FolderSwapRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v9.16A2.5 2.5 0 004.5 17h4.38l-.44-.43a1.5 1.5 0 01-.36-.57H4.36A1.5 1.5 0 013 14.5v-7H7.22c.36-.04.69-.2.94-.47L9.62 5.5h6.02A1.5 1.5 0 0117 7v5.88l1 1V6.84l-.02-.17A2.5 2.5 0 0015.5 4.5H9.67l-1.6-1.2-.14-.09zM4.5 4h2.75a.5.5 0 01.22.1l1.22.92-1.26 1.32-.06.06a.5.5 0 01-.3.1H3V5.36A1.5 1.5 0 014.5 4zm7.36 9.86a.5.5 0 00-.71-.7l-2 1.99a.5.5 0 000 .7l2 2a.5.5 0 10.7-.7L10.72 16h5.58l-1.14 1.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 10-.7.7L16.29 15h-5.58l1.15-1.14z",
    fill: primaryFill
  }));
};

export const FolderSwapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwapRegularIcon({}), 'FolderSwapRegular');

const FolderSyncFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const FolderSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSyncFilledIcon({}), 'FolderSyncFilled');

const FolderSyncRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const FolderSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSyncRegularIcon({}), 'FolderSyncRegular');

const FolderZipFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 4.5h-1.44l-2.4 2.53-.11.1c-.23.2-.52.33-.83.36l-.15.01H2v7.16A2.5 2.5 0 004.5 17H13v-1.94a.52.52 0 010-.12V14h-.5a.5.5 0 010-1h.5v-2h-.5a.5.5 0 010-1h.5V9h-.5a.5.5 0 01-.5-.5v-4zm2 0h-1V8h1V4.5zm1 0h.5a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H14v-1.5h.5a.5.5 0 000-1H14v-.96a.48.48 0 000-.09v-.95h.5a.5.5 0 100-1H14V9h.5a.5.5 0 00.5-.5v-4zM7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v1h5.15a.5.5 0 00.22-.1l.06-.06L9.4 4.3 8.06 3.3l-.14-.09z",
    fill: primaryFill
  }));
};

export const FolderZipFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZipFilledIcon({}), 'FolderZipFilled');

const FolderZipRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.17 3c.27 0 .53.07.76.21l.14.09 1.6 1.2h5.83a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H4.5A2.5 2.5 0 012 14.66V5.5A2.5 2.5 0 014.34 3h2.83zM14 5.5h-1V8h1V5.5zm-2 0H9.62L8.16 7.03a1.5 1.5 0 01-.94.46l-.15.01H3v7c0 .78.6 1.42 1.36 1.5H13v-.94a.51.51 0 010-.12V14h-.5a.5.5 0 110-1h.5v-2h-.5a.5.5 0 010-1h.5V9h-.5a.5.5 0 01-.5-.5v-3zm2 9h.5a.5.5 0 010 1H14v.5h1.5c.78 0 1.42-.6 1.5-1.36V7c0-.78-.6-1.42-1.36-1.5H15v3a.5.5 0 01-.5.5H14v2.5h.5a.5.5 0 010 1H14v.96a.48.48 0 010 .08v.96zM7.17 4H4.5c-.78 0-1.42.6-1.5 1.36V6.5h4.07a.5.5 0 00.3-.1l.06-.06L8.7 5.02 7.47 4.1a.5.5 0 00-.22-.1h-.08z",
    fill: primaryFill
  }));
};

export const FolderZipRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZipRegularIcon({}), 'FolderZipRegular');

const FontDecreaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.24 2.18a.75.75 0 00-.98 1.14l1.75 1.5c.28.24.7.24.98 0l1.75-1.5a.75.75 0 10-.98-1.14L15.5 3.26l-1.26-1.08zM10 4c-.3 0-.58.19-.7.47l-4.25 10.5a.75.75 0 101.4.56L7.87 12h4.26l1.42 3.53a.75.75 0 101.4-.56L10.7 4.47A.75.75 0 0010 4zm0 2.75l1.52 3.75H8.48L10 6.75z",
    fill: primaryFill
  }));
};

export const FontDecreaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontDecreaseFilledIcon({}), 'FontDecreaseFilled');

const FontDecreaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.15 2.15c.2-.2.5-.2.7 0l1.65 1.64 1.65-1.64a.5.5 0 11.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7zM10 4c.2 0 .39.12.46.31l4.5 11a.5.5 0 11-.92.38l-1.54-3.76V12h-5v-.07L5.96 15.7a.5.5 0 11-.92-.38l4.5-11A.5.5 0 0110 4zm-2.12 7h4.24L10 5.82 7.88 11z",
    fill: primaryFill
  }));
};

export const FontDecreaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontDecreaseRegularIcon({}), 'FontDecreaseRegular');

const FontIncreaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.24 4.82a.75.75 0 01-.98-1.14l1.75-1.5c.28-.24.7-.24.98 0l1.75 1.5a.75.75 0 11-.98 1.14L15.5 3.74l-1.26 1.08zM10 3.75c-.3 0-.58.18-.7.47l-4.5 11a.75.75 0 001.4.56l1.44-3.53h4.72l1.45 3.53a.75.75 0 101.38-.56l-4.5-11a.75.75 0 00-.69-.47zm0 2.73l1.75 4.27h-3.5L10 6.48z",
    fill: primaryFill
  }));
};

export const FontIncreaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontIncreaseFilledIcon({}), 'FontIncreaseFilled');

const FontIncreaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.85 4.85a.5.5 0 01-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7L15.5 3.21l-1.65 1.64zM10 4a.5.5 0 00-.46.31l-4.5 11a.5.5 0 10.92.38l1.54-3.76V12h5v-.07l1.54 3.76a.5.5 0 10.92-.38l-4.5-11A.5.5 0 0010 4zm0 1.82L12.12 11H7.88L10 5.82z",
    fill: primaryFill
  }));
};

export const FontIncreaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontIncreaseRegularIcon({}), 'FontIncreaseRegular');

const FontSpaceTrackingInFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.7 2.48a.75.75 0 00-1.4 0l-3.25 8.5a.75.75 0 001.4.53l.77-2.01h3.56l.77 2.01a.75.75 0 001.4-.53L7.7 2.48zM8.2 8H5.8L7 4.85 8.2 8zm-1.46 5.19a.75.75 0 10-.99 1.12l.5.44h-2.5a.75.75 0 000 1.5h2.5l-.5.44a.75.75 0 101 1.12l2-1.75a.75.75 0 000-1.13l-2-1.74zM13 12c.31 0 .59-.2.7-.48l3.25-8.5a.75.75 0 10-1.4-.53L13 9.15 10.45 2.5a.75.75 0 00-1.4.53l3.25 8.5c.11.29.39.48.7.48zm1.31 5.74a.75.75 0 01-1.05.07l-2-1.74a.75.75 0 010-1.13l2-1.75a.75.75 0 11.98 1.12l-.5.44h2.51a.75.75 0 010 1.5h-2.5l.5.44c.3.27.34.74.06 1.05z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingInFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingInFilledIcon({}), 'FontSpaceTrackingInFilled');

const FontSpaceTrackingInRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 12c.2 0 .38-.12.46-.32l3.5-9.02a.5.5 0 10-.93-.36L13 10.12 9.95 2.3a.5.5 0 00-.93.36l3.5 9.02c.08.2.27.32.47.32zM7.46 2.3a.5.5 0 00-.93 0l-2.34 6v.03l-1.17 3a.5.5 0 10.93.35L5.01 9h4l1.04 2.68a.5.5 0 10.93-.36L9.83 8.37a.5.5 0 00-.04-.11L7.47 2.3zM8.61 8H5.4L7 3.86 8.61 8zM6.5 13.12a.5.5 0 10-.65.76L7.14 15H3.5a.5.5 0 000 1h3.65l-1.3 1.12a.5.5 0 10.64.76l2.33-2a.5.5 0 000-.76l-2.33-2zm7.72 4.7a.5.5 0 01-.7.06l-2.34-2a.5.5 0 010-.76l2.33-2a.5.5 0 11.65.76L12.85 15h3.65a.5.5 0 010 1h-3.65l1.3 1.12c.21.18.24.5.06.7z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingInRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingInRegularIcon({}), 'FontSpaceTrackingInRegular');

const FontSpaceTrackingOutFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2c.31 0 .59.2.7.48l3.25 8.5a.75.75 0 01-1.4.53L7.78 9.5H4.22l-.77 2.01a.75.75 0 01-1.4-.53l3.25-8.5A.75.75 0 016 2zM4.8 8h2.4L6 4.85 4.8 8zm9.88 5.26a.75.75 0 011.06-.07l2 1.74a.75.75 0 010 1.13l-2 1.75a.75.75 0 11-.99-1.12l.5-.44H4.75l.5.44a.75.75 0 11-1 1.12l-2-1.74a.75.75 0 010-1.13l2-1.75a.75.75 0 011 1.12l-.5.44h10.5l-.5-.44a.75.75 0 01-.07-1.05zm.02-1.74a.75.75 0 01-1.4 0l-3.25-8.5a.75.75 0 011.4-.53L14 9.15l2.55-6.66a.75.75 0 011.4.53l-3.25 8.5z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOutFilledIcon({}), 'FontSpaceTrackingOutFilled');

const FontSpaceTrackingOutRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.46 11.68a.5.5 0 01-.93 0l-3.51-9.02a.5.5 0 11.93-.36l3.04 7.82 3.04-7.82a.5.5 0 01.94.36l-3.51 9.02zM6 1.98c.21 0 .4.13.47.32l2.32 5.96a.5.5 0 01.04.11l1.15 2.95a.5.5 0 11-.93.36L8 9H4l-1.04 2.68a.5.5 0 01-.93-.36l1.16-3 .01-.02 2.34-6A.5.5 0 016 1.98zM4.4 8H7.6l-1.6-4.14L4.4 8zm10.39 5.18a.5.5 0 01.7-.06l2.33 2a.5.5 0 010 .76l-2.33 2a.5.5 0 01-.65-.76l1.3-1.12H3.85l1.31 1.12a.5.5 0 11-.65.76l-2.33-2a.5.5 0 010-.76l2.33-2a.5.5 0 11.65.76L3.85 15h12.3l-1.3-1.12a.5.5 0 01-.06-.7z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOutRegularIcon({}), 'FontSpaceTrackingOutRegular');

const FoodFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3a.5.5 0 01.5.41V6.5a2.5 2.5 0 01-2 2.45v7.55a.5.5 0 01-1 .09V8.95a2.5 2.5 0 01-2-2.28V3.5a.5.5 0 011-.09V6.5c0 .65.42 1.2 1 1.41V3.5a.5.5 0 011-.09v4.5a1.5 1.5 0 001-1.26V3.5c0-.28.22-.5.5-.5zm5 0a.5.5 0 01.5.41V16.5a.5.5 0 01-1 .09V11h-1.5a.5.5 0 01-.5-.41V5.5A2.5 2.5 0 0114.5 3z",
    fill: primaryFill
  }));
};

export const FoodFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodFilledIcon({}), 'FoodFilled');

const FoodRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 3a.5.5 0 01.5.41V6.5a2.5 2.5 0 01-2 2.45v7.55a.5.5 0 01-1 .09V8.95a2.5 2.5 0 01-2-2.28V3.5a.5.5 0 011-.09V6.5c0 .65.42 1.2 1 1.41V3.5a.5.5 0 011-.09v4.5a1.5 1.5 0 001-1.26V3.5c0-.28.22-.5.5-.5zm5 0a.5.5 0 01.5.41V16.5a.5.5 0 01-1 .09V11h-1.5a.5.5 0 01-.5-.41V5.5A2.5 2.5 0 0114.5 3zm-.5 7V4.09a1.5 1.5 0 00-1 1.26V10h1V4.09 10z",
    fill: primaryFill
  }));
};

export const FoodRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodRegularIcon({}), 'FoodRegular');

const FoodAppleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.16 2.97a.5.5 0 00-.32-.94 3.18 3.18 0 00-1.86 1.9c-.05.11-.1.23-.13.34A4 4 0 006.2 2.14c-.58.01-1.05.48-1.06 1.06A3.99 3.99 0 006.3 6.14l.03.03A4 4 0 003.2 9.76v.07a8.5 8.5 0 001 4.75l.36.66a.5.5 0 00.03.05l1 1.4a2.69 2.69 0 004.09.34.46.46 0 01.64 0 2.69 2.69 0 004.09-.34l1-1.4a.51.51 0 00.03-.05l.36-.66a8.5 8.5 0 001-4.75v-.07a4 4 0 00-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34zm-5.25 6c-.28.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 01-.99.12c-.13-1.06 0-1.86.31-2.45.32-.6.8-.93 1.28-1.08a.5.5 0 01.32.94z",
    fill: primaryFill
  }));
};

export const FoodAppleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodAppleFilledIcon({}), 'FoodAppleFilled');

const FoodAppleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.22 8.34a.5.5 0 01-.31.63c-.28.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 01-.99.12c-.13-1.06 0-1.86.3-2.45.33-.6.82-.93 1.3-1.08a.5.5 0 01.62.31zm4.94-5.37a.5.5 0 00-.32-.94 3.18 3.18 0 00-1.86 1.9c-.05.11-.1.23-.13.34A4 4 0 006.2 2.14c-.58.01-1.05.48-1.06 1.06a3.99 3.99 0 001.2 2.97A4 4 0 003.2 9.76v.07a8.5 8.5 0 001 4.75l.36.66a.5.5 0 00.03.05l1 1.4a2.69 2.69 0 004.09.34.46.46 0 01.64 0 2.69 2.69 0 004.09-.34l1-1.4a.51.51 0 00.03-.05l.36-.66a8.5 8.5 0 001-4.75v-.07a4 4 0 00-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34zM8.72 6.28l-.16-.03a2.98 2.98 0 01-2.42-3.02c0-.05.04-.09.09-.1a2.99 2.99 0 013.08 3.1c0 .04-.04.08-.09.08-.17 0-.34 0-.5-.03zm-.33.96l.17.03.78.13a4 4 0 001.32 0l1.66-.28a3 3 0 013.49 2.72v.07a7.5 7.5 0 01-.9 4.2l-.33.62-.99 1.38c-.6.85-1.82.95-2.56.21a1.46 1.46 0 00-2.06 0c-.74.74-1.96.64-2.56-.21l-.99-1.38-.34-.63a7.5 7.5 0 01-.9-4.19l.01-.07a3 3 0 013.49-2.72l.71.12z",
    fill: primaryFill
  }));
};

export const FoodAppleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodAppleRegularIcon({}), 'FoodAppleRegular');

const FoodCakeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67.64 0 1.22-.2 1.6-.7.37-.47.49-1.11.44-1.83a3.56 3.56 0 00-.47-1.43C11.28 2.55 10.77 2 10 2zM3 9.78l3.2 2.94a1 1 0 001.43-.07l.86-.98a2 2 0 013 0l.86.98a1 1 0 001.43.07l3.2-2.94A2 2 0 0015 8H5a2 2 0 00-1.99 1.79zM17 11.14l-2.54 2.33a2 2 0 01-2.85-.15l-.86-.97a1 1 0 00-1.5 0l-.86.97a2 2 0 01-2.85.15L3 11.14V16h-.5a.5.5 0 000 1h15a.5.5 0 000-1H17v-4.86z",
    fill: primaryFill
  }));
};

export const FoodCakeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCakeFilledIcon({}), 'FoodCakeFilled');

const FoodCakeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67.64 0 1.22-.2 1.6-.7.37-.47.49-1.11.44-1.83a3.56 3.56 0 00-.47-1.43C11.28 2.55 10.77 2 10 2zM8.96 4.51c0-.2.11-.63.33-.99.22-.37.46-.54.7-.54.25 0 .5.17.72.55.21.37.32.8.33.98.04.6-.07.96-.23 1.16-.14.18-.38.31-.81.31-.45 0-.69-.12-.82-.3-.15-.18-.26-.54-.22-1.17zM5 8a2 2 0 00-2 2v6h-.5a.5.5 0 000 1h15a.5.5 0 000-1H17v-6a2 2 0 00-2-2H5zm11 8H4v-3.88l1.54 1.38a2 2 0 002.83-.16l.88-1a1 1 0 011.5 0l.88 1a2 2 0 002.83.16L16 12.12V16zm0-5.22l-2.21 1.97a1 1 0 01-1.42-.08l-.87-.99a2 2 0 00-3 0l-.87 1a1 1 0 01-1.42.07L4 10.78V10a1 1 0 011-1h10a1 1 0 011 1v.78z",
    fill: primaryFill
  }));
};

export const FoodCakeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCakeRegularIcon({}), 'FoodCakeRegular');

const FoodEggFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.47 9.6a.5.5 0 00.14-.98 2.14 2.14 0 00-2.35 2.16.5.5 0 001 0c0-.8.7-1.24 1.2-1.17zM3.99 7.14c-2.41 1.91-2.48 5.15-1.34 7.32a4.89 4.89 0 004.42 2.77c.54 0 .94-.01 1.24-.03.94-.03 1.11-.04 2.42.48a5.6 5.6 0 005.12-.47c1.39-.87 2.19-2.88 2.05-4.52-.08-.98 0-1.36.09-1.86.06-.33.13-.7.17-1.34a7.1 7.1 0 00-1.05-3.81 7.63 7.63 0 00-2.72-2.85 6.18 6.18 0 00-5.86-.15 7.15 7.15 0 00-3.07 3 5.1 5.1 0 01-1.47 1.46zm10.91 3.33a4.5 4.5 0 11-8.99 0 4.5 4.5 0 018.99 0z",
    fill: primaryFill
  }));
};

export const FoodEggFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEggFilledIcon({}), 'FoodEggFilled');

const FoodEggRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.06 9.58a.5.5 0 10.14-1c-.94-.12-1.78.6-1.78 1.64a.5.5 0 001 0c0-.46.32-.68.64-.64zm.35 5.38a4.5 4.5 0 100-8.99 4.5 4.5 0 000 9zm0-1a3.5 3.5 0 110-6.99 3.5 3.5 0 010 7zm1.22-11.89c1.04.07 2.02.38 2.72.83a7.6 7.6 0 012.7 2.83 7.1 7.1 0 011.05 3.82 9.84 9.84 0 01-.21 1.53c-.06.32-.1.66-.04 1.38.07.85-.1 1.78-.46 2.6a4.54 4.54 0 01-1.68 2.07 5.71 5.71 0 01-5.22.48c-.8-.33-1.08-.4-1.38-.42a6.7 6.7 0 00-.65 0c-.3.02-.67.03-1.18.03a5.05 5.05 0 01-4.56-2.84C1.59 12.2 1.62 8.9 4.1 6.94c.75-.6.98-.8 1.24-1.22.42-.7.82-1.25 1.3-1.73A7.7 7.7 0 018.4 2.74a5.9 5.9 0 013.23-.67zm-.07 1c-.9-.06-1.85.1-2.68.55a6.7 6.7 0 00-1.53 1.09c-.4.39-.75.86-1.14 1.52-.37.6-.73.9-1.49 1.5-2 1.59-2.1 4.31-1.11 6.19a4.05 4.05 0 003.67 2.3l1.14-.02h.02c.27-.01.5-.02.73 0 .48.02.89.16 1.7.48 1.46.58 3 .41 4.31-.4.54-.34 1-.92 1.3-1.61.3-.7.43-1.46.38-2.13a5.82 5.82 0 01.08-1.87c.06-.3.12-.63.16-1.19a6.12 6.12 0 00-.91-3.26 6.6 6.6 0 00-2.37-2.48 4.99 4.99 0 00-2.26-.67z",
    fill: primaryFill
  }));
};

export const FoodEggRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEggRegularIcon({}), 'FoodEggRegular');

const FoodGrainsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.43 2.21a.65.65 0 00-.86 0 5.72 5.72 0 00-1.92 4.35c0 .18.1.34.24.43A7.4 7.4 0 019.63 8.4a.5.5 0 00.74 0 7.4 7.4 0 011.74-1.42.5.5 0 00.24-.43c.02-1.59-.62-3.2-1.92-4.35zm-7.41 10a.66.66 0 01.6-.72A6.36 6.36 0 0110 15.33a6.36 6.36 0 016.38-3.84c.36.03.64.35.6.72A6.37 6.37 0 0110.64 18h-.46c-.06 0-.12 0-.18-.02a.66.66 0 01-.18.02h-.46a6.37 6.37 0 01-6.34-5.8zM10 10.83a6.36 6.36 0 00-6.38-3.84.66.66 0 00-.6.72c.08.9.35 1.75.76 2.5a.5.5 0 00.44.26c2.1.01 4.02.92 5.36 2.39.11.12.27.18.42.16a.5.5 0 00.42-.16 7.36 7.36 0 015.36-2.4.5.5 0 00.44-.25c.41-.75.68-1.6.76-2.5a.66.66 0 00-.6-.72A6.36 6.36 0 0010 10.83z",
    fill: primaryFill
  }));
};

export const FoodGrainsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodGrainsFilledIcon({}), 'FoodGrainsFilled');

const FoodGrainsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.43 2.21a.65.65 0 00-.86 0 5.73 5.73 0 00-1.74 5.74 7.11 7.11 0 00-4.2-.96.66.66 0 00-.61.72 6.99 6.99 0 001.65 3.77c-.35-.02-.7-.02-1.05 0a.66.66 0 00-.6.73A6.37 6.37 0 009.36 18h1.28c3.3 0 6.04-2.51 6.34-5.8a.66.66 0 00-.6-.71c-.35-.03-.7-.03-1.05-.01a6.99 6.99 0 001.65-3.77.66.66 0 00-.6-.72 7.1 7.1 0 00-4.21.96c.52-2-.06-4.24-1.74-5.74zM10 14.43a7.15 7.15 0 00-3.47-2.6 6.17 6.17 0 01-2.47-3.86c1.54-.05 3 .5 4.12 1.45.76.64.97 1.23 1.15 1.76l.22.54a.5.5 0 00.9 0l.22-.54c.18-.53.4-1.12 1.15-1.76a6.12 6.12 0 014.12-1.45 6.17 6.17 0 01-2.5 3.9A7.15 7.15 0 0010 14.42zM9.36 17a5.37 5.37 0 01-5.3-4.53 6.13 6.13 0 015.5 3.13.5.5 0 00.88 0 6.13 6.13 0 015.5-3.13 5.37 5.37 0 01-5.3 4.53H9.36zM10 9.82a4.74 4.74 0 010-6.64 4.74 4.74 0 010 6.64z",
    fill: primaryFill
  }));
};

export const FoodGrainsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodGrainsRegularIcon({}), 'FoodGrainsRegular');

const FoodPizzaFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86l-.25.19-.4-.44V9.3A16.37 16.37 0 004.88 4.5H4v-.55zM4 5.5V16.5a1.5 1.5 0 002.4 1.2L8 16.5a1 1 0 002 0v-2a.5.5 0 011-.06V15a1 1 0 002 0v-2.24c.82-.6 2.09-1.56 3.19-2.4l-.33-.37A15.37 15.37 0 004.87 5.5H4zm4.25 2.74a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.97 2a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-2.96 2.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const FoodPizzaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodPizzaFilledIcon({}), 'FoodPizzaFilled');

const FoodPizzaRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 9a.75.75 0 100-1.49.75.75 0 000 1.5zm3.72 1.26a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.5 13.5a.75.75 0 100-1.5.75.75 0 000 1.5zM4 3.96c0-1.1.9-2.02 2.03-1.95 4.45.27 8.35 1.77 11.4 4.68.87.83.7 2.18-.2 2.87-1.24.96-3.12 2.4-4.23 3.2v1.75c0 .71-.55 1.5-1.5 1.5-.18 0-.34-.03-.5-.08V16c0 .71-.55 1.49-1.5 1.49-.75 0-1.25-.5-1.42-1.05L6.4 17.7A1.5 1.5 0 014 16.5V3.96zm7 10.55c0 .25.2.5.5.5s.5-.25.5-.5v-2a.5.5 0 01.21-.4c.78-.57 2.1-1.58 3.28-2.48A15.43 15.43 0 005 5.52V16.5c0 .41.47.65.8.4l2.4-1.8a.5.5 0 01.8.4v.5c0 .26.2.5.5.5a.5.5 0 00.5-.5v-1.5a.5.5 0 011 0zm5.62-5.74c.46-.36.5-1 .12-1.35C13.88 4.69 10.22 3.27 5.97 3a.93.93 0 00-.97.96v.56c4.33.03 8.4 1.69 11.3 4.5l.32-.25z",
    fill: primaryFill
  }));
};

export const FoodPizzaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodPizzaRegularIcon({}), 'FoodPizzaRegular');

const FoodToastFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.78 7.45a.5.5 0 00-.5.5v4.1c0 .27.22.5.5.5h4.34a.5.5 0 00.5-.5v-4.1a.5.5 0 00-.5-.5H6.78zm.5 1h3.34v3.1H7.28v-3.1zM5.45 2.5c-1.63 0-3 1.1-3.6 2.48-.6 1.33-.49 3 .81 4.22v5.98c0 .3-.01.87.28 1.36.36.6 1.08.96 2.26.96h10.18c.41 0 .78-.02 1.1-.07.3-.06.6-.17.85-.39.5-.43.59-1.13.59-1.95 0-.88-.04-1.92-.07-2.93a66.88 66.88 0 01-.07-2.97 4.68 4.68 0 001.28-3 3.73 3.73 0 00-3.68-3.69H5.45zm7.38 1c.63 0 1.39.3 2 .82.6.51.99 1.18 1 1.85-.05.75-.21 1.24-.41 1.58-.16.27-.35.48-.56.69l-.16.15a13.81 13.81 0 00-.31.3l-.14.13v.2c-.04 1-.03 2.44-.02 3.84v.01l.01 2.02c0 .4-.02.7-.06.9-.04.2-.1.28-.14.32-.04.04-.12.1-.32.13a9.84 9.84 0 01-.89.06H5.2c-1 0-1.29-.29-1.4-.47-.14-.23-.14-.51-.14-.84V8.99a.5.5 0 00-.18-.39 2.65 2.65 0 01-.72-3.22 3.05 3.05 0 012.7-1.88h7.37z",
    fill: primaryFill
  }));
};

export const FoodToastFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToastFilledIcon({}), 'FoodToastFilled');

const FoodToastRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.23 7.95c0-.27.22-.5.5-.5h4.34c.28 0 .5.23.5.5v4.1a.5.5 0 01-.5.5H6.73a.5.5 0 01-.5-.5v-4.1zm1 3.6h3.34v-3.1H7.23v3.1zM1.79 4.98A4.05 4.05 0 015.4 2.5h9.93A3.73 3.73 0 0119 6.18c0 1.33-.76 2.46-1.28 3.01 0 .7.02 1.66.06 2.67v.3c.04 1 .08 2.05.08 2.93 0 .82-.1 1.52-.59 1.95-.24.22-.54.33-.86.39-.31.05-.68.07-1.1.07H5.16c-1.18 0-1.9-.35-2.26-.96a2.53 2.53 0 01-.28-1.45V9.2a3.64 3.64 0 01-.82-4.22zM5.4 3.5c-1.16 0-2.21.8-2.7 1.88a2.65 2.65 0 00.73 3.22c.12.1.18.24.18.38v6.21c0 .33 0 .6.14.84.1.18.4.47 1.4.47h7.63c.4 0 .68-.02.89-.06.2-.03.28-.09.32-.13.05-.04.1-.12.14-.32.04-.2.06-.5.06-.9v-2c-.02-1.42-.03-2.87 0-3.87a.5.5 0 01.15-.34l.3-.3c.24-.21.44-.4.63-.68.25-.35.46-.86.5-1.73 0-.67-.39-1.34-1-1.85a3.28 3.28 0 00-1.99-.82H5.4zm9.71 12.69l-.08.31h.3c.4 0 .69-.02.9-.06.23-.04.33-.1.4-.15.12-.1.24-.36.24-1.2 0-.86-.04-1.89-.07-2.9l-.01-.3c-.04-1.1-.07-2.16-.05-2.92a.5.5 0 01.15-.35 3.73 3.73 0 001.12-2.44 2.73 2.73 0 00-2.65-2.68l.06.06a3.52 3.52 0 011.35 2.62v.03a4.24 4.24 0 01-.67 2.26c-.26.38-.58.67-.84.91l-.07.07c-.02.97-.02 2.3 0 3.6v2.04c0 .42-.02.8-.08 1.1z",
    fill: primaryFill
  }));
};

export const FoodToastRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToastRegularIcon({}), 'FoodToastRegular');

const FormNewFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6V5.5A2.5 2.5 0 0014.5 3h-9zm9 6H10a.5.5 0 010-1h4.5a.5.5 0 010 1zm-9-4h9a.5.5 0 010 1h-9a.5.5 0 010-1zm1.25 3a.75.75 0 100 1.5.75.75 0 000-1.5zM5 8.75a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zm1 4.5a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm.75-1.75a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm12.25 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FormNewFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNewFilledIcon({}), 'FormNewFilled');

const FormNewRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5v-9C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v3.7c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0014.5 3h-9zM15 8.5a.5.5 0 01-.5.5H10a.5.5 0 010-1h4.5c.28 0 .5.22.5.5zM5.5 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm1.25 3a.75.75 0 100 1.5.75.75 0 000-1.5zM5 8.75a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zm1 4.5a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm.75-1.75a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm12.25 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FormNewRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNewRegularIcon({}), 'FormNewRegular');

const Fps120FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2.75a.75.75 0 00-1.4-.39 1.71 1.71 0 01-.1.16l-.33.41c-.3.33-.72.68-1.2.87a.75.75 0 00.56 1.4c.36-.15.69-.34.97-.55v4.6a.75.75 0 001.5 0v-6.5zm8 1.75a2.5 2.5 0 115 0v3a2.5 2.5 0 01-5 0v-3zm3.5 0a1 1 0 10-2 0v3a1 1 0 102 0v-3zM3 12.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1H4v2h1.5a.5.5 0 010 1H4v1.5a.5.5 0 01-1 0v-5zm5 0c0-.28.22-.5.5-.5H10a2 2 0 010 4H9v1.5a.5.5 0 01-1 0v-5zM9 15h1a1 1 0 100-2H9v2zm5.75-3a1.75 1.75 0 000 3.5h.5a.75.75 0 010 1.5h-.76a.49.49 0 01-.49-.49v-.01a.5.5 0 00-1 0v.01c0 .82.67 1.49 1.49 1.49h.76a1.75 1.75 0 100-3.5h-.5a.75.75 0 010-1.5h.76c.27 0 .49.22.49.49v.01a.5.5 0 101 0v-.01c0-.82-.67-1.49-1.49-1.49h-.76zM7.99 4.37v.01a.75.75 0 01-1.48-.25c-.07.41 0 0 0 0a1.71 1.71 0 01.1-.37A2.7 2.7 0 019.25 2c.96 0 1.73.38 2.22 1 .48.61.65 1.4.52 2.13-.14.81-.6 1.3-1.15 1.63a6.7 6.7 0 01-1.48.59c-.45.16-.76.33-.98.57-.11.13-.22.3-.3.58h3.17a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75c0-1.01.27-1.77.76-2.33.48-.53 1.09-.8 1.59-.98l.45-.16c.32-.1.56-.2.79-.32.24-.14.37-.3.42-.59a1.2 1.2 0 00-.22-.94c-.18-.23-.5-.43-1.04-.43-.62 0-.9.25-1.06.45a1.25 1.25 0 00-.2.43z",
    fill: primaryFill
  }));
};

export const Fps120Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps120FilledIcon({}), 'Fps120Filled');

const Fps120RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 10a.5.5 0 01-.5-.5V3.93c-.33.34-.75.7-1.24 1a.5.5 0 11-.52-.86 5.58 5.58 0 001.83-1.82.5.5 0 01.93.26V9.5a.5.5 0 01-.5.5zM12 4.5a2.5 2.5 0 015 0v3a2.5 2.5 0 01-5 0v-3zm4 0a1.5 1.5 0 00-3 0v3a1.5 1.5 0 003 0v-3zm-13 8c0-.28.22-.5.5-.5h3a.5.5 0 010 1H4v2h1.5a.5.5 0 010 1H4v1.5a.5.5 0 01-1 0v-5zm5 0c0-.28.22-.5.5-.5H10a2 2 0 110 4H9v1.5a.5.5 0 01-1 0v-5zM9 15h1a1 1 0 100-2H9v2zm5.75-3a1.75 1.75 0 100 3.5h.5a.75.75 0 010 1.5h-.76a.49.49 0 01-.49-.49v-.01a.5.5 0 00-1 0v.01c0 .82.67 1.49 1.49 1.49h.76a1.75 1.75 0 100-3.5h-.5a.75.75 0 010-1.5h.76c.27 0 .49.22.49.49v.01a.5.5 0 001 0v-.01c0-.82-.67-1.49-1.49-1.49h-.76zM6.99 4.08a.5.5 0 01-.57.41C5.94 4.41 6 3.92 6 3.92v-.04a1.66 1.66 0 01.09-.28c.06-.18.17-.41.34-.65A2.44 2.44 0 018.5 2c.86 0 1.59.3 2.05.88.46.58.59 1.36.44 2.2a2.12 2.12 0 01-1 1.49c-.34.21-.75.38-1.1.52l-.33.14c-.46.2-.84.4-1.1.72-.2.24-.36.56-.43 1.05h3.47a.5.5 0 010 1h-4a.5.5 0 01-.5-.5c0-.97.25-1.67.69-2.19.42-.5.98-.79 1.47-1l.43-.18c.33-.13.6-.25.85-.4.3-.2.5-.43.57-.81.11-.66-.01-1.13-.24-1.42-.23-.3-.63-.5-1.27-.5-.7 0-1.06.29-1.26.55a1.5 1.5 0 00-.25.53z",
    fill: primaryFill
  }));
};

export const Fps120Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps120RegularIcon({}), 'Fps120Regular');

const Fps124FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.26 3.03a1 1 0 01.76.97v8a1 1 0 01-2 0V6.5l-.47.33a1 1 0 01-1.1-1.66 6.55 6.55 0 001.69-1.63v-.01a1 1 0 011.12-.5zM18 3a3 3 0 00-3 3v4a3 3 0 006 0V6a3 3 0 00-3-3zm-1 3a1 1 0 112 0v4a1 1 0 01-2 0V6zM4 15.75c0-.41.34-.75.75-.75h3a.75.75 0 010 1.5H5.5V18h1.75a.75.75 0 010 1.5H5.5v1.73a.75.75 0 01-1.5 0v-5.48zm6.25-.75a.75.75 0 00-.75.75v5.5a.75.75 0 001.5 0V19.5h.75a2.25 2.25 0 100-4.5h-1.5zm1.5 3H11v-1.5h.75a.75.75 0 010 1.5zm3.5-.88c0-1.17.95-2.12 2.13-2.12H18a2 2 0 012 2 .75.75 0 01-1.5 0 .5.5 0 00-.5-.5h-.63a.62.62 0 100 1.25h.5a2.13 2.13 0 010 4.25h-.62a2 2 0 01-2-2 .75.75 0 011.5 0c0 .28.22.5.5.5h.63a.62.62 0 100-1.25h-.5a2.13 2.13 0 01-2.13-2.13zM8.13 6.19a1 1 0 001.29-.54l.03-.05c.04-.06.1-.14.2-.22.16-.16.49-.37 1.1-.37.42 0 .75.13.94.3.19.15.31.37.31.7 0 .55-.17.86-.42 1.12-.3.32-.73.56-1.33.9a6.9 6.9 0 00-1.8 1.33A3.82 3.82 0 007.5 12a1 1 0 001 1H13a1 1 0 100-2H9.72c.07-.12.15-.22.23-.32.3-.33.72-.6 1.3-.92l.1-.06c.51-.3 1.16-.66 1.67-1.19C13.6 7.9 14 7.1 14 6c0-.91-.38-1.7-1.01-2.23A3.44 3.44 0 0010.75 3c-1.14 0-1.94.42-2.45.89a3.11 3.11 0 00-.73.99s-.2.52 0 0a1 1 0 00.56 1.3z",
    fill: primaryFill
  }));
};

export const Fps124Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps124FilledIcon({}), 'Fps124Filled');

const Fps124RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3.75a.75.75 0 00-1.36-.44l-.02.02a6.36 6.36 0 01-.18.25c-.13.16-.31.4-.54.64a7.3 7.3 0 01-1.54 1.39.75.75 0 00.78 1.28c.48-.29.95-.7 1.36-1.1v6.46a.75.75 0 001.5 0v-8.5zm3.49 1.64A.75.75 0 018 5.13V5.1A1.36 1.36 0 018.04 5l.08-.26c.08-.2.21-.46.43-.72A3.04 3.04 0 0111 3a3 3 0 013 3c0 1.02-.36 1.78-.9 2.36-.47.52-1.09.9-1.6 1.23l-.1.06c-.58.36-1.04.67-1.37 1.06-.19.22-.34.47-.43.79h3.65a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75c0-1.07.35-1.88.88-2.5.5-.6 1.17-1.03 1.72-1.37l.03-.02c.58-.36 1.03-.65 1.36-1 .3-.34.51-.74.51-1.36 0-.83-.67-1.5-1.5-1.5-.78 0-1.13.28-1.3.48a1.12 1.12 0 00-.21.4zM17.99 3A3 3 0 0015 6v4a3 3 0 006 0V6a3 3 0 00-3-3zM16.5 6a1.5 1.5 0 113 0v4a1.5 1.5 0 11-3 0V6zM4 15.75c0-.41.34-.75.75-.75h3a.75.75 0 010 1.5H5.5V18h1.75a.75.75 0 010 1.5H5.5v1.73a.75.75 0 01-1.5 0v-5.48zm6.25-.75a.75.75 0 00-.75.75v5.5a.75.75 0 001.5 0V19.5h.75a2.25 2.25 0 100-4.5h-1.5zm1.5 3H11v-1.5h.75a.75.75 0 010 1.5zm3.5-.88c0-1.17.95-2.12 2.13-2.12H18a2 2 0 012 2 .75.75 0 01-1.5 0 .5.5 0 00-.5-.5h-.63a.62.62 0 100 1.25h.5a2.13 2.13 0 010 4.25h-.62a2 2 0 01-2-2 .75.75 0 011.5 0c0 .28.22.5.5.5h.63a.62.62 0 100-1.25h-.5a2.13 2.13 0 01-2.13-2.13z",
    fill: primaryFill
  }));
};

export const Fps124Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps124RegularIcon({}), 'Fps124Regular');

const Fps240FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.99 4.38a.75.75 0 01-1.48-.25v-.05a1.92 1.92 0 01.1-.32A2.7 2.7 0 014.25 2c.96 0 1.73.38 2.22 1 .48.61.65 1.4.52 2.13-.14.81-.6 1.3-1.15 1.63a6.71 6.71 0 01-1.48.59c-.45.16-.76.33-.98.57-.11.13-.22.3-.3.58h3.17a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75c0-1.01.27-1.77.76-2.33.48-.53 1.09-.8 1.59-.98l.45-.16c.32-.1.56-.2.79-.32.24-.14.37-.3.42-.59a1.2 1.2 0 00-.22-.94c-.18-.23-.5-.43-1.04-.43-.62 0-.9.25-1.06.45a1.25 1.25 0 00-.2.43zm0 0zm0 0zM16.5 2A2.5 2.5 0 0014 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0016.5 2zm1 5.5a1 1 0 11-2 0v-3a1 1 0 112 0v3zM3.5 12a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm.5 3v-2h1a1 1 0 110 2H9zm4-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zM8.75 2c.41 0 .75.34.75.75V5.5H11V2.75a.75.75 0 011.5 0V9.5a.75.75 0 01-1.5 0V7H8.75A.75.75 0 018 6.25v-3.5c0-.41.34-.75.75-.75zM2.99 4.38z",
    fill: primaryFill
  }));
};

export const Fps240Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps240FilledIcon({}), 'Fps240Filled');

const Fps240RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.09v-.03l.04-.12c.04-.11.1-.25.2-.39.2-.26.55-.55 1.26-.55.64 0 1.04.2 1.27.5.23.3.35.76.24 1.42-.07.38-.26.61-.57.8-.24.16-.52.28-.85.41l-.43.18c-.5.21-1.05.5-1.47 1A3.27 3.27 0 002 9.5a.5.5 0 00.5.5h4a.5.5 0 000-1H3.03c.07-.49.23-.81.43-1.05.26-.32.64-.52 1.1-.72.1-.05.2-.1.32-.14.36-.14.77-.3 1.1-.52.49-.31.89-.76 1.01-1.49.15-.84.02-1.62-.44-2.2C6.1 2.29 5.36 2 4.5 2a2.44 2.44 0 00-2.49 1.88v.03S2 4 2 3.92a.5.5 0 00.98.18zm10 .41a2.5 2.5 0 015 0v3a2.5 2.5 0 01-5 0v-3zm4 3v-3a1.5 1.5 0 00-3 0v3a1.5 1.5 0 003 0zm-14 5c0-.28.22-.5.5-.5h3a.5.5 0 010 1H4v2h1.5a.5.5 0 010 1H4v1.5a.5.5 0 01-1 0v-5zm5 0c0-.28.22-.5.5-.5H10a2 2 0 110 4H9v1.5a.5.5 0 01-1 0v-5zM9 15h1a1 1 0 100-2H9v2zm5.75-3a1.75 1.75 0 100 3.5h.5a.75.75 0 010 1.5h-.76a.49.49 0 01-.49-.49v-.01a.5.5 0 00-1 0v.01c0 .82.67 1.49 1.49 1.49h.76a1.75 1.75 0 100-3.5h-.5a.75.75 0 010-1.5h.76c.27 0 .49.22.49.49v.01a.5.5 0 001 0v-.01c0-.82-.67-1.49-1.49-1.49h-.76zM9 2.5a.5.5 0 00-1 0v4a.5.5 0 00.5.5H11v2.5a.5.5 0 001 0v-7a.5.5 0 00-1 0V6H9V2.5z",
    fill: primaryFill
  }));
};

export const Fps240Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps240RegularIcon({}), 'Fps240Regular');

const Fps30FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 2A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm0 6.5a1 1 0 01-1-1v-3a1 1 0 112 0v3a1 1 0 01-1 1zm-9 3.5a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zm-6.5-8.5c.63 0 1-.46 1-.88 0-.4-.37-.87-1-.87-.26 0-.48.08-.64.2-.2.15-.41.3-.65.3-.62 0-1.09-.58-.7-1.06A2.54 2.54 0 016.5 2C7.88 2 9 3.06 9 4.38a2.3 2.3 0 01-.66 1.6A2.37 2.37 0 016.62 10h-.25c-.78 0-1.47-.38-1.9-.96-.36-.48.1-1.04.7-1.04.25 0 .47.16.67.32.15.11.33.18.53.18h.25a.87.87 0 100-1.75H6.5a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const Fps30Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps30FilledIcon({}), 'Fps30Filled');

const Fps30RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 2A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm0 7A1.5 1.5 0 0111 7.5v-3a1.5 1.5 0 013 0v3c0 .83-.67 1.5-1.5 1.5zm-9 3a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zM6.75 3h-.5c-.49 0-.91.28-1.12.69-.08.17-.24.31-.44.31-.36 0-.65-.32-.5-.65A2.25 2.25 0 016.25 2h.5a2.25 2.25 0 011.41 4 2.25 2.25 0 01-1.41 4h-.5c-.92 0-1.71-.55-2.06-1.35-.15-.33.14-.65.5-.65.2 0 .36.14.44.31.2.41.63.69 1.12.69h.5a1.25 1.25 0 000-2.5H6.5a.5.5 0 010-1h.25a1.25 1.25 0 000-2.5z",
    fill: primaryFill
  }));
};

export const Fps30Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps30RegularIcon({}), 'Fps30Regular');

const Fps60FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 2A2.5 2.5 0 004 4.5v3A2.5 2.5 0 106.5 5h-.1c-.32 0-.62.06-.9.17V4.5a1 1 0 011-1h.25c.41 0 .75.34.75.75a.75.75 0 001.5 0C9 3.01 8 2 6.75 2H6.5zm-1 5.5v-.1c0-.5.4-.9.9-.9h.1a1 1 0 11-1 1zm6-3a1 1 0 112 0v3a1 1 0 11-2 0v-3zm1-2.5A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm-9 10a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.75c.83 0 1.5.67 1.5 1.5a.5.5 0 01-1 0 .5.5 0 00-.5-.5h-.75a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.75a1.5 1.5 0 01-1.5-1.5.5.5 0 011 0c0 .28.22.5.5.5h.75a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75z",
    fill: primaryFill
  }));
};

export const Fps60Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps60FilledIcon({}), 'Fps60Filled');

const Fps60RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 2A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm0 7A1.5 1.5 0 0111 7.5v-3a1.5 1.5 0 013 0v3c0 .83-.67 1.5-1.5 1.5zm-9 3a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zM4 4.5v3a2.5 2.5 0 101-2v-1a1.5 1.5 0 113 0 .5.5 0 001 0 2.5 2.5 0 00-5 0zM6.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const Fps60Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps60RegularIcon({}), 'Fps60Regular');

const Fps960FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 10A2.5 2.5 0 007 7.5v-3A2.5 2.5 0 104.5 7h.1c.32 0 .62-.06.9-.17v.67a1 1 0 01-1 1h-.25a.75.75 0 01-.75-.75.75.75 0 00-1.5 0C2 8.99 3 10 4.25 10h.25zm1-5.5v.1c0 .5-.4.9-.9.9h-.1a1 1 0 111-1zm5-2.5A2.5 2.5 0 008 4.5v3A2.5 2.5 0 1010.5 5h-.1c-.32 0-.62.06-.9.17V4.5a1 1 0 011-1h.25c.41 0 .75.34.75.75a.75.75 0 001.5 0C13 3.01 12 2 10.75 2h-.25zm-1 5.5v-.1c0-.5.4-.9.9-.9h.1a1 1 0 11-1 1zm6-3a1 1 0 112 0v3a1 1 0 11-2 0v-3zm1-2.5A2.5 2.5 0 0014 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0016.5 2zm-13 10a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm2.5 2a1 1 0 01-1 1H9v-2h1a1 1 0 011 1zm2-.25c0-.97.78-1.75 1.75-1.75h.75c.83 0 1.5.67 1.5 1.5a.5.5 0 01-1 0 .5.5 0 00-.5-.5h-.75a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.75a1.5 1.5 0 01-1.5-1.5.5.5 0 011 0c0 .28.22.5.5.5h.75a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75z",
    fill: primaryFill
  }));
};

export const Fps960Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps960FilledIcon({}), 'Fps960Filled');

const Fps960RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 7.5a2.5 2.5 0 01-5 0 .5.5 0 011 0 1.5 1.5 0 103 0v-1a2.5 2.5 0 111-2v3zm-1-3a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM10.5 2A2.5 2.5 0 008 4.5v3a2.5 2.5 0 101-2v-1a1.5 1.5 0 113 0 .5.5 0 001 0A2.5 2.5 0 0010.5 2zm0 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm6-6c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 003 0v-3c0-.83-.67-1.5-1.5-1.5zM14 4.5a2.5 2.5 0 015 0v3a2.5 2.5 0 01-5 0v-3zM3.5 12a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.75c.83 0 1.5.67 1.5 1.5a.5.5 0 01-1 0 .5.5 0 00-.5-.5h-.75a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.75a1.5 1.5 0 01-1.5-1.5.5.5 0 011 0c0 .28.22.5.5.5h.75a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75z",
    fill: primaryFill
  }));
};

export const Fps960Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps960RegularIcon({}), 'Fps960Regular');

const FullScreenMaximizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5.25C3 4.01 4 3 5.25 3h1.87a.75.75 0 110 1.5H5.25a.75.75 0 00-.75.75v1.87a.75.75 0 11-1.5 0V5.25zm9.13-1.5c0-.41.34-.75.75-.75h1.87C15.99 3 17 4 17 5.25v1.87a.75.75 0 01-1.5 0V5.25a.75.75 0 00-.75-.75h-1.87a.75.75 0 01-.75-.75zm-8.38 8.38c.41 0 .75.34.75.75v1.87c0 .41.34.75.75.75h1.87a.75.75 0 010 1.5H5.25C4.01 17 3 16 3 14.75v-1.87c0-.41.34-.75.75-.75zm12.5 0c.41 0 .75.34.75.75v1.87c0 1.24-1 2.25-2.25 2.25h-1.87a.75.75 0 010-1.5h1.87c.41 0 .75-.34.75-.75v-1.87c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const FullScreenMaximizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximizeFilledIcon({}), 'FullScreenMaximizeFilled');

const FullScreenMaximizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h2a.5.5 0 010 1H5a1 1 0 00-1 1v2a.5.5 0 01-1 0V5zm9.5-1.5c0-.28.22-.5.5-.5h2a2 2 0 012 2v2a.5.5 0 01-1 0V5a1 1 0 00-1-1h-2a.5.5 0 01-.5-.5zm-9 9c.28 0 .5.22.5.5v2a1 1 0 001 1h2a.5.5 0 010 1H5a2 2 0 01-2-2v-2c0-.28.22-.5.5-.5zm13 0c.28 0 .5.22.5.5v2a2 2 0 01-2 2h-2a.5.5 0 010-1h2a1 1 0 001-1v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const FullScreenMaximizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximizeRegularIcon({}), 'FullScreenMaximizeRegular');

const FullScreenMinimizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 5.5a.5.5 0 01-.5-.5V2.75a.75.75 0 00-1.5 0V5c0 1.1.9 2 2 2h2.25a.75.75 0 000-1.5H15zM5.5 15a.5.5 0 00-.5-.5H2.75a.75.75 0 010-1.5H5a2 2 0 012 2v2.25a.75.75 0 01-1.5 0V15zm9 0c0-.28.22-.5.5-.5h2.25a.75.75 0 000-1.5H15a2 2 0 00-2 2v2.25a.75.75 0 001.5 0V15zm-9-10a.5.5 0 01-.5.5H2.75a.75.75 0 000 1.5H5a2 2 0 002-2V2.75a.75.75 0 00-1.5 0V5z",
    fill: primaryFill
  }));
};

export const FullScreenMinimizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimizeFilledIcon({}), 'FullScreenMinimizeFilled');

const FullScreenMinimizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 5a1 1 0 001 1h2a.5.5 0 010 1h-2a2 2 0 01-2-2V3a.5.5 0 011 0v2zM6 15a1 1 0 00-1-1H3a.5.5 0 010-1h2a2 2 0 012 2v2a.5.5 0 01-1 0v-2zm8 0a1 1 0 011-1h2a.5.5 0 000-1h-2a2 2 0 00-2 2v2a.5.5 0 001 0v-2zM5 6a1 1 0 001-1V3a.5.5 0 011 0v2a2 2 0 01-2 2H3a.5.5 0 010-1h2z",
    fill: primaryFill
  }));
};

export const FullScreenMinimizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimizeRegularIcon({}), 'FullScreenMinimizeRegular');

const GamesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 4a5.5 5.5 0 100 11h5a5.5 5.5 0 100-11h-5zM6 7.5a.5.5 0 011 0V9h1.5a.5.5 0 010 1H7v1.5a.5.5 0 01-1 0V10H4.5a.5.5 0 010-1H6V7.5zm9 .5a1 1 0 11-2 0 1 1 0 012 0zm-3 4a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const GamesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GamesFilledIcon({}), 'GamesFilled');

const GamesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 7.5a.5.5 0 011 0V9h1.5a.5.5 0 010 1H7v1.5a.5.5 0 01-1 0V10H4.5a.5.5 0 010-1H6V7.5zm9 .5a1 1 0 11-2 0 1 1 0 012 0zm-3 4a1 1 0 100-2 1 1 0 000 2zM2 9.5A5.5 5.5 0 017.5 4h5a5.5 5.5 0 110 11h-5A5.5 5.5 0 012 9.5zM7.5 5a4.5 4.5 0 000 9h5a4.5 4.5 0 100-9h-5z",
    fill: primaryFill
  }));
};

export const GamesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GamesRegularIcon({}), 'GamesRegular');

const GanttChartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 014.5 4H7v2H4.5a1.5 1.5 0 100 3H7v7H4.5A2.5 2.5 0 012 13.5v-7zM8 16V9.5c0 .83.67 1.5 1.5 1.5H11v.5c0 .65.42 1.2 1 1.41V16H8zm2-8h2V4H8v2h.5c.83 0 1.5.67 1.5 1.5V8zm5.5 5H13v3h2.5a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4H13v4h.5c.83 0 1.5.67 1.5 1.5v.5h.5a1.5 1.5 0 010 3zm-11-6a.5.5 0 000 1h4a.5.5 0 000-1h-4zM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm3.5 1.5a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }));
};

export const GanttChartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GanttChartFilledIcon({}), 'GanttChartFilled');

const GanttChartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 7a.5.5 0 000 1h4a.5.5 0 000-1h-4zM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm3.5 1.5a.5.5 0 000 1h3a.5.5 0 000-1h-3zm-8-7A2.5 2.5 0 002 6.5v7A2.5 2.5 0 004.5 16h11a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015.5 4h-11zM3 6.5C3 5.67 3.67 5 4.5 5H7v1h1V5h4v3h1V5h2.5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H13v-2h-1v2H8V9H7v6H4.5A1.5 1.5 0 013 13.5v-7z",
    fill: primaryFill
  }));
};

export const GanttChartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GanttChartRegularIcon({}), 'GanttChartRegular');

const GasFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.08 2.22A.5.5 0 0111.5 2h3c.28 0 .5.22.5.5v3c.6.46 1 1.18 1 2v7a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 014 14.5v-7A2.5 2.5 0 016.5 5h.41c-.2-.58-.76-1-1.41-1h-1a.5.5 0 010-1h1c1.2 0 2.22.86 2.45 2h1.28l1.85-2.78zM14 3h-2.23l-1.34 2h3.07c.17 0 .34.02.5.05V3zm-1.15 5.15a.5.5 0 00-.7 0L10 10.29 7.85 8.15a.5.5 0 10-.7.7L9.29 11l-2.14 2.15a.5.5 0 00.7.7L10 11.71l2.15 2.14a.5.5 0 00.7-.7L10.71 11l2.14-2.15a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const GasFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GasFilledIcon({}), 'GasFilled');

const GasRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.08 2.22A.5.5 0 0111.5 2h3c.28 0 .5.22.5.5v3c.6.46 1 1.18 1 2v7a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 014 14.5v-7A2.5 2.5 0 016.5 5h.41c-.2-.58-.76-1-1.41-1h-1a.5.5 0 010-1h1c1.2 0 2.22.86 2.45 2h1.28l1.85-2.78zM14 3h-2.23l-1.34 2h3.07c.17 0 .34.02.5.05V3zM6.5 6C5.67 6 5 6.67 5 7.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7zm6.35 2.15c.2.2.2.5 0 .7L10.71 11l2.14 2.15a.5.5 0 01-.7.7L10 11.71l-2.15 2.14a.5.5 0 01-.7-.7L9.29 11 7.15 8.85a.5.5 0 11.7-.7L10 10.29l2.15-2.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const GasRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GasRegularIcon({}), 'GasRegular');

const GasPumpFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 17V4.5A2.5 2.5 0 016.5 2h5A2.5 2.5 0 0114 4.5v9a1.5 1.5 0 003 0V9.17c0-.33-.1-.64-.3-.9L15.6 6.8a.5.5 0 01.8-.6l1.1 1.47c.32.43.5.96.5 1.5v4.33a2.5 2.5 0 01-4 2V17h.5a.5.5 0 010 1h-11a.5.5 0 010-1H4zM6.5 4a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-5z",
    fill: primaryFill
  }));
};

export const GasPumpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GasPumpFilledIcon({}), 'GasPumpFilled');

const GasPumpRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 4.5V17h8V4.5c0-.83-.67-1.5-1.5-1.5h-5C5.67 3 5 3.67 5 4.5zm9 11V17h.5a.5.5 0 010 1h-11a.5.5 0 010-1H4V4.5A2.5 2.5 0 016.5 2h5A2.5 2.5 0 0114 4.5v9a1.5 1.5 0 003 0V9.17c0-.33-.1-.64-.3-.9L15.6 6.8a.5.5 0 01.8-.6l1.1 1.47c.32.43.5.96.5 1.5v4.33a2.5 2.5 0 01-4 2zm-8-11v4c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5zM7 5h4v3H7V5z",
    fill: primaryFill
  }));
};

export const GasPumpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GasPumpRegularIcon({}), 'GasPumpRegular');

const GaugeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1.82-12.66a5 5 0 00-5.36 8.2.5.5 0 01-.7.7 6 6 0 016.42-9.83.5.5 0 01-.36.93zm3.77 2.48a6 6 0 01-1.35 6.42.5.5 0 11-.7-.7 5 5 0 001.12-5.36.5.5 0 01.93-.36zm-1.5-2a.5.5 0 01.1.62l-.1.2a323.59 323.59 0 01-.69 1.2l-.23.4-.3.53a184.46 184.46 0 01-1.48 2.48 4.28 4.28 0 01-.16.23 1.5 1.5 0 11-2.28-1.95c.07-.09.2-.2.34-.33l.56-.48a125.12 125.12 0 012.96-2.4l.27-.22.37-.3a.5.5 0 01.64.02z",
    fill: primaryFill
  }));
};

export const GaugeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GaugeFilledIcon({}), 'GaugeFilled');

const GaugeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.47 5.06a.5.5 0 01-.65.28 5 5 0 00-5.36 8.2.5.5 0 11-.7.7 6 6 0 016.42-9.83c.26.1.39.39.29.65zm2.47 2.47a.5.5 0 01.65.29 6 6 0 01-1.35 6.42.5.5 0 11-.7-.7 5 5 0 001.12-5.36.5.5 0 01.28-.65zm-.85-1.71a.5.5 0 00-.64-.01l-.18.14A335.17 335.17 0 009.3 9.2c-.14.12-.27.24-.34.33a1.5 1.5 0 102.28 1.95l.27-.4.38-.62a123.47 123.47 0 002.2-3.82l.12-.2a.5.5 0 00-.11-.62zM10 18a8 8 0 100-16 8 8 0 000 16zm0-1a7 7 0 110-14 7 7 0 010 14z",
    fill: primaryFill
  }));
};

export const GaugeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GaugeRegularIcon({}), 'GaugeRegular');

const GaugeAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 10-8-7.75c.6-.48 1.3-.85 2.05-1.06a6 6 0 018.13-4.78.5.5 0 01-.36.93A5 5 0 005.1 9.01a5.58 5.58 0 013.57 1c.06-.17.15-.34.28-.48.07-.09.2-.2.34-.33l.56-.48a125.12 125.12 0 012.96-2.4l.27-.22.37-.3a.5.5 0 01.75.64l-.11.2a323.59 323.59 0 01-.69 1.2l-.23.4-.3.53a184.46 184.46 0 01-1.48 2.48 4.28 4.28 0 01-.16.23 1.5 1.5 0 01-.84.5A5.48 5.48 0 019.75 18H10zm5.6-10.18a6 6 0 01-1.36 6.42.5.5 0 11-.7-.7 5 5 0 001.12-5.36.5.5 0 01.93-.36zM8 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const GaugeAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GaugeAddFilledIcon({}), 'GaugeAddFilled');

const GaugeAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.4 16.99a7 7 0 10-7.39-7.4c-.36.19-.7.4-1 .66L2 10a8 8 0 117.75 8c.25-.31.47-.65.66-1.01zm2.07-11.93a.5.5 0 01-.65.28A5 5 0 005.1 9.01c-.36.03-.71.1-1.05.18a6 6 0 018.13-4.78c.26.1.39.39.29.65zM8.67 10c.72.5 1.3 1.18 1.72 1.96.31-.06.61-.23.84-.5.07-.08.17-.23.27-.38l.38-.63a123.47 123.47 0 002.2-3.82l.12-.2a.5.5 0 00-.75-.63l-.18.14A335.17 335.17 0 009.3 9.2c-.14.12-.27.24-.34.33-.13.14-.22.3-.28.48zm6.27-2.48a.5.5 0 01.65.29 6 6 0 01-1.35 6.42.5.5 0 11-.7-.7 5 5 0 001.12-5.36.5.5 0 01.28-.65zM8 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const GaugeAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GaugeAddRegularIcon({}), 'GaugeAddRegular');

const GavelFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.67 7.59a1.5 1.5 0 01-.23-2.3l2.84-2.85a1.5 1.5 0 012.28.19l.47.65L7.3 8.01l-.63-.42zm1.48 1l4.47-4.49 1.33 1.84a.5.5 0 00.1.11l1.85 1.33-4.48 4.47-1.26-1.87a.5.5 0 00-.14-.14L8.15 8.58zm3.84 4.11l4.73-4.73.65.47c.75.54.84 1.63.19 2.28l-2.84 2.84a1.5 1.5 0 01-2.31-.22l-.42-.64zm-3.8-2.89L2.4 15.6a1.41 1.41 0 102 2l5.78-5.78-.8-1.2-1.2-.8zM12 16.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h2a.5.5 0 010 1h-7a.5.5 0 010-1h2a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const GavelFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GavelFilledIcon({}), 'GavelFilled');

const GavelRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.44 5.28a1.5 1.5 0 00.23 2.31l1.76 1.18-5.85 5.86a1.98 1.98 0 102.8 2.8l5.85-5.86 1.18 1.77c.53.78 1.64.89 2.3.22l2.85-2.84a1.5 1.5 0 00-.19-2.28l-3.31-2.39a.5.5 0 01-.11-.1l-2.4-3.32a1.5 1.5 0 00-2.27-.19L6.44 5.28zm4.22 5.44l-6 6a.98.98 0 01-1.37-1.39l5.99-5.99.74.5c.06.04.1.08.14.14l.5.74zM7.22 6.76a.5.5 0 01-.07-.77l2.84-2.84a.5.5 0 01.76.06l.57.79-3.3 3.3-.8-.54zm1.65 1.1l3.04-3.04 1.22 1.7c.1.14.21.25.34.35l1.71 1.22-3.04 3.04-1.15-1.71a1.5 1.5 0 00-.41-.41L8.87 7.86zM16 8.7l.79.56a.5.5 0 01.06.76l-2.84 2.84a.5.5 0 01-.77-.07l-.53-.8 3.3-3.3zm-4 7.81c0-.28.22-.5.5-.5h3a.5.5 0 110 1h2a.5.5 0 110 1h-7a.5.5 0 110-1h2a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const GavelRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GavelRegularIcon({}), 'GavelRegular');

const GestureFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM3.5 16.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.75 4a.75.75 0 00-.3 1.43l9.06 4.1-9.6 4.8a.75.75 0 10.68 1.34l11-5.5a.75.75 0 00-.03-1.35L9.23 5.5h5.52a.75.75 0 000-1.5h-9z",
    fill: primaryFill
  }));
};

export const GestureFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GestureFilledIcon({}), 'GestureFilled');

const GestureRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.01 4.4A.5.5 0 015.5 4h9a.5.5 0 010 1H7.8l8.9 4.04a.5.5 0 01.04.9l-11 5.92a.5.5 0 11-.48-.88l10.12-5.44L5.29 4.96a.5.5 0 01-.28-.57zM17 4.5a.5.5 0 11-1 0 .5.5 0 011 0zM3.5 17a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const GestureRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GestureRegularIcon({}), 'GestureRegular');

const GifFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.4 3c1.39 0 2.52 1.19 2.6 2.68v8.48c0 1.51-1.09 2.75-2.45 2.84H4.6c-1.39 0-2.52-1.19-2.6-2.68V5.84C2 4.33 3.09 3.1 4.45 3H15.4zM6.85 7C5.18 7 4 8.32 4 10c0 1.64 1.26 3 2.85 3 1.2 0 2.07-.8 2.14-1.63l.01-.12V9.9a.52.52 0 00-.44-.4h-.1l-.92-.01h-.1A.51.51 0 007 10c0 .25.2.45.44.5h.48v.83c-.07.32-.47.67-1.07.67-.96 0-1.77-.88-1.77-2 0-1.17.74-2 1.77-2 .46 0 .83.07 1.1.2.26.12.59.02.72-.23.14-.24.03-.55-.24-.67C8 7.1 7.47 7 6.85 7zM11 7a.5.5 0 00-.5.41v5.18a.5.5 0 001 0V7.41A.5.5 0 0011 7zm4.5 0h-2a.5.5 0 00-.5.41v5.18a.5.5 0 001 0V11h1.59a.5.5 0 000-1H14V8h1.59a.5.5 0 000-1h-.09z",
    fill: primaryFill
  }));
};

export const GifFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GifFilledIcon({}), 'GifFilled');

const GifRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.4 3c1.39 0 2.52 1.19 2.6 2.68v8.48c0 1.51-1.09 2.75-2.45 2.84H4.6c-1.39 0-2.52-1.19-2.6-2.68V5.84C2 4.33 3.09 3.1 4.45 3H15.4zm-.15 1H4.75C3.82 4 3.07 4.8 3 5.8V14.07c0 1.02.72 1.86 1.63 1.93h10.62c.93 0 1.68-.8 1.75-1.8V5.93c0-1.02-.72-1.86-1.63-1.93h-.12zm-8.4 3c.62 0 1.15.1 1.58.3.27.12.38.43.24.67a.56.56 0 01-.72.22C7.68 8.07 7.3 8 6.85 8c-1.03 0-1.77.83-1.77 2 0 1.12.81 2 1.77 2 .6 0 1-.35 1.06-.67v-.83h-.37c-.3 0-.54-.22-.54-.5 0-.25.2-.45.44-.5h1.02c.26 0 .49.18.53.41l.01.1v1.24C9 12.12 8.11 13 6.85 13A2.92 2.92 0 014 10c0-1.68 1.18-3 2.85-3zM11 7a.5.5 0 01.5.41v5.09a.5.5 0 01-1 .09V7.5c0-.28.22-.5.5-.5zm4.5 0a.5.5 0 01.09 1H14v2h1.5a.5.5 0 01.09 1H14v1.5a.5.5 0 01-1 .09V7.5c0-.28.22-.5.5-.5h2z",
    fill: primaryFill
  }));
};

export const GifRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GifRegularIcon({}), 'GifRegular');

const GiftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 11v7h-3A2.5 2.5 0 014 15.66V11h5.5zm6.5 0v4.5a2.5 2.5 0 01-2.34 2.5H10.5v-7H16zm-4-9a2.5 2.5 0 012 4h2a1 1 0 011 1v2a1 1 0 01-1 1h-5.5V6h-1v4H4a1 1 0 01-1-1V7a1 1 0 011-1h2a2.5 2.5 0 114-3c.46-.6 1.18-1 2-1zm0 1c-.83 0-1.5.67-1.5 1.5V6H12a1.5 1.5 0 000-3zM8 3a1.5 1.5 0 00-.14 3H9.5V4.36A1.5 1.5 0 008 3z",
    fill: primaryFill
  }));
};

export const GiftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftFilledIcon({}), 'GiftFilled');

const GiftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 2a2.5 2.5 0 012 4h2a1 1 0 011 1v3a1 1 0 01-1 1v4.5a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 014 15.5V11a1 1 0 01-1-1V7a1 1 0 011-1h2a2.5 2.5 0 114-3c.46-.6 1.18-1 2-1zm-2.5 9H5v4.5c0 .83.67 1.5 1.5 1.5h3v-6zm5.5 0h-4.5v6h3c.83 0 1.5-.67 1.5-1.5V11zM9.5 7H4v3h5.5V7zM16 7h-5.5v3H16V7zm-4-4c-.83 0-1.5.67-1.5 1.5V6H12a1.5 1.5 0 000-3zM8 3a1.5 1.5 0 00-.14 3H9.5V4.36A1.5 1.5 0 008 3z",
    fill: primaryFill
  }));
};

export const GiftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftRegularIcon({}), 'GiftRegular');

const GiftCardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4H4.75A2.75 2.75 0 002 6.75V9h2.27A2 2 0 017 6.27V4zm1 4v1h1a1 1 0 10-1-1zm2.73 1A2 2 0 008 6.27V4h7.25A2.75 2.75 0 0118 6.75V9h-7.27zm-2.02 1l1.64 1.65a.5.5 0 01-.7.7L8 10.71V16h7.25A2.75 2.75 0 0018 13.25V10H8.7zM7 16v-5.3l-1.65 1.65a.5.5 0 01-.7-.7L6.29 10H2v3.25A2.75 2.75 0 004.75 16H7zm0-8a1 1 0 10-1 1h1V8z",
    fill: primaryFill
  }));
};

export const GiftCardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardFilledIcon({}), 'GiftCardFilled');

const GiftCardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 014.75 4h10.5A2.75 2.75 0 0118 6.75v6.5A2.75 2.75 0 0115.25 16H4.75A2.75 2.75 0 012 13.25v-6.5zM3 10v3.25c0 .97.78 1.75 1.75 1.75H7v-4.3l-1.65 1.65a.5.5 0 01-.7-.7L6.29 10H3zm1.27-1A2 2 0 017 6.27V5H4.75C3.78 5 3 5.78 3 6.75V9h1.27zM6 9h1V8a1 1 0 10-1 1zm2-1v1h1a1 1 0 10-1-1zm2.73 1H17V6.75C17 5.78 16.22 5 15.25 5H8v1.27A2 2 0 0110.73 9zm-2.02 1l1.64 1.65a.5.5 0 01-.7.7L8 10.71V15h7.25c.97 0 1.75-.78 1.75-1.75V10H8.7z",
    fill: primaryFill
  }));
};

export const GiftCardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardRegularIcon({}), 'GiftCardRegular');

const GiftCardAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2H4.75A2.75 2.75 0 002 4.75V7h2.27A2 2 0 017 4.27V2zM2 8v3.25A2.75 2.75 0 004.75 14H7V8.7l-1.65 1.65a.5.5 0 01-.7-.7L6.29 8H2zm7.02 6H8V8.7l1.65 1.65a.5.5 0 00.7-.7L8.71 8H18v2.26A5.5 5.5 0 009.02 14zM18 7h-7.27A2 2 0 008 4.27V2h7.25A2.75 2.75 0 0118 4.75V7zM8 6v1h1a1 1 0 10-1-1zM7 7H6a1 1 0 111-1v1zm12 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const GiftCardAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardAddFilledIcon({}), 'GiftCardAddFilled');

const GiftCardAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.75A2.75 2.75 0 014.75 2h10.5A2.75 2.75 0 0118 4.75v5.5a5.5 5.5 0 00-1-.65V8H8.7l1.65 1.65a.5.5 0 01-.7.7L8 8.71V13h1.2c-.08.32-.15.66-.18 1H4.75A2.75 2.75 0 012 11.25v-6.5zM4.75 3C3.78 3 3 3.78 3 4.75V7h1.27A2 2 0 017 4.27V3H4.75zM8 3v1.27A2 2 0 0110.73 7H17V4.75C17 3.78 16.22 3 15.25 3H8zm0 4h1a1 1 0 10-1-1v1zM6 5a1 1 0 000 2h1V6a1 1 0 00-1-1zm-3 6.25c0 .97.78 1.75 1.75 1.75H7V8.7l-1.65 1.65a.5.5 0 01-.7-.7L6.29 8H3v3.25zm16 3.25a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const GiftCardAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardAddRegularIcon({}), 'GiftCardAddRegular');

const GiftCardArrowRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2H4.75A2.75 2.75 0 002 4.75V7h2.27A2 2 0 017 4.27V2zM2 8v3.25A2.75 2.75 0 004.75 14H7V8.7l-1.65 1.65a.5.5 0 01-.7-.7L6.29 8H2zm6 6h1.02A5.5 5.5 0 0118 10.26V8H8.7l1.65 1.65a.5.5 0 01-.7.7L8 8.71V14zm10-7h-7.27A2 2 0 008 4.27V2h7.25A2.75 2.75 0 0118 4.75V7zM8 7V6a1 1 0 111 1H8zM7 7H6a1 1 0 111-1v1zm12 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const GiftCardArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardArrowRightFilledIcon({}), 'GiftCardArrowRightFilled');

const GiftCardArrowRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.75A2.75 2.75 0 014.75 2h10.5A2.75 2.75 0 0118 4.75v5.5a5.5 5.5 0 00-1-.65V8H8.7l1.65 1.65a.5.5 0 01-.7.7L8 8.71V13h1.2c-.08.32-.15.66-.18 1H4.75A2.75 2.75 0 012 11.25v-6.5zM4.75 3C3.78 3 3 3.78 3 4.75V7h1.27A2 2 0 017 4.27V3H4.75zM8 3v1.27A2 2 0 0110.73 7H17V4.75C17 3.78 16.22 3 15.25 3H8zm0 4h1a1 1 0 10-1-1v1zM6 5a1 1 0 000 2h1V6a1 1 0 00-1-1zM3 8v3.25c0 .97.78 1.75 1.75 1.75H7V8.7l-1.65 1.65a.5.5 0 01-.7-.7L6.29 8H3zm16 6.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const GiftCardArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardArrowRightRegularIcon({}), 'GiftCardArrowRightRegular');

const GiftCardMoneyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 2H4.75A2.75 2.75 0 002 4.75V7h2.27A2 2 0 017 4.27V2zm1 4v1h1a1 1 0 10-1-1zm2.73 1A2 2 0 008 4.27V2h7.25A2.75 2.75 0 0118 4.75V7h-7.27zM8.71 8l1.64 1.65a.5.5 0 01-.7.7L8 8.71V14h1v-.5a2.5 2.5 0 012.5-2.5h6c.17 0 .34.02.5.05V8H8.7zM7 14V8.7l-1.65 1.65a.5.5 0 01-.7-.7L6.29 8H2v3.25A2.75 2.75 0 004.75 14H7zm0-8a1 1 0 10-1 1h1V6zm12 7.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zm-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm-.5-3.5h-1c0 .83.67 1.5 1.5 1.5v-1a.5.5 0 01-.5-.5zm-6 0a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const GiftCardMoneyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardMoneyFilledIcon({}), 'GiftCardMoneyFilled');

const GiftCardMoneyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.75A2.75 2.75 0 014.75 2h10.5A2.75 2.75 0 0118 4.75V11h-1V8H8.7l1.65 1.65a.5.5 0 01-.7.7L8 8.71V13h1.12a2 2 0 00-.12.69V14H4.75A2.75 2.75 0 012 11.25v-6.5zM3 8v3.25c0 .97.78 1.75 1.75 1.75H7V8.7l-1.65 1.65a.5.5 0 01-.7-.7L6.29 8H3zm1.27-1A2 2 0 017 4.27V3H4.75C3.78 3 3 3.78 3 4.75V7h1.27zM6 7h1V6a1 1 0 10-1 1zm2-1v1h1a1 1 0 10-1-1zm2.73 1H17V4.75C17 3.78 16.22 3 15.25 3H8v1.27A2 2 0 0110.73 7zM19 13.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zm-1 3v-1c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5zm-.5-3.5h-1c0 .83.67 1.5 1.5 1.5v-1a.5.5 0 01-.5-.5zm-6 0a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const GiftCardMoneyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardMoneyRegularIcon({}), 'GiftCardMoneyRegular');

const GiftCardMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4H7v2.27A2 2 0 004.27 9H2V6.75A2.75 2.75 0 014.75 4zM2 12.25V10h4.3l-1.65 1.65a.5.5 0 00.7.7L7 10.71V15H4.75A2.75 2.75 0 012 12.25zM8 15h5.25A2.75 2.75 0 0016 12.25V10H8.7l1.65 1.65a.5.5 0 01-.7.7L8 10.71V15zm2.73-6H16V6.75A2.75 2.75 0 0013.25 4H8v2.27A2 2 0 0110.73 9zM8 9V8a1 1 0 111 1H8zM6 9h1V8a1 1 0 10-1 1zm.75 8c-.85 0-1.62-.39-2.12-1h8.62A3.75 3.75 0 0017 12.25v-5.5-.12c.61.5 1 1.27 1 2.12v3.5A4.75 4.75 0 0113.25 17h-6.5z",
    fill: primaryFill
  }));
};

export const GiftCardMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardMultipleFilledIcon({}), 'GiftCardMultipleFilled');

const GiftCardMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v5.5A2.75 2.75 0 004.75 15h8.5A2.75 2.75 0 0016 12.25v-5.5A2.75 2.75 0 0013.25 4h-8.5zM3 12.25V10h3.3l-1.65 1.65a.5.5 0 00.7.7L7 10.71V14H4.75C3.78 14 3 13.22 3 12.25zM3 9V6.75C3 5.78 3.78 5 4.75 5H7v1.27A2 2 0 004.27 9H3zm4 0H6a1 1 0 111-1v1zm1 0V8a1 1 0 111 1H8zm3-1a2 2 0 00-3-1.73V5h5.25c.97 0 1.75.78 1.75 1.75V9h-4.27A2 2 0 0011 8zm-.65 3.65L8.71 10H15v2.25c0 .97-.78 1.75-1.75 1.75H8v-3.3l1.65 1.65a.5.5 0 00.7-.7zM6.75 17c-.85 0-1.62-.39-2.12-1h8.62A3.75 3.75 0 0017 12.25v-5.5-.12c.61.5 1 1.27 1 2.12v3.5A4.75 4.75 0 0113.25 17h-6.5z",
    fill: primaryFill
  }));
};

export const GiftCardMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GiftCardMultipleRegularIcon({}), 'GiftCardMultipleRegular');

const GlanceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 14.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5zm0-10v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5C9 3.67 8.33 3 7.5 3h-3C3.67 3 3 3.67 3 4.5zm8 0v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5zM12.5 9c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-3z",
    fill: primaryFill
  }));
};

export const GlanceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlanceFilledIcon({}), 'GlanceFilled');

const GlanceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5C9 3.67 8.33 3 7.5 3h-3zM4 4.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-5zM12.5 9c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-3zm-.5 1.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-5zm-1-6c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0111 5.5v-1zm1.5-.5a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-3zm-8 9c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3zM4 14.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const GlanceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlanceRegularIcon({}), 'GlanceRegular');

const GlanceHorizontalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3h1c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 0113 7.5v-3c0-.83.67-1.5 1.5-1.5zm-10 0h5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 013 7.5v-3C3 3.67 3.67 3 4.5 3zm0 8h1c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 013 15.5v-3c0-.83.67-1.5 1.5-1.5zM9 12.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 019 15.5v-3z",
    fill: primaryFill
  }));
};

export const GlanceHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlanceHorizontalFilledIcon({}), 'GlanceHorizontalFilled');

const GlanceHorizontalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 15.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 019 15.5v-3c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v3zm-1.5.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h5zM11 7.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 013 7.5v-3C3 3.67 3.67 3 4.5 3h5c.83 0 1.5.67 1.5 1.5v3zM9.5 8a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h5zm6 1c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-1c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h1zm.5-1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v3zm-9 8c0 .83-.67 1.5-1.5 1.5h-1A1.5 1.5 0 013 15.5v-3c0-.83.67-1.5 1.5-1.5h1c.83 0 1.5.67 1.5 1.5v3zm-1.5.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h1z",
    fill: primaryFill
  }));
};

export const GlanceHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlanceHorizontalRegularIcon({}), 'GlanceHorizontalRegular');

const GlassesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.19 4a2 2 0 00-1.52.7L2.37 8.5A1.5 1.5 0 002 9.5v3A2.5 2.5 0 004.5 15h2A2.5 2.5 0 009 12.5V11h2v1.5a2.5 2.5 0 002.5 2.5h2a2.5 2.5 0 002.5-2.5v-3c0-.43-.18-.82-.47-1.09l-3.2-3.72A2 2 0 0012.8 4H12a.5.5 0 100 1h.81a1 1 0 01.76.35L15.86 8H12.5c-.83 0-1.5.67-1.5 1.5v.5H9v-.5C9 8.67 8.33 8 7.5 8H4.14l2.29-2.65A1 1 0 017.19 5H8a.5.5 0 000-1h-.81z",
    fill: primaryFill
  }));
};

export const GlassesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlassesFilledIcon({}), 'GlassesFilled');

const GlassesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.19 4a2 2 0 00-1.52.7l-3.3 3.82c-.23.27-.37.6-.37.98v3A2.5 2.5 0 004.5 15h2A2.5 2.5 0 009 12.5V11h2v1.5a2.5 2.5 0 002.5 2.5h2a2.5 2.5 0 002.5-2.5v-3c0-.43-.18-.82-.47-1.09l-3.2-3.72A2 2 0 0012.8 4H12a.5.5 0 100 1h.81a1 1 0 01.76.35L15.86 8H12.5c-.83 0-1.5.67-1.5 1.5v.5H9v-.5C9 8.67 8.33 8 7.5 8H4.14l2.29-2.65A1 1 0 017.19 5H8a.5.5 0 100-1h-.81zM8 9.5v3c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 013 12.5v-3c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5zm4 3v-3c0-.28.22-.5.5-.5h4a.5.5 0 01.32.11l.05.07c.08.08.13.2.13.32v3c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5z",
    fill: primaryFill
  }));
};

export const GlassesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlassesRegularIcon({}), 'GlassesRegular');

const GlassesOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L4.89 5.6 2.36 8.52c-.22.27-.36.6-.36.98v3A2.5 2.5 0 004.5 15h2A2.5 2.5 0 009 12.5V11h1.3l.7.7v.8a2.5 2.5 0 002.5 2.5h.8l2.85 2.85a.5.5 0 00.7-.7l-15-15zM7.3 8H4.14L5.6 6.3 7.3 8zm9.48 6.65L11.1 8.97A1.5 1.5 0 0112.5 8h3.36l-2.29-2.65a1 1 0 00-.76-.35H12a.5.5 0 010-1h.81a2 2 0 011.52.7l3.2 3.71c.29.28.47.66.47 1.09v3c0 .92-.5 1.72-1.23 2.15zM6.32 4.2l.8.8a1 1 0 01.07 0H8a.5.5 0 000-1h-.81a2 2 0 00-.87.2z",
    fill: primaryFill
  }));
};

export const GlassesOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlassesOffFilledIcon({}), 'GlassesOffFilled');

const GlassesOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L4.89 5.6 2.36 8.52c-.22.27-.36.6-.36.98v3A2.5 2.5 0 004.5 15h2A2.5 2.5 0 009 12.5V11h1.3l.7.7v.8a2.5 2.5 0 002.5 2.5h.8l2.85 2.85a.5.5 0 00.7-.7l-15-15zM7.3 8H4.14L5.6 6.3 7.3 8zM8 9.5v3c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 013 12.5v-3c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5zm4 .38l-.9-.9A1.5 1.5 0 0112.5 8h3.36l-2.29-2.65a1 1 0 00-.76-.35H12a.5.5 0 010-1h.81a2 2 0 011.52.7l3.2 3.71c.29.28.47.66.47 1.09v3c0 .92-.5 1.72-1.23 2.15l-.74-.75c.57-.2.97-.76.97-1.4v-3a.5.5 0 00-.12-.33l-.06-.06A.5.5 0 0016.5 9h-4a.5.5 0 00-.5.5v.38zM7.12 5l-.8-.8a2 2 0 01.87-.2H8a.5.5 0 010 1h-.81a1 1 0 00-.07 0z",
    fill: primaryFill
  }));
};

export const GlassesOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlassesOffRegularIcon({}), 'GlassesOffRegular');

const GlobeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 00-5.09-4.22zm5.5 5.22h-3.76a20.52 20.52 0 010 5h3.75a8 8 0 000-5zm-.41 6h-3.5c-.18 1-.44 1.92-.76 2.7-.24.58-.52 1.1-.83 1.52a8.02 8.02 0 005.09-4.22zM10 18c.3 0 .65-.15 1-.52.36-.37.71-.93 1.01-1.66.28-.66.5-1.45.67-2.32H7.32c.17.87.4 1.66.67 2.32.3.73.65 1.3 1 1.66.36.37.7.52 1.01.52zm-2.1-.28a8.02 8.02 0 01-5.1-4.22h3.5c.18 1 .44 1.92.76 2.7.24.58.52 1.1.83 1.52zM2.4 12.5h3.75a20.52 20.52 0 010-5H2.4a8 8 0 000 5zM7 10c0-.87.06-1.71.16-2.5h5.68a19.44 19.44 0 010 5H7.16C7.06 11.71 7 10.87 7 10z",
    fill: primaryFill
  }));
};

export const GlobeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeFilledIcon({}), 'GlobeFilled');

const GlobeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm0-15c.66 0 1.4.59 2.02 1.9.22.47.4 1.01.56 1.6H7.42c.15-.59.34-1.13.56-1.6C8.59 3.6 9.34 3 10 3zM7.07 4.49c-.27.59-.5 1.27-.68 2.01H3.94A7.02 7.02 0 017.7 3.38c-.24.33-.45.7-.64 1.1zM6.2 7.5a15.97 15.97 0 000 5H3.46a6.98 6.98 0 010-5h2.73zm.2 6c.17.74.4 1.42.68 2.01.19.4.4.78.64 1.1a7.02 7.02 0 01-3.77-3.11h2.45zm1.03 0h5.16a9.25 9.25 0 01-.56 1.6C11.41 16.4 10.66 17 10 17c-.66 0-1.4-.59-2.02-1.9-.22-.47-.4-1.01-.56-1.6zm5.37-1H7.21a14.87 14.87 0 010-5h5.58a14.86 14.86 0 010 5zm.82 1h2.45a7.02 7.02 0 01-3.77 3.12c.24-.33.45-.7.64-1.1.27-.6.5-1.28.68-2.02zm2.93-1h-2.73a15.97 15.97 0 000-5h2.73a6.98 6.98 0 010 5zm-4.25-9.12a7.02 7.02 0 013.77 3.12h-2.45a10.5 10.5 0 00-.68-2.01c-.19-.4-.4-.78-.64-1.1z",
    fill: primaryFill
  }));
};

export const GlobeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeRegularIcon({}), 'GlobeRegular');

const GlobeAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 00-5.09-4.22zm5.5 5.22h-3.76c.06.5.1 1 .13 1.52A5.57 5.57 0 0118 10.25a7.93 7.93 0 00-.4-2.75zm-4.77 0a19 19 0 01.14 1.71 5.51 5.51 0 00-3.6 3.29H7.15a19.44 19.44 0 010-5h5.68zm-5.52 6h1.77a5.53 5.53 0 001.14 4.47.99.99 0 01-.23.03c-.3 0-.65-.15-1-.52-.36-.37-.71-.93-1.01-1.66-.28-.66-.5-1.45-.67-2.32zm.57 4.22A8.02 8.02 0 012.8 13.5h3.5c.18 1 .44 1.92.76 2.7.24.58.52 1.1.83 1.52zM2.4 12.5h3.76a20.52 20.52 0 010-5H2.4a8 8 0 000 5zm16.61 2a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const GlobeAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeAddFilledIcon({}), 'GlobeAddFilled');

const GlobeAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18h.25a5.5 5.5 0 01-.7-1.09c-.53-.2-1.1-.79-1.57-1.82-.22-.46-.4-1-.56-1.59h1.67c.06-.35.16-.68.28-1H7.21a14.87 14.87 0 010-5h5.58c.1.54.16 1.11.19 1.71.32-.09.65-.15 1-.18-.04-.53-.1-1.04-.17-1.53h2.73c.25.66.4 1.36.45 2.1.36.18.7.4 1 .65L18 10a8 8 0 10-8 8zm0-15c.66 0 1.4.59 2.02 1.9.22.47.4 1.01.56 1.6H7.42c.15-.59.34-1.13.56-1.6C8.59 3.6 9.34 3 10 3zM7.07 4.49c-.27.59-.5 1.27-.68 2.01H3.94A7.02 7.02 0 017.7 3.38c-.24.33-.45.7-.64 1.1zM6.2 7.5a15.97 15.97 0 000 5H3.46a6.98 6.98 0 010-5h2.73zm.2 6c.17.74.4 1.42.68 2.01.19.4.4.78.64 1.1a7.02 7.02 0 01-3.77-3.11h2.45zm5.9-10.12a7.02 7.02 0 013.77 3.12h-2.45a10.5 10.5 0 00-.68-2.01c-.19-.4-.4-.78-.64-1.1zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const GlobeAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeAddRegularIcon({}), 'GlobeAddRegular');

const GlobeClockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 00-5.09-4.22zm5.5 5.22h-3.76c.06.5.1 1 .13 1.52A5.57 5.57 0 0118 10.25a7.93 7.93 0 00-.4-2.75zm-4.77 0a19 19 0 01.14 1.71 5.51 5.51 0 00-3.6 3.29H7.15a19.44 19.44 0 010-5h5.68zm-5.52 6h1.77a5.53 5.53 0 001.14 4.47.99.99 0 01-.23.03c-.3 0-.65-.15-1-.52-.36-.37-.71-.93-1.01-1.66-.28-.66-.5-1.45-.67-2.32zm.57 4.22A8.02 8.02 0 012.8 13.5h3.5c.18 1 .44 1.92.76 2.7.24.58.52 1.1.83 1.52zM2.4 12.5h3.76a20.52 20.52 0 010-5H2.4a8 8 0 000 5zm16.61 2a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const GlobeClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeClockFilledIcon({}), 'GlobeClockFilled');

const GlobeClockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18h.25a5.5 5.5 0 01-.7-1.09c-.53-.2-1.1-.79-1.57-1.82-.22-.46-.4-1-.56-1.59h1.67c.06-.35.16-.68.28-1H7.21a14.87 14.87 0 010-5h5.58c.1.54.16 1.11.19 1.71.32-.09.65-.15 1-.18-.04-.53-.1-1.04-.17-1.53h2.73c.25.66.4 1.36.45 2.1.36.18.7.4 1 .65L18 10a8 8 0 10-8 8zm0-15c.66 0 1.4.59 2.02 1.9.22.47.4 1.01.56 1.6H7.42c.15-.59.34-1.13.56-1.6C8.59 3.6 9.34 3 10 3zM7.07 4.49c-.27.59-.5 1.27-.68 2.01H3.94A7.02 7.02 0 017.7 3.38c-.24.33-.45.7-.64 1.1zM6.2 7.5a15.97 15.97 0 000 5H3.46a6.98 6.98 0 010-5h2.73zm.2 6c.17.74.4 1.42.68 2.01.19.4.4.78.64 1.1a7.02 7.02 0 01-3.77-3.11h2.45zm5.9-10.12a7.02 7.02 0 013.77 3.12h-2.45a10.5 10.5 0 00-.68-2.01c-.19-.4-.4-.78-.64-1.1zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 000-1h-1v-1.5a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const GlobeClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeClockRegularIcon({}), 'GlobeClockRegular');

const GlobeDesktopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 00-5.09-4.22zm5.5 5.22h-3.76c.1.8.15 1.63.15 2.5h4a8 8 0 00-.4-2.5zm-4.77 0c.1.79.16 1.63.16 2.5h-2a2 2 0 00-2 2v.5H7.16a19.44 19.44 0 010-5h5.68zm-5.52 6H9V16a2 2 0 001.41 1.91c-.14.06-.28.09-.41.09-.3 0-.65-.15-1-.52-.36-.37-.71-.93-1.01-1.66-.28-.66-.5-1.45-.67-2.32zm.57 4.22A8.02 8.02 0 012.8 13.5h3.5c.18 1 .44 1.92.76 2.7.24.58.52 1.1.83 1.52zM2.4 12.5h3.76a20.52 20.52 0 010-5H2.4a8 8 0 000 5zM10 12a1 1 0 011-1h7a1 1 0 011 1v4a1 1 0 01-1 1h-2v1h.5a.5.5 0 010 1h-4a.5.5 0 010-1h.5v-1h-2a1 1 0 01-1-1v-4z",
    fill: primaryFill
  }));
};

export const GlobeDesktopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeDesktopFilledIcon({}), 'GlobeDesktopFilled');

const GlobeDesktopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18c.22 0 .45 0 .67-.03a2 2 0 01-1.56-1.32 4.2 4.2 0 01-1.13-1.56c-.22-.46-.4-1-.56-1.59H9v-1H7.2a14.87 14.87 0 010-5h5.6c.13.77.2 1.62.2 2.5h1c0-.87-.07-1.71-.2-2.5h2.74c.3.78.46 1.62.46 2.5h1a8 8 0 10-8 8zm0-15c.66 0 1.4.59 2.02 1.9.22.47.4 1.01.56 1.6H7.42c.15-.59.34-1.13.56-1.6C8.59 3.6 9.34 3 10 3zM7.07 4.49c-.27.59-.5 1.27-.68 2.01H3.94A7.02 7.02 0 017.7 3.38c-.24.33-.45.7-.64 1.1zM6.2 7.5a15.97 15.97 0 000 5H3.46a6.98 6.98 0 010-5h2.73zm.2 6c.17.74.4 1.42.68 2.01.19.4.4.78.64 1.1a7.02 7.02 0 01-3.77-3.11h2.45zm5.9-10.12a7.02 7.02 0 013.77 3.12h-2.45a10.5 10.5 0 00-.68-2.01c-.19-.4-.4-.78-.64-1.1zM10 12a1 1 0 011-1h7a1 1 0 011 1v4a1 1 0 01-1 1h-2v1h.5a.5.5 0 010 1h-4a.5.5 0 010-1h.5v-1h-2a1 1 0 01-1-1v-4z",
    fill: primaryFill
  }));
};

export const GlobeDesktopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeDesktopRegularIcon({}), 'GlobeDesktopRegular');

const GlobeLocationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.32 6.5c.17-.87.4-1.66.67-2.32.3-.73.65-1.3 1-1.66C9.36 2.15 9.7 2 10 2c.3 0 .65.15 1 .52.36.37.71.93 1.01 1.66.28.66.5 1.45.67 2.32H7.32zm-.26-2.7c.24-.58.52-1.1.83-1.52A8.02 8.02 0 002.8 6.5h3.5c.18-1 .44-1.92.76-2.7zm5.88 0a7.19 7.19 0 00-.83-1.52A8.02 8.02 0 0117.2 6.5h-3.5c-.18-1-.44-1.92-.76-2.7zm.91 3.7h3.75c.24.71.37 1.47.4 2.25a4.52 4.52 0 00-4-.5c-.03-.6-.08-1.18-.15-1.75zM13 9.76c-.01-.79-.07-1.55-.16-2.26H7.16a19.44 19.44 0 000 5h3.98c.27-1.13.93-2.1 1.86-2.74zm-2 3.74H7.32c.17.87.4 1.66.67 2.32.3.73.65 1.3 1 1.66.36.37.7.52 1.01.52.3 0 .65-.15 1-.52.26-.26.5-.61.74-1.06A5.94 5.94 0 0111 13.5zm-8.2 0c1 2.05 2.85 3.6 5.1 4.22a7.19 7.19 0 01-.84-1.52c-.32-.78-.58-1.7-.76-2.7H2.8zm3.35-1H2.4a8 8 0 010-5h3.75a20.52 20.52 0 000 5zM19 13.68c0-2.03-1.47-3.68-3.5-3.68-2.03 0-3.5 1.65-3.5 3.68 0 1.53.98 3.53 3.26 5.24.14.1.34.1.49 0 2.27-1.7 3.25-3.71 3.25-5.24zm-2-.18a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const GlobeLocationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeLocationFilledIcon({}), 'GlobeLocationFilled');

const GlobeLocationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 002.5-.4 8.14 8.14 0 01-.98-1.63c-.5.7-1.03 1.03-1.52 1.03-.66 0-1.4-.59-2.02-1.9-.22-.47-.4-1.01-.56-1.6H11c.02-.34.06-.68.14-1H7.21a14.87 14.87 0 010-5h5.58c.12.7.2 1.46.2 2.26.3-.2.64-.38 1-.5-.03-.61-.1-1.2-.18-1.76h2.73c.21.55.35 1.13.42 1.74.37.12.72.3 1.04.51A8 8 0 1010 18zm0-15c.66 0 1.4.59 2.02 1.9.22.47.4 1.01.56 1.6H7.42c.15-.59.34-1.13.56-1.6C8.59 3.6 9.34 3 10 3zM7.07 4.49c-.27.59-.5 1.27-.68 2.01H3.94A7.02 7.02 0 017.7 3.38c-.24.33-.45.7-.64 1.1zM6.2 7.5a15.97 15.97 0 000 5H3.46a6.98 6.98 0 010-5h2.73zm.2 6c.17.74.4 1.42.68 2.01.19.4.4.78.64 1.1a7.02 7.02 0 01-3.77-3.11h2.45zm5.9-10.12a7.02 7.02 0 013.77 3.12h-2.45a10.5 10.5 0 00-.68-2.01c-.19-.4-.4-.78-.64-1.1zM19 13.68c0-2.03-1.47-3.68-3.5-3.68-2.03 0-3.5 1.65-3.5 3.68 0 1.53.98 3.53 3.26 5.24.14.1.34.1.49 0 2.27-1.7 3.25-3.71 3.25-5.24zm-2-.18a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const GlobeLocationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeLocationRegularIcon({}), 'GlobeLocationRegular');

const GlobePersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 00-5.09-4.22zm5.5 5.22h-3.76c.08.61.12 1.25.14 1.9a2.99 2.99 0 014 .93 8.26 8.26 0 00-.39-2.83zM13 10v.35a2.99 2.99 0 00-.46 2.15H7.16a19.44 19.44 0 010-5h5.68c.1.79.16 1.63.16 2.5zm-.32 3.5c-.04.24-.1.47-.15.7A2.5 2.5 0 0011 16.5c0 .29.04.58.12.86l-.12.12c-.35.37-.7.52-1 .52-.3 0-.65-.15-1-.52-.36-.37-.71-.93-1.01-1.66-.28-.66-.5-1.45-.67-2.32h5.36zM7.9 17.72A8.02 8.02 0 012.8 13.5h3.5c.18 1 .44 1.92.76 2.7.24.58.52 1.1.83 1.52zM2.4 12.5h3.76a20.52 20.52 0 010-5H2.4a8 8 0 000 5zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const GlobePersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobePersonFilledIcon({}), 'GlobePersonFilled');

const GlobePersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.31 17.9A8 8 0 1118 10.33a3.02 3.02 0 00-1.02-.95c-.05-.66-.2-1.3-.43-1.89h-2.73c.1.6.16 1.25.18 1.9-.4.24-.74.56-1 .95a15.93 15.93 0 00-.2-2.85H7.21a14.87 14.87 0 000 5h5.33c.06.36.19.7.36 1H7.42c.15.59.34 1.13.56 1.6C8.59 16.4 9.34 17 10 17c.32 0 .66-.14 1-.44 0 .46.11.91.31 1.33zm.71-13C11.41 3.6 10.66 3 10 3c-.66 0-1.4.59-2.02 1.9-.22.47-.4 1.01-.56 1.6h5.16a9.25 9.25 0 00-.56-1.6zM6.4 6.5c.17-.74.4-1.42.68-2.01.19-.4.4-.78.64-1.1A7.02 7.02 0 003.94 6.5h2.45zM6 10c0-.87.07-1.71.2-2.5H3.45a6.98 6.98 0 000 5h2.73C6.07 11.71 6 10.87 6 10zm1.07 5.51c-.27-.59-.5-1.27-.68-2.01H3.94a7.02 7.02 0 003.77 3.12c-.24-.33-.45-.7-.64-1.1zm9-9.01a7.02 7.02 0 00-3.78-3.12c.24.33.45.7.64 1.1.27.6.5 1.28.68 2.02h2.45zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const GlobePersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobePersonRegularIcon({}), 'GlobePersonRegular');

const GlobeProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.32 6.5c.17-.87.4-1.66.67-2.32.3-.73.65-1.3 1-1.66C9.36 2.15 9.7 2 10 2c.3 0 .65.15 1 .52.36.37.71.93 1.01 1.66.28.66.5 1.45.67 2.32H7.32zm-.26-2.7c.24-.58.52-1.1.83-1.52A8.02 8.02 0 002.8 6.5h3.5c.18-1 .44-1.92.76-2.7zm5.88 0a7.19 7.19 0 00-.83-1.52A8.02 8.02 0 0117.2 6.5h-3.5c-.18-1-.44-1.92-.76-2.7zm.91 3.7h3.75a8 8 0 01.4 2.75 5.48 5.48 0 00-4.02-1.23c-.03-.52-.07-1.03-.13-1.52zm-.87 1.71a19 19 0 00-.14-1.71H7.16a19.44 19.44 0 000 5h2.21a5.51 5.51 0 013.61-3.29zM9.1 13.5H7.32c.17.87.4 1.66.67 2.32.3.73.65 1.3 1 1.66.36.37.7.52 1.01.52.08 0 .15 0 .23-.03A5.48 5.48 0 019.1 13.5zm-6.29 0c1 2.05 2.85 3.6 5.1 4.22a7.19 7.19 0 01-.84-1.52c-.32-.78-.58-1.7-.76-2.7H2.8zm3.35-1H2.4a8 8 0 010-5h3.75a20.52 20.52 0 000 5zm3.85 2a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const GlobeProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeProhibitedFilledIcon({}), 'GlobeProhibitedFilled');

const GlobeProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.25 18H10a8 8 0 118-7.75 5.5 5.5 0 00-1.01-.66 6.97 6.97 0 00-.45-2.09h-2.73c.08.49.13 1 .16 1.53-.34.03-.67.1-.99.18-.03-.6-.1-1.17-.19-1.71H7.21a14.87 14.87 0 000 5h2.16c-.12.32-.22.65-.28 1H7.42c.15.59.34 1.13.56 1.6.48 1.02 1.04 1.6 1.58 1.81.19.4.42.76.7 1.09zm1.77-13.1C11.41 3.6 10.66 3 10 3c-.66 0-1.4.59-2.02 1.9-.22.47-.4 1.01-.56 1.6h5.16a9.25 9.25 0 00-.56-1.6zM6.4 6.5c.17-.74.4-1.42.68-2.01.19-.4.4-.78.64-1.1A7.02 7.02 0 003.94 6.5h2.45zM6 10c0-.87.07-1.71.2-2.5H3.45a6.98 6.98 0 000 5h2.73C6.07 11.71 6 10.87 6 10zm1.07 5.51c-.27-.59-.5-1.27-.68-2.01H3.94a7.02 7.02 0 003.77 3.12c-.24-.33-.45-.7-.64-1.1zm9-9.01a7.02 7.02 0 00-3.78-3.12c.24.33.45.7.64 1.1.27.6.5 1.28.68 2.02h2.45zm-6.07 8a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm2.4 2.8l4.9-4.9a3.5 3.5 0 01-4.9 4.9zm-.7-.7a3.5 3.5 0 014.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const GlobeProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeProhibitedRegularIcon({}), 'GlobeProhibitedRegular');

const GlobeSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm5.05 1.52a7.18 7.18 0 00-.83-1.52A8.02 8.02 0 0117.2 6.5h-3.5c-.18-1-.44-1.92-.76-2.7zm4.66 3.7h-3.75a20.54 20.54 0 010 5h3.75a7.99 7.99 0 000-5zm-3.9 6h3.5a8.02 8.02 0 01-5.09 4.22c.31-.43.59-.94.83-1.52.32-.78.58-1.7.76-2.7zm-4.14.44c.07-.14.13-.29.18-.44h2.94a12.22 12.22 0 01-.87 2.77 1.5 1.5 0 00-.25-.33l-2-2zm.41-1.44h2.87a19.44 19.44 0 000-5H7.16l-.04.3a4.5 4.5 0 012.85 4.7zm-3.82-5v.05a4.54 4.54 0 00-.65-.05h.65zm-3.75 0h3.1c-1.39 0-2.63.63-3.45 1.61.06-.55.18-1.1.35-1.61zm3.1 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 10.7-.7L8.3 14.1a3.5 3.5 0 10-2.8 1.4zm0-1a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const GlobeSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeSearchFilledIcon({}), 'GlobeSearchFilled');

const GlobeSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.05 9.11a8 8 0 119.72 8.7 1.5 1.5 0 00-.2-1.87l-.02-.01c.16-.24.32-.52.47-.84.22-.46.4-1 .56-1.59H9.74c.12-.32.2-.65.23-1h2.82a14.86 14.86 0 000-5H7.21l-.05.31c-.31-.12-.64-.2-.98-.26l.01-.05H3.46l-.2.6c-.46.26-.87.6-1.21 1.01zm9.97-4.2C11.41 3.59 10.66 3 10 3c-.66 0-1.4.59-2.02 1.9-.22.47-.4 1.01-.56 1.6h5.16a9.25 9.25 0 00-.56-1.6zM6.4 6.5c.17-.74.4-1.42.68-2.01.19-.4.4-.78.64-1.1A7.02 7.02 0 003.94 6.5h2.45zm9.67 7h-2.45c-.17.74-.4 1.42-.68 2.01-.19.4-.4.78-.64 1.1a7.02 7.02 0 003.77-3.11zm-2.25-1h2.73a6.98 6.98 0 000-5h-2.73a15.97 15.97 0 010 5zm2.25-6a7.02 7.02 0 00-3.77-3.12c.24.33.45.7.64 1.1.27.6.5 1.28.68 2.02h2.45zM8.3 14.1a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 00.7-.7L8.3 14.1zM8 12a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const GlobeSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeSearchRegularIcon({}), 'GlobeSearchRegular');

const GlobeShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 00-5.09-4.22zm5.5 5.22h-3.76l.1.95a1.63 1.63 0 012.2.09c.42.43 1.08.98 1.85 1.27a7.98 7.98 0 00-.4-2.31zm-4.77 0c.08.57.13 1.16.15 1.78-.47.33-1.03.61-1.63.7-.68.09-1.36.66-1.36 1.52v1H7.16a19.44 19.44 0 010-5h5.68zm-5.52 6H10v.5c0 1.42.45 2.55 1.07 3.4l-.07.08c-.35.37-.7.52-1 .52-.3 0-.65-.15-1-.52-.36-.37-.71-.93-1.01-1.66-.28-.66-.5-1.45-.67-2.32zm.57 4.22A8.02 8.02 0 012.8 13.5h3.5c.18 1 .44 1.92.76 2.7.24.58.52 1.1.83 1.52zM2.4 12.5h3.76a20.52 20.52 0 010-5H2.4a8 8 0 000 5zm16.11-1.54a5.69 5.69 0 01-3.06-1.72.62.62 0 00-.88 0 5.7 5.7 0 01-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 00.26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54z",
    fill: primaryFill
  }));
};

export const GlobeShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeShieldFilledIcon({}), 'GlobeShieldFilled');

const GlobeShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18c.5 0 .97-.04 1.44-.13a5.85 5.85 0 01-.75-1.08c-.24.14-.47.21-.69.21-.66 0-1.4-.59-2.02-1.9-.22-.47-.4-1.01-.56-1.6H10v-1H7.2a14.87 14.87 0 010-5h5.6c.09.56.15 1.16.18 1.78a6.32 6.32 0 00.95-.82c-.03-.32-.07-.65-.12-.96h2.73c.21.55.35 1.13.42 1.74.3.22.66.43 1.04.57A8 8 0 1010 18zm0-15c.66 0 1.4.59 2.02 1.9.22.47.4 1.01.56 1.6H7.42c.15-.59.34-1.13.56-1.6C8.59 3.6 9.34 3 10 3zM7.07 4.49c-.27.59-.5 1.27-.68 2.01H3.94A7.02 7.02 0 017.7 3.38c-.24.33-.45.7-.64 1.1zM6.2 7.5a15.97 15.97 0 000 5H3.46a6.98 6.98 0 010-5h2.73zm.2 6c.17.74.4 1.42.68 2.01.19.4.4.78.64 1.1a7.02 7.02 0 01-3.77-3.11h2.45zm5.9-10.12a7.02 7.02 0 013.77 3.12h-2.45a10.5 10.5 0 00-.68-2.01c-.19-.4-.4-.78-.64-1.1zm6.21 7.58a5.69 5.69 0 01-3.06-1.72.62.62 0 00-.88 0 5.7 5.7 0 01-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 00.26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54z",
    fill: primaryFill
  }));
};

export const GlobeShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeShieldRegularIcon({}), 'GlobeShieldRegular');

const GlobeStarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.32 6.5c.17-.87.4-1.66.67-2.32.3-.73.65-1.3 1-1.66C9.36 2.15 9.7 2 10 2c.3 0 .65.15 1 .52.36.37.71.93 1.01 1.66.28.66.5 1.45.67 2.32H7.32zm-.26-2.7c.24-.58.52-1.1.83-1.52A8.02 8.02 0 002.8 6.5h3.5c.18-1 .44-1.92.76-2.7zm5.88 0a7.19 7.19 0 00-.83-1.52A8.02 8.02 0 0117.2 6.5h-3.5c-.18-1-.44-1.92-.76-2.7zm.91 3.7h3.75a8 8 0 01.4 2.75 5.48 5.48 0 00-4.02-1.23c-.03-.52-.07-1.03-.13-1.52zm-.87 1.71a19 19 0 00-.14-1.71H7.16a19.44 19.44 0 000 5h2.21a5.51 5.51 0 013.61-3.29zM9.1 13.5H7.32c.17.87.4 1.66.67 2.32.3.73.65 1.3 1 1.66.36.37.7.52 1.01.52.08 0 .15 0 .23-.03A5.48 5.48 0 019.1 13.5zm-6.29 0c1 2.05 2.85 3.6 5.1 4.22a7.19 7.19 0 01-.84-1.52c-.32-.78-.58-1.7-.76-2.7H2.8zm3.35-1H2.4a8 8 0 010-5h3.75a20.52 20.52 0 000 5zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.95-5.6H17c.48 0 .68.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 01.96 0l.47 1.53z",
    fill: primaryFill
  }));
};

export const GlobeStarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeStarFilledIcon({}), 'GlobeStarFilled');

const GlobeStarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.25 18H10a8 8 0 118-7.75 5.5 5.5 0 00-1.01-.66 6.97 6.97 0 00-.45-2.09h-2.73c.08.49.13 1 .16 1.53-.34.03-.67.1-.99.18-.03-.6-.1-1.17-.19-1.71H7.21a14.87 14.87 0 000 5h2.16c-.12.32-.22.65-.28 1H7.42c.15.59.34 1.13.56 1.6.48 1.02 1.04 1.6 1.58 1.81.19.4.42.76.7 1.09zm1.77-13.1C11.41 3.6 10.66 3 10 3c-.66 0-1.4.59-2.02 1.9-.22.47-.4 1.01-.56 1.6h5.16a9.25 9.25 0 00-.56-1.6zM6.4 6.5c.17-.74.4-1.42.68-2.01.19-.4.4-.78.64-1.1A7.02 7.02 0 003.94 6.5h2.45zM6 10c0-.87.07-1.71.2-2.5H3.45a6.98 6.98 0 000 5h2.73C6.07 11.71 6 10.87 6 10zm1.07 5.51c-.27-.59-.5-1.27-.68-2.01H3.94a7.02 7.02 0 003.77 3.12c-.24-.33-.45-.7-.64-1.1zm9-9.01a7.02 7.02 0 00-3.78-3.12c.24.33.45.7.64 1.1.27.6.5 1.28.68 2.02h2.45zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.95-5.6H17c.48 0 .68.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 01.96 0l.47 1.53z",
    fill: primaryFill
  }));
};

export const GlobeStarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeStarRegularIcon({}), 'GlobeStarRegular');

const GlobeSurfaceFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.12 7c.12-.93.32-1.76.58-2.42.21-.55.45-.97.7-1.23.24-.27.44-.35.6-.35.16 0 .36.08.6.35.25.26.49.68.7 1.23.26.66.46 1.49.58 2.42H8.12zm-.35-2.78c.13-.34.28-.67.45-.95A6.02 6.02 0 004.34 7h2.78c.12-1.05.35-2 .65-2.78zm4.46 0a6.18 6.18 0 00-.45-.95A6.02 6.02 0 0115.66 7h-2.78c-.12-1.05-.35-2-.65-2.78zM12.97 8h2.95a6.04 6.04 0 010 2h-2.95a17.34 17.34 0 000-2zm-.09 3h2.78a6.02 6.02 0 01-3.88 3.73c.17-.28.32-.6.45-.95.3-.78.53-1.73.65-2.78zm-2.28 3.65c-.24.27-.44.35-.6.35-.16 0-.36-.08-.6-.35a3.99 3.99 0 01-.7-1.23c-.26-.66-.46-1.49-.58-2.42h3.76c-.12.93-.32 1.76-.58 2.42-.21.55-.45.97-.7 1.23zM4.34 11a6.02 6.02 0 003.88 3.73c-.17-.28-.32-.6-.45-.95-.3-.78-.53-1.73-.65-2.78H4.34zm2.69-1H4.08a6.04 6.04 0 010-2h2.95a17.4 17.4 0 000 2zm1-2a16.36 16.36 0 000 2h3.94a16.37 16.37 0 000-2H8.03zM3.5 13h.75c.25.36.53.69.84 1A.5.5 0 015 14H3.89l-.75 3h13.72l-.75-3H15a.5.5 0 01-.1 0c.32-.31.6-.64.85-1h.75a.5.5 0 01.49.38l1 4a.5.5 0 01-.49.62h-15a.5.5 0 01-.49-.62l1-4A.5.5 0 013.5 13z",
    fill: primaryFill
  }));
};

export const GlobeSurfaceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeSurfaceFilledIcon({}), 'GlobeSurfaceFilled');

const GlobeSurfaceRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a6 6 0 110 12 6 6 0 010-12zm0 11c.25 0 .74-.23 1.23-1.2.24-.5.45-1.1.58-1.8H8.2c.13.7.34 1.3.58 1.8.5.97.98 1.2 1.23 1.2zm-1.95-4h3.9a10.93 10.93 0 000-2h-3.9a10.94 10.94 0 000 2zm3.86 3.62A5.02 5.02 0 0014.58 11h-1.75a7.76 7.76 0 01-.92 2.62zM12.96 10h1.94a5.02 5.02 0 000-2h-1.94a11.96 11.96 0 010 2zM11.9 4.38c.42.68.74 1.59.92 2.62h1.75a5.02 5.02 0 00-2.67-2.62zm-.68.82C10.73 4.23 10.25 4 10 4s-.74.23-1.23 1.2c-.24.5-.45 1.1-.58 1.8h3.62c-.13-.7-.34-1.3-.58-1.8zm-3.14-.82A5.02 5.02 0 005.42 7h1.75c.18-1.03.5-1.94.92-2.62zM5 9c0 .34.03.68.1 1h1.94a11.97 11.97 0 010-2H5.1c-.07.32-.1.66-.1 1zm.42 2a5.02 5.02 0 002.67 2.62A7.76 7.76 0 017.17 11H5.42zM3.5 13h.75c.26.36.54.7.85 1H3.9l-.75 3h13.72l-.75-3H14.9c.31-.3.6-.64.85-1h.75a.5.5 0 01.49.38l1 4a.5.5 0 01-.49.62h-15a.5.5 0 01-.49-.62l1-4A.5.5 0 013.5 13z",
    fill: primaryFill
  }));
};

export const GlobeSurfaceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeSurfaceRegularIcon({}), 'GlobeSurfaceRegular');

const GlobeVideoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 00-5.09-4.22zm5.5 5.22h-3.76c.06.48.1.99.13 1.5h.52c.96 0 1.79.54 2.2 1.33l.97-.64c.1-.07.2-.13.32-.17a7.97 7.97 0 00-.39-2.02zm-4.77 0c.06.48.11.98.14 1.5H9.5a2.5 2.5 0 00-2.47 2.11 20.2 20.2 0 01.13-3.61h5.68zm-6.54 6c.17.94.4 1.8.7 2.54v1.38a8.03 8.03 0 01-4.2-3.92h3.5zm-3.9-1h3.75a20.52 20.52 0 010-5H2.4a8 8 0 000 5zm5.6-1c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v.5l2.22-1.48a.5.5 0 01.78.41v7.14a.5.5 0 01-.78.41L16 17v.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 018 17.5v-6z",
    fill: primaryFill
  }));
};

export const GlobeVideoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeVideoFilledIcon({}), 'GlobeVideoFilled');

const GlobeVideoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 17.42a8 8 0 1110.99-7.9c-.11.04-.22.1-.32.17l-.67.44a7.28 7.28 0 00-.46-2.63h-2.73c.07.48.13.98.16 1.5h-1c-.04-.52-.1-1.02-.18-1.5H7.21a14.87 14.87 0 00-.17 3.57c-.03.14-.04.28-.04.43v3.86c-.24-.56-.45-1.18-.61-1.86H3.94A7.03 7.03 0 007 16.33v1.09zM12.02 4.9C11.41 3.59 10.66 3 10 3c-.66 0-1.4.59-2.02 1.9-.22.47-.4 1.01-.56 1.6h5.16a9.25 9.25 0 00-.56-1.6zM6.4 6.5c.17-.74.4-1.42.68-2.01.19-.4.4-.78.64-1.1A7.02 7.02 0 003.94 6.5h2.45zM6 10c0-.87.07-1.71.2-2.5H3.45a6.98 6.98 0 000 5h2.73C6.07 11.71 6 10.87 6 10zm10.06-3.5a7.02 7.02 0 00-3.77-3.12c.24.33.45.7.64 1.1.27.6.5 1.28.68 2.02h2.45zM9.5 10c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5V17l2.22 1.48a.5.5 0 00.78-.41v-7.14a.5.5 0 00-.78-.41L16 12v-.5c0-.83-.67-1.5-1.5-1.5h-5z",
    fill: primaryFill
  }));
};

export const GlobeVideoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GlobeVideoRegularIcon({}), 'GlobeVideoRegular');

const GridFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 11c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-4c0-.83.67-1.5 1.5-1.5h4zm9 0c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 01-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h4zm-9-9C8.33 2 9 2.67 9 3.5v4C9 8.33 8.33 9 7.5 9h-4A1.5 1.5 0 012 7.5v-4C2 2.67 2.67 2 3.5 2h4zm9 0c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0111 7.5v-4c0-.83.67-1.5 1.5-1.5h4z",
    fill: primaryFill
  }));
};

export const GridFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GridFilledIcon({}), 'GridFilled');

const GridRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 11c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-4c0-.83.67-1.5 1.5-1.5h4zm9 0c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 01-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h4zm-9 1h-4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zm9 0h-4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zm-9-10C8.33 2 9 2.67 9 3.5v4C9 8.33 8.33 9 7.5 9h-4A1.5 1.5 0 012 7.5v-4C2 2.67 2.67 2 3.5 2h4zm9 0c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0111 7.5v-4c0-.83.67-1.5 1.5-1.5h4zm-9 1h-4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zm9 0h-4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5z",
    fill: primaryFill
  }));
};

export const GridRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GridRegularIcon({}), 'GridRegular');

const GridDotsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.75 4a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm0 6a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM4 17.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM11.75 4a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM10 11.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM11.75 16a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM16 5.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM17.75 10a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM16 17.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: primaryFill
  }));
};

export const GridDotsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GridDotsFilledIcon({}), 'GridDotsFilled');

const GridDotsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.25 4a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm12 12a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM16 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM17.25 4a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM10 17.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM11.25 10a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM10 5.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM5.25 16a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM4 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const GridDotsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GridDotsRegularIcon({}), 'GridDotsRegular');

const GridKanbanFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V3a1 1 0 00-1-1H3zm0 6a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V9a1 1 0 00-1-1H3zm0 6a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1v-2a1 1 0 00-1-1H3zm9-12a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V3a1 1 0 00-1-1h-5zm0 6a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V9a1 1 0 00-1-1h-5z",
    fill: primaryFill
  }));
};

export const GridKanbanFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GridKanbanFilledIcon({}), 'GridKanbanFilled');

const GridKanbanRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3a1 1 0 011-1h5a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm6 0H3v2h5V3zM2 9a1 1 0 011-1h5a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1V9zm6 0H3v2h5V9zm-5 5a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1v-2a1 1 0 00-1-1H3zm0 1h5v2H3v-2zm8-12a1 1 0 011-1h5a1 1 0 011 1v2a1 1 0 01-1 1h-5a1 1 0 01-1-1V3zm6 0h-5v2h5V3zm-5 5a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V9a1 1 0 00-1-1h-5zm0 1h5v2h-5V9z",
    fill: primaryFill
  }));
};

export const GridKanbanRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GridKanbanRegularIcon({}), 'GridKanbanRegular');

const GroupFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4.5c0 .36-.07.7-.2 1H10c.28 0 .5.22.5.5v2H10a2 2 0 00-2 2v.5H6a.5.5 0 01-.5-.5V6.8a2.5 2.5 0 01-1.5.15V10c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h3.05a2.51 2.51 0 01.16-1.5H10a.5.5 0 01-.5-.5v-2h.5a2 2 0 002-2v-.5h2c.28 0 .5.22.5.5v3.2a2.5 2.5 0 011.5-.15V10a2 2 0 00-2-2h-2V6a2 2 0 00-2-2H6.95c.03.16.05.33.05.5zm3.5 5v.5a.5.5 0 01-.5.5h-.5V10c0-.28.22-.5.5-.5h.5zM6 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0-11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const GroupFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupFilledIcon({}), 'GroupFilled');

const GroupRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4.5c0 .17-.02.34-.05.5H10a1 1 0 011 1v2h-1a2 2 0 00-2 2v1H6a1 1 0 01-1-1V6.95a2.51 2.51 0 01-1 0V10c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h3.05a2.51 2.51 0 010-1H10a1 1 0 01-1-1v-2h1a2 2 0 002-2V9h2a1 1 0 011 1v3.05a2.51 2.51 0 011 0V10a2 2 0 00-2-2h-2V6a2 2 0 00-2-2H6.95c.03.16.05.33.05.5zM11 9v1a1 1 0 01-1 1H9v-1a1 1 0 011-1h1zM6 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0-11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const GroupRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupRegularIcon({}), 'GroupRegular');

const GroupDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4.5c0 .36-.07.7-.2 1H10c.28 0 .5.22.5.5v2H10a2 2 0 00-2 2v.5H6a.5.5 0 01-.5-.5V6.8a2.5 2.5 0 01-1.5.15V10c0 1.1.9 2 2 2h2v2a2 2 0 001.16 1.81 5.51 5.51 0 01.34-3.6V10c0-.28.22-.5.5-.5h2.2a5.48 5.48 0 013.61-.34A2 2 0 0014 8h-2V6a2 2 0 00-2-2H6.95c.03.16.05.33.05.5zm-1 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm13-1a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const GroupDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupDismissFilledIcon({}), 'GroupDismissFilled');

const GroupDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4.5c0 .17-.02.34-.05.5H10a1 1 0 011 1v2h-1a2 2 0 00-2 2v1H6a1 1 0 01-1-1V6.95a2.51 2.51 0 01-1 0V10c0 1.1.9 2 2 2h2v2a2 2 0 001.16 1.81A5.51 5.51 0 019 14v-4a1 1 0 011-1h4a5.58 5.58 0 011.81.16A2 2 0 0014 8h-2V6a2 2 0 00-2-2H6.95c.03.16.05.33.05.5zm-1 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm13-1a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const GroupDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupDismissRegularIcon({}), 'GroupDismissRegular');

const GroupListFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 2a.75.75 0 00-.75.75v6c0 .41.34.75.75.75h2.5a.75.75 0 000-1.5H3.5V3.5h1.75a.75.75 0 000-1.5h-2.5zm0 8.5a.75.75 0 00-.75.75v6c0 .41.34.75.75.75h2.5a.75.75 0 000-1.5H3.5V12h1.75a.75.75 0 000-1.5h-2.5zm5 1.5a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5zM7 15.75c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5a.75.75 0 01-.75-.75zm0-11.5c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-9.5A.75.75 0 017 4.25zm.75 2.25a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5z",
    fill: primaryFill
  }));
};

export const GroupListFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupListFilledIcon({}), 'GroupListFilled');

const GroupListRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 3a.5.5 0 00-.5.5v5c0 .28.22.5.5.5h2a.5.5 0 000-1H3V4h1.5a.5.5 0 000-1h-2zm0 8a.5.5 0 00-.5.5v5c0 .28.22.5.5.5h2a.5.5 0 000-1H3v-4h1.5a.5.5 0 000-1h-2zM6 4.5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm.5 7.5a.5.5 0 000 1h11a.5.5 0 000-1h-11zM6 7.5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm.5 7.5a.5.5 0 000 1h11a.5.5 0 000-1h-11z",
    fill: primaryFill
  }));
};

export const GroupListRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupListRegularIcon({}), 'GroupListRegular');

const GroupReturnFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4.5c0 .36-.07.7-.2 1H10c.28 0 .5.22.5.5v2H10a2 2 0 00-2 2v.5H6a.5.5 0 01-.5-.5V6.8a2.5 2.5 0 01-1.5.15V10c0 1.1.9 2 2 2h2v2a2 2 0 001.16 1.81 5.51 5.51 0 01.34-3.6V10c0-.28.22-.5.5-.5h2.2a5.48 5.48 0 013.61-.34A2 2 0 0014 8h-2V6a2 2 0 00-2-2H6.95c.03.16.05.33.05.5zm-1 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm8.5 3.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const GroupReturnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupReturnFilledIcon({}), 'GroupReturnFilled');

const GroupReturnRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 4.5c0 .17-.02.34-.05.5H10a1 1 0 011 1v2h-1a2 2 0 00-2 2v1H6a1 1 0 01-1-1V6.95a2.51 2.51 0 01-1 0V10c0 1.1.9 2 2 2h2v2a2 2 0 001.16 1.81A5.51 5.51 0 019 14v-4a1 1 0 011-1h4a5.58 5.58 0 011.81.16A2 2 0 0014 8h-2V6a2 2 0 00-2-2H6.95c.03.16.05.33.05.5zm-1 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-11 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm8.5 3.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const GroupReturnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupReturnRegularIcon({}), 'GroupReturnRegular');

const GuardianFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 4.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM10.73 9A2 2 0 009 8H4a2 2 0 00-2 2v2.5a1 1 0 102 0v4.25a1.25 1.25 0 102.5 0 1.25 1.25 0 102.5 0V12.5a1 1 0 102 0V10a2 2 0 00-.27-1zM14 8a2 2 0 100-4 2 2 0 000 4zm-3 6.23a2 2 0 001-1.73V10a3 3 0 00-.17-1H16a2 2 0 012 2v2a1 1 0 11-2 0v3.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 11-2.5 0v-2.52z",
    fill: primaryFill
  }));
};

export const GuardianFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuardianFilledIcon({}), 'GuardianFilled');

const GuardianRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 11.62A1.5 1.5 0 014 16.5v-3.05a1.5 1.5 0 01-2-1.42V10.5A2.5 2.5 0 014.5 8h4c.82 0 1.54.4 2 1h5a2.5 2.5 0 012.5 2.5v1a1.5 1.5 0 01-2 1.41v2.59a1.5 1.5 0 01-2.5 1.12A1.5 1.5 0 0111 16.5v-4.46a1.5 1.5 0 01-2 1.4v3.06a1.5 1.5 0 01-2.5 1.12zM3 10.5v1.53a.5.5 0 001 0V10.5a.5.5 0 011 0v6a.5.5 0 001 0v-3a.5.5 0 011 0v3a.5.5 0 001 0v-6a.5.5 0 011 0v1.53a.5.5 0 001 0V10.5C10 9.67 9.33 9 8.5 9h-4C3.67 9 3 9.67 3 10.5zm7.95-.5c.03.16.05.33.05.5v.5h1v5.5a.5.5 0 001 0v-2a.5.5 0 011 0v2a.5.5 0 001 0v-5a.5.5 0 011 0v1a.5.5 0 001 0v-1c0-.83-.67-1.5-1.5-1.5h-4.55zM16 6a2 2 0 11-4 0 2 2 0 014 0zm-1 0a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const GuardianRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuardianRegularIcon({}), 'GuardianRegular');

const GuestFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 7a2 2 0 100 4 2 2 0 000-4zm-2.28 5c-.61 0-1.31.41-1.33 1.2-.01.51.1 1.24.66 1.83.56.6 1.5.97 2.95.97 1.45 0 2.39-.37 2.95-.97.57-.6.67-1.32.66-1.83-.02-.79-.72-1.2-1.33-1.2H7.72zM9 2a2 2 0 00-2 2H5.5C4.67 4 4 4.67 4 5.5v11c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5H13a2 2 0 00-2-2H9zm3.73 3h1.77c.28 0 .5.22.5.5v11a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-11c0-.28.22-.5.5-.5h1.77c.34.6.99 1 1.73 1h2a2 2 0 001.73-1zM8 4a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const GuestFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuestFilledIcon({}), 'GuestFilled');

const GuestRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 9a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zm-2.28 4c-.61 0-1.31.41-1.33 1.2-.01.51.1 1.24.66 1.83.56.6 1.5.97 2.95.97 1.45 0 2.39-.37 2.95-.97.57-.6.67-1.32.66-1.83-.02-.79-.72-1.2-1.33-1.2H7.72zm-.33 1.22c0-.05.02-.1.07-.14a.42.42 0 01.26-.08h4.56c.11 0 .2.04.26.08.05.04.07.09.07.14.01.37-.07.8-.38 1.12-.31.33-.94.66-2.23.66s-1.92-.33-2.23-.66c-.31-.33-.39-.75-.38-1.12zM9 2a2 2 0 00-2 2H5.5C4.67 4 4 4.67 4 5.5v11c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5H13a2 2 0 00-2-2H9zm3.73 3h1.77c.28 0 .5.22.5.5v11a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-11c0-.28.22-.5.5-.5h1.77c.34.6.99 1 1.73 1h2a2 2 0 001.73-1zM8 4a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const GuestRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuestRegularIcon({}), 'GuestRegular');

const GuestAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 7a2 2 0 10.27 3.98c.45-.54 1-.99 1.62-1.32A2 2 0 0010 7zm-2.28 5H9.6a5.48 5.48 0 00-.4 3.96c-1-.12-1.7-.45-2.15-.93a2.52 2.52 0 01-.66-1.83c.02-.79.72-1.2 1.33-1.2zM5.5 17h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 014 16.5v-11C4 4.67 4.67 4 5.5 4H7c0-1.1.9-2 2-2h2a2 2 0 012 2h1.5c.83 0 1.5.67 1.5 1.5v3.7c-.32-.08-.66-.15-1-.18V5.5a.5.5 0 00-.5-.5h-1.77A2 2 0 0111 6H9a2 2 0 01-1.73-1H5.5a.5.5 0 00-.5.5v11c0 .28.22.5.5.5zM8 4a1 1 0 001 1h2a1 1 0 100-2H9a1 1 0 00-1 1zm11 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const GuestAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuestAddFilledIcon({}), 'GuestAddFilled');

const GuestAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 9a2 2 0 113.89.66c-.62.33-1.17.78-1.62 1.32L10 11a2 2 0 01-2-2zm7-3.5v3.52c.34.03.68.1 1 .19V5.5c0-.83-.67-1.5-1.5-1.5H13a2 2 0 00-2-2H9a2 2 0 00-2 2H5.5C4.67 4 4 4.67 4 5.5v11c0 .83.67 1.5 1.5 1.5h4.76a5.5 5.5 0 01-.66-1H5.5a.5.5 0 01-.5-.5v-11c0-.28.22-.5.5-.5h1.77c.34.6.99 1 1.73 1h2a2 2 0 001.73-1h1.77c.28 0 .5.22.5.5zM7.72 12H9.6c-.16.32-.3.65-.4 1H7.73c-.11 0-.2.04-.26.08a.18.18 0 00-.07.14c-.01.37.07.8.38 1.12.22.23.6.46 1.25.58.02.36.08.7.18 1.04-1-.12-1.7-.45-2.15-.93a2.52 2.52 0 01-.66-1.83c.02-.79.72-1.2 1.33-1.2zM10 8a1 1 0 100 2 1 1 0 000-2zM8 4a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1zm11 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const GuestAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuestAddRegularIcon({}), 'GuestAddRegular');

const GuitarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3.78l1.11-1.12c.23-.23.6-.23.83 0l.9.9c.22.23.22.6 0 .83L16.22 5.5l-1.73-1.73zm-.72.71l-2.53 2.53-.13-.13a2.13 2.13 0 00-3.4.55l-.34.68a.6.6 0 01-.66.32h-.06a3.72 3.72 0 00-3.7 1.4 4.8 4.8 0 00.44 6.27l.49.49a4.8 4.8 0 006.26.44 3.72 3.72 0 001.42-3.7l-.01-.06a.6.6 0 01.32-.66l.68-.34a2.13 2.13 0 00.55-3.4l-.13-.13 2.53-2.53-1.73-1.73zm-5.41 7.14a1.25 1.25 0 111.76-1.76 1.25 1.25 0 01-1.76 1.76z",
    fill: primaryFill
  }));
};

export const GuitarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuitarFilledIcon({}), 'GuitarFilled');

const GuitarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.7 11.7a1 1 0 11-1.4-1.4 1 1 0 011.4 1.4zm5.56-9.39a1.09 1.09 0 011.53 0l.9.9c.42.42.42 1.1 0 1.53l-4.37 4.38a2.13 2.13 0 01-.76 3.16l-.68.34a.6.6 0 00-.32.66v.06a3.72 3.72 0 01-1.4 3.7 4.8 4.8 0 01-6.27-.44l-.49-.5a4.8 4.8 0 01-.44-6.25 3.72 3.72 0 013.7-1.42l.06.01a.6.6 0 00.66-.32l.34-.68a2.13 2.13 0 013.16-.76l4.38-4.37zm.83.7a.09.09 0 00-.13 0L14.8 4.19l1.02 1.02 1.16-1.16a.09.09 0 000-.13l-.9-.9zm-.98 2.9l-1.02-1.02-2.84 2.84a.5.5 0 01-.7 0l-.13-.13a1.13 1.13 0 00-1.8.3l-.35.67a1.6 1.6 0 01-1.75.85h-.05c-1.03-.21-2.08.19-2.71 1.03a3.8 3.8 0 00.35 4.95l.49.49a3.8 3.8 0 004.95.35 2.72 2.72 0 001.04-2.7l-.02-.07c-.14-.7.21-1.42.86-1.75l.68-.33c.69-.35.83-1.26.3-1.8l-.14-.14a.5.5 0 010-.7l2.84-2.84z",
    fill: primaryFill
  }));
};

export const GuitarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GuitarRegularIcon({}), 'GuitarRegular');

const HandDrawFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 3c0-.61-.37-1.04-.84-1.3a5.15 5.15 0 00-1.74-.5A37.9 37.9 0 009.53 1H9.5a.5.5 0 000 1c1.8 0 3.52 0 4.77.18.64.1 1.1.22 1.4.39.27.15.33.3.33.43 0 .15-.06.29-.31.44-.28.16-.7.29-1.3.38C13.22 4 11.64 4 10 4h-.03c-1.6 0-3.26 0-4.51.2-.63.09-1.22.24-1.66.5-.46.28-.8.7-.8 1.3 0 .8.65 1.27 1.32 1.52.7.27 1.65.4 2.68.4v-1c-.97 0-1.78-.12-2.32-.33C4.1 6.37 4 6.14 4 6c0-.15.06-.29.31-.44.28-.16.7-.29 1.3-.38C6.78 5 8.36 5 10 5h.03c1.6 0 3.26 0 4.51-.2.63-.09 1.22-.24 1.66-.5.46-.28.8-.7.8-1.3zM9.5 6C8.67 6 8 6.67 8 7.5v4.24l-1.35-.58a1.94 1.94 0 00-2.61 1.2c-.12.39.04.8.38 1l3.97 2.36h.02c.52.29.82.69 1 1.07.17.35.44.68.78.9.34.23.77.37 1.23.28l2-.38a1.5 1.5 0 001.17-1.11l.83-3.33a2.5 2.5 0 00-1.93-3.05L11 9.6V7.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const HandDrawFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandDrawFilledIcon({}), 'HandDrawFilled');

const HandDrawRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 3c0-.61-.37-1.04-.84-1.3a5.15 5.15 0 00-1.74-.5A37.9 37.9 0 009.53 1H9.5a.5.5 0 000 1c1.8 0 3.52 0 4.77.18.64.1 1.1.22 1.4.39.27.15.33.3.33.43 0 .15-.06.29-.31.44-.28.16-.7.29-1.3.38C13.22 4 11.64 4 10 4h-.03c-1.6 0-3.26 0-4.51.2-.63.09-1.22.24-1.66.5-.46.28-.8.7-.8 1.3 0 .8.65 1.27 1.32 1.52.7.27 1.65.4 2.68.4v-1c-.97 0-1.78-.12-2.32-.33C4.1 6.37 4 6.14 4 6c0-.15.06-.29.31-.44.28-.16.7-.29 1.3-.38C6.78 5 8.36 5 10 5h.03c1.6 0 3.26 0 4.51-.2.63-.09 1.22-.24 1.66-.5.46-.28.8-.7.8-1.3zM9 7.5a.5.5 0 011 0V10c0 .24.17.44.4.49l2.9.59c.83.16 1.36 1 1.15 1.83l-.83 3.33a.5.5 0 01-.39.37l-2 .38c-.14.03-.3 0-.48-.12a1.3 1.3 0 01-.43-.51 3.3 3.3 0 00-1.43-1.51l-3.86-2.29a.94.94 0 011.23-.48l2.04.88a.5.5 0 00.7-.46v-5zM9.5 6C8.67 6 8 6.67 8 7.5v4.24l-1.34-.58a1.94 1.94 0 00-2.62 1.2c-.12.39.04.8.38 1l3.97 2.36h.02c.52.29.83.69 1 1.07.17.35.44.68.78.9.34.23.77.37 1.23.28l2-.38a1.5 1.5 0 001.17-1.11l.83-3.33a2.5 2.5 0 00-1.93-3.05L11 9.6V7.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const HandDrawRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandDrawRegularIcon({}), 'HandDrawRegular');

const HandLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 8.5V2.75a.75.75 0 00-1.5 0V8.5a.5.5 0 01-1 0V3.75a.75.75 0 00-1.5 0v6.5a4.06 4.06 0 00-2-.75c-.97 0-1.79.32-1.98 1.12a.6.6 0 00-.02.14c0 .15.07.3.2.38l1.3.99c1.07.8 2.07 1.86 2.76 2.99.38.6.72 1.23 1.06 1.86.36.68.59 1.02 1.68 1.02h3.05c.95 0 1.31-.53 1.95-2 .64-1.47 1-2.94 1-3.5V5.25a.75.75 0 00-1.5 0V9a.5.5 0 01-1 0V3.75a.75.75 0 00-1.5 0V8.5a.5.5 0 01-1 0z",
    fill: primaryFill
  }));
};

export const HandLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandLeftFilledIcon({}), 'HandLeftFilled');

const HandLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 12.02c0 1.06-.2 2.1-.6 3.08l-.6 1.42a2.55 2.55 0 01-1.17 1.29c-.27.14-.56.21-.86.21h-2.55c-.77 0-1.49-.41-1.87-1.08-.5-.87-1.02-1.7-1.72-2.43l-1.32-1.39c-.44-.46-.97-.84-1.49-1.23l-.59-.45a.6.6 0 01-.23-.47c0-.75.54-1.57 1.22-1.79A3.34 3.34 0 017 9.47V4.5a1.5 1.5 0 012.05-1.4 1.5 1.5 0 012.9 0A1.5 1.5 0 0114 4.5v.09A1.5 1.5 0 0116 6v6.02zM12 4.5v4a.5.5 0 01-1 0v-5a.5.5 0 00-1 0v5a.5.5 0 01-1 0v-4a.5.5 0 00-1 0v6a.5.5 0 01-.85.37h-.01c-.22-.22-.44-.44-.72-.58-.7-.35-2.22-.57-2.4.5l.53.4c.52.4 1.04.78 1.48 1.24l1.33 1.38c.75.79 1.31 1.7 1.85 2.63.21.36.6.58 1.01.58h2.55c.13 0 .27-.03.4-.1.32-.17.57-.44.71-.78l.59-1.42c.35-.86.53-1.78.53-2.7V6a.5.5 0 00-1 0v3.5a.5.5 0 01-1 0v-5a.5.5 0 00-1 0z",
    fill: primaryFill
  }));
};

export const HandLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandLeftRegularIcon({}), 'HandLeftRegular');

const HandRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 8.5V2.75a.75.75 0 011.5 0V8.5a.5.5 0 001 0V3.75a.75.75 0 011.5 0v6.5c.66-.43 1.4-.75 2-.75.97 0 1.79.32 1.98 1.12.02.04.02.1.02.14 0 .15-.07.3-.2.38l-1.3.99c-1.07.8-2.07 1.86-2.76 2.99-.38.6-.72 1.23-1.06 1.86-.36.68-.59 1.02-1.68 1.02H6.95C6 18 5.64 17.47 5 16a11.7 11.7 0 01-1-3.5V5.25a.75.75 0 011.5 0V9a.5.5 0 001 0V3.75a.75.75 0 011.5 0V8.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const HandRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandRightFilledIcon({}), 'HandRightFilled');

const HandRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 12.02c0 1.06.2 2.1.6 3.08l.6 1.42c.22.55.64 1.01 1.17 1.29.27.14.56.21.86.21h2.55c.77 0 1.49-.41 1.87-1.08.5-.87 1.02-1.7 1.72-2.43l1.32-1.39c.44-.46.97-.84 1.49-1.23l.59-.45a.6.6 0 00.23-.47c0-.75-.54-1.57-1.22-1.79a3.34 3.34 0 00-2.78.29V4.5a1.5 1.5 0 00-2.05-1.4 1.5 1.5 0 00-2.9 0A1.5 1.5 0 006 4.5v.09A1.5 1.5 0 004 6v6.02zM8 4.5v4a.5.5 0 001 0v-5a.5.5 0 011 0v5a.5.5 0 001 0v-4a.5.5 0 011 0v6a.5.5 0 00.85.37h.01c.22-.22.44-.44.72-.58.7-.35 2.22-.57 2.4.5l-.53.4c-.52.4-1.04.78-1.48 1.24l-1.33 1.38c-.75.79-1.31 1.7-1.85 2.63-.21.36-.6.58-1.01.58H7.23a.87.87 0 01-.4-.1 1.55 1.55 0 01-.71-.78l-.59-1.42a7.09 7.09 0 01-.53-2.7V6a.5.5 0 011 0v3.5a.5.5 0 001 0v-5a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const HandRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandRightRegularIcon({}), 'HandRightRegular');

const HandRightOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5.25c0-.15.05-.3.13-.42L2.15 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-3.72-3.71c-.25.31-.49.64-.7.98-.37.6-.71 1.23-1.05 1.86-.36.68-.59 1.02-1.68 1.02H6.95C6 18 5.64 17.47 5 16a11.7 11.7 0 01-1-3.5V5.25zm2.5 1.96l-1-1V9a.5.5 0 001 0V7.2zM8 3.75v2.13l-1.5-1.5v-.63a.75.75 0 011.5 0zm3.1 5.24l3.71 3.7c.22-.2.45-.39.69-.56l1.3-.99c.13-.09.2-.23.2-.38 0-.05 0-.1-.02-.14-.2-.8-1-1.12-1.98-1.12-.6 0-1.34.32-2 .75v-6.5a.75.75 0 00-1.5 0V8.5a.5.5 0 01-.4.49zM9 6.88l1.5 1.5V2.75a.75.75 0 00-1.5 0v4.13z",
    fill: primaryFill
  }));
};

export const HandRightOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandRightOffFilledIcon({}), 'HandRightOffFilled');

const HandRightOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 6c0-.36.13-.7.34-.95l-2.2-2.2a.5.5 0 11.71-.7l15 15a.5.5 0 01-.7.7l-3.57-3.56-.21.22c-.7.72-1.22 1.56-1.72 2.43a2.16 2.16 0 01-1.87 1.08H7.23c-.3 0-.6-.07-.86-.21a2.55 2.55 0 01-1.18-1.3l-.58-1.41c-.4-.98-.61-2.02-.61-3.08V6zm8.87 7.58L7 7.7V9.5a.5.5 0 01-1 0V6.7l-.94-.93A.5.5 0 005 6v6.02c0 .93.18 1.84.53 2.7l.59 1.42c.14.34.4.61.71.78.13.07.27.1.4.1h2.55c.42 0 .8-.22 1-.58.55-.94 1.11-1.84 1.86-2.63l.23-.23zM10 3.5v4.38l.9.9a.5.5 0 00.1-.28v-4a.5.5 0 011 0v5.38l.92.92c.2-.2.4-.38.66-.51.7-.35 2.22-.57 2.4.5l-.53.4c-.4.3-.81.61-1.18.95l.7.71c.38-.34.8-.65 1.2-.96l.6-.45a.6.6 0 00.23-.47c0-.75-.54-1.57-1.22-1.79a3.34 3.34 0 00-2.78.29V4.5a1.5 1.5 0 00-2.05-1.4 1.5 1.5 0 00-2.9 0 1.5 1.5 0 00-1.96.87l.91.9V4.5a.5.5 0 011 0v1.38l1 1V3.5a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const HandRightOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandRightOffRegularIcon({}), 'HandRightOffRegular');

const HandshakeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.63 3.01a.5.5 0 00.06 0H12a2.5 2.5 0 012 .31 3.7 3.7 0 011.71 5.1L12.5 5.18a.5.5 0 00-.36-.15H10.8a.5.5 0 00-.3.1L8.35 6.76a1.12 1.12 0 01-1.67-.4A1.1 1.1 0 017 5l2.63-1.99zm-4 8.85l-.01.02-.77.76v.01a.6.6 0 01-.84-.01.6.6 0 010-.84l.76-.76a.6.6 0 01.85 0c.23.22.23.6.01.82zm-.08 1.5a.6.6 0 00.01.82.6.6 0 00.85 0l.76-.76a.6.6 0 00-.09-.91.6.6 0 00-.74.06l-.01.01-.77.76v.02zM3.75 9.8a.6.6 0 010 .84l-.77.76a.6.6 0 01-.84 0 .6.6 0 010-.84l.76-.76a.6.6 0 01.85 0zm4.98 4.33a.6.6 0 010 .84l-.76.76a.6.6 0 01-.85 0 .6.6 0 01-.09-.73.6.6 0 01.09-.11l.76-.76a.6.6 0 01.85 0zM3.53 4.4a4.76 4.76 0 014.3-1.29L6.4 4.21A2.1 2.1 0 006 7.14c.7.92 2.03 1.1 2.95.4l2.02-1.53h.9l1.95 1.93 1.6 1.62.03.03.87.86a1.02 1.02 0 01-1.37 1.51l-.07-.07a.5.5 0 00-.06-.05l-.85-.85a.5.5 0 10-.7.71l.9.9.1.1.03.03a.7.7 0 01-.98.98l-.13-.14a.5.5 0 00-.85.37c0 .13.05.26.15.36l.17.17a.63.63 0 11-.9.9l-.08-.1a1.63 1.63 0 00-.1-.1l-.16-.16a.5.5 0 00-.7.7l.11.13a.5.5 0 00.06.06l.04.05a.65.65 0 01-.96.86L9.11 16l.33-.32a1.58 1.58 0 00-1.09-2.72c0-.4-.16-.78-.47-1.08-.3-.3-.69-.46-1.08-.47A1.6 1.6 0 004.9 9.9 1.61 1.61 0 002.31 9 4.7 4.7 0 013.52 4.4z",
    fill: primaryFill
  }));
};

export const HandshakeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandshakeFilledIcon({}), 'HandshakeFilled');

const HandshakeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.24 3.01a.5.5 0 00-.39.19l-.08.06A5.13 5.13 0 004.7 4.44a4.7 4.7 0 00-1.37 4.31l-.05.05-.78.75c-.64.61-.64 1.6 0 2.22.4.38.95.53 1.46.43.06.29.21.56.44.79.31.3.71.45 1.11.46.01.39.17.77.48 1.07.3.3.7.44 1.1.45.02.4.18.78.49 1.07.6.58 1.56.61 2.2.1l.43.42c.64.61 1.68.61 2.32 0 .3-.3.47-.68.48-1.07.4 0 .8-.16 1.1-.46.3-.3.47-.67.48-1.06.4-.01.78-.17 1.09-.46.24-.23.39-.52.45-.82.5.08 1.05-.06 1.44-.44.63-.61.63-1.6 0-2.22l-.72-.7.14-.54c.3-1.13.15-2.32-.42-3.34a4.8 4.8 0 00-4.2-2.43h-2.13zm2.46 3.72l2.4 2.31 1.75 1.68c.24.23.24.6 0 .84a.63.63 0 01-.87 0l-1.32-1.27a.52.52 0 00-.72 0h-.01c-.2.2-.2.51 0 .7l1.03 1c.24.22.24.6 0 .83a.63.63 0 01-.8.05.52.52 0 00-.67.05.48.48 0 00-.04.64c.18.24.16.57-.06.78a.63.63 0 01-.8.05.52.52 0 00-.68.04.48.48 0 00-.05.64c.2.24.18.58-.05.8a.64.64 0 01-.87 0l-.44-.42.16-.16c.64-.61.64-1.6 0-2.22-.3-.3-.7-.45-1.1-.46a1.54 1.54 0 00-.49-1.07c-.3-.3-.7-.44-1.1-.45a1.54 1.54 0 00-.48-1.07c-.4-.39-.95-.53-1.46-.43a1.55 1.55 0 00-.45-.8c-.35-.33-.83-.48-1.29-.45a3.74 3.74 0 011.13-3.2 4.06 4.06 0 013.29-1.1L7.25 5.11a1.7 1.7 0 00-.33 2.44c.6.76 1.7.9 2.48.33l1.58-1.15h1.72zm-4.86-.81l2.6-1.9h.53a2.26 2.26 0 01.15 0h1.24c1.4 0 2.69.74 3.34 1.92.44.8.56 1.72.33 2.6l-2.77-2.67a.5.5 0 00-.35-.14h-2.1a.5.5 0 00-.3.1l-1.7 1.25a.8.8 0 01-1.1-.15.7.7 0 01.13-1.01zm.45 8.6l.78-.75.01-.01a.63.63 0 01.86 0c.24.24.24.6 0 .84l-.78.75a.63.63 0 01-.86 0 .57.57 0 01-.01-.83zm.07-1.46v.01l-.78.75-.01.01a.63.63 0 01-.86 0 .57.57 0 010-.84l.78-.75a.63.63 0 01.86 0c.24.23.24.6.01.82zm-1.6-1.52L6 12.3v.01a.63.63 0 01-.86 0 .57.57 0 010-.84l.77-.75a.63.63 0 01.87 0c.24.23.24.6 0 .83zm-1.9-1.21l-.78.74a.63.63 0 01-.86 0 .57.57 0 010-.83L4 9.5a.63.63 0 01.86 0c.24.23.24.6 0 .84z",
    fill: primaryFill
  }));
};

export const HandshakeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HandshakeRegularIcon({}), 'HandshakeRegular');

const HardDriveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.49 4a2 2 0 00-1.84 1.21l-2 4.7c.38-.26.85-.41 1.35-.41h12c.56 0 1.08.18 1.5.5a57.37 57.37 0 00-2.14-4.91A1.96 1.96 0 0013.59 4H6.5zM2.5 12c0-.83.67-1.5 1.5-1.5h12c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H4A1.5 1.5 0 012.5 14v-2zm12.5.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0z",
    fill: primaryFill
  }));
};

export const HardDriveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HardDriveFilledIcon({}), 'HardDriveFilled');

const HardDriveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.25 13.5a.75.75 0 100-1.5.75.75 0 000 1.5zM2.24 10.84C2.08 11.21 2 11.6 2 12v2c0 1.1.9 2 2 2h12a2 2 0 002-2v-2c0-.38-.06-.77-.19-1.14a54.93 54.93 0 00-2.45-5.77A1.96 1.96 0 0013.59 4H6.5a2 2 0 00-1.84 1.21l-2.41 5.63zM6.49 5h7.1c.38 0 .7.2.87.53.47.95 1.27 2.65 1.99 4.52-.15-.03-.3-.05-.45-.05H4c-.11 0-.22 0-.32.03L5.57 5.6A1 1 0 016.49 5zM17 14a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h12a1 1 0 011 1v2z",
    fill: primaryFill
  }));
};

export const HardDriveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HardDriveRegularIcon({}), 'HardDriveRegular');

const HatGraduationFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 14.5v-3.33l4 2.3a4 4 0 004 0l4-2.3v3.33a.5.5 0 01-.15.35v.01l-.03.03a3.66 3.66 0 01-.38.32A9.1 9.1 0 0110 17a9.1 9.1 0 01-5.74-2.05 3.6 3.6 0 01-.08-.07l-.02-.03A.51.51 0 014 14.5zm14.75-6.07l-7.26 4.17a3 3 0 01-2.98 0L2 8.86v4.64a.5.5 0 01-1 0V8c0-.19.1-.36.26-.44L8.51 3.4a3 3 0 012.98 0l7.26 4.17a.5.5 0 010 .86z",
    fill: primaryFill
  }));
};

export const HatGraduationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HatGraduationFilledIcon({}), 'HatGraduationFilled');

const HatGraduationRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 3.4a3 3 0 013 0l7.25 4.17a.5.5 0 010 .86L16 10.01v4.49a.5.5 0 01-.15.35v.01l-.03.03a3.88 3.88 0 01-.38.32A9.1 9.1 0 0110 17a9.1 9.1 0 01-5.74-2.05 3.81 3.81 0 01-.08-.07.53.53 0 01-.18-.39v-4.49L2 8.86v4.64a.5.5 0 11-1 0V8c0-.19.1-.35.26-.44L8.51 3.4zm3 9.2a3 3 0 01-3 0L5 10.59v3.69l.17.14A8.1 8.1 0 0010 16a8.1 8.1 0 005-1.72v-3.7l-3.5 2.02zM11 4.27a2 2 0 00-2 0L2.5 8 9 11.73a2 2 0 002 0L17.5 8 11 4.27z",
    fill: primaryFill
  }));
};

export const HatGraduationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HatGraduationRegularIcon({}), 'HatGraduationRegular');

const HdFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.42 12h-.92V8h.92c.87 0 1.58.7 1.58 1.58v.84c0 .87-.7 1.58-1.58 1.58zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zm-.5 4c.28 0 .5.22.5.5V10h2.5V7.5a.5.5 0 011 0v5a.5.5 0 01-1 0V11H6v1.5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zM11 7h1.42A2.58 2.58 0 0115 9.58v.84A2.58 2.58 0 0112.42 13H11a.5.5 0 01-.5-.5v-5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const HdFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HdFilledIcon({}), 'HdFilled');

const HdRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 7c.28 0 .5.22.5.5V10h2.5V7.5a.5.5 0 011 0v5a.5.5 0 01-1 0V11H6v1.5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zM11 7a.5.5 0 00-.5.5v5c0 .28.22.5.5.5h1.42A2.58 2.58 0 0015 10.42v-.84A2.58 2.58 0 0012.42 7H11zm1.42 5h-.92V8h.92c.87 0 1.58.7 1.58 1.58v.84c0 .87-.7 1.58-1.58 1.58zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2V6a2 2 0 00-2-2H6z",
    fill: primaryFill
  }));
};

export const HdRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HdRegularIcon({}), 'HdRegular');

const HdrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.5A2.75 2.75 0 0018 13.25v-6.5A2.75 2.75 0 0015.25 4H4.75zM4.5 7.5c.28 0 .5.22.5.5v1.5h2V8a.5.5 0 011 0v4a.5.5 0 01-1 0v-1.5H5V12a.5.5 0 01-1 0V8c0-.28.22-.5.5-.5zM9 8c0-.28.22-.5.5-.5h.25c1.24 0 2.25 1 2.25 2.25v.5c0 1.24-1 2.25-2.25 2.25H9.5A.5.5 0 019 12V8zm1 3.47c.57-.11 1-.62 1-1.22v-.5c0-.6-.43-1.1-1-1.22v2.95zM13 8c0-.28.22-.5.5-.5h1a1.5 1.5 0 01.87 2.72l.6 1.6a.5.5 0 01-.94.36l-.63-1.68H14V12a.5.5 0 01-1 0V8zm1 1.5h.5a.5.5 0 000-1H14v1z",
    fill: primaryFill
  }));
};

export const HdrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HdrFilledIcon({}), 'HdrFilled');

const HdrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.5A2.75 2.75 0 0018 13.25v-6.5A2.75 2.75 0 0015.25 4H4.75zM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25v-6.5zm1.5.75c.28 0 .5.22.5.5v1.5h2V8a.5.5 0 011 0v4a.5.5 0 01-1 0v-1.5H5V12a.5.5 0 01-1 0V8c0-.28.22-.5.5-.5zM9 8c0-.28.22-.5.5-.5h.25c1.24 0 2.25 1 2.25 2.25v.5c0 1.24-1 2.25-2.25 2.25H9.5A.5.5 0 019 12V8zm1 3.47c.57-.11 1-.62 1-1.22v-.5c0-.6-.43-1.1-1-1.22v2.95zM13 8c0-.28.22-.5.5-.5h1a1.5 1.5 0 01.87 2.72l.6 1.6a.5.5 0 01-.94.36l-.63-1.68H14V12a.5.5 0 01-1 0V8zm1 1.5h.5a.5.5 0 000-1H14v1z",
    fill: primaryFill
  }));
};

export const HdrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HdrRegularIcon({}), 'HdrRegular');

const HdrOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l1.41 1.42A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.54l1.86 1.85a.5.5 0 00.7-.7l-15-15zm8.38 9.8c-.4.34-.91.55-1.48.55H9.5A.5.5 0 019 12V9.7l1 1v.78c.2-.04.37-.13.52-.25l.71.71zM8 8.7V12a.5.5 0 01-1 0v-1.5H5V12a.5.5 0 01-1 0V8a.5.5 0 011 0v1.5h2V8a.5.5 0 01.06-.23L8 8.7zm4 1.04v.13l1 1V8c0-.28.22-.5.5-.5h1a1.5 1.5 0 01.87 2.72l.6 1.6a.5.5 0 01-.94.36l-.63-1.68H14v1.38l3.25 3.25c.47-.49.75-1.15.75-1.88v-6.5A2.75 2.75 0 0015.25 4H6.12l3.5 3.5h.13c1.24 0 2.25 1 2.25 2.25zm2-.25h.5a.5.5 0 000-1H14v1z",
    fill: primaryFill
  }));
};

export const HdrOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HdrOffFilledIcon({}), 'HdrOffFilled');

const HdrOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l1.41 1.42A2.75 2.75 0 002 6.75v6.5A2.75 2.75 0 004.75 16h10.54l1.86 1.85a.5.5 0 00.7-.7l-15-15zM14.3 15H4.75C3.78 15 3 14.22 3 13.25v-6.5c0-.83.57-1.52 1.34-1.7l2.72 2.72A.5.5 0 007 8v1.5H5V8a.5.5 0 00-1 0v4a.5.5 0 001 0v-1.5h2V12a.5.5 0 001 0V8.7l1 1V12c0 .28.22.5.5.5h.25c.57 0 1.09-.21 1.48-.56L14.3 15zM10 10.7l.52.53c-.15.12-.32.2-.52.24v-.76zm-.38-3.2L12 9.88v-.13c0-1.24-1-2.25-2.25-2.25h-.13zM13 10.88l1 1V10.5h.4l.63 1.68a.5.5 0 00.94-.36l-.6-1.6a1.5 1.5 0 00-.87-2.72h-1a.5.5 0 00-.5.5v2.88zm4 2.37c0 .45-.17.86-.45 1.18l.7.7c.47-.49.75-1.15.75-1.88v-6.5A2.75 2.75 0 0015.25 4H6.12l1 1h8.13c.97 0 1.75.78 1.75 1.75v6.5zM14 9.5h.5a.5.5 0 000-1H14v1z",
    fill: primaryFill
  }));
};

export const HdrOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HdrOffRegularIcon({}), 'HdrOffRegular');

const HeadphonesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 10a7 7 0 0114 0v1h-3.5a.5.5 0 00-.5.5v6c0 .28.22.5.5.5H16a2 2 0 002-2v-6a8 8 0 10-16 0v6c0 1.1.9 2 2 2h2.5a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5H3v-1z",
    fill: primaryFill
  }));
};

export const HeadphonesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadphonesFilledIcon({}), 'HeadphonesFilled');

const HeadphonesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 10a7 7 0 0114 0v1h-3.5a.5.5 0 00-.5.5v6c0 .28.22.5.5.5H16a2 2 0 002-2v-6a8 8 0 10-16 0v6c0 1.1.9 2 2 2h2.5a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5H3v-1zm0 2h3v5H4a1 1 0 01-1-1v-4zm14 0v4a1 1 0 01-1 1h-2v-5h3z",
    fill: primaryFill
  }));
};

export const HeadphonesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadphonesRegularIcon({}), 'HeadphonesRegular');

const HeadphonesSoundWaveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 00-7 7v1h1.5c.28 0 .5.22.5.5v6a.5.5 0 01-.5.5H4a2 2 0 01-2-2v-6a8 8 0 1116 0v6a2 2 0 01-2 2h-.5a.5.5 0 01-.5-.5v-6c0-.28.22-.5.5-.5H17v-1a7 7 0 00-7-7zm.5 7.5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7zm-3 1.5c.28 0 .5.22.5.5v4a.5.5 0 01-1 0v-4c0-.28.22-.5.5-.5zm5.5.5a.5.5 0 00-1 0v4a.5.5 0 001 0v-4z",
    fill: primaryFill
  }));
};

export const HeadphonesSoundWaveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadphonesSoundWaveFilledIcon({}), 'HeadphonesSoundWaveFilled');

const HeadphonesSoundWaveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 00-7 7v1h1.5c.28 0 .5.22.5.5v6a.5.5 0 01-.5.5H4a2 2 0 01-2-2v-6a8 8 0 1116 0v6a2 2 0 01-2 2h-.5a.5.5 0 01-.5-.5v-6c0-.28.22-.5.5-.5H17v-1a7 7 0 00-7-7zM3 16a1 1 0 001 1v-5H3v4zm14 0v-4h-1v5a1 1 0 001-1zm-6.5-5.5a.5.5 0 00-1 0v7a.5.5 0 001 0v-7zm-3 1.5c.28 0 .5.22.5.5v4a.5.5 0 01-1 0v-4c0-.28.22-.5.5-.5zm5.5.5a.5.5 0 00-1 0v4a.5.5 0 001 0v-4z",
    fill: primaryFill
  }));
};

export const HeadphonesSoundWaveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadphonesSoundWaveRegularIcon({}), 'HeadphonesSoundWaveRegular');

const HeadsetFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a6 6 0 00-6 6v6a3 3 0 003 3h1.27A2 2 0 108 16H7a2 2 0 01-2-2v-1h2a1 1 0 001-1V9a1 1 0 00-1-1H5a5 5 0 0110 0h-2a1 1 0 00-1 1v3a1 1 0 001 1h1a2 2 0 002-2V8a6 6 0 00-6-6z",
    fill: primaryFill
  }));
};

export const HeadsetFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadsetFilledIcon({}), 'HeadsetFilled');

const HeadsetRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 8a6 6 0 1112 0v3a2 2 0 01-2 2h-1a1 1 0 01-1-1V9a1 1 0 011-1h2A5 5 0 005 8h2a1 1 0 011 1v3a1 1 0 01-1 1H5v1c0 1.1.9 2 2 2h1a2 2 0 11.27 1H7a3 3 0 01-3-3V8zm11 1h-2v3h1a1 1 0 001-1V9zM5 12h2V9H5v3zm4 4a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const HeadsetRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadsetRegularIcon({}), 'HeadsetRegular');

const HeadsetAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm-.5 7.5a5.5 5.5 0 001.5-.2v.2a2 2 0 01-2 2h-1a1 1 0 01-1-1v-1.6c.75.38 1.6.6 2.5.6zm-4.25-9a5.5 5.5 0 00-.66 1.02A5 5 0 005 8h2a1 1 0 011 1v3a1 1 0 01-1 1H5v1c0 1.1.9 2 2 2h1a2 2 0 11.27 1H7a3 3 0 01-3-3V8a6 6 0 016.25-6z",
    fill: primaryFill
  }));
};

export const HeadsetAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadsetAddFilledIcon({}), 'HeadsetAddFilled');

const HeadsetAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5zm0 7.5v-.02c.34-.03.68-.1 1-.19V11a2 2 0 01-2 2h-1a1 1 0 01-1-1v-1.6c.32.16.65.3 1 .4V12h1a1 1 0 001-1zm-4.75-9a5.5 5.5 0 00-.66 1.02A5 5 0 005 8h2a1 1 0 011 1v3a1 1 0 01-1 1H5v1c0 1.1.9 2 2 2h1a2 2 0 11.27 1H7a3 3 0 01-3-3V8a6 6 0 016.25-6zM5 12h2V9H5v3zm4 4a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const HeadsetAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadsetAddRegularIcon({}), 'HeadsetAddRegular');

const HeadsetVrFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6.89a28.51 28.51 0 0114 0c.6.14 1 .68 1 1.28v2.55c0 1.8-1.44 3.28-3.24 3.28h-2c-.61 0-1.2-.27-1.6-.73l-.52-.61a.83.83 0 00-1.27 0l-.53.6c-.4.47-.99.74-1.6.74h-2A3.26 3.26 0 012 10.72V8.17c0-.6.4-1.14 1-1.28zm7.75 1.86a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM4.5 9a.5.5 0 000 1H6a.5.5 0 000-1H4.5zm9 .5c0 .28.22.5.5.5h1.5a.5.5 0 000-1H14a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const HeadsetVrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadsetVrFilledIcon({}), 'HeadsetVrFilled');

const HeadsetVrRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.75 8.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM4 9.5c0-.28.22-.5.5-.5H6a.5.5 0 010 1H4.5a.5.5 0 01-.5-.5zM14 9a.5.5 0 000 1h1.5a.5.5 0 000-1H14zm-4-3c-2.33 0-4.67.3-7 .89-.6.14-1 .68-1 1.28v2.55C2 12.52 3.44 14 5.24 14h2c.61 0 1.2-.27 1.6-.73l.52-.61a.83.83 0 011.28 0l.52.6c.4.47.99.74 1.6.74h2c1.8 0 3.24-1.48 3.24-3.28V8.17c0-.6-.4-1.14-1-1.28A28.51 28.51 0 0010 6zM3.24 7.86a27.51 27.51 0 0113.52 0c.14.03.24.16.24.31v2.55c0 1.27-1 2.28-2.24 2.28h-2c-.32 0-.63-.14-.84-.39l-.53-.6a1.83 1.83 0 00-2.78 0l-.53.6c-.21.25-.52.39-.84.39h-2A2.26 2.26 0 013 10.72V8.17c0-.15.1-.28.24-.31z",
    fill: primaryFill
  }));
};

export const HeadsetVrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeadsetVrRegularIcon({}), 'HeadsetVrRegular');

const HeartFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29a4.3 4.3 0 00-6.13-.02 4.4 4.4 0 00.02 6.2l6.27 6.33c.26.27.69.27.95 0l6.24-6.3a4.4 4.4 0 00-.02-6.19 4.3 4.3 0 00-6.13-.01l-.6.6-.6-.61z",
    fill: primaryFill
  }));
};

export const HeartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartFilledIcon({}), 'HeartFilled');

const HeartRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 16.8l6.24-6.3a4.4 4.4 0 00-.02-6.19 4.3 4.3 0 00-6.13-.01l-.6.6-.6-.61a4.3 4.3 0 00-6.13-.02 4.4 4.4 0 00.02 6.2l6.27 6.33c.26.27.69.27.95 0zM11.3 5a3.3 3.3 0 014.71.02 3.4 3.4 0 01.02 4.78l-6 6.06-6.04-6.1a3.4 3.4 0 01-.02-4.78 3.3 3.3 0 014.7.01l.97.97c.2.2.51.2.7 0L11.3 5z",
    fill: primaryFill
  }));
};

export const HeartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartRegularIcon({}), 'HeartRegular');

const HeartBrokenFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.27 4.18a4.3 4.3 0 00-6 .1 4.4 4.4 0 000 6.18l6.28 6.34c.26.27.69.27.95 0l6.24-6.3a4.4 4.4 0 00-.02-6.19 4.3 4.3 0 00-6.13-.01l-.59.59-1.34 2.06 3 2.53a.5.5 0 01.03.73l-2 2a.5.5 0 11-.71-.7l1.62-1.62-2.92-2.46a.5.5 0 01-.1-.66l1.7-2.6z",
    fill: primaryFill
  }));
};

export const HeartBrokenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartBrokenFilledIcon({}), 'HeartBrokenFilled');

const HeartBrokenRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.74 10.5l-6.24 6.3a.66.66 0 01-.95 0l-6.27-6.34a4.4 4.4 0 01-.02-6.19 4.3 4.3 0 016.13.02l.6.61.06-.06.54-.54.1-.1a4.3 4.3 0 016.03.11 4.4 4.4 0 01.02 6.19zm-5.76-5.18l-.03.03-.2.2-.4.41a.5.5 0 01-.05.04l-1 1 2.32 2.31c.2.2.2.52 0 .71l-2 2a.5.5 0 01-.7-.7l1.64-1.65-2.31-2.32a.5.5 0 010-.7L9.29 5.6l-.61-.62a3.3 3.3 0 00-4.7-.01 3.4 3.4 0 000 4.78l6.05 6.1 6-6.06A3.4 3.4 0 0016 5.02 3.3 3.3 0 0011.3 5l-.32.32z",
    fill: primaryFill
  }));
};

export const HeartBrokenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartBrokenRegularIcon({}), 'HeartBrokenRegular');

const HeartCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 1016 0 8 8 0 00-16 0zm7.6-2.39l.39.4.4-.4a2.12 2.12 0 013.03 2.96l-3.05 3.27a.5.5 0 01-.74 0l-3.06-3.28A2.11 2.11 0 019.6 7.61z",
    fill: primaryFill
  }));
};

export const HeartCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartCircleFilledIcon({}), 'HeartCircleFilled');

const HeartCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.6 7.61l.39.39.4-.4a2.12 2.12 0 013.03 2.97l-3.05 3.27a.5.5 0 01-.74 0l-3.06-3.28A2.11 2.11 0 019.6 7.61zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const HeartCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartCircleRegularIcon({}), 'HeartCircleRegular');

const HeartPulseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.39 4.29a4.3 4.3 0 00-6.13-.02 4.4 4.4 0 00-.94 4.74L2.5 9h2.3l1.32-3.09a1.5 1.5 0 012.76.01l1.39 3.32.96-1.54a1.5 1.5 0 012.4-.19L14.93 9h2.57l.2.01c.61-1.57.29-3.42-.98-4.7a4.3 4.3 0 00-6.13-.01l-.6.6-.6-.61zm.16 12.51L4.8 12h1c.6 0 1.15-.36 1.38-.91l.3-.72 1.14 2.7a1.5 1.5 0 002.65.22l1.43-2.28.42.48c.29.32.7.51 1.13.51h1l-4.75 4.8a.66.66 0 01-.95 0zM7.96 6.3a.5.5 0 00-.92 0L5.47 10H2.5a.5.5 0 000 1h3.3a.5.5 0 00.46-.3L7.5 7.79l2.04 4.9a.5.5 0 00.88.08l2.15-3.43 1.3 1.49c.1.1.24.17.38.17h3.25a.5.5 0 000-1h-3.02l-1.6-1.83a.5.5 0 00-.8.06l-2 3.18-2.12-5.1z",
    fill: primaryFill
  }));
};

export const HeartPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartPulseFilledIcon({}), 'HeartPulseFilled');

const HeartPulseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 16.8l4.75-4.8h-1a1.5 1.5 0 01-.36-.04l-3.86 3.9-3.87-3.9a1.5 1.5 0 01-.36.04h-1l4.75 4.8c.26.27.69.27.95 0zm6.22-12.49a4.42 4.42 0 01.98 4.7L17.5 9h-.89c.67-1.28.48-2.9-.6-3.98A3.3 3.3 0 0011.3 5l-.95.96a.5.5 0 01-.71 0L8.68 5a3.3 3.3 0 00-4.7-.01A3.4 3.4 0 003.41 9H2.5l-.18.01a4.4 4.4 0 01.94-4.74 4.3 4.3 0 016.13.02l.6.61.6-.6.1-.1a4.3 4.3 0 016.03.11zm-8.76 2a.5.5 0 00-.92 0L5.47 10H2.5a.5.5 0 000 1h3.3a.5.5 0 00.46-.3L7.5 7.79l2.04 4.9a.5.5 0 00.88.08l2.15-3.43 1.3 1.49c.1.1.24.17.38.17h3.25a.5.5 0 000-1h-3.02l-1.6-1.83a.5.5 0 00-.8.06l-2 3.18-2.12-5.1z",
    fill: primaryFill
  }));
};

export const HeartPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HeartPulseRegularIcon({}), 'HeartPulseRegular');

const HighlightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v3C3 7.33 3.67 8 4.5 8h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zM6 11a2 2 0 01-2-2h12a2 2 0 01-2 2H6zm0 1h8v1.07a2 2 0 01-1.1 1.8l-6.18 3.08A.5.5 0 016 17.5V12z",
    fill: primaryFill
  }));
};

export const HighlightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HighlightFilledIcon({}), 'HighlightFilled');

const HighlightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2c.28 0 .5.22.5.5v4c0 .28.22.5.5.5h11a.5.5 0 00.5-.5v-4a.5.5 0 011 0v4c0 .65-.42 1.2-1 1.41V9a2 2 0 01-2 2v2.07a2 2 0 01-1.1 1.8l-6.18 3.08A.5.5 0 016 17.5V11a2 2 0 01-2-2V7.91c-.58-.2-1-.76-1-1.41v-4c0-.28.22-.5.5-.5zM5 8v1a1 1 0 001 1h8a1 1 0 001-1V8H5zm2 3v5.7l5.45-2.73a1 1 0 00.55-.9V11H7z",
    fill: primaryFill
  }));
};

export const HighlightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HighlightRegularIcon({}), 'HighlightRegular');

const HighlightAccentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.5 3v4a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V3h13zm-10 7.5v7l6.45-3.1a1 1 0 00.55-.9v-3h-7z",
    fill: primaryFill
  }));
};

export const HighlightAccentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HighlightAccentFilledIcon({}), 'HighlightAccentFilled');

const HighlightLinkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v3C3 7.33 3.67 8 4.5 8h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zM6 11a2 2 0 01-2-2h12a2 2 0 01-2 2H6zm0 1h6.5a3.5 3.5 0 00-3.29 4.7l-2.49 1.25A.5.5 0 016 17.5V12zm6.5 1a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const HighlightLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HighlightLinkFilledIcon({}), 'HighlightLinkFilled');

const HighlightLinkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2c.28 0 .5.22.5.5v4c0 .28.22.5.5.5h11a.5.5 0 00.5-.5v-4a.5.5 0 011 0v4c0 .65-.42 1.2-1 1.41V9a2 2 0 01-2 2v1h-1v-1H7v5.7l2-1.01c.02.35.1.7.21 1.01l-2.49 1.25A.5.5 0 016 17.5V11a2 2 0 01-2-2V7.91c-.58-.2-1-.76-1-1.41v-4c0-.28.22-.5.5-.5zM5 8v1a1 1 0 001 1h8a1 1 0 001-1V8H5zm7.5 5a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const HighlightLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HighlightLinkRegularIcon({}), 'HighlightLinkRegular');

const HistoryFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.37 2.02A8 8 0 112 9.74a.75.75 0 011.5.04 6.5 6.5 0 101.57-4.03l-.2.25h1.88l.1.01a.75.75 0 010 1.49h-3.7a.75.75 0 01-.64-.64V2.66c.04-.34.3-.6.64-.65h.2c.34.05.6.3.65.64v2.06a7.98 7.98 0 015.37-2.69zM9.75 6l.1.01c.33.05.6.3.64.64l.01.1V10h1.85a.75.75 0 010 1.5h-2.7a.75.75 0 01-.64-.65l-.01-.1v-4.1c.05-.33.32-.6.65-.64h.1z",
    fill: primaryFill
  }));
};

export const HistoryFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HistoryFilledIcon({}), 'HistoryFilled');

const HistoryRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2h.09c.2.04.36.2.4.4l.01.1v2.2a8 8 0 11-2 4.77.5.5 0 011 .05A7 7 0 104.26 6H7l.09.01a.5.5 0 010 .99H3.4a.5.5 0 01-.4-.4L3 6.49V2.42a.5.5 0 01.41-.4L3.5 2zm6 4h.09c.2.04.36.2.4.4l.01.1V10h2.09a.5.5 0 010 1H9.41a.5.5 0 01-.4-.41L9 10.5V6.4a.5.5 0 01.41-.4h.09z",
    fill: primaryFill
  }));
};

export const HistoryRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HistoryRegularIcon({}), 'HistoryRegular');

const HistoryDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.37 2.03A8 8 0 0118 10.25a5.5 5.5 0 00-1.53-.89 6.5 6.5 0 00-11.4-3.6l-.2.24h1.88l.1.01a.75.75 0 010 1.49h-3.7a.75.75 0 01-.64-.64V2.66c.04-.34.3-.6.64-.65h.2c.34.05.6.3.65.64v2.06a7.98 7.98 0 015.37-2.68zm0 14.44c.2.56.51 1.07.88 1.53A8 8 0 012 9.74a.75.75 0 111.5.04 6.5 6.5 0 005.86 6.69zm.89-5.47a5.52 5.52 0 011.95-1.5H10.5V6.65a.75.75 0 00-.65-.64h-.2c-.34.05-.6.3-.64.64l-.01.1v3.6c.05.33.31.6.65.64l.1.01h.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const HistoryDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HistoryDismissFilledIcon({}), 'HistoryDismissFilled');

const HistoryDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2h.1c.2.04.36.2.4.4V4.7a8 8 0 0114 5.55 5.5 5.5 0 00-1-.65A7 7 0 004.26 6h2.82a.5.5 0 010 .99H3.41a.5.5 0 01-.4-.4V2.4a.5.5 0 01.4-.4l.1-.01zm6.1 14.99c.18.36.4.7.65 1a8 8 0 01-8.24-8.51.5.5 0 111 .04 7 7 0 006.59 7.47zm.66-5.99c.31-.38.67-.72 1.08-1H10V6.4a.5.5 0 00-.4-.4H9.4a.5.5 0 00-.4.4V10.6c.04.2.2.36.4.4l.1.01h.75zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const HistoryDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HistoryDismissRegularIcon({}), 'HistoryDismissRegular');

const HomeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2.39a1.5 1.5 0 00-2 0L3.5 7.33c-.32.28-.5.69-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-4c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v4c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V8.45c0-.43-.18-.84-.5-1.12L11 2.39z",
    fill: primaryFill
  }));
};

export const HomeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeFilledIcon({}), 'HomeFilled');

const HomeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.39a1.5 1.5 0 012 0l5.5 4.94c.32.28.5.69.5 1.12v7.05c0 .83-.67 1.5-1.5 1.5H13a1.5 1.5 0 01-1.5-1.5V12a.5.5 0 00-.5-.5H9a.5.5 0 00-.5.5v3.5c0 .83-.67 1.5-1.5 1.5H4.5A1.5 1.5 0 013 15.5V8.45c0-.43.18-.84.5-1.12L9 2.39zm1.33.74a.5.5 0 00-.66 0l-5.5 4.94a.5.5 0 00-.17.38v7.05c0 .28.22.5.5.5H7a.5.5 0 00.5-.5V12c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v3.5c0 .28.22.5.5.5h2.5a.5.5 0 00.5-.5V8.45a.5.5 0 00-.17-.38l-5.5-4.94z",
    fill: primaryFill
  }));
};

export const HomeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeRegularIcon({}), 'HomeRegular');

const HomeAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2.39a1.5 1.5 0 00-2 0L3.5 7.33c-.32.28-.5.69-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h5.1A5.5 5.5 0 0117 9.6V8.45c0-.43-.18-.84-.5-1.12L11 2.39zm8 12.11a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const HomeAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeAddFilledIcon({}), 'HomeAddFilled');

const HomeAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.39a1.5 1.5 0 012 0l5.5 4.94c.32.28.5.69.5 1.12V9.6c-.32-.16-.65-.3-1-.4v-.75a.5.5 0 00-.17-.38l-5.5-4.94a.5.5 0 00-.66 0l-5.5 4.94a.5.5 0 00-.17.38v7.05c0 .28.22.5.5.5h4.7c.1.35.24.68.4 1H4.5A1.5 1.5 0 013 15.5V8.45c0-.43.18-.84.5-1.12L9 2.39zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const HomeAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeAddRegularIcon({}), 'HomeAddRegular');

const HomeCheckmarkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.38a1.5 1.5 0 012 0l5.5 4.95c.32.28.5.69.5 1.11v7.06c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 15.5V8.44c0-.42.18-.83.5-1.11L9 2.38zm4.35 6.47a.5.5 0 00-.7-.7L9 11.78l-1.65-1.65a.5.5 0 10-.7.71l2 2c.2.2.5.2.7 0l4-4z",
    fill: primaryFill
  }));
};

export const HomeCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeCheckmarkFilledIcon({}), 'HomeCheckmarkFilled');

const HomeCheckmarkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.35 8.85a.5.5 0 00-.7-.7L9 11.78l-1.65-1.65a.5.5 0 10-.7.71l2 2c.2.2.5.2.7 0l4-4zM11 2.38a1.5 1.5 0 00-2 0L3.5 7.33c-.32.28-.5.69-.5 1.11v7.06c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.44c0-.42-.18-.83-.5-1.11L11 2.38zm-1.33.75a.5.5 0 01.66 0l5.5 4.94c.11.1.17.23.17.37v7.06a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5V8.44a.5.5 0 01.17-.37l5.5-4.94z",
    fill: primaryFill
  }));
};

export const HomeCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeCheckmarkRegularIcon({}), 'HomeCheckmarkRegular');

const HomeDatabaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2.39a1.5 1.5 0 00-2 0L3.5 7.33c-.32.28-.5.69-.5 1.12v7.05c0 .83.67 1.5 1.5 1.5h4.55a2.46 2.46 0 01-.05-.5v-6c0-1.22.88-2.11 1.83-2.64A7.68 7.68 0 0114.5 7c.64 0 1.27.07 1.85.2L11 2.38zm6 6.03A7.25 7.25 0 0014.5 8C12.01 8 10 9.12 10 10.5s2.02 2.5 4.5 2.5c2.49 0 4.5-1.12 4.5-2.5 0-.87-.8-1.63-2-2.08zM14.5 14c1.38 0 2.68-.3 3.67-.86.29-.16.58-.36.83-.59v3.95c0 1.38-2.01 2.5-4.5 2.5S10 17.88 10 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85z",
    fill: primaryFill
  }));
};

export const HomeDatabaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeDatabaseFilledIcon({}), 'HomeDatabaseFilled');

const HomeDatabaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.39a1.5 1.5 0 012 0l5.35 4.8A8.7 8.7 0 0014.64 7l-4.3-3.87a.5.5 0 00-.67 0l-5.5 4.94a.5.5 0 00-.17.38v7.05c0 .28.22.5.5.5H9v.5c0 .17.02.34.05.5H4.5A1.5 1.5 0 013 15.5V8.45c0-.43.18-.84.5-1.12L9 2.39zm6.88 5.73c.4.07.78.17 1.12.3 1.2.45 2 1.21 2 2.08 0 1.38-2.01 2.5-4.5 2.5S10 11.88 10 10.5 12.01 8 14.5 8c.48 0 .94.04 1.38.12zM14.5 14c1.38 0 2.68-.3 3.67-.86.29-.16.58-.36.83-.59v3.95c0 1.38-2.01 2.5-4.5 2.5S10 17.88 10 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85z",
    fill: primaryFill
  }));
};

export const HomeDatabaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeDatabaseRegularIcon({}), 'HomeDatabaseRegular');

const HomeMoreFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2.38a1.5 1.5 0 00-2 0L3.5 7.33c-.32.28-.5.69-.5 1.11v7.06c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8.44c0-.42-.18-.83-.5-1.11L11 2.38zM7 11a1 1 0 110-2 1 1 0 010 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 110-2 1 1 0 010 2zm-5 2a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 110-2 1 1 0 010 2zm4-1a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const HomeMoreFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeMoreFilledIcon({}), 'HomeMoreFilled');

const HomeMoreRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 11a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm-7 4a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zM9 2.38a1.5 1.5 0 012 0l5.5 4.95c.32.28.5.69.5 1.11v7.06c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 15.5V8.44c0-.42.18-.83.5-1.11L9 2.38zm1.33.75a.5.5 0 00-.66 0l-5.5 4.94a.5.5 0 00-.17.37v7.06c0 .28.22.5.5.5h11a.5.5 0 00.5-.5V8.44a.5.5 0 00-.17-.37l-5.5-4.94z",
    fill: primaryFill
  }));
};

export const HomeMoreRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomeMoreRegularIcon({}), 'HomeMoreRegular');

const HomePersonFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.39a1.5 1.5 0 012 0l5.5 4.94c.32.28.5.69.5 1.12v.95a2.99 2.99 0 00-4.33 1.6H8.5a.5.5 0 00-.5.5v4c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 013 15.5V8.45c0-.43.18-.84.5-1.12L9 2.39zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const HomePersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomePersonFilledIcon({}), 'HomePersonFilled');

const HomePersonRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.39a1.5 1.5 0 012 0l5.5 4.94c.32.28.5.69.5 1.12v.95c-.3-.17-.64-.3-1-.36v-.6a.5.5 0 00-.17-.37l-5.5-4.94a.5.5 0 00-.66 0l-5.5 4.94a.5.5 0 00-.17.38v7.05c0 .28.22.5.5.5H7a.5.5 0 00.5-.5V12c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2.2c-.4.18-.74.46-1 .8v-3a.5.5 0 00-.5-.5H9a.5.5 0 00-.5.5v3.5c0 .83-.67 1.5-1.5 1.5H4.5A1.5 1.5 0 013 15.5V8.45c0-.43.18-.84.5-1.12L9 2.39zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const HomePersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/HomePersonRegularIcon({}), 'HomePersonRegular');

const IconsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 00-3.46 6H3.42C2.64 8 2 8.64 2 9.42 2 12.5 4.5 15 7.58 15h1.27a4.55 4.55 0 01-.35-1.75c0-1.2.67-2.21 1.46-2.9a5.91 5.91 0 013.99-1.4 3.01 3.01 0 00-.74-.57 4 4 0 00.25-.38h1.7C16.19 8 17 7.18 17 6.17 17 5.52 16.48 5 15.83 5h-1.96A4 4 0 0010 2zm7.5 8.5a.5.5 0 01.45.72l-.22.38-.02.02-.32.54a7.5 7.5 0 00-.77 1.86c-.16.56-.37 1.31-.74 1.94a2.94 2.94 0 01-2.63 1.54c-1.06 0-1.8-.53-2.27-1.03a4.1 4.1 0 01-.59-.81c-.6.6-1.06 1.3-1.44 2.06a.5.5 0 11-.9-.44 8.47 8.47 0 013.44-3.71c.66-.42 1.4-.79 2.2-1.1a.5.5 0 10-.38-.93 13.17 13.17 0 00-3.77 2.23 2.85 2.85 0 01.9-2.62c.63-.59 1.55-1 2.75-1.15a8.52 8.52 0 013.8.37l.09.03a6.17 6.17 0 00.41.1h.01z",
    fill: primaryFill
  }));
};

export const IconsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/IconsFilledIcon({}), 'IconsFilled');

const IconsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a3 3 0 00-2.17 5.07c.1.11.17.25.17.4 0 .3-.24.53-.53.53H3.42a.42.42 0 00-.42.42A4.58 4.58 0 007.58 14H8.7c.05.09.12.17.18.25a8.6 8.6 0 00-.61.75h-.7A5.58 5.58 0 012 9.42C2 8.64 2.64 8 3.42 8h3.12a4 4 0 117.34-3h1.95c.65 0 1.17.52 1.17 1.17 0 1-.82 1.83-1.83 1.83h-1.7a4 4 0 01-.26.38c.37.2.68.48.93.8a9.84 9.84 0 00-1.34.12c-.2-.13-.42-.22-.67-.26-.2-.04-.38-.21-.38-.43 0-.13.07-.25.17-.33a3 3 0 00.9-1.28h2.35c.46 0 .83-.37.83-.83 0-.1-.07-.17-.17-.17H13a3 3 0 00-3-3zm5.66 8.15A7.11 7.11 0 0013.3 11c-1.57.2-2.38 1.27-2.85 2.43a.5.5 0 11-.92-.37c.53-1.33 1.57-2.8 3.65-3.06 1-.12 1.92.02 2.67.18l.66.14.34.08c.3.07.5.1.64.1a.5.5 0 01.45.72l-.22.38-.02.02-.32.54a7.5 7.5 0 00-.77 1.86c-.16.56-.37 1.31-.74 1.94a2.94 2.94 0 01-2.63 1.54 3.1 3.1 0 01-2.3-1.08 4.42 4.42 0 01-.56-.76c-.6.61-1.06 1.3-1.44 2.06a.5.5 0 11-.9-.44c1.06-2.13 2.67-3.71 5.8-4.75a.5.5 0 11.3.94 10.2 10.2 0 00-2.99 1.51l.02.04a2.93 2.93 0 00.5.73c.37.4.89.75 1.57.75.47 0 .82-.12 1.1-.3.27-.17.49-.43.67-.74.3-.51.46-1.09.62-1.64l.13-.47a8.5 8.5 0 01.91-1.96l-.03-.01-.38-.09-.61-.14z",
    fill: primaryFill
  }));
};

export const IconsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/IconsRegularIcon({}), 'IconsRegular');

const ImageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 8a.5.5 0 100-1 .5.5 0 000 1zM3 6a3 3 0 013-3h8a3 3 0 013 3v8c0 .65-.2 1.25-.56 1.74l-5.39-5.3a1.5 1.5 0 00-2.1 0l-5.4 5.3C3.22 15.25 3 14.64 3 14V6zm9.5 3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-8.23 7.45c.49.35 1.08.55 1.73.55h8c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.7 0l-5.38 5.3z",
    fill: primaryFill
  }));
};

export const ImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageFilledIcon({}), 'ImageFilled');

const ImageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v8c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2H6zm0 12h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58A2 2 0 006 16z",
    fill: primaryFill
  }));
};

export const ImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageRegularIcon({}), 'ImageRegular');

const ImageAddFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zM5.5 11a5.5 5.5 0 004.9-8H14a3 3 0 013 3v8c0 .65-.2 1.25-.56 1.74l-5.39-5.3a1.5 1.5 0 00-2.1 0l-5.4 5.3C3.22 15.25 3 14.64 3 14v-3.6c.75.38 1.6.6 2.5.6zm7-3a.5.5 0 100-1 .5.5 0 000 1zm0 1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-8.23 7.45c.49.35 1.08.55 1.73.55h8c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.7 0l-5.38 5.3z",
    fill: primaryFill
  }));
};

export const ImageAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageAddFilledIcon({}), 'ImageAddFilled');

const ImageAddRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zm8 .5h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-3.6c.32.16.65.3 1 .4V14c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2zm0 3.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zm-8.01 8.23A2 2 0 006 16h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58z",
    fill: primaryFill
  }));
};

export const ImageAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageAddRegularIcon({}), 'ImageAddRegular');

const ImageAltTextFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1 3c0-1.1.9-2 2-2h5a2 2 0 012 2v4a2 2 0 01-2 2H3a2 2 0 01-2-2V3zm2 3.5c0 .28.22.5.5.5h4a.5.5 0 000-1h-4a.5.5 0 00-.5.5zM3.5 3a.5.5 0 000 1h4a.5.5 0 000-1h-4zm9 5a.5.5 0 100-1 .5.5 0 000 1zM3 10h5a3 3 0 003-3V3h3a3 3 0 013 3v8c0 .65-.2 1.25-.56 1.74l-5.39-5.3a1.5 1.5 0 00-2.1 0l-5.4 5.3C3.22 15.25 3 14.64 3 14v-4zm9.5-1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-8.23 7.45c.49.35 1.08.55 1.73.55h8c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.7 0l-5.38 5.3z",
    fill: primaryFill
  }));
};

export const ImageAltTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageAltTextFilledIcon({}), 'ImageAltTextFilled');

const ImageAltTextRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 1a2 2 0 00-2 2v4c0 1.1.9 2 2 2h5a2 2 0 002-2V3a2 2 0 00-2-2H3zm.5 5h4a.5.5 0 010 1h-4a.5.5 0 010-1zM3 3.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zM3 14v-4h1v4c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2h-3V3h3a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3zm3 2h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58A2 2 0 006 16zm6.5-7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm.5-1.5a.5.5 0 10-1 0 .5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const ImageAltTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageAltTextRegularIcon({}), 'ImageAltTextRegular');

const ImageArrowBackFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 018 7.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75H3.71l.9.9a.5.5 0 11-.71.7L2.14 5.35a.5.5 0 010-.7L3.9 2.9a.5.5 0 11.7.7zM11 5.5a5.5 5.5 0 01-8 4.9V14c0 .65.2 1.25.56 1.74l5.39-5.3a1.5 1.5 0 012.1 0l5.4 5.3c.34-.49.55-1.1.55-1.74V6a3 3 0 00-3-3h-3.6c.38.75.6 1.6.6 2.5zM12.5 8a.5.5 0 100-1 .5.5 0 000 1zm0 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-8.23 7.45c.49.35 1.08.55 1.73.55h8c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.7 0l-5.38 5.3z",
    fill: primaryFill
  }));
};

export const ImageArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageArrowBackFilledIcon({}), 'ImageArrowBackFilled');

const ImageArrowBackRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 018 7.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75H3.71l.9.9a.5.5 0 11-.71.7L2.14 5.35a.5.5 0 010-.7L3.9 2.9a.5.5 0 11.7.7zM3 10.4c.32.16.65.3 1 .4V14c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-3.6zm11-2.9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zm-8.01 8.23A2 2 0 006 16h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58z",
    fill: primaryFill
  }));
};

export const ImageArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageArrowBackRegularIcon({}), 'ImageArrowBackRegular');

const ImageArrowCounterclockwiseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2-5a.5.5 0 01-.5-.63V3a.5.5 0 011 0v.2a2.75 2.75 0 11-.55 4.14.5.5 0 01.75-.67A1.74 1.74 0 007.25 5.5 1.75 1.75 0 004.6 4H5a.5.5 0 010 1H3.5zm2 6c-.9 0-1.75-.22-2.5-.6V14c0 .65.2 1.25.56 1.74l5.39-5.3a1.5 1.5 0 012.1 0l5.4 5.3c.34-.49.55-1.1.55-1.74V6a3 3 0 00-3-3h-3.6a5.5 5.5 0 01-4.9 8zm7-3a.5.5 0 100-1 .5.5 0 000 1zm0 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-8.23 7.45c.49.35 1.08.55 1.73.55h8c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.7 0l-5.38 5.3z",
    fill: primaryFill
  }));
};

export const ImageArrowCounterclockwiseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageArrowCounterclockwiseFilledIcon({}), 'ImageArrowCounterclockwiseFilled');

const ImageArrowCounterclockwiseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-2-5a.5.5 0 01-.5-.63V3a.5.5 0 011 0v.2a2.75 2.75 0 11-.55 4.14.5.5 0 01.75-.67A1.74 1.74 0 007.25 5.5 1.75 1.75 0 004.6 4H5a.5.5 0 010 1H3.5zM3 10.4c.32.16.65.3 1 .4V14c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-3.6zm11-2.9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zm-8.01 8.23A2 2 0 006 16h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58z",
    fill: primaryFill
  }));
};

export const ImageArrowCounterclockwiseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageArrowCounterclockwiseRegularIcon({}), 'ImageArrowCounterclockwiseRegular');

const ImageArrowForwardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm.9-6.4l.9.9H5.74A2.75 2.75 0 003 7.25v.25a.5.5 0 001 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 10.71.7l1.76-1.75a.5.5 0 000-.7L7.1 2.9a.5.5 0 10-.7.7zM11 5.5a5.5 5.5 0 01-8 4.9V14c0 .65.2 1.25.56 1.74l5.39-5.3a1.5 1.5 0 012.1 0l5.4 5.3c.34-.49.55-1.1.55-1.74V6a3 3 0 00-3-3h-3.6c.38.75.6 1.6.6 2.5zM12.5 8a.5.5 0 100-1 .5.5 0 000 1zm0 1a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-8.23 7.45c.49.35 1.08.55 1.73.55h8c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.7 0l-5.38 5.3z",
    fill: primaryFill
  }));
};

export const ImageArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageArrowForwardFilledIcon({}), 'ImageArrowForwardFilled');

const ImageArrowForwardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm.9-6.4l.9.9H5.74A2.75 2.75 0 003 7.25v.25a.5.5 0 001 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 10.71.7l1.76-1.75a.5.5 0 000-.7L7.1 2.9a.5.5 0 10-.7.7zM3 10.4c.32.16.65.3 1 .4V14c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-3.6zm11-2.9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zm-8.01 8.23A2 2 0 006 16h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58z",
    fill: primaryFill
  }));
};

export const ImageArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageArrowForwardRegularIcon({}), 'ImageArrowForwardRegular');

const ImageCopyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 6a3 3 0 013-3h6a3 3 0 013 3v6c0 .65-.2 1.25-.55 1.74L12.2 9.5a1.71 1.71 0 00-2.42 0l-4.24 4.24A2.99 2.99 0 015 12V6zm3.5 1.5a1 1 0 100-2 1 1 0 000 2zm3 2.7l4.24 4.25c-.5.34-1.1.55-1.74.55H8c-.65 0-1.25-.2-1.74-.55l4.24-4.24a.71.71 0 011 0zm2.74 5.8A3 3 0 0112 17H7.5A4.5 4.5 0 013 12.5V8a3 3 0 011-2.24v6.74A3.5 3.5 0 007.5 16h6.74z",
    fill: primaryFill
  }));
};

export const ImageCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageCopyFilledIcon({}), 'ImageCopyFilled');

const ImageCopyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 7.5a1 1 0 100-2 1 1 0 000 2zM5 6a3 3 0 013-3h6a3 3 0 013 3v6a3 3 0 01-3 3H8a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v6c0 .37.1.72.28 1.02L9.79 9.5a1.71 1.71 0 012.42 0l3.51 3.52A2 2 0 0016 12V6a2 2 0 00-2-2H8zm7.02 9.72l-3.52-3.51a.71.71 0 00-1 0l-3.52 3.51A2 2 0 008 14h6a2 2 0 001.02-.28zM12 17a3 3 0 002.24-1H7.5A3.5 3.5 0 014 12.5V5.76A3 3 0 003 8v4.5A4.5 4.5 0 007.5 17H12z",
    fill: primaryFill
  }));
};

export const ImageCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageCopyRegularIcon({}), 'ImageCopyRegular');

const ImageEditFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 8a.5.5 0 100-1 .5.5 0 000 1zM3 6a3 3 0 013-3h8a3 3 0 013 3v3c-.7.03-1.37.31-1.9.84l-2.3 2.3-1.75-1.7a1.5 1.5 0 00-2.1 0l-5.4 5.3C3.22 15.24 3 14.64 3 14V6zm9.5 3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2.23 5.67l1.82-1.81-1.74-1.71a.5.5 0 00-.7 0l-5.38 5.3c.48.34 1.08.55 1.73.55h3.22l.21-.85a3.2 3.2 0 01.84-1.48zm.7.7l4.84-4.82a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const ImageEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageEditFilledIcon({}), 'ImageEditFilled');

const ImageEditRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zM3 6a3 3 0 013-3h8a3 3 0 013 3v3c-.34.02-.68.1-1 .23V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l1.75 1.72-.71.7-1.74-1.7a.5.5 0 00-.7 0l-4.66 4.57c.3.18.64.28 1.01.28h3.47l-.04.15-.21.85H6a3 3 0 01-3-3V6zm7.98 9.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const ImageEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageEditRegularIcon({}), 'ImageEditRegular');

const ImageGlobeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.55 2.15A8.9 8.9 0 004.01 5h2.98a8.9 8.9 0 00-.54-2.85 2.93 2.93 0 00-.53-.91C5.73 1.04 5.59 1 5.5 1c-.1 0-.23.05-.42.24-.18.19-.36.5-.53.91zm-.72-.83A9.92 9.92 0 003 5H1.03a4.5 4.5 0 012.8-3.68zm3.34 0A9.92 9.92 0 017.99 5h1.98a4.5 4.5 0 00-2.8-3.68zM9.97 6H8a9.92 9.92 0 01-.82 3.68A4.5 4.5 0 009.97 6zM5.5 10c.1 0 .23-.05.42-.24.18-.19.36-.5.53-.91.3-.73.5-1.72.54-2.85H4.01a8.9 8.9 0 00.54 2.85c.17.42.35.72.53.91.19.2.33.24.42.24zm-1.67-.32A4.5 4.5 0 011.03 6H3a9.92 9.92 0 00.82 3.68zM5.5 11a5.5 5.5 0 004.9-8H14a3 3 0 013 3v8c0 .65-.2 1.25-.56 1.74l-5.39-5.3a1.5 1.5 0 00-2.1 0l-5.4 5.3C3.22 15.25 3 14.64 3 14v-3.6c.75.38 1.6.6 2.5.6zm7-3a.5.5 0 100-1 .5.5 0 000 1zm0 1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-8.23 7.45c.49.35 1.08.55 1.73.55h8c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.7 0l-5.38 5.3z",
    fill: primaryFill
  }));
};

export const ImageGlobeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageGlobeFilledIcon({}), 'ImageGlobeFilled');

const ImageGlobeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.55 2.15A8.9 8.9 0 004.01 5h2.98a8.9 8.9 0 00-.54-2.85 2.93 2.93 0 00-.53-.91C5.73 1.04 5.59 1 5.5 1c-.1 0-.23.05-.42.24-.18.19-.36.5-.53.91zm-.72-.83A9.92 9.92 0 003 5H1.03a4.5 4.5 0 012.8-3.68zm3.34 0A9.92 9.92 0 017.99 5h1.98a4.5 4.5 0 00-2.8-3.68zM9.97 6H8a9.92 9.92 0 01-.82 3.68A4.5 4.5 0 009.97 6zM5.5 10c.1 0 .23-.05.42-.24.18-.19.36-.5.53-.91.3-.73.5-1.72.54-2.85H4.01a8.9 8.9 0 00.54 2.85c.17.42.35.72.53.91.19.2.33.24.42.24zm-1.67-.32A4.5 4.5 0 011.03 6H3a9.92 9.92 0 00.82 3.68zM14 4h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-3.6c.32.16.65.3 1 .4V14c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2zm0 3.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zM6 16h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58A2 2 0 006 16z",
    fill: primaryFill
  }));
};

export const ImageGlobeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageGlobeRegularIcon({}), 'ImageGlobeRegular');

const ImageMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v6c0 .65.2 1.25.55 1.74L7.6 9.7a2 2 0 012.82 0l4.04 4.03c.34-.5.55-1.1.55-1.74V6a3 3 0 00-3-3H6zm6.5 3.5a1 1 0 11-2 0 1 1 0 012 0zm1.24 7.95L9.7 10.4a1 1 0 00-1.42 0l-4.03 4.04c.5.34 1.1.55 1.74.55h6c.65 0 1.25-.2 1.74-.55zM5.76 16A3 3 0 008 17h4.5a4.5 4.5 0 004.5-4.5V8a3 3 0 00-1-2.24v6.74c0 .12 0 .24-.02.36A3.5 3.5 0 0112.5 16H5.76z",
    fill: primaryFill
  }));
};

export const ImageMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageMultipleFilledIcon({}), 'ImageMultipleFilled');

const ImageMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 7.5a1 1 0 100-2 1 1 0 000 2zM3 6a3 3 0 013-3h6a3 3 0 013 3v6a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v6c0 .37.1.72.28 1.02l3.3-3.31a2 2 0 012.83 0l3.31 3.3A2 2 0 0014 12V6a2 2 0 00-2-2H6zm3.7 6.41a1 1 0 00-1.4 0l-3.32 3.31A2 2 0 006 14h6a2 2 0 001.02-.28l-3.31-3.3zM8 17a3 3 0 01-2.24-1h6.74a3.5 3.5 0 003.5-3.5V5.76A3 3 0 0117 8v4.5a4.5 4.5 0 01-4.5 4.5H8z",
    fill: primaryFill
  }));
};

export const ImageMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageMultipleRegularIcon({}), 'ImageMultipleRegular');

const ImageOffFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l1.4 1.41A2.99 2.99 0 003 6v8c0 .65.2 1.25.56 1.74l5.39-5.3c.14-.14.3-.25.46-.32l.64.63-.36.36a.51.51 0 00-.04.04l-5.38 5.3c.49.35 1.08.55 1.73.55h8c.6 0 1.15-.17 1.62-.47l.01-.01.1-.07 1.42 1.4a.5.5 0 00.7-.7l-15-15zM13 7.5a.5.5 0 11-1 0 .5.5 0 011 0zM5.22 3.1L16.9 14.78A3 3 0 0017 14V6a3 3 0 00-3-3H6a3 3 0 00-.78.1zM14 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const ImageOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageOffFilledIcon({}), 'ImageOffFilled');

const ImageOffRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l1.4 1.41A2.99 2.99 0 003 6v8a3 3 0 003 3h8c.65 0 1.25-.2 1.74-.55l1.4 1.4a.5.5 0 00.71-.7l-15-15zm6.56 7.97a1.5 1.5 0 00-.46.31l-4.67 4.59A2 2 0 014 14V6a2 2 0 01.28-1.02l5.13 5.14zM6 16a2 2 0 01-1.01-.27l4.66-4.58c.2-.2.5-.2.7 0l4.66 4.58A2 2 0 0114 16H6zM16 6v7.88l.9.9A3 3 0 0017 14V6a3 3 0 00-3-3H6a3 3 0 00-.78.1l.9.9H14a2 2 0 012 2zm-2 1.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-1 0a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const ImageOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageOffRegularIcon({}), 'ImageOffRegular');

const ImageProhibitedFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-1c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 015.5 9zM2.7 7.6a3.5 3.5 0 014.9-4.9L2.7 7.6zM13 7.5a.5.5 0 11-1 0 .5.5 0 011 0zM5.5 11a5.5 5.5 0 004.9-8H14a3 3 0 013 3v8c0 .65-.2 1.25-.56 1.74l-5.39-5.3a1.5 1.5 0 00-2.1 0l-5.4 5.3C3.22 15.25 3 14.64 3 14v-3.6c.75.38 1.6.6 2.5.6zM14 7.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM6 17c-.65 0-1.24-.2-1.73-.55l5.38-5.3c.2-.2.5-.2.7 0l5.38 5.3c-.49.35-1.08.55-1.73.55H6z",
    fill: primaryFill
  }));
};

export const ImageProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageProhibitedFilledIcon({}), 'ImageProhibitedFilled');

const ImageProhibitedRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-1c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 015.5 9zm2.1-6.3L2.7 7.6a3.5 3.5 0 014.9-4.9zM3 10.4c.32.16.65.3 1 .4V14c0 .37.1.72.28 1.02l4.67-4.59a1.5 1.5 0 012.1 0l4.67 4.59c.18-.3.28-.65.28-1.02V6a2 2 0 00-2-2h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3v-3.6zm1.99 5.33A2 2 0 006 16h8a2 2 0 001.01-.27l-4.66-4.58a.5.5 0 00-.7 0l-4.66 4.58zM14 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const ImageProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageProhibitedRegularIcon({}), 'ImageProhibitedRegular');

const ImageReflectionFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 6a3 3 0 013-3h6a3 3 0 013 3v6a3 3 0 01-1.34 2.5A3 3 0 0116 17a.5.5 0 01-1 0 2 2 0 00-2-2 .5.5 0 010-1h-2.5a.5.5 0 010 1h-1a.5.5 0 010-1H7a.5.5 0 010 1 2 2 0 00-2 2 .5.5 0 01-1 0 3 3 0 011.34-2.5A3 3 0 014 12V6zm1.98 7.72l3.53-3.52a.7.7 0 01.98 0l3.53 3.52c.29-.17.53-.41.7-.7L11.2 9.49a1.7 1.7 0 00-2.4 0l-3.52 3.53c.17.29.41.53.7.7zM13 7a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const ImageReflectionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageReflectionFilledIcon({}), 'ImageReflectionFilled');

const ImageReflectionRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 3a3 3 0 00-3 3v6a3 3 0 001.34 2.5A3 3 0 004 17a.5.5 0 001 0c0-1.1.9-2 2-2a.5.5 0 000-1 2 2 0 01-1.02-.28l3.53-3.52a.7.7 0 01.98 0l3.53 3.52A2 2 0 0113 14a.5.5 0 000 1 2 2 0 012 2 .5.5 0 001 0 3 3 0 00-1.34-2.5A3 3 0 0016 12V6a3 3 0 00-3-3H7zm1.8 6.5l-3.52 3.52A2 2 0 015 12V6c0-1.1.9-2 2-2h6a2 2 0 012 2v6a2 2 0 01-.28 1.02L11.2 9.49a1.7 1.7 0 00-2.4 0zm.7 4.5a.5.5 0 000 1h1a.5.5 0 000-1h-1zM13 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const ImageReflectionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageReflectionRegularIcon({}), 'ImageReflectionRegular');

const ImageSearchFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 8a.5.5 0 100-1 .5.5 0 000 1zM3 6a3 3 0 013-3h8a3 3 0 013 3v8c0 .65-.2 1.25-.56 1.74l-5.39-5.3a1.5 1.5 0 00-1.7-.28A4.5 4.5 0 003 8.76V6zm9.5 3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-.59 8H14c.65 0 1.24-.2 1.73-.55l-5.38-5.3a.5.5 0 00-.58-.09 4.5 4.5 0 01-.2 3.38l2 2c.15.16.27.36.34.56zm-3.6-2.4a3.5 3.5 0 10-.7.7l2.54 2.55a.5.5 0 00.7-.7L8.3 14.6zM5.5 15a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const ImageSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageSearchFilledIcon({}), 'ImageSearchFilled');

const ImageSearchRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v2.76c.3-.2.64-.38 1-.5V6c0-1.1.9-2 2-2h8a2 2 0 012 2v8c0 .37-.1.72-.28 1.02l-4.67-4.59a1.5 1.5 0 00-1.7-.28c.16.29.3.6.41.91a.5.5 0 01.59.09l4.66 4.58A2 2 0 0114 16h-2.88l.44.44c.16.16.28.36.35.56H14a3 3 0 003-3V6a3 3 0 00-3-3H6zm6.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 110-1 .5.5 0 010 1zm-4.2 6.6a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 00.7-.7L8.3 14.6zm-2.8.4a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
    fill: primaryFill
  }));
};

export const ImageSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageSearchRegularIcon({}), 'ImageSearchRegular');

const ImageShadowFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v6c0 .65.2 1.25.55 1.74L6.8 8.49a1.7 1.7 0 012.4 0l4.25 4.25c.34-.5.55-1.1.55-1.74V5a3 3 0 00-3-3H5zm0 12c-.65 0-1.25-.2-1.74-.55L7.51 9.2a.7.7 0 01.98 0l4.25 4.25c-.5.34-1.1.55-1.74.55H5zm6-8a1 1 0 11-2 0 1 1 0 012 0zm-5 9a3 3 0 003 3h3a6 6 0 006-6V9a3 3 0 00-3-3v5a4 4 0 01-4 4H6z",
    fill: primaryFill
  }));
};

export const ImageShadowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageShadowFilledIcon({}), 'ImageShadowFilled');

const ImageShadowRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-3-3H5zM3 5c0-1.1.9-2 2-2h6a2 2 0 012 2v6a2 2 0 01-.28 1.02L9.2 8.49a1.7 1.7 0 00-2.4 0l-3.52 3.53A2 2 0 013 11V5zm5.5 4.2l3.52 3.52A2 2 0 0111 13H5a2 2 0 01-1.02-.28L7.51 9.2a.7.7 0 01.98 0zM11 6a1 1 0 11-2 0 1 1 0 012 0zm-5 9a3 3 0 003 3h3a6 6 0 006-6V9a3 3 0 00-3-3v5a4 4 0 01-4 4H6z",
    fill: primaryFill
  }));
};

export const ImageShadowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImageShadowRegularIcon({}), 'ImageShadowRegular');

const ImmersiveReaderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.75v5.45a1.5 1.5 0 00-1.5 0V4.75a.25.25 0 00-.25-.25H12c-.69 0-1.25.56-1.25 1.25V12h-.25c-.52 0-.98.27-1.25.67V5.75c0-.69-.56-1.25-1.25-1.25H3.75a.25.25 0 00-.25.25v10.5c0 .14.11.25.25.25H8c.4 0 .77-.2 1-.5v.5c0 .42.18.8.46 1.08-.42.27-.92.42-1.46.42H3.75C2.78 17 2 16.22 2 15.25V4.75C2 3.78 2.78 3 3.75 3H8c.79 0 1.5.33 2 .86.5-.53 1.21-.86 2-.86h4.25c.97 0 1.75.78 1.75 1.75zm.13 6.45c.12.16.29.45.45.87.25.68.4 1.5.4 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 01-.84-.52l.11-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 11.8-.6zm-4.44-.16c.19.08.31.26.31.46v6a.5.5 0 01-.85.35L11.29 16h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm3.02 1.93c-.1-.3-.2-.55-.28-.7a.5.5 0 00-.9.45 4.6 4.6 0 01.45 1.78 3.94 3.94 0 01-.37 1.6l-.07.18a.5.5 0 00.89.44 5.53 5.53 0 00.55-2.22c0-.5-.1-1.02-.27-1.53z",
    fill: primaryFill
  }));
};

export const ImmersiveReaderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImmersiveReaderFilledIcon({}), 'ImmersiveReaderFilled');

const ImmersiveReaderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4.5v5.7a1.5 1.5 0 00-1-.18V4.5a.5.5 0 00-.5-.5H12c-.83 0-1.5.67-1.5 1.5V12c-.38 0-.73.14-1 .38V5.5C9.5 4.67 8.83 4 8 4H3.5a.5.5 0 00-.5.5v11c0 .28.22.5.5.5H8c.39 0 .74-.15 1-.39.03.37.19.7.43.94-.4.28-.9.45-1.43.45H3.5A1.5 1.5 0 012 15.5v-11C2 3.67 2.67 3 3.5 3H8c.82 0 1.54.4 2 1 .46-.6 1.18-1 2-1h4.5c.83 0 1.5.67 1.5 1.5zm-4.3 6.54c.18.08.3.26.3.46v6a.5.5 0 01-.85.35L11.29 16h-.79a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 01.54-.11zm4.45.16c.12.16.28.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.17.42-.33.7-.45.87a.5.5 0 01-.85-.52l.12-.19a5.9 5.9 0 00.58-2.6 5.9 5.9 0 00-.58-2.58l-.07-.11a.5.5 0 01.8-.6zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 10-.9.45A4.6 4.6 0 0116 14.5a3.94 3.94 0 01-.37 1.6l-.08.18a.5.5 0 10.9.44A5.5 5.5 0 0017 14.5c0-.5-.1-1.02-.28-1.53z",
    fill: primaryFill
  }));
};

export const ImmersiveReaderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImmersiveReaderRegularIcon({}), 'ImmersiveReaderRegular');

const ImportantFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a3 3 0 00-3 3c0 2.23.79 5.2 1.22 6.69.24.79.97 1.31 1.78 1.31s1.54-.52 1.78-1.31C12.2 10.2 13 7.25 13 5a3 3 0 00-3-3zm0 12a2 2 0 100 4 2 2 0 000-4z",
    fill: primaryFill
  }));
};

export const ImportantFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImportantFilledIcon({}), 'ImportantFilled');

const ImportantRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a2 2 0 00-2 2c0 2.07.75 4.91 1.18 6.4.1.36.44.6.82.6.39 0 .71-.24.82-.6C11.25 9.94 12 7.1 12 5a2 2 0 00-2-2zM7 5a3 3 0 016 0c0 2.25-.79 5.21-1.22 6.69-.24.8-.97 1.31-1.78 1.31s-1.54-.52-1.78-1.31C7.8 10.2 7 7.23 7 5zm3 10a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0z",
    fill: primaryFill
  }));
};

export const ImportantRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ImportantRegularIcon({}), 'ImportantRegular');

const IncognitoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.08 8.75a34.9 34.9 0 0111.86 0l1.48.24a.5.5 0 10.16-.98l-1.13-.19a1.42 1.42 0 00-.08-.22l-1.65-3.7a1.5 1.5 0 00-1.37-.9h-6.7c-.6 0-1.13.35-1.37.9L3.63 7.6l-.09.23L2.42 8a.5.5 0 00.16.98 90.9 90.9 0 011.5-.24zM3 13.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM5.5 10a3.5 3.5 0 103.46 4h2.08a3.5 3.5 0 100-1H8.96a3.5 3.5 0 00-3.46-3zm6.5 3.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z",
    fill: primaryFill
  }));
};

export const IncognitoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/IncognitoFilledIcon({}), 'IncognitoFilled');

const IncognitoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.17 4.28A.5.5 0 016.62 4h6.76c.2 0 .36.1.45.28l1.22 2.44a.5.5 0 10.9-.44l-1.23-2.45A1.5 1.5 0 0013.38 3H6.62a1.5 1.5 0 00-1.34.83L4.05 6.28a.5.5 0 00.9.44l1.22-2.44zm11.25 4.71C11.47 8 8.52 8 2.58 9a.5.5 0 01-.16-.98C8.47 7 11.52 7 17.58 8a.5.5 0 11-.16.98zM5.5 11a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM2 13.5a3.5 3.5 0 016.96-.5h2.08a3.5 3.5 0 110 1H8.96A3.5 3.5 0 012 13.5zM14.5 11a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    fill: primaryFill
  }));
};

export const IncognitoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/IncognitoRegularIcon({}), 'IncognitoRegular');

const InfoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0 8 8 0 0016 0zM9.5 8.91a.5.5 0 011 0V13.6a.5.5 0 01-1 0V8.9zm-.25-2.16a.75.75 0 111.5 0 .75.75 0 01-1.5 0z",
    fill: primaryFill
  }));
};

export const InfoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/InfoFilledIcon({}), 'InfoFilled');

const InfoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 8.91a.5.5 0 00-1 .09v4.6a.5.5 0 001-.1V8.91zm.3-2.16a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM18 10a8 8 0 10-16 0 8 8 0 0016 0zM3 10a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const InfoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/InfoRegularIcon({}), 'InfoRegular');

const InfoShieldFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 9a8 8 0 10-6.28 7.81 7.05 7.05 0 01-.72-2.93v-2.79c0-.75.59-1.42 1.4-1.42.9 0 1.76-.37 2.6-1.24a1.39 1.39 0 012 0 5.06 5.06 0 001 .8V9zM8.5 7.91a.5.5 0 011 0V12.6a.5.5 0 01-1 0V7.9zm-.25-2.16a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm8.75 4.6a4.63 4.63 0 01-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0013 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 00-.4-.33 4.24 4.24 0 01-1.6-.32z",
    fill: primaryFill
  }));
};

export const InfoShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/InfoShieldFilledIcon({}), 'InfoShieldFilled');

const InfoShieldRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 9a8 8 0 10-6.28 7.81 5.93 5.93 0 01-.39-.94 7 7 0 115.64-7.47c.02 0 .03.02.04.03a5.06 5.06 0 00.99.8V9zM9.05 5a.75.75 0 110 1.5.75.75 0 010-1.5zM9 7.5a.5.5 0 01.5.41v4.59a.5.5 0 01-1 .1V8c0-.28.22-.5.5-.5zm8 2.85a4.63 4.63 0 01-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 00-.56 0 4.5 4.5 0 01-3.32 1.55.4.4 0 00-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0013 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 00-.4-.33 4.24 4.24 0 01-1.6-.32z",
    fill: primaryFill
  }));
};

export const InfoShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/InfoShieldRegularIcon({}), 'InfoShieldRegular');

const InkStrokeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98.2.1.4.23.57.41.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 01-.7.37c-1.02.4-2.95.8-5.98 1.17-1.44.18-2.5.36-3.22.52a42.44 42.44 0 004.24.57c1.02.09 2.1.23 3.02.4.46.09.9.19 1.26.3.36.1.71.23.97.4.13.1.3.23.42.45.14.25.17.56.03.85-.11.24-.3.4-.45.5-.16.1-.35.18-.54.25-.77.29-2.15.55-4.29.8-2.12.23-3.4.54-4.11.85-.3.13-.45.24-.51.3.03.04.07.1.16.17.15.14.36.3.64.45.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 11-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96-.34-.2-.67-.41-.93-.65a2.03 2.03 0 01-.62-.94c-.12-.44-.01-.88.28-1.24.26-.33.65-.58 1.1-.77.93-.4 2.4-.73 4.55-.98 1.37-.15 2.36-.31 3.04-.46l-.55-.12c-.86-.16-1.89-.29-2.86-.37a43.94 43.94 0 01-3.7-.46c-.53-.09-1-.2-1.4-.3-.37-.11-.75-.24-1.02-.43a1.19 1.19 0 01-.43-.49.93.93 0 01.06-.87c.13-.22.32-.36.47-.44.17-.1.36-.18.56-.26.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96-.64-.2-1.63-.42-2.9-.63a88.96 88.96 0 00-5.8-.72l-3.05-.27a.75.75 0 01-.68-.82z",
    fill: primaryFill
  }));
};

export const InkStrokeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/InkStrokeFilledIcon({}), 'InkStrokeFilled');

const InkStrokeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2.96a.5.5 0 01.54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96.19.1.37.21.51.36.14.16.27.4.22.69a.95.95 0 01-.4.57c-.16.13-.38.24-.63.34-.99.4-2.89.77-5.92 1.15a22.58 22.58 0 00-4.13.78l.3.1c.34.09.77.18 1.28.27 1 .18 2.25.33 3.59.44 1 .09 2.07.22 2.99.4.45.08.87.18 1.23.29.35.1.67.22.9.38.12.07.26.18.34.35.1.18.13.4.03.62a.97.97 0 01-.37.4c-.13.08-.3.16-.49.23-.74.27-2.08.53-4.22.77a16 16 0 00-4.2.88c-.37.16-.55.3-.63.4-.06.08-.05.11-.04.14.02.07.08.19.26.35.17.15.4.31.7.48.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 01-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94-.33-.19-.64-.4-.88-.62a1.78 1.78 0 01-.55-.81c-.1-.36-.01-.72.23-1.03.23-.28.58-.5 1.02-.7.88-.38 2.32-.7 4.47-.95 2.1-.24 3.33-.48 3.95-.7a11.8 11.8 0 00-1.44-.37 30 30 0 00-2.89-.38 43.66 43.66 0 01-3.68-.45c-.52-.1-.98-.2-1.37-.3-.37-.1-.71-.24-.95-.4a.94.94 0 01-.34-.38.68.68 0 01.04-.64c.1-.17.25-.28.39-.36.14-.08.32-.16.52-.23a23.3 23.3 0 014.31-.82c3.05-.38 4.83-.75 5.68-1.09.1-.04.2-.08.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 013 2.96z",
    fill: primaryFill
  }));
};

export const InkStrokeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/InkStrokeRegularIcon({}), 'InkStrokeRegular');

const InkingToolFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.52 15a6.2 6.2 0 00-.02.5c0 .58.07 1.16.27 1.62.21.47.6.88 1.23.88s1.02-.41 1.23-.88c.2-.46.27-1.04.27-1.62 0-.17 0-.34-.02-.5H8.52zM2.5 5.5v-3c0-.28.22-.5.5-.5h14c.28 0 .5.22.5.5v3c0 .83-.67 1.5-1.5 1.5H4a1.5 1.5 0 01-1.5-1.5zM4.75 8l2.72 5.45a1 1 0 00.9.55h3.26a1 1 0 00.9-.55L15.25 8H4.75z",
    fill: primaryFill
  }));
};

export const InkingToolFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/InkingToolFilledIcon({}), 'InkingToolFilled');

const InkingToolRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 2c.28 0 .5.22.5.5v3c0 .28.22.5.5.5h12a.5.5 0 00.5-.5v-3a.5.5 0 011 0v3c0 .83-.67 1.5-1.5 1.5h-.2l-3.58 7.17a1.5 1.5 0 01-.75.71c.02.2.03.4.03.62 0 .58-.07 1.16-.27 1.62-.21.47-.6.88-1.23.88s-1.02-.41-1.23-.88a4.12 4.12 0 01-.27-1.62c0-.21.01-.42.03-.62a1.5 1.5 0 01-.75-.7L4.19 7H4a1.5 1.5 0 01-1.5-1.5v-3c0-.28.22-.5.5-.5zm6.12 12h1.76a.5.5 0 00.45-.28L14.69 7H5.31l3.36 6.72a.5.5 0 00.45.28zm.4 1l-.02.5c0 .52.07.94.19 1.21.11.26.22.29.31.29.1 0 .2-.03.31-.29.12-.27.19-.69.19-1.21 0-.18 0-.35-.02-.5h-.96z",
    fill: primaryFill
  }));
};

export const InkingToolRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/InkingToolRegularIcon({}), 'InkingToolRegular');

const InkingToolAccentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 6V3H3v3c0 .28.22.5.5.5h13A.5.5 0 0017 6zm-4.55 1l-2.4 4.78a.5.5 0 10.9.44L13.56 7 13 6.5l-.55.5zM10 17.5c.55 0 1-.67 1-1.5s-.45-1.5-1-1.5-1 .67-1 1.5.45 1.5 1 1.5z",
    fill: primaryFill
  }));
};

export const InkingToolAccentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/InkingToolAccentFilledIcon({}), 'InkingToolAccentFilled');

const InprivateAccountFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a4 4 0 103.12 6.5H10v-1h3.7c.14-.32.23-.65.27-1H10v-1h3.97a3.97 3.97 0 00-.26-1H10v-1h3.12A4 4 0 0010 2zm-5 9a2 2 0 00-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0010 18c1.7 0 3.28-.32 4.52-1H10v-1h5.84c.28-.3.52-.64.7-1H10v-1h6.9c.06-.32.1-.65.1-1h-7v-1h6.73A2 2 0 0015 11H5z",
    fill: primaryFill
  }));
};

export const InprivateAccountFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/InprivateAccountFilledIcon({}), 'InprivateAccountFilled');

const InprivateAccountRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a4 4 0 017.12-2.5H10V3a3 3 0 000 6v-.5h3.12A4 4 0 016 6zm7.7 1.5H10v-1h3.97c-.04.35-.13.68-.26 1zm.27-2a3.97 3.97 0 00-.26-1H10v1h3.97zM3 13a2 2 0 012-2h10a2 2 0 011.73 1H5a1 1 0 00-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0010 17h4.52c-1.24.68-2.83 1-4.52 1a9.14 9.14 0 01-4.87-1.2A4.35 4.35 0 013 13zm7 1v-1h7c0 .35-.04.68-.1 1H10zm6.54 1c-.18.36-.42.7-.7 1h-1.59.01H10v-1h6.54z",
    fill: primaryFill
  }));
};

export const InprivateAccountRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/InprivateAccountRegularIcon({}), 'InprivateAccountRegular');

const InsertFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm0 12c0 1.1.9 2 2 2h8a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2zM2.5 9.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const InsertFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/InsertFilledIcon({}), 'InsertFilled');

const InsertRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3a1 1 0 00-1 1v2a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1H6zM4 4c0-1.1.9-2 2-2h8a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 13a1 1 0 01-1-1v-2a1 1 0 011-1h8a1 1 0 011 1v2a1 1 0 01-1 1H6zm-2-1c0 1.1.9 2 2 2h8a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2zm-2-6c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15A.5.5 0 012 10z",
    fill: primaryFill
  }));
};

export const InsertRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/InsertRegularIcon({}), 'InsertRegular');

const IosChevronRightFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.22 6.03a.75.75 0 011.06-1.06l4.5 4.5c.3.3.3.77 0 1.06l-4.5 4.5a.75.75 0 11-1.06-1.06L16.19 10l-3.97-3.97z",
    fill: primaryFill
  }));
};

export const IosChevronRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/IosChevronRightFilledIcon({}), 'IosChevronRightFilled');

const IosChevronRightRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.65 5.85a.5.5 0 01.7-.7l4.5 4.5c.2.2.2.5 0 .7l-4.5 4.5a.5.5 0 01-.7-.7L16.79 10l-4.14-4.15z",
    fill: primaryFill
  }));
};

export const IosChevronRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/IosChevronRightRegularIcon({}), 'IosChevronRightRegular');

const IotFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 4a2 2 0 01-2.65 1.88l-1.28 1.95A3 3 0 0113 9.99l1.17.2a2 2 0 11-.16.99l-1.17-.2a3 3 0 01-1.43 1.67l.45 1.35H12a2 2 0 11-1.1.32l-.44-1.36a3.02 3.02 0 01-2.87-1.18l-1.64.8A2 2 0 014 15a2 2 0 111.5-3.32l1.64-.79A3 3 0 017.77 8l-.93-1.17a2 2 0 11.77-.63l.95 1.18a2.99 2.99 0 012.68-.1l1.28-1.94A2 2 0 1116 4z",
    fill: primaryFill
  }));
};

export const IotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/IotFilledIcon({}), 'IotFilled');

const IotRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 4a2 2 0 01-2.65 1.88l-1.28 1.95A3 3 0 0113 9.99l1.17.2a2 2 0 11-.16.99l-1.17-.2a3 3 0 01-1.43 1.67l.45 1.35H12a2 2 0 11-1.1.32l-.44-1.36a3.02 3.02 0 01-2.87-1.18l-1.64.8A2 2 0 014 15a2 2 0 111.5-3.32l1.64-.79A3 3 0 017.77 8l-.93-1.17a2 2 0 11.77-.63l.95 1.18a2.99 2.99 0 012.68-.1l1.28-1.94A2 2 0 1116 4zm-1 0a1 1 0 10-2 0 1 1 0 002 0zM6 6a1 1 0 100-2 1 1 0 000 2zm4 6a2 2 0 100-4 2 2 0 000 4zm-5 1a1 1 0 10-2 0 1 1 0 002 0zm8 3a1 1 0 10-2 0 1 1 0 002 0zm3-4a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const IotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/IotRegularIcon({}), 'IotRegular');

const JavascriptFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm7.25 1.5a.75.75 0 00-.75.75v5c0 .14-.11.25-.25.25h-1a.75.75 0 000 1.5h1c.97 0 1.75-.78 1.75-1.75v-5a.75.75 0 00-.75-.75zm1.25 1.75v1c0 .97.78 1.75 1.75 1.75h.5c.14 0 .25.11.25.25v1c0 .14-.11.25-.25.25h-1.5a.75.75 0 000 1.5h1.5c.97 0 1.75-.78 1.75-1.75v-1c0-.97-.78-1.75-1.75-1.75h-.5a.25.25 0 01-.25-.25v-1c0-.14.11-.25.25-.25h1.5a.75.75 0 000-1.5h-1.5c-.97 0-1.75.78-1.75 1.75z",
    fill: primaryFill
  }));
};

export const JavascriptFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/JavascriptFilledIcon({}), 'JavascriptFilled');

const JavascriptRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 9.5c0-.83.67-1.5 1.5-1.5h1.5a.5.5 0 010 1H13a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5H12a.5.5 0 010-1h1.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13a1.5 1.5 0 01-1.5-1.5v-1zm-.5-1a.5.5 0 00-1 0v5a.5.5 0 01-.5.5h-1a.5.5 0 000 1h1c.83 0 1.5-.67 1.5-1.5v-5zM3 6v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6a3 3 0 00-3 3zm3-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const JavascriptRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/JavascriptRegularIcon({}), 'JavascriptRegular');

const KeyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 7.5C7 4.42 9.42 2 12.5 2S18 4.42 18 7.5 15.58 13 12.5 13c-.5 0-1-.05-1.5-.18V13a1 1 0 01-1 1H9v1a1 1 0 01-1 1H7v.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 16.5v-1.59c0-.4.16-.78.44-1.06l4.54-4.54c.13-.13.2-.37.14-.64A5.62 5.62 0 017 7.5zM15 6a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const KeyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyFilledIcon({}), 'KeyFilled');

const KeyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6a1 1 0 11-2 0 1 1 0 012 0zm-2.5-4a5.45 5.45 0 00-5.38 6.67c.06.27 0 .5-.14.64l-4.54 4.54A1.5 1.5 0 002 14.91v1.59c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h1a1 1 0 001-1v-1h1a1 1 0 001-1v-.18c.5.13 1 .18 1.5.18 3.08 0 5.5-2.42 5.5-5.5S15.58 2 12.5 2zM8 7.5C8 4.98 9.98 3 12.5 3S17 4.98 17 7.5 15.02 12 12.5 12c-.66 0-1.27-.1-1.78-.35a.5.5 0 00-.72.45v.9H9a1 1 0 00-1 1v1H7a1 1 0 00-1 1v.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1.59a.5.5 0 01.15-.35l4.54-4.54c.43-.43.52-1.04.4-1.56-.06-.3-.09-.63-.09-.96z",
    fill: primaryFill
  }));
};

export const KeyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyRegularIcon({}), 'KeyRegular');

const KeyCommandFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.75 4.5C6.44 4.5 7 5.06 7 5.75V7H5.75a1.25 1.25 0 110-2.5zM8.5 7V5.75A2.75 2.75 0 105.75 8.5H7v3H5.75a2.75 2.75 0 102.75 2.75V13h3v1.25a2.75 2.75 0 102.75-2.75H13v-3h1.25a2.75 2.75 0 10-2.75-2.75V7h-3zm0 1.5h3v3h-3v-3zM13 7V5.75A1.25 1.25 0 1114.25 7H13zm0 6h1.25A1.25 1.25 0 1113 14.25V13zm-6 0v1.25A1.25 1.25 0 115.75 13H7z",
    fill: primaryFill
  }));
};

export const KeyCommandFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyCommandFilledIcon({}), 'KeyCommandFilled');

const KeyCommandRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 4C6.33 4 7 4.67 7 5.5V7H5.5a1.5 1.5 0 110-3zM8 7V5.5A2.5 2.5 0 105.5 8H7v4H5.5A2.5 2.5 0 108 14.5V13h4v1.5a2.5 2.5 0 102.5-2.5H13V8h1.5A2.5 2.5 0 1012 5.5V7H8zm0 1h4v4H8V8zm5-1V5.5A1.5 1.5 0 1114.5 7H13zm0 6h1.5a1.5 1.5 0 11-1.5 1.5V13zm-6 0v1.5A1.5 1.5 0 115.5 13H7z",
    fill: primaryFill
  }));
};

export const KeyCommandRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyCommandRegularIcon({}), 'KeyCommandRegular');

const KeyMultipleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2l.32.01a5.5 5.5 0 00-1.09 7.96l-.73.74v1.69a.6.6 0 01-.6.6H6v1.4a.6.6 0 01-.6.6H2.6a.6.6 0 01-.6-.6v-2.86a.6.6 0 01.18-.42l3.98-3.99A4 4 0 0110 2zM9 6.5a4.5 4.5 0 117 3.74v2.05l.78.79a.6.6 0 010 .84L15.71 15l1.06 1.07a.6.6 0 01-.04.89l-2.36 1.88a.6.6 0 01-.74 0l-2.4-1.92a.6.6 0 01-.23-.47v-6.2A4.5 4.5 0 019 6.5zm5.25-1a.75.75 0 10-1.5 0 .75.75 0 001.5 0z",
    fill: primaryFill
  }));
};

export const KeyMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyMultipleFilledIcon({}), 'KeyMultipleFilled');

const KeyMultipleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.32 2.01L10 2a4 4 0 00-3.84 5.13l-3.98 3.99a.6.6 0 00-.18.42v2.86c0 .33.27.6.6.6h2.8a.6.6 0 00.6-.6V13h1.9a.6.6 0 00.6-.6v-1.7l.73-.73c-.21-.26-.4-.54-.56-.84l-1 .99a.6.6 0 00-.17.42V12H5.6a.6.6 0 00-.6.6V14H3v-2.3L7.32 7.4l-.12-.3a3 3 0 011.96-3.97c.33-.42.72-.8 1.16-1.1zm3.18 4.24a.75.75 0 100-1.5.75.75 0 000 1.5zM9 6.5a4.5 4.5 0 117 3.74v2.05l.78.79a.6.6 0 010 .84L15.71 15l1.06 1.07a.6.6 0 01-.04.89l-2.36 1.88a.6.6 0 01-.74 0l-2.4-1.92a.6.6 0 01-.23-.47v-6.2A4.5 4.5 0 019 6.5zM13.5 3a3.5 3.5 0 00-1.75 6.53.5.5 0 01.25.43v6.3l2 1.6 1.75-1.4-1.03-1.04a.6.6 0 010-.84l1.07-1.08-.61-.62a.6.6 0 01-.18-.42v-2.5c0-.17.1-.34.25-.43A3.5 3.5 0 0013.5 3z",
    fill: primaryFill
  }));
};

export const KeyMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyMultipleRegularIcon({}), 'KeyMultipleRegular');

const KeyResetFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 2a5.45 5.45 0 00-5.38 6.67c.06.27 0 .5-.14.64l-4.54 4.54A1.5 1.5 0 002 14.91v1.59c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h1a1 1 0 001-1v-1c0-.51.26-.96.65-1.23l-1.21-1.2a1.5 1.5 0 010-2.13l2-2A1.5 1.5 0 0112.9 9H14a5 5 0 013.3 1.24A5.54 5.54 0 0012.5 2zM14 5a1 1 0 110 2 1 1 0 010-2zm-2.15 3.85a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L10.71 11H14a3 3 0 11-3 3 .5.5 0 10-1 0 4 4 0 104-4h-3.3l1.15-1.15z",
    fill: primaryFill
  }));
};

export const KeyResetFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyResetFilledIcon({}), 'KeyResetFilled');

const KeyResetRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 7a1 1 0 100-2 1 1 0 000 2zm-7 .5C7 4.42 9.42 2 12.5 2S18 4.42 18 7.5c0 1-.26 1.93-.7 2.74a4.99 4.99 0 00-.83-.59c.34-.63.53-1.37.53-2.15C17 4.98 15.02 3 12.5 3a4.45 4.45 0 00-4.4 5.46c.1.52.02 1.13-.41 1.56l-4.54 4.54a.5.5 0 00-.15.35v1.59c0 .28.22.5.5.5h2a.5.5 0 00.5-.5V16a1 1 0 011-1h1v-1a1 1 0 011-1h.38A1.5 1.5 0 009 14v1a1 1 0 01-1 1H7v.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 16.5v-1.59c0-.4.16-.78.44-1.06l4.54-4.54c.13-.13.2-.37.14-.64A5.62 5.62 0 017 7.5zm4.85 1.35a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L10.71 11H14a3 3 0 11-3 3 .5.5 0 10-1 0 4 4 0 104-4h-3.3l1.15-1.15z",
    fill: primaryFill
  }));
};

export const KeyResetRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyResetRegularIcon({}), 'KeyResetRegular');

const Keyboard123FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.88 3.6c.38-.44.76-.58 1.05-.6.3-.01.58.1.78.3.2.19.3.43.28.63-.01.2-.12.44-.49.65a5.8 5.8 0 00-2.2 1.93 2.25 2.25 0 00-.3.92v.12a.5.5 0 00.5.45h3a.5.5 0 000-1H5.18C5.4 6.64 5.9 6.1 7 5.45c.62-.36.95-.88.99-1.45a1.84 1.84 0 00-.59-1.43c-.38-.36-.92-.6-1.52-.57-.61.04-1.22.34-1.76.95a.5.5 0 10.76.65zM2.76 2.07c.15.1.24.26.24.43v5a.5.5 0 01-1 0V3.3l-.78.4a.5.5 0 01-.45-.9l1.5-.75a.5.5 0 01.5.02zm8.28.93c-.33 0-.75.14-1.17.6a.5.5 0 11-.74-.66 2.57 2.57 0 011.9-.94c.64 0 1.2.28 1.57.7a1.5 1.5 0 01-.32 2.3c.27.2.47.42.6.69.26.59.08 1.2-.28 1.61-.36.42-.93.7-1.56.7-.65 0-1.33-.29-1.91-.94a.5.5 0 11.74-.66c.42.46.84.6 1.17.6.34 0 .63-.15.8-.35.17-.2.2-.4.12-.55-.07-.17-.33-.44-1.07-.61a.5.5 0 010-.98c.74-.17 1-.44 1.07-.61.07-.15.05-.35-.12-.55-.17-.2-.46-.35-.8-.35zM2 14.5V8.91a1.5 1.5 0 001.5-.3c.27.25.62.4 1 .4h3c.59 0 1.1-.35 1.34-.84.66.55 1.42.83 2.2.83.92 0 1.77-.4 2.32-1.05A2.5 2.5 0 0013.64 5h2.86c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 14.5zM5.5 13a.5.5 0 000 1h9a.5.5 0 000-1h-9zm8.25-4.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-7.5 2.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm3.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zm2.25-.75a.75.75 0 101.51 0 .75.75 0 00-1.5 0z",
    fill: primaryFill
  }));
};

export const Keyboard123Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Keyboard123FilledIcon({}), 'Keyboard123Filled');

const Keyboard123RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.88 3.6c.38-.44.76-.58 1.05-.6.3-.01.58.1.78.3.2.19.3.43.28.63-.01.2-.12.44-.49.65a5.8 5.8 0 00-2.2 1.93 2.25 2.25 0 00-.3.92v.12a.5.5 0 00.5.45h3a.5.5 0 000-1H5.18C5.4 6.64 5.9 6.1 7 5.45c.62-.36.95-.88.99-1.45a1.84 1.84 0 00-.59-1.43c-.38-.36-.92-.6-1.52-.57-.61.04-1.22.34-1.76.95a.5.5 0 10.76.65zM2.76 2.07c.15.1.24.26.24.43v5a.5.5 0 01-1 0V3.3l-.78.4a.5.5 0 01-.45-.9l1.5-.75a.5.5 0 01.5.02zm8.28.93c-.33 0-.75.14-1.17.6a.5.5 0 11-.74-.66 2.57 2.57 0 011.9-.94c.64 0 1.2.28 1.57.7a1.5 1.5 0 01-.32 2.3c.27.2.47.42.6.69.26.59.08 1.2-.28 1.61-.36.42-.93.7-1.56.7-.65 0-1.33-.29-1.91-.94a.5.5 0 11.74-.66c.42.46.84.6 1.17.6.34 0 .63-.15.8-.35.17-.2.2-.4.12-.55-.07-.17-.33-.44-1.07-.61a.5.5 0 010-.98c.74-.17 1-.44 1.07-.61.07-.15.05-.35-.12-.55-.17-.2-.46-.35-.8-.35zM2 8.91v5.59c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-2.86a2.51 2.51 0 01.35 1h2.51c.28 0 .5.22.5.5v8a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V8.91a1.5 1.5 0 01-1 0zM5.5 13a.5.5 0 000 1h9a.5.5 0 000-1h-9zm9-4a.75.75 0 100-1.5.75.75 0 000 1.5zM7 11.5A.75.75 0 107 10a.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.26.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const Keyboard123Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Keyboard123RegularIcon({}), 'Keyboard123Regular');

const KeyboardFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v8c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-13zm2.75 3.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm6 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5 12.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zM14.5 8a.75.75 0 110-1.5.75.75 0 010 1.5zM7 10.5A.75.75 0 117 9a.75.75 0 010 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.26.75A.75.75 0 1113 9a.75.75 0 010 1.5zM9.25 7.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const KeyboardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardFilledIcon({}), 'KeyboardFilled');

const KeyboardRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 12.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zM11.5 8a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.5 8a.75.75 0 100-1.5.75.75 0 000 1.5zm2.25 1.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25.75A.75.75 0 1010 9a.75.75 0 000 1.5zm3.76-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM8.5 8a.75.75 0 100-1.5.75.75 0 000 1.5zM2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 13.5v-8zM3.5 5a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-13z",
    fill: primaryFill
  }));
};

export const KeyboardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardRegularIcon({}), 'KeyboardRegular');

const KeyboardDockFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5C2 2.67 2.67 2 3.5 2h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-6v3.3l1.15-1.15a.5.5 0 01.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.15 1.14V13h-6A1.5 1.5 0 012 11.5v-8zM5.5 6a.75.75 0 100-1.5.75.75 0 000 1.5zm6 0a.75.75 0 100-1.5.75.75 0 000 1.5zm-6 4a.5.5 0 000 1h9a.5.5 0 000-1h-9zm8.25-4.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-7.5 2.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM10 8.5A.75.75 0 1010 7a.75.75 0 000 1.5zm2.25-.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM8.5 6a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const KeyboardDockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardDockFilledIcon({}), 'KeyboardDockFilled');

const KeyboardDockRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 10a.5.5 0 000 1h9a.5.5 0 000-1h-9zm6.75-4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14.5 6a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.25-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7 8.5A.75.75 0 107 7a.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.26.75A.75.75 0 1013 7a.75.75 0 000 1.5zM9.25 5.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM3.5 2C2.67 2 2 2.67 2 3.5v8c0 .83.67 1.5 1.5 1.5h6v3.3l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7l-1.15 1.14V13h6c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-13zm13 10h-13a.5.5 0 01-.5-.5v-8c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5v8a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};

export const KeyboardDockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardDockRegularIcon({}), 'KeyboardDockRegular');

const KeyboardLayoutFloatFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H11a1 1 0 11-2 0H3.5A1.5 1.5 0 012 12.5v-8zM5.5 7a.75.75 0 100-1.5.75.75 0 000 1.5zm6 0a.75.75 0 100-1.5.75.75 0 000 1.5zm-6 4a.5.5 0 000 1h9a.5.5 0 000-1h-9zm8.25-4.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-7.5 2.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM10 9.5A.75.75 0 1010 8a.75.75 0 000 1.5zm2.25-.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM8.5 7a.75.75 0 100-1.5.75.75 0 000 1.5zM2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutFloatFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutFloatFilledIcon({}), 'KeyboardLayoutFloatFilled');

const KeyboardLayoutFloatRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 11.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zM11.5 7a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.5 7a.75.75 0 100-1.5.75.75 0 000 1.5zm2.25 1.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM10 9.5A.75.75 0 1010 8a.75.75 0 000 1.5zm3.76-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM8.5 7a.75.75 0 100-1.5.75.75 0 000 1.5zM2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H11a1 1 0 11-2 0H3.5A1.5 1.5 0 012 12.5v-8zM3.5 13h13a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v8c0 .28.22.5.5.5zM2 16.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutFloatRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutFloatRegularIcon({}), 'KeyboardLayoutFloatRegular');

const KeyboardLayoutOneHandedLeftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v8c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-13zm2 8h3a.5.5 0 010 1h-3a.5.5 0 010-1zm0-4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.75 8a.75.75 0 110-1.5.75.75 0 010 1.5zM6 9.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25.75a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutOneHandedLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutOneHandedLeftFilledIcon({}), 'KeyboardLayoutOneHandedLeftFilled');

const KeyboardLayoutOneHandedLeftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v8c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-13zM3 5.5c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5v8a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-8zM5.5 12a.5.5 0 000 1h3a.5.5 0 000-1h-3zm0-4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zM6 9.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutOneHandedLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutOneHandedLeftRegularIcon({}), 'KeyboardLayoutOneHandedLeftRegular');

const KeyboardLayoutResizeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5h7a.5.5 0 000-1h-7C2.67 2 2 2.67 2 3.5v4a.5.5 0 001 0v-4zM3.5 9C2.67 9 2 9.67 2 10.5v6c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-8zm2 6h4a.5.5 0 010 1h-4a.5.5 0 010-1zm0-2.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2 .75a.75.75 0 110-1.5.75.75 0 010 1.5zm3.5-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM17.5 9c.28 0 .5.22.5.5v7c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 010-1h2a.5.5 0 00.5-.5v-7c0-.28.22-.5.5-.5zm-4-7a.5.5 0 000 1h2.8l-4.15 4.15a.5.5 0 00.7.7L17 3.71V6.5a.5.5 0 001 0v-4a.5.5 0 00-.5-.5h-4z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutResizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutResizeFilledIcon({}), 'KeyboardLayoutResizeFilled');

const KeyboardLayoutResizeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5h7a.5.5 0 000-1h-7C2.67 2 2 2.67 2 3.5v4a.5.5 0 001 0v-4zM3.5 9C2.67 9 2 9.67 2 10.5v6c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-8zM3 10.5c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v6a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-6zM5.5 15a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0-2.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2 .75a.75.75 0 100-1.5.75.75 0 000 1.5zm3.5-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM17.5 9c.28 0 .5.22.5.5v7c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 010-1h2a.5.5 0 00.5-.5v-7c0-.28.22-.5.5-.5zm-4-7a.5.5 0 000 1h2.8l-4.15 4.15a.5.5 0 00.7.7L17 3.71V6.5a.5.5 0 001 0v-4a.5.5 0 00-.5-.5h-4z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutResizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutResizeRegularIcon({}), 'KeyboardLayoutResizeRegular');

const KeyboardLayoutSplitFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 13.5v-8zm3 7c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5zM4.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM5.25 10.5a.75.75 0 100-1.5.75.75 0 000 1.5zM9 9.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM14.5 12h-3a.5.5 0 000 1h3a.5.5 0 000-1zm0-4.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM12.25 8a.75.75 0 100-1.5.75.75 0 000 1.5zM14 9.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutSplitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutSplitFilledIcon({}), 'KeyboardLayoutSplitFilled');

const KeyboardLayoutSplitRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 13.5v-8zM3.5 5a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-13zM5 12.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM4.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.25 10.5a.75.75 0 100-1.5.75.75 0 000 1.5zM9 9.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14.5 12a.5.5 0 010 1h-3a.5.5 0 010-1h3zm0-4.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM12.25 8a.75.75 0 110-1.5.75.75 0 010 1.5zM14 9.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-2.25.75a.75.75 0 110-1.5.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const KeyboardLayoutSplitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardLayoutSplitRegularIcon({}), 'KeyboardLayoutSplitRegular');

const KeyboardShiftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.14 2.53a1.5 1.5 0 00-2.28 0l-6.62 7.8A1 1 0 003 11.98h3V17a1 1 0 001 1h6a1 1 0 001-1v-5.02h3a1 1 0 00.76-1.65l-6.62-7.8z",
    fill: primaryFill
  }));
};

export const KeyboardShiftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardShiftFilledIcon({}), 'KeyboardShiftFilled');

const KeyboardShiftRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.86 2.53c.6-.7 1.68-.7 2.28 0l6.62 7.8a1 1 0 01-.76 1.65h-3V17a1 1 0 01-1 1H7a1 1 0 01-1-1v-5.02H3a1 1 0 01-.76-1.65l6.62-7.8zm1.52.65a.5.5 0 00-.76 0L3 10.98h3.5c.28 0 .5.23.5.5V17h6v-5.52c0-.27.22-.5.5-.5H17l-6.62-7.8z",
    fill: primaryFill
  }));
};

export const KeyboardShiftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardShiftRegularIcon({}), 'KeyboardShiftRegular');

const KeyboardShiftUppercaseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.14 2.53a1.5 1.5 0 00-2.28 0l-6.62 7.8A1 1 0 003 11.98h3V15a1 1 0 001 1h6a1 1 0 001-1v-3.02h3a1 1 0 00.76-1.65l-6.62-7.8zM6.5 17a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const KeyboardShiftUppercaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardShiftUppercaseFilledIcon({}), 'KeyboardShiftUppercaseFilled');

const KeyboardShiftUppercaseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.14 2.53a1.5 1.5 0 00-2.28 0l-6.62 7.8A1 1 0 003 11.98h3V15a1 1 0 001 1h6a1 1 0 001-1v-3.02h3a1 1 0 00.76-1.65l-6.62-7.8zm-1.52.65a.5.5 0 01.76 0l6.62 7.8h-3.5a.5.5 0 00-.5.5V15H7v-3.52a.5.5 0 00-.5-.5H3l6.62-7.8zM6.5 17a.5.5 0 100 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }));
};

export const KeyboardShiftUppercaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardShiftUppercaseRegularIcon({}), 'KeyboardShiftUppercaseRegular');

const KeyboardTabFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 4.75a.75.75 0 00-1.5 0v10.5a.75.75 0 001.5 0V4.75zm-8.47-.53a.75.75 0 00-1.06 1.06l3.97 3.97H2.75a.75.75 0 000 1.5h8.69l-3.97 3.97a.75.75 0 101.06 1.06l5.25-5.25c.3-.3.3-.77 0-1.06L8.53 4.22z",
    fill: primaryFill
  }));
};

export const KeyboardTabFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardTabFilledIcon({}), 'KeyboardTabFilled');

const KeyboardTabRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.35 4.15a.5.5 0 10-.7.7l4.64 4.65H3.5a.5.5 0 000 1h9.8l-4.65 4.65a.5.5 0 00.7.7l5.5-5.5a.5.5 0 000-.7l-5.5-5.5zM17 4.5a.5.5 0 00-1 0v11a.5.5 0 001 0v-11z",
    fill: primaryFill
  }));
};

export const KeyboardTabRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/KeyboardTabRegularIcon({}), 'KeyboardTabRegular');

const LaptopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 5C3.67 5 3 5.67 3 6.5v6c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-11zm-2 10a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const LaptopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LaptopFilledIcon({}), 'LaptopFilled');

const LaptopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 7c0-1.1.9-2 2-2h10a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2V7zm2-1a1 1 0 00-1 1v5a1 1 0 001 1h10a1 1 0 001-1V7a1 1 0 00-1-1H5zm-3 9.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const LaptopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LaptopRegularIcon({}), 'LaptopRegular');

const LaptopDismissFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 5.5a5.5 5.5 0 01-8 4.9v2.1c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-4.52l.02.5zm-9 10c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM5.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L6.21 5.5l1.14 1.15a.5.5 0 11-.7.7L5.5 6.21 4.35 7.35a.5.5 0 11-.7-.7L4.79 5.5 3.65 4.35a.5.5 0 11.7-.7L5.5 4.79l1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const LaptopDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LaptopDismissFilledIcon({}), 'LaptopDismissFilled');

const LaptopDismissRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.98 6H15a1 1 0 011 1v5a1 1 0 01-1 1H5a1 1 0 01-1-1v-1.2c-.35-.1-.68-.24-1-.4V12c0 1.1.9 2 2 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-4.02a5.59 5.59 0 010 1zM2.5 15a.5.5 0 000 1h15a.5.5 0 000-1h-15zm3-5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L6.21 5.5l1.14 1.15a.5.5 0 11-.7.7L5.5 6.21 4.35 7.35a.5.5 0 11-.7-.7L4.79 5.5 3.65 4.35a.5.5 0 11.7-.7L5.5 4.79l1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const LaptopDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LaptopDismissRegularIcon({}), 'LaptopDismissRegular');

const LassoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.16 2.21a8.02 8.02 0 013.68 0 .75.75 0 01-.35 1.46 6.52 6.52 0 00-2.98 0 .75.75 0 01-.35-1.46zM6.83 3.44c.21.35.1.81-.25 1.03a6.54 6.54 0 00-2.11 2.11.75.75 0 01-1.28-.79 8.04 8.04 0 012.6-2.6.75.75 0 011.04.25zm6.34 0a.75.75 0 011.04-.25 8.04 8.04 0 012.6 2.6.75.75 0 01-1.28.8 6.54 6.54 0 00-2.11-2.12.75.75 0 01-.25-1.03zM3.11 7.6c.4.1.66.5.56.9a6.52 6.52 0 000 3 .75.75 0 01-1.46.34 8.02 8.02 0 010-3.68c.1-.4.5-.65.9-.56zm13.78 0c.4-.1.8.16.9.56a8.02 8.02 0 010 3.68.75.75 0 01-1.46-.35 6.52 6.52 0 000-2.98c-.1-.4.15-.81.56-.9zM3.44 13.17a.75.75 0 011.03.25 6.54 6.54 0 002.11 2.11.75.75 0 11-.79 1.28 8.04 8.04 0 01-2.6-2.6.75.75 0 01.25-1.04zm13.67 1.27a.75.75 0 00-1.22-.88l-.02.03a4.79 4.79 0 01-.38.46c-.24.28-.6.64-1.02 1.01a6.73 6.73 0 00-3.97-1.31 2.6 2.6 0 00-1.84.68 2.17 2.17 0 000 3.14 2.6 2.6 0 001.84.68c1.53 0 2.87-.58 3.91-1.27a9.4 9.4 0 011.1 1.31 7.02 7.02 0 01.3.52l.02.02c-.15-.26 0 0 0 0a.75.75 0 001.34-.67c.19.38 0 0 0 0l-.01-.02-.02-.04a5.61 5.61 0 00-.4-.64 9.9 9.9 0 00-1.13-1.4 11.79 11.79 0 001.46-1.57l.03-.04v-.01h.01zm-6.61.81c1.03 0 1.91.3 2.65.74a5.4 5.4 0 01-2.65.76c-.42 0-.67-.13-.8-.26a.67.67 0 010-.98c.13-.13.38-.26.8-.26z",
    fill: primaryFill
  }));
};

export const LassoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LassoFilledIcon({}), 'LassoFilled');

const LassoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.16 2.21a8.02 8.02 0 013.68 0 .5.5 0 01-.23.98 7.02 7.02 0 00-3.22 0 .5.5 0 01-.23-.98zM6.48 3.36a.5.5 0 01-.16.68 7.04 7.04 0 00-2.28 2.28.5.5 0 11-.85-.53 8.04 8.04 0 012.6-2.6.5.5 0 01.7.17zm7.04 0a.5.5 0 01.69-.17 8.04 8.04 0 012.6 2.6.5.5 0 01-.85.53 7.04 7.04 0 00-2.28-2.28.5.5 0 01-.16-.68zM2.82 7.79a.5.5 0 01.37.6 7.02 7.02 0 000 3.22.5.5 0 01-.98.23 8.02 8.02 0 010-3.68.5.5 0 01.6-.37zm14.37 0a.5.5 0 01.6.37 8.03 8.03 0 010 3.68.5.5 0 01-.98-.23 7.02 7.02 0 000-3.22.5.5 0 01.38-.6zM3.36 13.52a.5.5 0 01.68.16c.58.92 1.36 1.7 2.28 2.28a.5.5 0 11-.53.85 8.04 8.04 0 01-2.6-2.6.5.5 0 01.17-.7zm13.57.73a.5.5 0 10-.86-.5l-.02.03a3.6 3.6 0 01-.32.46 7.8 7.8 0 01-1.16 1.22A6.55 6.55 0 0010.5 14c-1.52 0-2.49.9-2.49 2s.97 2 2.49 2a7.1 7.1 0 004.03-1.26 8.6 8.6 0 011.5 1.95l.02.03a.5.5 0 10.9-.44s-.13-.24 0 0l-.01-.02a3.37 3.37 0 00-.1-.18 9.6 9.6 0 00-1.49-1.93l-.02-.03a8.8 8.8 0 001.6-1.86.9.9 0 010-.01zM10.5 15c1.3 0 2.38.46 3.23 1.07-.85.53-1.93.93-3.23.93-1.13 0-1.49-.6-1.49-1s.36-1 1.49-1z",
    fill: primaryFill
  }));
};

export const LassoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LassoRegularIcon({}), 'LassoRegular');

const LauncherSettingsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 013.7 4.3a.5.5 0 01.54-.13l1.92.68a1 1 0 001.32-.76l.36-2a.5.5 0 01.4-.4 8.53 8.53 0 013.55 0c.2.04.35.2.38.4l.37 2a1 1 0 001.32.76l1.92-.68a.5.5 0 01.54.13 8.5 8.5 0 011.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 000 1.52l1.56 1.32a.5.5 0 01.15.54 8.5 8.5 0 01-1.78 3.08.5.5 0 01-.54.13l-1.92-.68a1 1 0 00-1.32.76l-.37 2a.5.5 0 01-.38.4 8.53 8.53 0 01-3.56 0 .5.5 0 01-.39-.4l-.36-2a1 1 0 00-1.32-.76l-1.92.68a.5.5 0 01-.54-.13 8.5 8.5 0 01-1.78-3.08.5.5 0 01.15-.54l1.56-1.32a1 1 0 000-1.52L2.06 7.92a.5.5 0 01-.15-.54zm6.19.4l-1.58 1.9a.5.5 0 000 .64l1.39 1.67c.1.12.28.12.38 0l.93-1.11a.25.25 0 000-.32L8.75 10l.6-.72-1.25-1.5zM8.75 7l2.5 3-2.16 2.59a.25.25 0 00.2.41h1.84c.08 0 .15-.03.2-.09l2.15-2.59a.5.5 0 000-.64L11.25 7h-2.5z",
    fill: primaryFill
  }));
};

export const LauncherSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LauncherSettingsFilledIcon({}), 'LauncherSettingsFilled');

const LauncherSettingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 013.7 4.3a.5.5 0 01.54-.13l1.92.68a1 1 0 001.32-.76l.36-2a.5.5 0 01.4-.4 8.53 8.53 0 013.55 0c.2.04.35.2.38.4l.37 2a1 1 0 001.32.76l1.92-.68a.5.5 0 01.54.13 8.5 8.5 0 011.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 000 1.52l1.56 1.32a.5.5 0 01.15.54 8.5 8.5 0 01-1.78 3.08.5.5 0 01-.54.13l-1.92-.68a1 1 0 00-1.32.76l-.37 2a.5.5 0 01-.38.4 8.53 8.53 0 01-3.56 0 .5.5 0 01-.39-.4l-.36-2a1 1 0 00-1.32-.76l-1.92.68a.5.5 0 01-.54-.13 8.5 8.5 0 01-1.78-3.08.5.5 0 01.15-.54l1.56-1.32a1 1 0 000-1.52L2.06 7.92a.5.5 0 01-.15-.54zm1.06 0l1.3 1.1a2 2 0 010 3.04l-1.3 1.1c.3.79.72 1.51 1.25 2.16l1.6-.58a2 2 0 012.63 1.53l.3 1.67a7.56 7.56 0 002.5 0l.3-1.67a2 2 0 012.64-1.53l1.6.58a7.5 7.5 0 001.24-2.16l-1.3-1.1a2 2 0 010-3.04l1.3-1.1a7.5 7.5 0 00-1.25-2.16l-1.6.58a2 2 0 01-2.63-1.53l-.3-1.67a7.55 7.55 0 00-2.5 0l-.3 1.67A2 2 0 015.81 5.8l-1.6-.58a7.5 7.5 0 00-1.24 2.16zm5.13.4l-1.58 1.9a.5.5 0 000 .64l1.39 1.67c.1.12.28.12.38 0l.93-1.11a.25.25 0 000-.32L8.75 10l.6-.72-1.25-1.5zM8.75 7h2.5l2.23 2.68a.5.5 0 010 .64l-2.16 2.59a.25.25 0 01-.19.09H9.28a.25.25 0 01-.19-.41L11.25 10l-2.5-3z",
    fill: primaryFill
  }));
};

export const LauncherSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LauncherSettingsRegularIcon({}), 'LauncherSettingsRegular');

const LayerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 3.12a1 1 0 00-1 0L3.47 6.64a1 1 0 000 1.72l6.02 3.5a1 1 0 001 0l6.01-3.5a1 1 0 000-1.72l-6-3.52zM3.07 9.65l6.44 3.62a1 1 0 00.98 0l6.44-3.62a1 1 0 01-.42 1.26l-6 3.5a1 1 0 01-1.01 0l-6.01-3.5a1 1 0 01-.42-1.26zm0 2.45l6.44 3.63a1 1 0 00.98 0l6.44-3.63a1 1 0 01-.42 1.26l-6 3.5a1 1 0 01-1.01 0l-6.01-3.5a1 1 0 01-.42-1.26z",
    fill: primaryFill
  }));
};

export const LayerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LayerFilledIcon({}), 'LayerFilled');

const LayerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 3.12a1 1 0 00-1 0L3.47 6.64a1 1 0 000 1.72l6.02 3.5a1 1 0 001 0l6.01-3.5a1 1 0 000-1.72l-6-3.52zm-1 1.16a1 1 0 011 0L16 7.5l-5.5 3.2a1 1 0 01-1 0L3.99 7.5l5.5-3.22zM3.06 9.65l6.44 3.62a1 1 0 00.98 0l6.44-3.62a1 1 0 01-.42 1.26l-6 3.5a1 1 0 01-1.01 0l-6.01-3.5a1 1 0 01-.42-1.26zm0 2.45l6.44 3.63a1 1 0 00.98 0l6.44-3.63a1 1 0 01-.42 1.26l-6 3.5a1 1 0 01-1.01 0l-6.01-3.5a1 1 0 01-.42-1.26z",
    fill: primaryFill
  }));
};

export const LayerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LayerRegularIcon({}), 'LayerRegular');

const LeafOneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.07 2.46a1.5 1.5 0 00-2.14 0l-3.24 3.3a6.03 6.03 0 00.06 8.5v.01a5.98 5.98 0 003.75 1.74v1.49a.5.5 0 101 0V16c1.36-.1 2.7-.68 3.74-1.73h.01l.01-.02a6.03 6.03 0 00.05-8.48l-3.24-3.3zM10.5 15c-.33.03-.67.03-1 0V9.5a.5.5 0 111 0V15z",
    fill: primaryFill
  }));
};

export const LeafOneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LeafOneFilledIcon({}), 'LeafOneFilled');

const LeafOneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.07 2.46l3.24 3.3A6.03 6.03 0 0110.5 16v1.5a.5.5 0 11-1 0V16A6.03 6.03 0 015.69 5.76l3.24-3.3a1.5 1.5 0 012.14 0zm-.57 12.53a5.03 5.03 0 003.1-8.52l-3.24-3.31a.5.5 0 00-.72 0L6.4 6.46A5.03 5.03 0 009.5 15v-5.5a.5.5 0 111 0V15z",
    fill: primaryFill
  }));
};

export const LeafOneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LeafOneRegularIcon({}), 'LeafOneRegular');

const LeafThreeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2a5 5 0 00-4 2 6 6 0 015.23 3.05c.25-.03.5-.05.77-.05h3V3.34C16 2.6 15.4 2 14.66 2H11zM7.34 14.99L7 15a5 5 0 01-5-5V6.34C2 5.6 2.6 5 3.34 5H7a5 5 0 014.2 2.28 6.02 6.02 0 00-3.43 2.78L6.35 8.65a.5.5 0 10-.7.7l1.68 1.69a6 6 0 000 3.95zM8 13a5 5 0 015-5h3.66C17.4 8 18 8.6 18 9.34V13a5 5 0 01-8.16 3.87l-.99.98a.5.5 0 01-.7-.7l.98-.99A4.98 4.98 0 018 13zm2.55 3.16l3.3-3.3a.5.5 0 00-.7-.71l-3.31 3.3c.2.27.44.5.7.71z",
    fill: primaryFill
  }));
};

export const LeafThreeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LeafThreeFilledIcon({}), 'LeafThreeFilled');

const LeafThreeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 7c0 .34-.03.68-.1 1h.76C17.4 8 18 8.6 18 9.34V13a5 5 0 01-8.16 3.87l-.99.98a.5.5 0 01-.7-.7l.98-.99a5 5 0 01-.79-1.34A5 5 0 012 10V6.34C2 5.6 2.6 5 3.34 5h3.08A5 5 0 0111 2h3.66C15.4 2 16 2.6 16 3.34V7zM7.52 5.03a5 5 0 014.14 3.15A5 5 0 0113 8h1.87A4 4 0 0015 7V3.34a.34.34 0 00-.34-.34H11a4 4 0 00-3.48 2.03zm3.03 11.13A4 4 0 0017 13V9.34a.34.34 0 00-.34-.34H13a4 4 0 00-3.16 6.45l3.3-3.3a.5.5 0 01.71.7l-3.3 3.31zM8 13c0-.4.05-.79.13-1.16L5.65 9.35a.5.5 0 11.7-.7l2.16 2.15a5.02 5.02 0 012.22-2.25A4 4 0 007 6H3.34a.34.34 0 00-.34.34V10a4 4 0 005.07 3.85A5.03 5.03 0 018 13z",
    fill: primaryFill
  }));
};

export const LeafThreeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LeafThreeRegularIcon({}), 'LeafThreeRegular');

const LeafTwoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.32 3C2.59 3 2 3.59 2 4.32V8a5 5 0 004.49 4.97 6.48 6.48 0 01-.05-4.82l-1.3-1.3a.5.5 0 11.71-.7L6.9 7.19a6.52 6.52 0 013.51-2.85A4.98 4.98 0 007 3H3.32zm4.95 11.02l-2.13 2.14a.5.5 0 10.7.7l2.14-2.13A5.5 5.5 0 0018 10.5V6.4c0-.77-.63-1.4-1.4-1.4h-4.1a5.5 5.5 0 00-4.23 9.02zm4.58-3.17L9.7 14.02c-.26-.21-.5-.45-.7-.71l3.16-3.16a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const LeafTwoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LeafTwoFilledIcon({}), 'LeafTwoFilled');

const LeafTwoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.32V8a5 5 0 005.58 4.97c.2.37.42.73.7 1.05l-2.14 2.14a.5.5 0 00.7.7l2.14-2.13A5.5 5.5 0 0018 10.5V6.4c0-.77-.63-1.4-1.4-1.4h-4.1c-.47 0-.94.06-1.38.17A5 5 0 007 3H3.32C2.59 3 2 3.59 2 4.32zm7.7 9.7l3.15-3.17a.5.5 0 00-.7-.7L8.98 13.3A4.5 4.5 0 0112.5 6l4.1-.01c.22 0 .4.18.4.4v4.1a4.5 4.5 0 01-7.3 3.52zM7 4a4 4 0 013.15 1.53 5.52 5.52 0 00-2.51 2.4L5.85 6.15a.5.5 0 10-.7.7l2.08 2.08A5.5 5.5 0 007.2 12 4 4 0 013 8V4.32c0-.18.14-.32.32-.32H7z",
    fill: primaryFill
  }));
};

export const LeafTwoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LeafTwoRegularIcon({}), 'LeafTwoRegular');

const LearningAppFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 01-.66-1H6a1 1 0 01-1-1h4.2A5.5 5.5 0 0116 9.2V4a2 2 0 00-2-2H6zm.75 2.5h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 010-1.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.98-1.97a.45.45 0 00-.45-.03.49.49 0 00-.15.1.51.51 0 00-.14.36v3.08a.5.5 0 00.14.35.45.45 0 00.48.13.52.52 0 00.13-.06l2.3-1.57c.06-.04.12-.1.16-.18a.54.54 0 000-.49.49.49 0 00-.17-.18l-2.3-1.5z",
    fill: primaryFill
  }));
};

export const LearningAppFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LearningAppFilledIcon({}), 'LearningAppFilled');

const LearningAppRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 3h8a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 01-.66-1H6a1 1 0 01-1-1h4.2c-.08-.32-.15-.66-.18-1H5V4a1 1 0 011-1zm1 1a1 1 0 00-1 1v1a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1H7zm6 1v1H7V5h6zm6 9.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.98-1.97a.45.45 0 00-.45-.03.49.49 0 00-.15.1.51.51 0 00-.14.36v3.08a.5.5 0 00.14.35.45.45 0 00.48.13.52.52 0 00.13-.06l2.3-1.57c.06-.04.12-.1.16-.18a.54.54 0 000-.49.49.49 0 00-.17-.18l-2.3-1.5z",
    fill: primaryFill
  }));
};

export const LearningAppRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LearningAppRegularIcon({}), 'LearningAppRegular');

const LibraryFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5C6 2.67 5.33 2 4.5 2h-1zm5 0C7.67 2 7 2.67 7 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5c0-.83-.67-1.5-1.5-1.5h-1zm7.22 4.16a1.5 1.5 0 00-1.87-1.1l-.75.2A1.5 1.5 0 0012.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78l-2.25-9.76z",
    fill: primaryFill
  }));
};

export const LibraryFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LibraryFilledIcon({}), 'LibraryFilled');

const LibraryRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5C2 2.67 2.67 2 3.5 2h1C5.33 2 6 2.67 6 3.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 01-1.5-1.5V3.5zM3.5 3a.5.5 0 00-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 00.5-.5V3.5a.5.5 0 00-.5-.5h-1zm3.5.5C7 2.67 7.67 2 8.5 2h1c.83 0 1.5.67 1.5 1.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 01-1.5-1.5V3.5zM8.5 3a.5.5 0 00-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 00.5-.5V3.5a.5.5 0 00-.5-.5h-1zm7.22 3.16a1.5 1.5 0 00-1.87-1.1l-.75.2A1.5 1.5 0 0012.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78l-2.25-9.76zM14.12 6a.5.5 0 01.62.37L17 16.14a.5.5 0 01-.37.6l-.98.25a.5.5 0 01-.61-.39l-2-9.8a.5.5 0 01.35-.58l.74-.2z",
    fill: primaryFill
  }));
};

export const LibraryRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LibraryRegularIcon({}), 'LibraryRegular');

const LightbulbFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.07 15l-.38 1.6a1.84 1.84 0 01-1.67 1.4H9.13c-.82 0-1.54-.52-1.78-1.26l-.04-.14-.38-1.6h6.14zM10 2c3.31 0 6 2.6 6 5.8 0 1.68-.75 3.22-2.2 4.6a.6.6 0 00-.15.2l-.02.09L13.3 14H6.7l-.31-1.31a.6.6 0 00-.17-.3A6.32 6.32 0 014 8.04L4 7.8v-.2A5.91 5.91 0 0110 2z",
    fill: primaryFill
  }));
};

export const LightbulbFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LightbulbFilledIcon({}), 'LightbulbFilled');

const LightbulbRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2c3.31 0 6 2.6 6 5.8 0 1.68-.75 3.22-2.2 4.6a.6.6 0 00-.15.2l-.02.09-.94 3.92a1.84 1.84 0 01-1.67 1.38l-.15.01H9.13c-.82 0-1.54-.52-1.78-1.26l-.04-.14-.93-3.91a.6.6 0 00-.17-.3A6.32 6.32 0 014 8.04L4 7.8v-.2A5.91 5.91 0 0110 2zm2.04 13H7.96l.31 1.33.03.1c.1.3.38.52.71.56l.12.01h1.81a.86.86 0 00.75-.53l.03-.1.32-1.37zM10 3a4.92 4.92 0 00-4.98 4.41L5 7.63V8c.06 1.3.68 2.52 1.9 3.67.18.17.32.4.4.64l.05.15.37 1.54h4.57l.38-1.61.05-.16c.09-.21.22-.4.39-.56C14.38 10.47 15 9.18 15 7.8A4.9 4.9 0 0010 3z",
    fill: primaryFill
  }));
};

export const LightbulbRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LightbulbRegularIcon({}), 'LightbulbRegular');

const LightbulbCircleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM6.5 8.5a3.5 3.5 0 115.59 2.81c-.19.14-.29.29-.31.43l-.05.26H8.27l-.05-.26c-.02-.14-.12-.3-.3-.43A3.5 3.5 0 016.5 8.5zm2.18 5.68L8.46 13h3.08l-.22 1.18a1 1 0 01-.98.82h-.68a1 1 0 01-.98-.82z",
    fill: primaryFill
  }));
};

export const LightbulbCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LightbulbCircleFilledIcon({}), 'LightbulbCircleFilled');

const LightbulbCircleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 3a7 7 0 100 14 7 7 0 000-14zm-8 7a8 8 0 1116 0 8 8 0 01-16 0zm8-4a2.75 2.75 0 00-1.69 4.92c.2.15.35.37.4.63l.08.45h2.42l.08-.45c.05-.26.2-.48.4-.63A2.74 2.74 0 0010 6zm1.02 7H8.98l.1.6c.05.23.26.4.5.4h.84a.5.5 0 00.5-.4l.1-.6zM6.25 8.75a3.75 3.75 0 116.03 2.98l-.39 2.05A1.5 1.5 0 0110.42 15h-.84a1.5 1.5 0 01-1.47-1.22l-.39-2.04c0-.01 0-.02-.02-.03a3.74 3.74 0 01-1.45-2.96z",
    fill: primaryFill
  }));
};

export const LightbulbCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LightbulbCircleRegularIcon({}), 'LightbulbCircleRegular');

const LightbulbFilamentFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.07 15l-.38 1.6a1.84 1.84 0 01-1.67 1.4H9.13c-.82 0-1.54-.52-1.78-1.26l-.04-.14-.38-1.6h6.14zM10 2c3.31 0 6 2.6 6 5.8 0 1.68-.75 3.22-2.2 4.6a.6.6 0 00-.15.2l-.02.09L13.3 14H10.5V9.5a.5.5 0 10-1 0V14H6.69l-.31-1.31a.6.6 0 00-.17-.3A6.32 6.32 0 014 8.04L4 7.8v-.2A5.91 5.91 0 0110 2zm-.5 4.5v1a.5.5 0 001 0v-1a.5.5 0 00-1 0zm3.35.94a.5.5 0 00-.7 0l-.71.71a.5.5 0 00.7.7l.71-.7a.5.5 0 000-.7zm-5 0a.5.5 0 10-.7.71l.7.7a.5.5 0 10.71-.7l-.7-.7z",
    fill: primaryFill
  }));
};

export const LightbulbFilamentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LightbulbFilamentFilledIcon({}), 'LightbulbFilamentFilled');

const LightbulbFilamentRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 6.5a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zm3.35.94a.5.5 0 00-.7 0l-.71.71a.5.5 0 00.7.7l.71-.7a.5.5 0 000-.7zm-5 0a.5.5 0 10-.7.71l.7.7a.5.5 0 10.71-.7l-.7-.7zM10 2c3.31 0 6 2.6 6 5.8 0 1.68-.75 3.22-2.2 4.6a.6.6 0 00-.15.2l-.02.09-.94 3.92a1.84 1.84 0 01-1.67 1.38l-.15.01H9.13c-.82 0-1.54-.52-1.78-1.26l-.04-.14-.93-3.91a.6.6 0 00-.17-.3A6.32 6.32 0 014 8.04L4 7.8v-.2A5.91 5.91 0 0110 2zM7.96 15l.31 1.33.03.1c.1.3.38.52.71.56l.12.01h1.81a.86.86 0 00.75-.53l.03-.1.32-1.37H7.96zM10 3a4.92 4.92 0 00-4.98 4.41L5 7.63V8c.06 1.3.68 2.52 1.9 3.67.18.17.32.4.4.64l.05.15.37 1.54H9.5V9.5a.5.5 0 111 0V14h1.79l.38-1.61.05-.16c.09-.21.22-.4.39-.56C14.38 10.47 15 9.18 15 7.8A4.9 4.9 0 0010 3z",
    fill: primaryFill
  }));
};

export const LightbulbFilamentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LightbulbFilamentRegularIcon({}), 'LightbulbFilamentRegular');

const LikertFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 16v-5.5H2V13a3 3 0 003 3h1zm1 0h8a3 3 0 003-3v-2.5H7V16zm2-2a.75.75 0 110-1.5.75.75 0 010 1.5zm2.25 0a.75.75 0 110-1.5.75.75 0 010 1.5zm2.25 0a.75.75 0 110-1.5.75.75 0 010 1.5zm2.25 0a.75.75 0 110-1.5.75.75 0 010 1.5zM18 9.5V7a3 3 0 00-3-3H7v5.5h11zM9.75 6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6 4H5a3 3 0 00-3 3v2.5h4V4z",
    fill: primaryFill
  }));
};

export const LikertFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LikertFilledIcon({}), 'LikertFilled');

const LikertRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.5 12.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM8.75 8a.75.75 0 100-1.5.75.75 0 000 1.5zM11 8a.75.75 0 100-1.5.75.75 0 000 1.5zm2.25 0a.75.75 0 100-1.5.75.75 0 000 1.5zm2.25 0a.75.75 0 100-1.5.75.75 0 000 1.5zM2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7zm3-2a2 2 0 00-2 2v2.5h3V5H5zm1 5.5H3V13c0 1.1.9 2 2 2h1v-4.5zm1 0V15h8a2 2 0 002-2v-2.5H7zm10-1V7a2 2 0 00-2-2H7v4.5h10z",
    fill: primaryFill
  }));
};

export const LikertRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LikertRegularIcon({}), 'LikertRegular');

const LineFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.78 2.22c.3.3.3.77 0 1.06l-14.5 14.5a.75.75 0 01-1.06-1.06l14.5-14.5c.3-.3.77-.3 1.06 0z",
    fill: primaryFill
  }));
};

export const LineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineFilledIcon({}), 'LineFilled');

const LineRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.85 2.15c.2.2.2.51 0 .7l-15 15a.5.5 0 01-.7-.7l15-15c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const LineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineRegularIcon({}), 'LineRegular');

const LineDashesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.78 4.28a.75.75 0 00-1.06-1.06l-.5.5a.75.75 0 001.06 1.06l.5-.5zm-3 1.94c.3.3.3.77 0 1.06l-.5.5a.75.75 0 11-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0zm-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 11-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0zm-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 01-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0zm-3 4.06a.75.75 0 10-1.06-1.06l-.5.5a.75.75 0 101.06 1.06l.5-.5z",
    fill: primaryFill
  }));
};

export const LineDashesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineDashesFilledIcon({}), 'LineDashesFilled');

const LineDashesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.85 3.85a.5.5 0 00-.7-.7l-1 1a.5.5 0 00.7.7l1-1zm-3 2.3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0zm-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0zm-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l1-1c.2-.2.5-.2.7 0zm-3 3.7a.5.5 0 00-.7-.7l-1 1a.5.5 0 00.7.7l1-1z",
    fill: primaryFill
  }));
};

export const LineDashesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineDashesRegularIcon({}), 'LineDashesRegular');

const LineHorizontal1FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 9.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75z",
    fill: primaryFill
  }));
};

export const LineHorizontal1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal1FilledIcon({}), 'LineHorizontal1Filled');

const LineHorizontal1RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const LineHorizontal1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal1RegularIcon({}), 'LineHorizontal1Regular');

const LineHorizontal3FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75zM2.75 14a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const LineHorizontal3Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal3FilledIcon({}), 'LineHorizontal3Filled');

const LineHorizontal3RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const LineHorizontal3Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal3RegularIcon({}), 'LineHorizontal3Regular');

const LineHorizontal5FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 3.75zm0 6c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75zM2.75 12a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zM2 6.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 6.75zM2.75 15a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const LineHorizontal5Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal5FilledIcon({}), 'LineHorizontal5Filled');

const LineHorizontal5RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm0 6c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM2.5 6a.5.5 0 000 1h15a.5.5 0 000-1h-15zM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const LineHorizontal5Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal5RegularIcon({}), 'LineHorizontal5Regular');

const LineHorizontal5ErrorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.75 3a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zm0 6a.75.75 0 000 1.5h7.14c.38-.59.87-1.1 1.45-1.5H2.75zm0 3h6.46c-.14.48-.21.98-.21 1.5H2.75a.75.75 0 010-1.5zm0 3h6.46c.15.54.38 1.04.68 1.5H2.75a.75.75 0 010-1.5zm0-9a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zM19 13.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 11a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const LineHorizontal5ErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal5ErrorFilledIcon({}), 'LineHorizontal5ErrorFilled');

const LineHorizontal5ErrorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 3a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 6a.5.5 0 000 1h7.76c.31-.38.67-.72 1.08-1H2.5zm0 3h6.7c-.08.32-.15.66-.18 1H2.5a.5.5 0 010-1zm0 3h6.7c.1.35.24.68.4 1H2.5a.5.5 0 010-1zm0-9a.5.5 0 000 1h15a.5.5 0 000-1h-15zM19 13.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 11a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const LineHorizontal5ErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal5ErrorRegularIcon({}), 'LineHorizontal5ErrorRegular');

const LineStyleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.75c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5A.75.75 0 012 4.75zm6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5A.75.75 0 018 4.75zm6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75zm-12 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75zM3.25 14a1.25 1.25 0 100 2.5h13.5a1.25 1.25 0 100-2.5H3.25z",
    fill: primaryFill
  }));
};

export const LineStyleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineStyleFilledIcon({}), 'LineStyleFilled');

const LineStyleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm6 0c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm6 0c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zm-12 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zM3 14a1 1 0 100 2h14a1 1 0 100-2H3z",
    fill: primaryFill
  }));
};

export const LineStyleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineStyleRegularIcon({}), 'LineStyleRegular');